export default {
  app: {
    title: {
      rentablo: "Rentablo - macht Fondssparen rentabler",
      depotcheck: "Depotcheck.ai - Intelligente Portfolio-Optimierung",
      compliance: "Compliance",
    },
  },
  common: {
    confirm: "Bestätigen",
    close: "Schließen",
    back: "Zurück",
    chartNoData: "Keine Daten",
    chartOther: "Sonstiges",
    englishLegalNote: "",
  },
  today: "Heute",
  notFound: {
    title: "Oh nein! Fehler 404",
    text: "Ups! Diese Seite scheint einen Umweg genommen zu haben. Lassen Sie uns Ihnen helfen, zurück zu Ihrem Ziel zu finden.",
    button: "Zurück zur Startseite",
  },
  dateRangePicker: {
    title: "Zeitraum auswählen",
    startLabel: "Von",
    endLabel: "Bis",
    resetLabel: "Zurücksetzen",
    applyLabel: "Anwenden",
  },
  expiresIn: {
    day: "1 Tag",
    days: "{{days}} Tagen",
    month: "1 Monat",
    months: "{{months}} Monaten",
  },
  copiedToClipboard: "In die Zwischenablage kopiert",
  currencyMode: {
    global: "in {{currency}}",
    account: "in Kontowährung",
  },
  currencyToggle: {
    original: "Originalwährung",
    global: "{{currency}}",
  },
  bankImportStatus: {
    importedData: "Importierte Bankdaten",
    updatedData: "Aktualisierte Bankdaten",
    successImport: "Bankdaten erfolgreich importiert",
    successUpdate: "Bankdaten erfolgreich aktualisiert",
    errorImport: "Bankdaten-Import fehlgeschlagen",
    errorUpdate: "Bankdaten-Update fehlgeschlagen",
    status: {
      CONNECTING: "Stelle Verbindung zur Bank her",
      DECOUPLED_AUTH_REQUIRED:
        "Bitte bestätigen Sie den Banking-Login in Ihrer Banking-APP",
      VERIFYING_CHALLENGE_RESPONSE: "Prüfe TAN",
      AUTHENTICATION_IN_PROGRESS: "Führe Authentifizierung durch",
      AUTHENTICATION_FAILED: "Authentifizierung fehlgeschlagen",
      ACCOUNTS: "Rufe Konten ab",
      TRANSACTIONS: "Rufe Transaktionsdaten ab",
      SECURITIES: "Rufe Wertpapierdaten ab",
      PERSISTING_TRANSACTIONS: "Speichere Transaktionshistorie",
      PERSISTING_BOOKINGS: "Speichere Orderhistorie",
      SUCCESS: "Alle Daten gespeichert",
      FAILED_WITH_ERROR: "Unerwarteter Fehler",
    },
  },
  dropdownWithSections: {
    noOptions: "Keine Optionen verfügbar",
    noMatches: "Keine Übereinstimmungen gefunden",
    loading: "Lade...",
  },
  form: {
    yes: "ja",
    no: "nein",
    successMessage: "Ihre Daten wurden erfolgreich gespeichert",
    errors: {
      pdfImport:
        "Leider konnten wir eine oder mehrere Ihrer PDF-Dateien nicht auslesen, bitte versuchen Sie es erneut",
      pdfImportFileLength:
        "Sie haben mehr als 10 Dateien ausgewählt. Es können maximal 10 Dateien verarbeitet werden. Zusätzliche Dateien werden nicht akzeptiert",
      required: "Dieses Feld wird benötigt.",
      wrongEmailFormat: "Ungültiges Email Format.",
      emailsNotMatched: "Emails sollten übereinstimmen.",
      passwordMinLength: "Passwort sollte mindestens 8 Zeichen lang sein.",
      passwordsNotMatched: "Passwörter sollten übereinstimmen.",
      wrongDateFormat: "Ungültiges Datum Format.",
      wrongIbanFormat:
        "IBAN ist ungültig. Bitte überprüfen Sie dies und geben Sie eine gültige IBAN ein.",
      wrongPhoneFormat:
        "Ungültiges Telefon Format. Bitte verwenden Sie nur Ziffern und das + Symbol.",
      min: "Dieses Feld muss mindestens {{min}} Zeichen lang sein.",
      max: "Dieses Feld darf höchstens {{max}} Zeichen lang sein.",
      emailAlreadyExists: "Diese Email Adresse ist bereits registriert.",
      somethingWentWrong:
        "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
      noData: "Keine Daten verfügbar",
    },
  },
  domains: {
    dividends: {
      dividendsTable: {
        noDividends: "Keine Dividenden",
      },
    },
    cashback: {
      download: {
        customerFirstName: "Vorname",
        customerLastName: "Nachname",
        bank: "Bank",
        depotId: "Depotnummer",
        securityIsin: "ISIN",
        securityName: "Fondsname",
        date: "Datum",
        netCommission: "Provision",
        valuationBase: "Bewertungsbasis",
        commissionType: "Provisionstyp",
      },
      dashboard: {
        details: {
          title: "Provisions-Positionen",
          commission: "Provision auf",
          evaluation: "Bewertungssumme",
        },
        summary: {
          accountingFrom: "Abrechnung vom: ",
          download: "Abrechnung herunterladen",
          afterBilling: "Nach Abrechnung",
          notBilledYet: "Noch nicht abgerechnet",
          trailerCommission: "Bestandsprovision / Agio",
          commissionRetention: "Provisionseinbehalt",
          yourCashback: "Ihr Cashback",
          incomplete: "Abrechnung in Bearbeitung",
          lastBills: "Letzte Abrechnungen",
          goToBilling: "Gehe zu Abrechnungen",
          period: "Zeitraum:",
          taxHelper: "Steuerhelfer",
        },
        tabs: {
          overview: "Übersicht",
          invoices: "Abrechnungen",
          contacts: "Kontakt & Zahlung",
        },
        title: "Mein Cashback",
        breadcrumbs: {
          home: "Home",
          cashback: "Cashback",
        },
        titleAction: "Neue Cashback Buchung",
        openBookings: "Meine Cashback Buchungen",
        showAll: "Alle anzeigen",
        info: {
          title: "Freunde werben und doppelt profitieren",
          text: "Sichern Sie sich jetzt <blueText>{{amount}} € Cashback-Bonus*</blueText> für jeden geworbenen Freund.\nIhr Freund erhält ebenfalls <blueText>{{amount}} € Bonus.</blueText>",
          recommend: "{{appName}} weiterempfehlen",
          notNow: "Jetzt nicht",
        },
        cashbackBonusBanner: {
          amountText: "{{amount}} Bonus verfügbar",
          inactiveText: "• Aktivierung nach Abschluss der Buchung",
        },
        footer:
          "* Der Cashback-Bonus wird mit dem Provisionseinbehalt verrechnet und erhöht so Ihr Cashback.",
        item: {
          depositNumber: "Depotnnummer",
          edit: "Bearbeiten",
          abort: "Abbrechen",
          pdf: "PDF",
          deleteSuccess: "Die Cashback Buchung wurde erfolgreich gelöscht",
        },
        status: {
          incomplete: "Bitte Angaben vervollständigen",
          in_progress: "Bitte Unterlagen einreichen",
          internal_processing: "Unterlagen erhalten",
          processing_at_bank: "Unterlagen an Bank weitergeleitet",
          processing_at_bank_reduced:
            "Eröffnungsprozess an Bank weitergeleitet",
          processed: "Aktiv",
          contract_terminated: "Gekündigt",
          cancelled: "Abgebrochen",
        },
        taxHelper: {
          title: "Steuerhelfer",
          back: "zurück",
          categories: {
            EQUITY_FUND: "Aktienfonds, Aktienanteil > 51%",
            BALANCED_FUND: "Mischfonds, Aktienanteil > 25%",
            GERMAN_REAL_ESTATE_FUND: "Immobilien, Deutschland > 51%",
            FOREIGN_REAL_ESTATE_FUND: "Immobilien, Ausland > 51%",
            OTHERS: "Andere (Keine Freistellung)",
          },
          summary: {
            period: "Zeitraum",
            taxableAmount: "Steuerrelevanter Betrag",
            export: "Export",
            exportData: "Daten exportieren",
          },
          banner: {
            title: "Ausschluss der steuerlichen Beratung",
            text: "Die hier dargebotenen Informationen stellen keine steuerliche Beratung dar. Die angegebenen Werte und Software-Werkzeuge bieten lediglich eine Orientierungshilfe. Insbesondere übernimmt Rentablo keine Garantie für die angezeigten Werte und übernimmt auch keine Haftung. Eine individuelle Beratung durch fachkundige Personen kann dadurch nicht ersetzt werden.",
          },
          info: {
            title: "Teilfreistellungen",
            text: "Jeder Fonds, der eine Teilfreistellung der Erträge für seine Anleger gewährleisten will, muss in den Fondsbedingungen zukünftig die Quoten der Aktien- bzw. Immobilienanteile festschreiben und dem Bundesaufsichtamt für Finanzdienstleistungen (BaFin) nachweisen. Laut Gesetzgeber stellt der WM Datenservice die entsprechenden Daten zur Verfügung. In der Praxis ist der <linkText>WM Datenservice</linkText> leider nicht in der Lage, diese Daten auch bereitzustellen.",
            text2:
              "Aus diesem Grunde nehmen wir eine Vorklassifizierung basierend auf internen Daten und den Eingaben anderer Rentablo Benutzer vor. Bitte überprüfen Sie daher die angegebenen Werte.",
          },
          products: {
            name: "Produkt",
            category: "Steuerfreistellung",
            taxableAmount: "Steuerrelevanter Betrag",
            success: "Die Feistellung wurde erfolgreich aktualisiert",
          },
        },
      },
      form: {
        breadcrumbs: {
          home: "Home",
          contacts: "Kontakte",
          editContact: "Bearbeiten",
        },
        required: "Wird benötigt",
        accountData: "Kontodaten",
        payment: "Auszahlungskonto",
        cancel: "Abbrechen",
        save: "Änderungen speichern",
        recommend: "Empfehlung senden",
      },
      paymentDataForm: {
        nameWarning:
          "Bitte kontaktieren Sie unseren Support um den Namen des Kontoinhabers zu ändern",
        payment: "Auszahlungskonto",
        owner: "Kontoinhaber",
        iban: "IBAN",
        bank: "Bank",
        bic: "BIC",
        bankLocation: "Bankort",
        ownerData: "Kontoinhaber",
        lastName: "Nachname",
        firstName: "Vorname",
        ibanError: "Diese IBAN ist ungültig. Bitte überprüfen Sie die IBAN",
      },
      accountDataForm: {
        nameWarning:
          "Bitte kontaktieren Sie unseren Support um den Namen des Kontoinhabers zu ändern",
        title: "Kontoinhaber bearbeiten",
        accountData: "Auszahlungskonto",
        name: "Name Kontoinhaber",
        type: "Art",
        phone: "Telefon / Mobil (Für Rückfragen)",
        address: "Anschrift",
        street: "Straße",
        number: "Hausnummer",
        zip: "PLZ",
        city: "Ort",
        region: "Land",
        anschrift: "Anschirft",
      },
      contact: {
        owner: "Kontoinhaber",
        edit: "Bearbeiten",
        person: "PERSON",
        company: "FIRMENDEPOT",
        details: "Details ansehen",
      },
      invite: {
        breadcrumbs: {
          page: "{{appName}} weiterempfehlen",
        },
        title:
          "{{appName}} Cashback weiterempfehlen und {{amount}} € Bonus erhalten!",
        subtitle: "So funktioniert es",
        subtitle2:
          "Alternativ können Sie direkt hier eine Email mit Ihrem persönlichen Empfehlungs-Code versenden.",
        description:
          "Senden Sie Ihren persönlichen Empfehlungscode einfach per WhatsAPP oder SMS. Ihr Freund gibt diesen während der Buchung von {{appName}}-Cashback an.",
        myName: "Ihr Name",
        friendName: "Name Ihres Freundes",
        email: "Email Ihres Freundes",
        message: "Ihre Nachricht (optional)",
        send: "Senden",
        promotion: "Ihr Empfehlungscode",
        success:
          "Die E-Mail mit dem Code wurde erfolgreich an Ihren Freund gesendet",
      },
      breadcrumbs: {
        home: "Home",
        cashback: "Cashback",
      },
    },
    accountPreviewCard: {
      updateRecommended: "Aktualisierung empfohlen",
    },
  },
  questions: {
    INVESTMENT_HORIZON: {
      title: "Wie lange möchten Sie Ihr Geld anlegen?",
      subtitle: "Bitte wählen Sie Ihren Anlagehorizont aus",
      options: {
        LONG_TERM: {
          title: "Langfristige Geldanlage",
          subtitle: "Geldanlage mit einem Anlagehorizont über 7 Jahren",
        },
        MID_TERM: {
          title: "Mittelfristige Geldanlage",
          subtitle: "Geldanlage mit einem Anlagehorizont von 3 bis 7 Jahren",
        },
        SHORT_TERM: {
          title: "Kurzfristige Geldanlage",
          subtitle: "Geldanlage mit einem Anlagehorizont unter 3 Jahren",
        },
      },
    },
    SUSTAINABILITY: {
      title: "Wie wichtig ist Ihnen Nachhaltigkeit?",
      subtitle: "Bitte wählen Sie Ihre Präferenz",
      options: {
        MORE_IMPORTANT: {
          title: "Nachhaltigkeit ist mir wichtiger als Rendite",
          subtitle:
            "Nachhaltigkeit ist Priorität, ich würde auch auf höhere Rendite verzichten",
        },
        IMPORTANT: {
          title: "Nachhaltigkeit ist mir wichtig",
          subtitle: "Grundsätzlich wichtig, aber kein Ausschlusskriterium",
        },
        LESS_IMPORTANT: {
          title: "Rendite ist mir wichtiger als Nachhaltigkeit",
          subtitle:
            "Ich möchte eine gute Rendite, Nachhaltigkeit ist eher zweitrangig",
        },
        NOT_IMPORTANT: {
          title: "Ist mir nicht wichtig",
          subtitle: "Keine Präferenz",
        },
      },
    },
    RISK_RETURN_PREFERENCE: {
      title:
        "Wie würden Sie Ihre persönliche Chance-Risiko-Neigung einschätzen?",
      subtitle:
        "Wählen Sie die Antwortmöglichkeit, die am ehesten auf Sie zutrifft",
      options: {
        NO_RISK: {
          title: "Ich akzeptiere kein Verlustrisiko",
          tooltip: "Kein Risiko. Nur Festgeldprodukte mit festem Zinssatz.",
        },
        LOW_RETURN_EXPECTATION: {
          title:
            "Meine Ertragserwartung ist niedrig. Ich nehme geringe Kursschwankungen in Kauf.",
          tooltip: "Geringes Risiko. Anlagen mit Fokus auf Stabilität.",
        },
        MODERATE_RETURN_EXPECTATION: {
          title:
            "Ich habe eine moderate Ertragserwartung. Dafür nehme ich aufgrund von Marktschwankungen moderate Verlustrisiken in Kauf.",
          tooltip:
            "Mittleres Risiko. Anlagen mit Fokus auf langfristigem Kapitalwachstum.",
        },
        HIGH_RETURN_EXPECTATION: {
          title:
            "Ich habe eine hohe Renditeerwartung, die möglichst dauerhaft über dem Kapitalmarktzinsniveau liegt. Dafür nehme ich entsprechende Marktschwankungen und höhere Verlustrisiken in Kauf.",
          tooltip:
            "Hohes Risiko.  Anlagen mit Fokus auf Chancen und höherer Rendite.",
        },
      },
    },
    LIQUID_ASSETS: {
      title: "Wie hoch ist Ihr frei verfügbares Vermögen?",
      subtitle:
        "Die Angaben zu Ihren Vermögenswerten und Verbindlichkeiten helfen uns dabei, Ihre Risikotragfähigkeit zu bewerten und einen maximalen Anlagebetrag zu ermitteln.",
      CASH: "Wie hoch ist Ihr Barvermögen?",
      CASH_placeholder: "Bitte auswählen",
      cashAssetsOptions: {
        UNDER_20K: "Unter € 20.000",
        "20K_TO_50K": "€ 20.000 - € 50.000",
        "50K_TO_100K": "€ 50.001 - € 100.000",
        OVER_100K: "Über € 100.000",
      },
      ASSETS_IN_SECURITIES:
        "Wie hoch ist Ihr Vermögen, dass Sie in Wertpapieren angelegt haben?",
      ASSETS_IN_SECURITIES_placeholder: "Bitte auswählen",
      securitiesOptions: {
        UNDER_20K: "Unter € 20.000",
        "20K_TO_50K": "€ 20.000 - € 50.000",
        "50K_TO_100K": "€ 50.001 - € 100.000",
        OVER_100K: "Über € 100.000",
      },
    },
    NET_INCOME_AND_NET_EXPENSES: {
      title: "Welche Erfahrungen und Kenntnisse haben Sie mit Fonds und ETF?",
      subtitle:
        "Wir möchten sicher gehen, dass Sie sich mit Ihren Anlageprodukten wohlfühlen. Daher fragen wir, inwieweit Sie schon Erfahrungen mit bestimmten Anlagen gesammelt haben.",
      YEARS_INVESTING_FUNDS:
        "Erfahrung - Seit wie vielen Jahren investieren Sie in das genannte Finanzinstrument?",
      investingYearsOptions: {
        NO_INVEST: "Keine Erfahrung",
        UP_TO_1: "Bis zu 1 Jahr",
        UP_TO_3: "Bis zu 3 Jahren",
        OVER_3: "Mehr als 3 Jahre ",
      },
      KNOWLEDGE_FUNDS:
        "Kenntnisse - Wie vertraut sind Sie mit der Funktionsweise, den Chancen und den Risiken des Finanzinstruments?",
      knowledgeOptions: {
        NO_KNOWLEDGE: "Keine Kenntnisse",
        LOW_KNOWLEDGE: "Wenig Kenntnisse",
        MEDIUM_KNOWLEDGE: "Mittlere Kenntnisse",
        HIGH_KNOWLEDGE: "Viele Kenntnisse",
      },
      TRADES_PER_YEAR_FUNDS: "Durchschnittliche Anzahl Geschäfte / Jahr",
      averageFundTransactionsOptions: {
        "1_TO_4": "0 bis 4",
        "5_TO_10": "5 bis 10",
        "11_TO_50": "11 bis 50",
        OVER_50: "Mehr als 50",
      },
    },
    PREFERENCE_ETF_OR_FUNDS: {
      title: "Präferieren Sie ETF oder klassische Fonds bei Ihrer Anlage?",
      infoBox: {
        title: "Der Unterschied zwischen ETF und Investmentfonds",
        text: "Ziel von klassischen Investmentfonds ist es, einen Index zu übertreffen, während Exchange Traded Funds (ETF) die jeweiligen Indizes abbilden. Investmentfonds werden von einem Fondsmanagement aktiv verwaltet, wohingegen ETF auf ein aktives Fondsmanagement verzichten. Anleger müssen für das aktive Fondsmanagement höhere Gebühren als für passiv gemanagte  ETF zahlen.",
      },
      subtitle:
        "Wir möchten sicher gehen, dass Sie sich mit Ihren Anlageprodukten wohlfühlen. Daher fragen wir Sie nach Ihren Präferenzen für bestimmte Anlagen.",
      options: {
        ETF: {
          title: "ETF",
          subtitle: "Kein aktives Fondsmanagement",
        },
        FUNDS: {
          title: "Klassische Fonds",
          subtitle: "Aktives Fondsmanagement",
        },
        NO_PREFERENCE: {
          title: "Ist mir nicht wichtig",
          subtitle: "Keine Präferenz",
        },
      },
    },
    age: {
      title: "Wie alt sind Sie?",
      subtitle: "Bitte wählen Sie Ihr Alter aus",
      age: "Alter",
      options: {
        "under-18": "unter 18",
        "18-25": "18 bis 25 Jahre",
        "26-40": "26 bis 40 Jahre",
        "41-60": "41 bis 60 Jahre",
        "over-60": "über 60 Jahre",
      },
    },
    children: {
      title: "Wie viele Kinder haben Sie?",
      subtitle: "Bitte geben Sie die Nummer an",
      children: "Anzahl Kinder",
    },
    income: {
      title: "Wie hoch sind Ihre monatlichen Einnahmen und Ausgaben?",
      subtitle:
        "Bitte machen Sie realistische Angaben damit wir Ihnen die Geldanlage vorschlagen können, die am besten zu Ihnen passt.",
      income: "Monatliche Nettoeinnahmen",
      expenses: "Monatliche Ausgaben",
      options: {
        income: {
          "under-1000": "Unter 1.000 Euro",
          "1000-1500": "1.000 - 1.500 Euro",
          "1501-2500": "1.501 - 2.500 Euro",
          "over-2500": "Über 2.500 Euro",
        },
        expenses: {
          "under-1000": "Unter 1.000 Euro",
          "1000-1500": "1.000 - 1.500 Euro",
          "1501-2500": "1.501 - 2.500 Euro",
          "over-2500": "Über 2.500 Euro",
        },
      },
    },
  },
  productBasicInfo: {
    title: "Stammdaten",
    savingsPlan: {
      title: "Sparplan-fähig",
    },
    vl: {
      title: "VL-fähig",
    },
    distribution: {
      title: "Aussch. Art",
      RETAINED: "Thesaurierend",
      DISTRIBUTING: "Ausschüttend",
    },
    distributionFrequency: {
      title: "Aussch. Intervall",
      monthly: "Monatlich",
      quarterly: "Quartalsweise",
      biAnnually: "Halbjährlich",
      annually: "Jährlich",
    },
    currency: {
      title: "Währung",
    },
    age: {
      title: "Alter",
      value_one: "{{years}} Jahr",
      value_other: "{{years}} Jahre",
      valueMonth_one: "{{months}} Monat",
      valueMonth_other: "{{months}} Monate",
    },
    establishedAt: {
      title: "Auflage",
    },
    volume: {
      title: "Volumen",
    },
  },
  recommender: {
    title: "Unsere Investmentvorschläge für Sie",
    description:
      'Wir zeigen Ihnen alternative Produkte zu Ihrem Fonds "{{name}}".  Die Produktvorschläge sind sortiert nach einem Score, der bemisst, wie gut das Produkt zu Ihrem Anlageprofil passt. Zusätzlich werden Ihnen zu jedem Produkt konkrete Vorteile im Vergleich zu "{{name}}" angezeigt (z.B. geringere Gebühren, höhere Rendite).',
    matchScore: "Stimmt zu {{score}}% mit Ihren Angaben überein",
    openProductDetails: "zu den Produktdetails",
    addToWatchlist: "Zur Watchlist hinzufügen",
    removeFromWatchlist: "Von Watchlist entfernen",
    goToWatchlist: "Zur Watchlist",
    compare: "Produkt vergleichen",
    showMore: "mehr Produkte anzeigen",
    showLess: "weniger Produkte anzeigen",
    results: "{{count}} Produkte Ergebnisse",
    watchlistName: "Rentablo Produktvorschläge",
    scoreTooltip:
      "Die Produktvorschläge sind sortiert nach einem Score, der bemisst, wie gut das Produkt zu Ihrem Anlageprofil passt",
    back: "Zurück",
    chips: {
      all: "Alle",
      fonds: "Fonds",
      etf: "ETF",
    },
    tags: {
      popular: "Beliebt bei anderen Anlegern",
      popularTooltip:
        "Die Beliebtheit wird anhand des Volumens an Kundengeldern (AuM) gemessen, die ein Fonds oder ETF verwaltet. Die Auszeichnung ”Beliebt bei anderen Anlegern” erhalten nur Fonds oder ETF mit einem Volumen über 500 Millionen Euro.",
      savingsPlan: "Sparplanfähig",
      distributing: "Ausschüttend",
      retaining: "Thesaurierend",
      lowerRisk: "{{percentage}}% Niedrigeres Risiko",
      higherReturn: "{{percentage}}% Höhere Rendite",
      lowerFees: "{{percentage}}% Weniger Gebühren",
      lowerFeesTooltip:
        "Die Gebühren werden anhand der Gesamtkostenquote (TER) verglichen. Die Gesamtkostenquote ist eine prozentuale Kennzahl, welche die jährlichen Kosten bei Fonds oder ETF angibt.",
    },
    compareView: {
      title:
        "Vergleichen Sie Ihr ausgewähltes Produkt mit dem bestehenden Produkt im Portfolio.",
      stockPerformanceOf: "Kursentwicklung von {{name}}",
      noData: "Aktuell liegen noch keine Daten vor.",
      performanceRisk: {
        title: "Vergleichen Sie Performance und Risiko",
        yieldTitle: "{{name}} hat eine {{percentage}}% höhere Rendite",
        yieldTooltip:
          "Die Performance wird anhand der annualisierten Rendite bestimmt. Diese wird auf Basis der historischen Performance für den verfügbaren Zeitraum berechnet.",
        yieldLabel: "Rendite",
        riskTitle: "{{name}} hat ein {{percentage}}% niedrigeres Risiko",
        riskTooltip:
          "Das Risiko wird anhand der Volatilität bestimmt. Die Volatilität wird als annualisierte Standardabweichung  der Tagesrenditen für den verfügbaren Zeitraum angegeben.",
        riskLabel: "Risiko",
      },
      fees: {
        title: "Vergleichen Sie die laufenden Kosten",
        feeTitle: "{{name}} hat {{percentage}}% niedrigere laufende Kosten",
        feeTooltip:
          "Die laufenden Kosten sind ein Maß für die Gesamtkosten, die mit der Verwaltung und dem Betrieb eines Investmentfonds oder ETF verbunden sind.",
        feeLabel: "Laufende Kosten",
        cost: "Kosten",
        productName: "PRODUKT",
        ongoingFee: "Laufende Kosten",
      },
      donutCharts: {
        showMore: "Weitere Details anzeigen",
        showLess: "Weniger Details anzeigen",
        regionTitle: "Investments nach Region",
        industryTitle: "Investments nach Branche",
        region: "Regionen",
        industries: "Branchen",
        branch: "Investments nach Branche",
        top10Holdings: "Top 10 Holdings",
        fromFund: "Von {{name}} Fund",
        global: "Global",
        regions: {
          americas: "Amerika",
          europe: "Europa",
          asia: "Asien",
          africa: "Afrika",
          oceania: "Australien",
        },
      },
      productInfo: {
        title: "Wichtige Produktinformationen",
        header: {
          label: "Bezeichnung",
          productDataOf: "Produktdaten von {{name}}",
        },
        rows: {
          provider: "Anbieter",
          replicationMethod: "Replikationsmethode",
          distributionPolicy: "Ertragsverwendung",
          directPurchaseVia: "Direktkauf möglich über",
          savingsPlan: "Sparpläne",
          payoutPlans: "Auszahlpläne",
          qualityRating: "FWW® Rating",
          sustainability: "Nachhaltigkeit",
          popularity: "Popularität",
          diversificationOverlapTitle:
            "Deckungsgleichheit der Top-Holdings mit dem bestehenden Portfolio (Diversifikation)",
          before: "Vorher",
          after: "Nachher",
        },
      },
    },
    detailsModal: {
      header: {
        isin: "ISIN",
        wkn: "WKN",
      },
      details: {
        thema: "Thema",
        region: "Regionen",
      },
      quoteChartTitle: "Performance-Chart",
      ideaTitle: "Anlageidee",
      holdings: "Top 10 Holdings",
      cashback: {
        title: "Kosten",
        cashbackTitle: "Kosten und Cashbackersparnis",
        ter: "Total Expense Ratio (TER)",
        adminFee: "Verwaltungsgebühr",
        amountPercentage: "Cashback-fähiger Betrag",
        premiumDiscount: "Ihr Agio Rabatt",
        commision: "Bestandsprovision: welche Bank zahlt wieviel?",
        example: "Sie können eine Investition von 10.000 Euro sehen.",
        goToCashback: "Jetzt Fonds-Cashback beantragen",
      },
      distributionTypes: {
        distributing: "Ausschüttend",
        retained: "Thesaurierend",
      },
      distributionFrequency: {
        monthly: "Monatlich",
        quarterly: "Quartalsweise",
        halfYearly: "Halbjährlich",
        annually: "Jährlich",
        daily: "Täglich",
      },
    },
  },
  gaugeChart: {
    risk: "Risiko",
    performance: "Perf.",
    riskClass: {
      extremelyLow: "Äußerst gering",
      veryLow: "Sehr gering",
      low: "Gering",
      medium: "Mittel",
      high: "Hoch",
      veryHigh: "Sehr hoch",
      extremelyHigh: "Äußerst hoch",
      unknown: "Unbekannt",
    },
    performanceClass: {
      negative: "Negativ",
      veryLow: "Sehr gering",
      low: "Gering",
      medium: "Mittel",
      high: "Hoch",
      veryHigh: "Sehr hoch",
      top: "Top",
      unknown: "Unbekannt",
    },
  },
  performanceTags: {
    title: "Kursentwicklung",
    tags: "Tags",
  },
  performanceGauges: {
    risk: "Risiko",
    riskClass: "Risiko-Klasse",
    riskTooltip:
      "Jedes Produkt wird einer Risikoklasse zugeordnet. Die Einteilung in 7 Klassen erfolgt anhand der Volatilität. Die Volatilität wird als annualisierte Standardabweichung der Tagesrenditen für den pro Strategie verfügbaren Zeitraum angegeben.",
    performance: "Performance",
    performanceClass: "Performance-Klasse",
    performanceTooltip:
      "Jedes Produkt wird einer Performanceklasse zugeordnet. Die Einteilung in 7 Klassen erfolgt anhand der annualisierten Rendite. Diese wird auf Basis der historischen Performance für den pro Strategie verfügbaren Zeitraum berechnet.",
    volatility: "Volatilität (1J / 3J)",
    noData: "N/A",
  },
  performanceNumbers: {
    value: "Wert",
    actual: "Aktuell",
  },
  cashflowAnalyzer: {
    title: "Budget",
    accountsBalance: "Kontostand",
    actualMonth: "Aktueller Monat",
    mean: "Durchschnitt",
    chartTitle: "Einnahmen & Ausgaben nach Kategorie",
    bannerTitle:
      "Ihre Ausgaben lagen diesen Monat <red>{{amount}}</red> über Ihren Durchschnittswert",
    income: "Einnahmen",
    expenses: "Ausgaben",
    balance: "Liquide Mittel",
    monthly: "Monate",
    quarterly: "Quartale",
    yearly: "Jahre",
    total: "Gesamtausgaben",
    sankeyChart: {
      noExpenses: "Keine Ausgaben",
      revenue: "Einnahmen",
    },
    chartSwitcher: {
      flow: "Fluss",
      distribution: "Verteilung",
    },
    chart: {
      period: "Zeitraum",
      unclassified: "Nicht klassifiziert",
    },
    transactionsTable: {
      title: "Transaktionen",
      showMore: "Mehr Transaktionen anzeigen",
      noData: "Keine Transaktionen für den Zeitraum",
      filter: "Filter",
      thisTransactionIs: "Diese Transaktion ist",
      category: "Kategorie",
      regular: "Regelmäßig",
      accountTransfer: "ein Kontentransfer",
      account: "Konto",
      counterpart: "Gegenstelle",
    },
    categoryModal: {
      searchPlaceholder: "Schnellsuche Kategorie",
      title: "Kategorie ändern",
      addCategory: "Neue Kategorie hinzufügen",
      back: "Zurück",
      save: "Speichern",
    },
    addCategoryModal: {
      title: "Neue Kategorie hinzufügen",
      main: "Oberkategorie erstellen",
      sub: "Unterkategorie erstellen",
      mainCategory: "Oberkategorie wählen",
      mainCategory_placeholder: "Bitte auswählen",
      subCategoryName: "Unterkategorie erstellen",
      subCategoryName_placeholder: "Neue Kategorie",
      mainCategoryName: "Kategorie erstellen",
      mainCategoryName_placeholder: "Neue Kategorie",
      created: "Kategorie wurde erfolgreich erstellt",
      deleted: "Kategorie wurde erfolgreich gelöscht",
      assigned: "Kategorie wurde erfolgreich zugewiesen",
    },
    statistic: {
      currentMonth: "Aktueller Monat",
      average: "Durchschnitt",
      revenue: "Einnahmen",
      expenditure: "Ausgaben",
      liquidAssets: "Liquide Mittel",
    },
  },
  contractAnalyzer: {
    title: "Contract-Analyzer",
    ytdExpenses: "Vertragsausgaben seit Jahresbeginn",
    fullYearExpenses: "Vertragsausgaben Gesamtjahr {{year}}",
    showInactive: "Inaktive Verträge anzeigen",
    createNewContract: "Neuen Vertrag hinzufügen",
    curation: {
      menuItem: "Vertragskuratierung",
      modalTitle: "Vertragskuratierung",
      description:
        "Unser Assistent prüft alle Verträge eines Kontos und korrigiert Duplikate, falsche Namen und falsch zugeordnete Verträge automatisch.",
      selectAccount: "Konto",
      noAccounts: "Keine Konten verfügbar.",
      start: "Kuratierung starten",
      runningTitle: "Kuratierung läuft…",
      resultTitle: "Kuratierung abgeschlossen",
      successGeneric:
        "Die Verträge Ihres Kontos wurden erfolgreich überprüft und kuratiert.",
      failedTitle: "Kuratierung fehlgeschlagen",
      failedGeneric:
        "Die Kuratierung konnte nicht abgeschlossen werden. Bitte versuchen Sie es später erneut.",
      errorSnackbar: "Kuratierung der Verträge fehlgeschlagen",
    },
    infoBanner:
      "Bitte aktualisieren Sie Ihre Konten, damit Ihre Verträge automatisch erkannt werden können. Anschließend werden Ihnen die Verträge nach dem Zahlungszeitraum gruppiert hier angezeigt.",
    categories: {
      all: "Alle",
      7: "Versicherungen",
      8: "Wohnen",
      1: "Finanzen",
      6: "Sparen",
      4: "Telekommunikation",
      2: "Freizeit",
      3: "Kinder",
      5: "Mobilität",
      74: "Pflege und Soziales",
      75: "Produktivität",
      notClassified: "Nicht klassifiziert",
    },
    subCategories: {
      9: "Bankgebühren",
      10: "Baufinanzierung",
      11: "Kredittilgung und -zinsen",
      12: "Spende",
      13: "Steuern",
      14: "Sonstige Finanzausgaben",
      15: "Mitgliedschaft",
      16: "Streamingdienste",
      17: "Sport & Fitness",
      18: "Software & Cloud",
      19: "Zeitungen & Zeitschriften",
      20: "Sonstige Freizeitausgaben",
      21: "Kinderbetreuung",
      22: "Schule & Förderung",
      23: "Sonstige Kinderausgaben",
      24: "Internet & Telefon",
      25: "Mobilfunk",
      26: "Auto (Auto-Abo, Leasing)",
      27: "Fahrrad (Leasing)",
      28: "Bus & Bahn",
      29: "Bausparvertrag",
      30: "Sparplan",
      31: "Anhängerversicherung",
      32: "Bauherrenhaftpflichtversicherung",
      33: "Berufsunfähigkeitsversicherung",
      34: "Brillenversicherung",
      35: "Drohnenhaftpflichtversicherung",
      36: "Geräteversicherung",
      37: "Gesetzliche Rentenversicherung",
      38: "Gewässerschadenhaftpflichtversicherung",
      39: "Haftpflichtversicherung",
      40: "Hausratversicherung",
      41: "Jagdhaftpflichtversicherung",
      42: "KFZ-Versicherung",
      43: "Kapitallebensversicherung",
      44: "Kautionsversicherung",
      45: "Kombi-Sachversicherung",
      46: "Krankentagegeldversicherung",
      47: "Krankenzusatzversicherung",
      48: "Lebensversicherung",
      49: "Motorradversicherung",
      50: "Pflegeversicherung",
      51: "Photovoltaikhaftpflichtversicherung",
      52: "Private Krankenversicherung",
      53: "Rechtsschutzversicherung",
      54: "Reisekrankenversicherung",
      55: "Rentenversicherung",
      56: "Riester Rente",
      57: "Risikolebensversicherung",
      58: "Rürup-/Basisrente",
      59: "Sonstige Sachversicherung",
      60: "Sterbegeldversicherung",
      61: "Tierhaftpflichtversicherung",
      62: "Tierkrankenversicherung",
      63: "Unfallversicherung",
      64: "Wohngebäudeversicherung",
      65: "Wohnwagenversicherung",
      66: "Zahnzusatzversicherung",
      67: "Sonstige Versicherung",
      68: "Gas",
      69: "Miete",
      70: "Rundfunkgebühren",
      71: "Strom",
      72: "Wohnnebenkosten",
      73: "Sonstige Wohnausgaben",
      76: "Pflegeheim",
      77: "Häusliche Pflege",
      78: "Sonstige soziale Ausgaben",
      79: "Sonstige Produktivitätsausgaben",
      83: "Gesetzliche Krankenversicherung",
      notClassified: "Nicht klassifiziert",
    },
    newContractModal: {
      createContract: {
        title: "Neuen Vertrag anlegen",
        subtitle: "Neuer Vertrag, in den die Transaktionen eingelesen werden",
        description:
          "Hinweis: Betrag und Turnus werden automatisch eingetragen, nachdem die entsprechenden Transaktionen ausgewählt und der neue Vertrag erstellt wurden.",
      },
      selectTransactions: {
        title: "Transaktionen für den neuen Vertrag suchen",
        accountPlaceholder: "Konto",
        selectPeriod:
          "Wählen Sie das Konto und den gewünschten Zeitraum für Ihre Transaktionssuche",
        periods: {
          default: "Default-Zeitraum",
          from: "Von",
          to: "Bis",
        },
        defaultPeriodOptions: {
          oneDay: "1 Tag",
          threeDays: "3 Tage",
          tenDays: "10 Tage",
          thirtyDays: "30 Tage",
          sixtyDays: "60 Tage",
          ninetyDays: "90 Tage",
          hundredEightyDays: "180 Tage",
          threeHundredSixtyDays: "360 Tage",
        },
        showOtherSearchOptions: "Alle weitere Suchkriterien anzeigen",
        all: "Alle",
        notClassified: "Nicht klassifiziert",
        noData:
          "Für die ausgewählten Filter wurden keine Transaktionen gefunden. Bitte versuchen Sie es erneut",
      },
      confirmSelection: {
        title: "Bitte überprüfen Sie Ihre Eingaben",
        subtitle:
          "Sie können die vorausgewählten Transaktionen zu einem neuen Vertrag hinzufügen.",
        allPreselectedTransactions: "Alle vorausgewählten Transaktionen",
        yourContract: "Ihr Vertrag, in den die Transaktionen eingelesen werden",
        info: "Hinweis: Betrag und Turnus werden automatisch eingetragen, nachdem der neue Vertrag erstellt wurde.",
      },
      category: {
        title: "Kategorie ändern",
      },
      buttons: {
        back: "Zurück",
        createNewContract: "Neuen Vertrag anlegen",
        addToNewContract: "Zu neuen Vertrag hinzufügen",
      },
      success: "Der Vertrag wurde erfolgreich erstellt",
      error: "Etwas ist schief gelaufen. Bitte versuche es erneut",
    },
    notRecognized: {
      titleSingle: "1 Vertrag wurde nicht vollständig erkannt.",
      subtitleSingle:
        "Ich habe 1 Vertrag identifiziert, bei dem ich mir nicht sicher bin.",
      title: "{{count}} Verträge wurden nicht vollständig erkannt.",
      subtitle:
        "Ich habe {{count}} Verträge identifiziert, bei denen ich mir nicht sicher bin.",
      reviewContracts: "Verträge prüfen",
    },
    graph: {
      period: "Zeitraum",
      totalAmount: "Gesamt Betrag",
    },
    table: {
      allContracts: "Alle Verträge",
      category: "Kategorie:",
      subcategory: "Subkategorie: {{count}}",
      noData: "Keine Verträge verfügbar",
      noDataSelectedFilter: "Keine Verträge für diese Kategorie verfügbar",
      noDataAllSubsUnchecked:
        "Keine Verträge verfügbar. Bitte wählen Sie eine Subkategorie aus.",
      showAll: "Alle weitere anzeigen",
      hideAll: "Weitere Bearbeitenfunktionen ausblenden",
      needsReviewTooltip:
        "Dieser Vertrag wurde nicht vollständig erkannt. Bitte klicken Sie auf das Stift-Icon zum Bearbeiten und ergänzen oder korrigieren Sie bei Bedarf die Angaben.",
      timeIntervals: {
        1: "Monatlich",
        2: "Alle 2 Monate",
        3: "Vierteljährlich",
        6: "Halbjährlich",
        12: "Jährlich",
        other: "Sonstige",
      },
      columns: {
        logo: "Frist",
        contractNameExpiryDate: "Vertragsname / Ablaufdatum",
        type: "Typ",
        costs: "Kosten",
      },
      options: {
        delete: "Vertrag löschen",
        showAllContracts: "Alle Verträge anzeigen",
        showAllContractsHint: "Auch unbestätigte und ausgeblendete",
      },
      expiryIn: "Ablauf in {{time}}...",
      expiryInTooltip:
        "Die Tage oder Monate geben die Zeit bis zur nächsten Vertragsverlängerung an. Sie haben immer im Blick, wie lange Sie Ihren Vertrag noch kündigen können. Wenn Sie das Vertragsende und die Kündigungsfrist nicht selbst angegeben haben, wird standardmäßig eine 30-tägige Kündigungsfrist vor dem nächsten Zahlungsdatum zugrundegelegt.",
      noExpiry: "Jetzt Vertragsfristen überwachen",
      noExpiryTooltip:
        "Sie möchten erinnert werden, wann Sie Ihren Vertrag kündigen können? Bitte geben Sie Vertragsende und Kündigungsfrist manuell ein.",
      debitedOn: "Abgebucht am {{date}}",
      deleteContract: {
        title_one: "Vertrag löschen",
        title_other: "{{count}} Verträge löschen",
        text_one: "Sind Sie sicher, dass Sie diesen Vertrag löschen wollen?",
        text_other:
          "Sind Sie sicher, dass Sie {{count}} Verträge löschen wollen? Diese Aktion kann nicht rückgängig gemacht werden.",
        cancel: "Zurück",
        confirm: "Verträge löschen",
        success: "Verträge erfolgreich gelöscht",
        error: "Etwas ist schief gelaufen. Bitte versuche es erneut",
      },
      newProvider: "Neuer Anbieter",
    },
    unrecognizedContractsModal: {
      title: "Vertrag überprüfen ({{current}} von {{total}})",
      titleSingle: "Vertrag überprüfen",
      description: "Ist dieser Vertrag richtig erkannt?",
      transactionDetails: "Detailinformationen zur letzten Transaktion:",
      confirmButton: "Vertrag übernehmen",
      cancelButton: "Vertrag überspringen",
      discardButton: "Vertrag verwerfen",
      discardConfirm: {
        title: "Diesen Vertrag löschen?",
        text: "Diese Aktion kann nicht rückgängig gemacht werden.",
        confirm: "Ja",
        cancel: "Nein",
        success: "Vertrag wurde gelöscht.",
        error: "Löschen fehlgeschlagen. Bitte versuchen Sie es erneut.",
      },
      success: "Vertrag wurde erfolgreich bestätigt.",
      error:
        "Bestätigung des Vertrags fehlgeschlagen. Bitte versuchen Sie es erneut.",
      completeReview:
        "Sie haben alle Verträge bearbeitet, die nicht vollständig erkannt wurden. Sie können das Modal nun schließen, indem Sie rechts oben auf das X oder irgendwo auf die Webseite klicken.",
    },
    editModal: {
      title: "Vertrag bearbeiten",
      description:
        "Hier können Sie den Anbieter und die Kategorie / Subkategorie Ihres Vertrages ändern.",
      tabs: {
        details: "Details",
        transactions: "Transaktionen",
        transactionsWithCount: "Transaktionen ({{count}})",
        manage: "Verwalten",
      },
      providerPlaceholder: "Muster-Anbieter",
      labels: {
        provider: "Anbieter*",
        name: "Name",
        subCategory: "Subkategorie",
        amount: "Betrag",
        timeInterval: "Turnus",
        comment: "Kommentar",
      },
      subCategoryPlaceholder: "Bitte auswählen",
      cancelButton: "Zurück",
      confirmButton: "Speichern",
      success: "Die Änderungen wurden erfolgreich gespeichert.",
      error: "Etwas ist schief gelaufen. Bitte versuche es erneut",
      category: {
        modalTitle: "Kategorie ändern",
        searchPlaceholder: "Schnellsuche Kategorie",
      },
      alarm: {
        copy: "Sie können eine Erinnerung an das Ablaufdatum des Vertrages setzen, damit Sie nicht vergessen, den Vertrag zu dem im Vertrag angegebenen Zeitpunkt zu kündigen.",
        toggle: "Vertragswecker aktivieren",
        label: "Wecker",
      },
      alarmEdit: {
        copy: "Der Vertragswecker kann konfiguriert werden, wenn die Vertragsweckerfunktion aktiviert ist.",
        button: "Vertragswecker konfigurieren",
        label: "Konfigurieren",
        description: "Bitte geben Sie das Datum der Kündigung laut Vertrag an.",
        modalTitle: "Vertragswecker für diesen Vertag aktivieren",
        modalTitleEdit: "Vertragsalarm für diesen Vertrag bearbeiten",
        save: "Vertragswecker aktivieren",
        labels: {
          endDate: "Vertragsende",
          endDateTooltip:
            "Bitte geben Sie das Datum an, zu dem der Vertrag nächstmöglich gekündigt werden kann (Mindestlaufzeit).",
          noticePeriod: "Kündigungsfrist",
          noticePeriodTooltip:
            "Bitte geben Sie den Zeitraum an, bis wann Sie den Vertrag vor Ablauf der Mindestlaufzeit spätestens kündigen müssen.",
          contractDuration: "Vertragslaufzeit",
          contractDurationTooltip:
            'Vertragslaufzeit: "Bitte geben Sie die Laufzeit an, um die sich der Vertrag nach Ablauf der Mindestlaufzeit automatisch verlängert.',
        },
        global: {
          title: "Globale Einstellungen für alle Verträge",
          copy: "Hier können Sie bestimmte Zeiträume festlegen, in denen Sie über das Ablaufdatum Ihrer Verträge informiert werden möchten. Diese Einstellung wird automatisch auf alle Kontakte in Ihrer Liste angewendet.",
          labels: {
            remindMe: "Erinnerung vor Vertragsende",
            snooze: "Snooze (Schlummertaste)",
          },
          back: "Zurück",
          save: "Einstellungen speichern",
        },
        noticePeriods: {
          notSpecified: "Keine Angabe",
          monthlyCancelable: "Monatlich kündbar",
          twoWeeks: "2 Wochen",
          fourWeeks: "4 Wochen",
          sixWeeks: "6 Wochen",
          twoMonths: "2 Monate",
          threeMonths: "3 Monate",
          fourMonths: "4 Monate",
          fiveMonths: "5 Monate",
          sixMonths: "6 Monate",
          oneYear: "1 Jahr",
        },
        contractTerms: {
          oneTime: "Einmalig",
          monthly: "Monatlich",
          biMonthly: "Alle zwei Monate",
          quarterly: "Vierteljährlich",
          biAnnually: "Halbjährlich",
          annually: "Jährlich",
        },
        reminder: {
          noSnooze: "Kein Snooze",
          oneDay: "1 Tag",
          twoDays: "2 Tage",
          threeDays: "3 Tage",
          fourDays: "4 Tage",
          fiveDays: "5 Tage",
          sixDays: "6 Tage",
          oneWeek: "1 Woche",
          twoWeeks: "2 Wochen",
          threeWeeks: "3 Wochen",
          oneMonth: "1 Monat",
        },
        snooze: {
          noReminder: "Kein Reminder",
          oneDay: "1 Tag",
          threeDays: "3 Tage",
          oneWeek: "1 Woche",
          twoWeeks: "2 Wochen",
          threeWeeks: "3 Wochen",
          oneMonth: "1 Monat",
          twoMonths: "2 Monate",
          threeMonths: "3 Monate",
        },
      },
      transactions: {
        modalTitle: "Buchungen",
        transactionsNumber:
          "Sie haben im Rahmen dieses Vertrags {{count}} Buchungen vorgenommen",
        nextTransaction: "Die nächste Buchung wird nach {{inTime}} vorgenommen",
        split: {
          description:
            "Sie können diesen Vertrag in zwei Verträge aufteilen. Dazu wählen Sie zuerst die Transaktionen aus, die aus dem bestehenden Vertrag entfernt und zu einem neuen Vertrag hinzugefügt werden sollen",
          addToNewContract: "Transaktionen zu neuem Vertrag hinzufügen",
          addToNewContractShort: "Zu neuem Vertrag hinzufügen",
          splitButton: "Zu neuem Vertrage hinzufügen",
        },
      },
      split: {
        button: "Vertrag aufteilen",
        label: "Aufteilen",
        tooltip:
          "Nach der Aufteilung wird der zusätzliche Vertrag in Ihrer Vertragsübersicht mit angezeigt. Die Kosten des zusätzlichen Vertrags werden in den Gesamtkosten mit ausgewiesen.",
        modalTitle: "Vertrag aufteilen",
        description:
          "Wählen Sie die Buchungen, die aus „{{name}}“ entfernt und in einen neuen Vertrag verschoben werden sollen.",
        previewEmptyNote:
          "Wählen Sie oben mindestens eine Buchung aus, um einen neuen Vertrag anzulegen.",
        resultLabel: "Neuer Vertrag",
        transactionCount_one: "{{count}} Buchung",
        transactionCount_other: "{{count}} Buchungen",
        selectedSuffix: "{{count}} ausgewählt",
        deselectAll: "Auswahl zurücksetzen",
        deselectAllShort: "Zurücksetzen",
        confirmButton: "Neuen Vertrag anlegen",
        confirmModal: {
          modalTitle: "Neuen Vertrag anlegen?",
          text: "Diese Aktion kann nicht automatisch rückgängig gemacht werden.",
          confirmButton: "Ja",
          cancelButton: "Nein",
        },
      },
      merge: {
        tooltip:
          "Nach der Zusammenfassung wird der zweite Vertrag gelöscht und in Ihrer Vertragsübersicht nicht mehr angezeigt.",
        button: "Zusammenfassen",
        label: "Zusammenfassen",
        modalTitle: "Verträge zusammenfassen",
        description:
          "Sie können einen zweiten Vertrag mit diesem Vertrag  zusammenfassen. Die Daten des Mastervertrags bleiben bestehen. Die Beträge der beiden Verträge werden im Mastervertrag aufsummiert.",
        masterContract:
          "Mastervertrag (in den der zweite Vertrag eingelessen wird)",
        masterTag: "Mastervertrag",
        addSecondContract: "Zweiten Vertrag hinzufügen",
        secondContract: "Zweiter Vertrag",
        absorbedTag: "wird aufgenommen",
        removeSecondContract: "Zweiten Vertrag entfernen",
        resultLabel: "Ergebnis",
        confirmButton: "Verträge zusammenfassen",
        confirmModal: {
          modalTitle: "Verträge zusammenfassen?",
          text: "Sind Sie sicher, dass Sie diese Verträge zusammenfassen wollen? Leider ist es nicht möglich, sie automatisch wieder zu trennen.",
          confirmButton: "Ja",
          cancelButton: "Nein",
        },
      },
      selectContract: {
        modalTitle: "Vertrag suchen",
        searchPlaceholder: "Anbieter, Name, Typ, Betrag",
        showMore: "Mehr anzeigen",
        noDataForAccount: "Für dieses Konto sind keine Verträge verfügbar",
        columns: {
          name: "Vertragsname",
          type: "Typ",
          amount: "Kosten",
        },
      },
      showHide: {
        copy: "Aus Übersicht und Gesamtkosten ausschließen.",
        toggle: "Vertrag ausblenden",
        tooltip:
          "Wenn Sie den Vertrag ausblenden, wird dieser nicht mehr in Ihrer Vertragsübersicht angezeigt. Die Kosten des Vertrags werden nicht mehr in den Gesamtkosten mit ausgewiesen. Der Vertrag wird aber nicht gelöscht und kann jederzeit wieder eingeblendet werden",
      },
      internalTransfer: {
        copy: "Zahlungen zwischen Ihren eigenen Konten zählen nicht als Ausgaben.",
        toggle: "Als Kontentransfer markieren",
      },
    },
  },
  contractAdminPage: {
    title: "Provider Name",
    breadcrumb: "Provider Name",
    searchLabel: "Hier können Sie nach Provider Namen suchen",
    searchPlaceholder: "Name eingeben",
    table: {
      name: "Name",
      iban: "IBAN",
      category: "Katagorie",
      subCategory: "Sub-Kategorie",
      popularity: "Popularität",
      status: "Stand",
      date: "Date",
      done: "Done",
    },
    buttonText: "Done",
    tooltip: {
      userSuggestions: "User Vorschläge für Provider-Name",
      edit: "Bearbeiten",
    },
    noData: "Keine Klassifizierungsdaten verfügbar",
    modal: {
      title: "Diesen Eintrag auf erledigt setzen?",
      subtitle: "Diese Aktion kann nicht rückgängig gemacht werden.",
      cancelButton: "Nein",
      confirmButton: "Ja",
      success: "Eintrag erfolgreich erledigt.",
      error:
        "Etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal",
    },
  },
  settings: {
    changesSaved: "Änderungen gespeichert",
    errorOccurred: "Ein Fehler ist aufgetreten",
    sidebar: {
      title: "Einstellungen",
      common: {
        title: "Allgemein",
        profile: "Profil",
        notifications: "Benachrichtigungen",
        premium: "Premium Pakete",
        advanced: "Erweitert",
        currency: "Standardwährung",
        apiAccess: "API-Zugriff",
      },
      themeMode: {
        title: "Interface-Ansicht",
        dark: "Dark mode",
      },
      bankConnections: {
        title: "Bankverbindungen",
        addNewConnection: "Neue Verbindung hinzufügen",
        noAccountsTooltip:
          "Zu dieser Bankverbindung existieren bislang keine Konten oder Depots. Bevor die Bankverbindung erneut aufgebaut wird, bitte zuerst die bestehende Bankverbindung löschen. Damit werden potentielle Probleme beim Import von Konten oder Depots vermieden.",
      },
      twoFA: {
        title: "Sicherheitseinstellungen",
      },
      userId: {
        label: "USER ID",
        tooltip:
          "Das ist Deine UserID. Du benötigst diese ID z.B. bei Support-Anfragen oder zur Verbindung mit KICS.",
      },
      language: {
        title: "Sprache",
      },
    },
    currency: {
      title: "Standardwährung ändern",
      description:
        "Hier können Sie für Ihren Account die Standardwährung ändern. Bei jedem Nutzer ist automatisch die Standardwährung 'Euro' voreingestellt. Wenn Sie eine andere Währung (wie z.B. US-Dollar oder Britisches Pfund) einstellen möchten, selektieren Sie diese einfach aus dem Dropdown. Abschließend aktivieren Sie die neue Standardwährung durch einen Klick auf den Button 'Neue Standardwährung speichern'.",
      form: {
        label: "Währungen",
      },
      saveButton: "Neue Standardwährung speichern",
      saveSuccess: "Standardwährung erfolgreich gespeichert",
    },
    twoFA: {
      title: "Sicherheitseinstellungen",
      subtitle: "Zwei-Faktor-Authentifizierung",
      codeLabel: "Code eingeben",
      methods: {
        title: "Ihre 2FA-Methode",
        subtitle:
          "Die Zwei-Faktor-Authentifizierung generiert für jeden Anmeldevorgang einen individuellen, temporär gültigen Sicherheitscode. In der folgenden Übersicht werden Ihnen mögliche Apps vorgeschlagen.",
        googleAuth: "Google Authenticator",
        microsoftAuth: "Microsoft Authenticator",
        linkForAndroid: "Link für Android",
        linkForApple: "Link für Apple",
      },
      disabled: {
        description:
          "Schützen Sie Ihren Account, indem Sie die Zwei-Faktor-Authentifizierung (2FA) aktivieren. Zur Einrichtung wird eine sogenannte Authentifizierungs-App benötigt (Auswahl siehe unten).",
        toggle: "Zwei-Faktor-Authentifizierung aktivieren",
      },
      enabled: {
        description:
          "Ihr Account ist durch die Zwei-Faktor-Authentifizierung (2FA) geschützt.",
        description1:
          "Um die Zwei-Faktor-Authentifizierung zu deaktivieren, nutzen Sie den Umschalter und geben Sie den bereitgestellten Einmalcode ein.",
        toggle: "Zwei-Faktor-Authentifizierung deaktivieren",
      },
      setup: {
        step1: {
          title: "Schritt 1 - Sichern Sie Ihr Konto",
          subtitle:
            "Scannen Sie den untenstehenden QR-Code mit Ihrer bevorzugten Authenticator-App und geben Sie anschließend den bereitgestellten Einmalcode unten ein.",
        },
        step2: {
          title: "Schritt 2",
          subtitle: "Geben Sie den Zwei-Faktor-Verifizierungscode ein.",
        },
        confirmButton: "2FA aktivieren",
      },
      disable: {
        description: "Geben Sie den Zwei-Faktor-Verifizierungscode ein.",
        disableButton: "2FA deaktivieren",
      },
      messages: {
        error: "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
        qrLoadError:
          "QR-Code konnte nicht geladen werden. Bitte erneut versuchen.",
        invalidCodeError:
          "Ungültiger oder abgelaufener 2FA Code. Bitte versuchen Sie es erneut.",
        disableSuccess: {
          title: "Zwei-Faktor-Authentifizierung",
          text: "Die Zwei-Faktor-Authentifizierung Ihres Kontos wurde deaktiviert.",
        },
        enableSuccess: {
          title: "Zwei-Faktor-Authentifizierung",
          text: "Die Zwei-Faktor-Authentifizierung wurde aktiviert.",
        },
      },
    },
    apiAccess: {
      title: "API-Zugriff",
      subtitle:
        "Verwalte API-Tokens für den programmatischen Zugriff auf dein Vermögen. Jeder Token gilt nur für die ausgewählten Berechtigungen.",
      createButton: "Token erstellen",
      table: {
        id: "ID",
        name: "Name",
        permissions: "Berechtigungen",
        lastUsed: "Zuletzt verwendet",
        expires: "Läuft ab",
        createdAt: "Erstellt {{date}}",
        lastUsedToday: "heute, {{time}}",
        neverUsed: "Nie verwendet",
        noExpiry: "Kein Ablauf",
        expired: "Abgelaufen {{date}}",
        revokeAction: "Token widerrufen",
        footnote:
          "Widerrufene Tokens verlieren ihre Gültigkeit sofort. Der geheime Token-Wert wird nur einmal bei der Erstellung angezeigt.",
      },
      emptyState: {
        title: "Noch keine API-Tokens",
        text: "Erstelle einen Token, um deine Daten aus eigenen Anwendungen abzurufen.",
      },
      createModal: {
        title: "Neuen API-Token erstellen",
        subtitle:
          "Der Token erhält genau die Berechtigungen, die du hier auswählst.",
        nameLabel: "Name",
        namePlaceholder: "z. B. Portfolio Sync",
        nameHint: "Hilft dir, den Token später wiederzuerkennen.",
        unnamedToken: "Unbenannter Token",
        permissionsLabel: "Berechtigungen",
        selectAll: "Alle auswählen",
        deselectAll: "Keine auswählen",
        permissionsError: "Wähle mindestens eine Berechtigung aus.",
        permissions: {
          accountsRead: "Konten lesen",
          accountsWrite: "Konten ändern",
          investmentsRead: "Investitionen lesen",
          investmentsWrite: "Investitionen ändern",
          transactionsRead: "Transaktionen lesen",
          transactionsWrite: "Transaktionen ändern",
          profileRead: "Profil lesen",
          profileWrite: "Profil ändern",
        },
        validityLabel: "Gültigkeit",
        validity: {
          days30: "30 Tage",
          days60: "60 Tage",
          days90: "90 Tage",
          oneYear: "1 Jahr",
          never: "Kein Ablauf",
        },
        cancel: "Abbrechen",
        submit: "Token erstellen",
        error:
          "Der Token konnte nicht erstellt werden. Bitte versuche es später erneut.",
      },
      createdModal: {
        title: "Token erstellt",
        subtitle: "„{{name}}“ ist ab sofort aktiv.",
        warning:
          "Kopiere den Token jetzt — er wird aus Sicherheitsgründen nur dieses eine Mal angezeigt und lässt sich später nicht mehr abrufen.",
        tokenLabel: "Dein API-Token",
        done: "Fertig",
      },
      deleteModal: {
        title: "Token widerrufen?",
        text: "„{{name}}“ wird sofort ungültig. Anwendungen, die diesen Token verwenden, erhalten ab dann 401 Unauthorized.",
        cancel: "Abbrechen",
        confirm: "Widerrufen",
        error:
          "Der Token konnte nicht widerrufen werden. Bitte versuche es später erneut.",
      },
      snackbar: {
        revoked: "Token widerrufen",
      },
    },
    profile: {
      title: "Ihr Benutzerprofil",
      subtitle: "Passe deine Benutzerdaten an",
      avatar: {
        title: "Avatar / Benutzerbild",
        upload: "Avatar hochladen",
        replace: "Avatar ersetzen",
        delete: "Löschen",
        info: "Wir unterstützen PNGs, JPEGs mit einer Dateigröße unter 10MB.",
      },
      form: {
        gender: "Anrede",
        academicTitle: "Titel",
        genderOption: {
          male: "Herr",
          female: "Frau",
        },
        academicTitleOption: {
          none: "Kein Titel",
          dr: "Dr.",
          prof: "Prof.",
          profDr: "Prof. Dr.",
        },
        firstName: "Vorname",
        lastName: "Nachname",
        email: "Email Adresse",
        oldEmail: "Aktuelle Email Adresse",
        newEmail: "Neue Email Adresse",
        newEmail_placeholder: "Ihre neue Email Adresse",
        newEmailConfirmation: "Neue Email Adresse wiederholen",
        newEmailConfirmation_placeholder: "Ihre neue Email Adresse",
        oldPassword: "Aktuelles Passwort",
        forgotPassword: "Passwort vergessen",
        oldPassword_placeholder: "Bitte geben Sie Ihr aktuelles Passwort ein",
        newPassword: "Neues Passwort festlegen",
        newPassword_placeholder: "Bitte legen Sie ein Passwort fest...",
      },
      emailEditLink: "Email Adresse ändern",
      passwordEditLink: "Passwort ändern",
      emailEditModal: {
        title: "Email ändern",
        subtitle: "Geben Sie Ihre neue Email Adresse an",
        close: "Schließen",
        submit: "Emailadresse ändern",
        success:
          "Wir haben eine Bestätigungs-Email an <strongText>{{email}}</strongText> gesendet. Ihre alte Email-Adresse bleibt bis zur Bestätigung gültig.",
      },
      passwordEditModal: {
        title: "Password ändern",
        subtitle: "Geben Sie Ihre neue Passwort ein",
        close: "Abbrechen",
        submit: "Passwort ändern",
        success: "Ihr Passwort wurde erfolgreich geändert",
        forgotPassword: "Passwort vergessen",
        error: "Etwas ist schief gelaufen. Bitte versuche es erneut",
      },
      emailChangeSuccess: "Email Adresse geändert",
      emailChangeError:
        "Email Adresse konnte nicht geändert werden. Bitte kontaktieren Sie unseren Support.",
      saveSuccess: "Änderungen gespeichert",
    },
    notifications: {
      title: "Benachrichtigungen",
      subtitle: "Passe deine Benachrichtigungen an",
      banner: {
        title: "Alle Benachrichtigungen deaktiviert",
        subtitle: "Sie erhalten aktuell keine Benachrichtigungen",
      },
      form: {
        investmentReportFrequency: "Investment-Report",
        investmentReportFrequency_weekly: "Wöchentlich",
        investmentReportFrequency_monthly: "Monatlich",
        investmentReportFrequency_never: "Nie",
        emailNotification: "Automatische Benachrichtigung bei Depot-Updates",
        emailNotification_yes: "Ja",
        emailNotification_no: "Nein",
      },
      kpmgReport: {
        buttonText: "Report jetzt versenden",
        tooltip:
          "Mit diesem Button wird der Statusreport sofort an die hinterlegte Email-Adresse versendet. Dies kann zu Testzwecken beliebig oft geschehen. Der reguläre Versand (Wöchentlich/12 Tage/Monatlich) wird dadurch nicht beeinträchtigt.",
        success: "Der Report wurde erfolgreich versendet.",
        error:
          "Der Report konnte nicht versendet werden. Bitte versuchen Sie es erneut.",
      },
    },
    advanced: {
      title: "Erweitert",
      subtitle:
        "Passen Sie die erweiterten Funktionen an, die Ihren Account betreffen",
      bankImport: {
        title: "Bankimport Verbindungeinstellungen",
      },
      deleteConnection: {
        title: "Alle finAPI Bankverbindungsdaten löschen",
        text: "Löschen Sie Ihre gesamten, bei <linkText>finAPI</linkText> gespeicherten Daten. Bereits importierte Daten bleiben erhalten. Eine Synchronisierung Ihrer Depots und Konten ist danach nicht mehr möglich.",
        info: "Falls Sie lediglich einen gespeicherten Bank-Login löschen möchten, so tun Sie das bitte hier in der Kontoverwaltung",
        buttonText: "Bankdaten löschen",
        deleteConnectionConfirmModal: {
          title: "Sind Sie sich sicher?",
          text: "Wenn Sie Ihre Bankverbindung löschen, findet keine automatische Depot- und Kontenaktualisierung mehr statt.",
          cancel: "Abbrechen",
          confirm: "Verbindung löschen",
        },
      },
      tracking: {
        title: "Tracking",
        text: "Helfen Sie uns, {{appName}} durch Statistiken zu Websitenutzung und Benutzerverhalten zu verbessern. Die Daten werden ausschließlich zur Verbesserung unseres Web-Auftrittes verwendet.",
        buttonTextOff: "Zustimmung widerrufen",
        buttonTextOn: "Zustimmung geben",
      },
      deleteAccount: {
        title: "{{appName}} Account dauerhaft schließen",
        text: "Hiermit schließen Sie Ihren {{appName}} Account. Ihre Daten werden hierdurch unwiderruflich gelöscht. Ein Zugriff auf Ihren Account ist nach der Schließung nicht mehr möglich.",
        info: "Dieser Vorgang kann nicht rückgängig gemacht werden!",
        buttonText: "{{appName}} Account löschen",
        deleteAccountConfirmModal: {
          title: "Sind Sie sich sicher?",
          text: "Ihr Account wird geschlossen und alle Daten unwiderruflich gelöscht. Weiterer Zugriff ist dann nicht mehr möglich.",
          cancel: "Abbrechen",
          confirm: "Account löschen",
          success: "Ihr Account wurde erfolgreich gelöscht",
        },
      },
    },
    bankConnection: {
      subtitle: "Konten und Depots verwalten",
      accounts: {
        title: "Konten",
        menu: {
          deleteSavedPins: "Gespeicherte Pins löschen",
          deleteBankDetails: "Bankverbindung löschen",
        },
      },
      accountTypes: {
        1: "Girokonto",
        2: "Sparkonto",
        3: "Kreditkarte",
        4: "Depot",
        5: "Darlehenskonto",
        6: "Girokonto",
        7: "Mitgliedschaft",
        8: "Bausparen",
        21: "Verrechnungskonto",
        22: "Währungskonto",
        "01_depot": "Depot",
        "02_cash": "Girokonto",
      },
      deletePinsModal: {
        title: "Sind Sie sich sicher?",
        text: "Bei der nächsten Aktualisierung des Kontos / Wertpapier-Depots fragt {{appName}} Ihre neue Banking-PIN ab.",
        cancel: "Abbrechen",
        submit: "Pins löschen",
        error:
          "Etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal",
        success: "Pins wurden erfolgreich gelöscht",
      },
      deleteBankConnectionModal: {
        title: "Sind Sie sich sicher?",
        text: "Wenn Sie Ihre Bankverbindung löschen, findet keine automatische Depot- und Kontenaktualisierung mehr statt.",
        cancel: "Abbrechen",
        submit: "Verbindung löschen",
        error:
          "Etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal",
        success: "Die Verbindung wurde erfolgreich gelöscht",
      },
      interfaces: {
        title: "Schnittstellen",
        active: "Active",
        info: "{{appName}} ermöglicht den Zugang zu rund 3.500 Bankanbindungen. Die entsprechenden Schnittstellen (API) werden vor allem von unserem Partner finAPI zur Verfügung gestellt. Darüber hinaus hat {{appName}} einige Banken und Broker via Direkt-API selbst angebunden. Dies sind unter anderem comdirect, Trade Republic, Whitebox, Quirion und Scalabe.",
        actualized: "Aktualisiert",
      },
    },
  },
  components: {
    depotSelect: {
      label: "Depot oder Konten wählen",
      types: {
        "01_depot": "DEPOTS",
        "02_cash": "KONTEN",
      },

      modal: {
        title: "Neues Depot erstellen",
        name: "Depotname",
        name_placeholder: "Depotname",
        save: "Erstellen",
      },
    },
    bankSearchField: {
      label: "Bitte wählen Sie Ihre Bank aus",
      placeholder: "Name, ISIN oder WKN eingeben",
      useSlug: 'Suche nach "{{value}}"',
    },
    depotsStatistic: {
      showHistoricSwitch: "Historische anzeigen",
      tabs: {
        export: "Export CSV",
        exportShort: "Export",
        investments: "Investments",
        bookings: "Buchungen",
      },
      bookingsTable: {
        noItems: "Keine Buchungen",
        headers: {
          type: "Typ",
          name: "Name",
          price: "Kaufpreis",
          amount: "Wert (Gesamt)",
        },
        lots: "St.",
        mobile: {
          count_one: "{{count}} Buchung",
          count_other: "{{count}} Buchungen",
          typeFilter: {
            label: "Transaktionsart",
            all: "Alle Transaktionsarten",
            selected: "{{count}} Transaktionsarten",
          },
          sort: {
            valueDate: "Datum",
            amount: "Betrag",
            newest: "Neueste zuerst",
            oldest: "Älteste zuerst",
          },
          loadingMore: "Weitere Buchungen werden geladen…",
          allLoaded: "Alle Buchungen geladen",
          loadMoreFailed: "Weitere Buchungen konnten nicht geladen werden.",
          retry: "Erneut versuchen",
        },
      },
      chart: {
        today: "heute",
        subheader: {
          performance: "Gesamtwert:",
          valuation: "Einstandswert:",
        },
        typeSwitcher: {
          performance: "Performance",
          valuation: "Wertentwicklung",
        },
      },
    },
    watchlistsCreateAndEditForm: {
      form: {
        nameInputLabel: "Neue Watchlist",
        saveButton: "Speichern",
      },
    },
    AssetTypeCard: {
      ytd: "YTD",
    },
    quotes: {
      quoteChartContainer: {
        subheader: "Aktueller Wert",
      },
    },
    layouts: {
      showcaseLayout: {
        imageAlt: "{{appName}} Firmenzeichen",
      },
    },
  },
  aboutCompany: {
    support: {
      phone: "(0) 30 - 71 53 30 10",
      phoneLink: "+03071533010",
      phoneInfo: "Mo. bis Fr. 9-19 Uhr erreichbar",
      email: "{{supportEmail}}",
    },
    company: {
      name: "{{appName}}, eine Marke der wealthAPI GmbH",
      street: "Fanny-Zobel-Str.",
      streetNumber: "9",
      zip: "12435",
      city: "Berlin",
      claim: "Das kostenfreie Tool für Ihren Finanzerfolg",
    },
    brand: {
      name: "{{appName}}",
    },
    media: {
      email: "presse@rentablo.de",
      b2bEmail: "presse@wealthapi.eu",
    },
    b2b: {
      name: "wealthAPI GmbH",
      claim: "Smart Financial Decisions",
      email: "info@wealthapi.eu",
      privacyEmail: "datenschutz@wealthapi.eu",
      website: "https://wealthapi.eu",
    },
  },
  docs: {
    agb: {
      title: "AGBs",
    },
    disclaimer: {
      title: "Haftungsausschluss",
    },
    impressum: {
      title: "Impressum",
    },
    privacy: {
      title: "Datenschutz",
    },
  },
  feedbackGlobalButton: {
    tooltip: "Feedback",
    emailSubject: "Feedback an das {{teamName}} Team",
  },
  customerSupport: {
    tooltip: "Problem melden",
    title: "Problem melden",
    subtitle:
      "Bitte füllen Sie das untenstehende Formular aus. Wir werden Ihre Anfrage schnellstmöglich bearbeiten.",
    userId: {
      label: "User ID:",
    },
    bank: {
      label: "Bank",
    },
    isin: {
      label: "ISIN",
    },
    stepsToReproduce: {
      label: "Schritte zur Reproduktion",
      required: "Bitte beschreiben Sie das Problem.",
    },
    errorCodeOrUrl: {
      label: "Fehlercode / URL",
    },
    attachments: {
      label: "Anhang - Screenshot, Video",
      hint: "Bitte ziehen Sie den Screenshot oder das Video hierher.",
      remove: "Anhang entfernen",
      limits: "Bis zu {{max}} Dateien, je 10 MB. Bilder, Videos oder PDF.",
      full: "Die maximale Anzahl von {{max}} Dateien ist erreicht.",
      ready: "Bereit",
      rejected:
        "Erlaubt sind bis zu {{max}} Dateien (Bild, Video oder PDF) mit je maximal 10 MB.",
      readError:
        "Die Anhänge konnten nicht gelesen werden. Bitte versuchen Sie es erneut.",
    },
    cancel: "Zurück",
    submit: "Absenden",
    success: "Vielen Dank! Ihre Anfrage wurde übermittelt.",
    error:
      "Ihre Anfrage konnte nicht übermittelt werden. Bitte versuchen Sie es später erneut.",
  },
  navigation: {
    cancel: "Abbrechen",
    previous: "Zurück",
    next: "Weiter",
    save: "Speichern",
    deleteModal: {
      errorTitle: "Fehler",
      confirmTitle: "Wirklich löschen?",
      yes: "Ja",
      no: "Nein",
      close: "Schließen",
      cannotBeUndone: "Diese Aktion kann nicht rückgängig gemacht werden.",
    },
  },
  somethingWrong: {
    loginFailed: "Login fehlgeschlagen, bitte prüfen Sie Email und Passwort",
    shortTitle: "Es ist ein Fehler aufgetreten.",
    subTitle:
      "Bitte versuchen Sie es nochmals. Kontaktieren Sie unseren Support unter {{supportEmail}}, sollte dieses Problem mehrfach auftreten.",
    title:
      "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmals. Kontaktieren Sie unseren Support unter {{supportEmail}}, sollte dieses Problem mehrfach auftreten.",
    message: "{{message}}.",
    eventIdMessage: "Die Fehler-ID ist: {{eventId}}",
    reload: "Seite neu laden",
  },
  company: {
    name: "Rentablo GmbH",
    customerService: "Kundenservice",
    street: "Fanny-Zobel-Straße 9",
    zip: "12435",
    city: "Berlin",
  },
  cashback: {
    "50": "Cashback-50",
    "100": "Cashback-100",
    "50upTo": "bis ca. 75.000 €",
    "100from": "ab ca. 75.000 €",
  },
  terms: {
    agb: "Nutzungsbedingungen",
    impressum: "Impressum",
  },
  ranges: {
    years: {
      oneYear: "1 Jahr",
      threeYears: "3 Jahre",
      fiveYears: "5 Jahre",
      tenYears: "10 Jahre",
    },
    max: "Max",
  },
  accountTypes: {
    "01_depot": "Depot",
    "02_cash": "Konten & Kreditkarte",
    "04_insurance": "Versicherungen",
    "05_material_assets": "Edelmetalle & Sachwerte",
    "06_crypto": "Crypto",
    "07_real_estate": "Immobilien",
    bankSelect: {
      label: "Bank Name, BIC oder IBAN",
      noOptions: "Keine Optionen",
      bankName: "Bank name",
      bic: "BIC",
    },
  },
  bookingTypes: {
    buy: "Kauf",
    sell: "Verkauf",
    dividend: "Dividende",
    book_in: "Einbuchung",
    book_out: "Ausbuchung",
    split: "Split",
    reverse_split: "Reverse Split",
    retained_dividend: "Thes. Dividende",
    purchase_right: "Bezugsrecht",
    pre_tax_allowance: "Vorabpauschale",
    carve_out: "Carve Out",
    switch: "Switch",
    cap_gains_tax: "KESt",
    cap_gains_tax_refund: "KESt-Rückerstattung",
    fees: "Gebühren",
  },
  investmentTypes: {
    "11_stock": "Aktie",
    "21_fund": "Fonds",
    "22_etf": "ETF",
    "31_bond": "Anleihe",
    "41_cash": "Cash",
    "51_certos": "Zertifikat / OS",
    "52_future": "Future",
    "61_pmetals": "Edelmetall",
    "71_massets": "Sachwert / Immobilie",
    "81_fcurr": "Fremdwährung",
    "82_crypto": "Kryptowährung",
    "91_managed": "Robo / Vermögensverwaltung",
    "92_other": "Sonstiges",
  },
  quantities: {
    pieces: "Stück",
    percent: "Prozent",
  },
  signupWizard: {
    restoreWizardDialog: {
      title:
        "Es liegt eine nicht abgeschlossene Buchung vor. Möchten Sie diese vervollständigen oder abbrechen?",
      contentText: "Es kann nur eine unvollständige Buchung vorliegen.",
      continueButton: "Vervollständigen",
      startNewButton: "Abbrechen und neu starten",
    },
    validation: {
      isNotEmpty: "wird benötigt",
      isNotEmptyArray: "wird benötigt",
      isPhoneNumber: "Ist keine gültige Telefonnummer",
      isPassword: "Das Passwort muss mindestens 8 Zeichen haben",
      isAgbAccepted: "Sie müssen unsere AGB akzeptieren",
      isEmail: "Die Email-Adresse ist ungültig",
      isPayoutBank: "Die angegebene IBAN ist nicht korrekt",
      isComdirectCustomerNumber: "muss aus 10 Zahlen bestehen (0-9)",
      isEbaseDepotNumber: "muss aus 10 oder 11 Zahlen bestehen (0-9)",
      isDabAccountNumber: "muss aus 7 Zahlen bestehen (0-9)",
      isAugsburgerAktienbankDepotNumber: "Muss aus 10 Zahlen bestehen (0-9)",
      isDwsDepotNumber: "ein Buchstabe, gefolgt von 7 Zahlen",
      isFfbDepotNumber: "muss aus 10 Zahlen bestehen (0-9)",
      isFondsdepotDepotNumber: "muss aus 10 Zahlen bestehen (0-9)",
      isMetzlerDepotNumber: "muss aus 10 Zahlen bestehen (0-9)",
      isStreetWithNumber: "wird benötigt",
    },
    cashbackProcessIntroduction: {
      heading: "In wenigen Schritten zu Ihrem Cashback:",
      enterData: "Daten eingeben",
      print: "Ausdrucken",
      sendToUs: "An uns senden",
      youRequire:
        "Sie benötigen ca. <1>5 Minuten</1>. Falls Sie bereits Kunde einer {{appName}} Partnerbank sind, halten Sie bitte Ihre Depot- bzw. Kundennummer bereit.",
      startNow: "Jetzt starten",
      thatIsHowWeCalculateCashback: "So berechnen wir Ihr Cashback",
      depotSize: "Depotvolumen",
      bestPriceGuarantee:
        "<0>Bestpreis-Garantie:</0> wir wählen bei jeder Abrechnung das für Sie beste Cashback-Modell",
      onceForAllYourDepots: "unabhängig von der Anzahl Ihrer Depots",
      discountOnAgio: "Rabatt Ausgabeaufschlag",
      cost: "Sie zahlen",
      noCost: "Nichts",
      youReceive: "Ihr Cashback",
      "50percentCashback": "50 % der Bestandsprovision (max. 15 €)",
      "100percentCashback": "100 % der Bestandsprovision",
      administrationFee: "15 € / Monat",
      administrationFeeDetails: "(mit Cashback verrechnet)",
      rentabloReceives: "{{appName}} erhält",
      moreAssetsMoreCashback: "Erhalten Sie bis zu 100% Cashback",
      seeIllustration: "Siehe interaktiver Chart",
    },
    cashbackSummary: {
      heading: "PDF jetzt ausdrucken",
      printOutNote:
        "Ihr Cashback Antrag wurde erstellt und liegt zum Download bereit.",
      printedOutQuestion: "Ausgedruckt?",
      foundAMistake: "Sie haben einen Fehler gefunden",
      correctDataButton: "Daten bearbeiten",
      print: "Hier drucken",
      printPdf: "Antrag ausdrucken",
      nextStepsButton: "Nächste Schritte",
      wouldYouLikeToCorrectYourData: "Möchten Sie Ihre Daten korrigieren?",
    },
    cashbackNextSteps: {
      heading: "Super, fast fertig!",
      reviewForms: "Bitte prüfen Sie den generierten Antrag.",
      printOutAndSign:
        "Bitte <1>unterschreiben Sie die ausgedruckten Dokumente</1> und senden Sie diese an uns zurück!",
      sendBack: "Dokumente zurücksenden",
      sendBackDescription: "Ein Rücksende-Formular liegt bei.",
      identifyViaPostident: "und <1>Identifikation über PostIdent</1>",
      identifyViaPostidentDescription:
        "Bitte identifizieren Sie sich mit dem beiliegenden PostIdent Formular bei der Post.",
      identifyViaRentablo:
        "und <1>legen Sie eine Kopie Ihres Personalausweises / Reisepass bei</1>",
      identifyViaRentabloDescription:
        "Wir legitimieren Sie im Zuge der Depoteröffnung. Unsere Mitarbeiter kontaktieren Sie nach Erhalt der Dokumente.",
      birthCertificate: "legen Sie eine <1>Geburtsurkunde</1> bei",
      birthCertificateDescription:
        "Bitte fügen Sie eine Kopie der Geburtsurkunde des Minderjährigen bei. Diese wird von der Bank im Rahmen der Kontoeröffnung benötigt.",
      allDone: "Fertig!",
      backButton: "Zurück zur Buchung",
      addAnotherDepot: "Ein weiteres Depot hinzufügen",
      altExit: "oder",
      backToMainPage: "Weiter zur Übersicht",
    },
    cashbackNextStepsForCompany: {
      heading: "Super, so geht es jetzt weiter...",
      dataReceived: "Wir haben Ihre Anfrage zur Depoteröffnung erhalten",
      weWillContactYou: "Wir werden uns in Kürze bei Ihnen melden",
      weWillContactYouDescription:
        "Leider ergeben sich bei der Eröffnung von Firmendepots häufige Änderungen in den Abläufen der jeweiligen Bank. Einer unserer Mitarbeiter wird Sie daher in Kürze mit Details zur Depoteröffnung kontaktieren.",
      contactUs:
        "Sollten Sie innerhalb des nächsten Arbeitstages keine Rückmeldung von uns erhalten haben, so senden Sie uns gerne eine Email an <1>{{supportEmail}}</1> oder rufen Sie uns einfach unter der <1>030 - 71533009</1> an.",
    },
    selectNewOrExistingDepotStep: {
      naturalPerson: "Privatkunden",
      legalPerson:
        "Juristische Personen (UGs, GmbHs, AGs, Stiftungen, Vereine)",
      newDepot: "Neues Depot eröffnen",
      newCompanyDepot: "Neues Firmen-Depot eröffnen",
      existingDepot: "Ich führe bereits ein Depot",
      existingCompanyDepot: "Meine Firma führt bereits ein Depot",
      question: "Bitte wählen Sie:",
    },
    companyDepotTermsStep: {
      question: "Hinweis: Bedingungen für Firmendepots",
      terms:
        "Firmendepots unterscheiden sich in Größe und Betreuungsaufwand erheblich von Privatkunden-Depots. Aus diesem Grund beträgt Ihr Cashback <1>pauschal 80 %</1> der an {{appName}} ausgekehrten Bestandsprovisionen, ab dem ersten Euro.",
      oneClick:
        "Darüber hinaus steht Ihnen kostenfrei der {{appName}} One-Click Import zur einfachen Verwaltung Ihres Firmendepots zur Verfügung.",
    },
    selectBankStep: {
      question: "Bei welcher Bank möchten Sie Ihr Cashback-Depot eröffnen?",
      onvistaQuestion:
        "Bei welcher Partnerbank möchten Sie Ihr onvista-Cashback Depot eröffnen?",
      recommendedBankHeading:
        "Aufgrund des hervorragenden Service empfehlen wir die comdirect",
    },
    selectRecommendedBankStep: {
      question: "Bei welcher Bank möchten Sie Ihr Cashback-Depot eröffnen?",
      recommendedBankHeading:
        "Aufgrund des hervorragenden Service empfehlen wir die comdirect",
    },
    selectExistingDepotStep: {
      question:
        "Bei welcher der {{appName}} Partnerbanken führen Sie Ihr Depot?",
      noDepotYet: "Noch kein Depot bei einer {{appName}} Partnerbank?",
      openDepot: "Jetzt eröffnen.",
    },
    emailStep: {
      question: "Was ist Ihre Email-Adresse?",
      placeholder: "Email-Adresse",
    },
    passwordStep: {
      question: "Bitte legen Sie ein sicheres Passwort fest",
      placeholder: "Passwort (min. 8 Zeichen)",
    },
    acceptTermsAndConditionsStep: {
      question: "Bitte bestätigen Sie unsere AGB",
      agb: "Mit der Registrierung akzeptiere ich die <1>Allgemeinen Geschäftsbedingungen</1> und die <3>Datenschutzbestimmungen</3>*",
      newsLetters:
        "Ich möchte über neue Funktionen und Sparangebote informiert werden",
      accountCreationFailed:
        "Entschuldigung, aber wir konnten das Benutzerkonto nicht erstellen:",
      pleaseLogin:
        "Fall Sie diese Email-Adresse zuvor verwendet haben, so <1>Loggen Sie sich bitte ein</1>",
    },
    selectAccountHolderTypeStep: {
      questionNewDepot: "Welche Art von Depot möchten Sie eröffnen?",
      questionAdvisorChange: "Um welche Art von Depot handelt es sich?",
      single: "Einzel-Depot",
      joined: "Gemeinschafts-Depot",
      minor: "Minderjährigen-Depot",
    },
    // Natural person
    summaryStep: {
      takeoverData: "Ja, Daten übernehmen",
      editData: "Nein, Daten bearbeiten",
    },
    personalInformationSummaryStep: {
      question: "Sind Ihre persönlichen Daten korrekt?",
      questionPartner: "Sind die persönlichen Daten Ihres Partners korrekt?",
      questionMinor: "Sind die persönlichen Daten des Minderjährigen korrekt?",
      questionLegalGuardian1:
        "Sind die persönlichen Daten des ersten Erziehungsberechtigten korrekt?",
      questionLegalGuardian2:
        "Sind die persönlichen Daten des zweiten Erziehungsberechtigten korrekt?",
      questionCompany: "Sind die Daten der Firma korrekt?",
      gender: "Geschlecht",
      firstName: "Vorname",
      lastName: "Nachname",
      nameAtBirth: "Geburtsname",
      dateOfBirth: "Geburtsdatum",
      placeOfBirth: "Geburtsort",
      countryOfBirth: "Geburtsland",
      street: "Straße",
      houseNumber: "Hausnummer",
      zip: "Postleitzahl",
      city: "Stadt",
      addressCountry: "Land",
    },
    companyInformationSummaryStep: {
      question: "Sind die Firmendaten korrekt?",
      salutation: "Anrede",
      companyName: "Firmenname",
      legalForm: "Rechtsform",
      street: "Straße",
      houseNumber: "Hausnummer",
      zip: "Postleitzahl",
      city: "Stadt",
      addressCountry: "Land",
    },
    payoutSummaryStep: {
      question: "Ist dieses Cashback-Auszahlungskonto korrekt?",
      bankNameWithBic: "Bank",
      iban: "IBAN",
      payoutAccountFirstName: "Vorname Inhaber",
      payoutAccountLastName: "Nachname Inhaber",
    },
    mifidSummaryStep: {
      question: "Sind Ihre MIFID Daten korrekt?",
      questionPartner: "Sind die MIFID Daten Ihres Partners korrekt?",
      questionMinor: "Sind die MIFID Daten des Minderjährigen korrekt?",
      questionLegalGuardian1:
        "Sind die MIFID Daten des ersten Erziehungsberechtigten korrekt?",
      questionLegalGuardian2:
        "Sind die MIFID Daten des zweiten Erziehungsberechtigten korrekt?",
      mifidOccupationGroup: "Berufsgruppe",
      mifidOccupation: "Beruf",
      mifidSector: "Branche",
      mifidCountryOfWork: "Tätigkeits-Land",
      mifidAccessToInsiderInfo: "Zugang zu Insider Informationen",
      yes: "Ja",
      no: "Nein",
      mifidAnnualIncome: "Jährliches Einkommen",
      mifidLiquidAssets: "Liquides Vermögen",
    },
    investmentExperienceSummaryStep: {
      question: "Sind die Angaben zur Investment-Erfahrung korrekt?",
      "0": "keine Angabe",
      "1": "weniger als ein Jahr",
      "2": "mehr als ein Jahr",
      "3": "mehr als zwei Jahre",
      experienceCertificatesAndOptionsWithLeverage:
        "Optionsscheine und Zertifikate mit Hebelwirkung",
      experienceCertificatesAndOptionsWithoutLeverage:
        "Zertifikate ohne Hebelwirkung",
      experienceDomesticBonds:
        "Festverzinsliche Wertpapiere inländischer Emittenten",
      experienceDomesticStocks: "Aktien inländischer Gesellschaften",
      experienceForeignCurrency: "Devisengeschäften (nicht auf Termin)",
      experienceForeignStocks: "Aktien ausländischer Gesellschaften",
      experienceFunds: "Investmentfonds (Anlagegesellschaft außerhalb der EU)",
      experienceOther:
        "Sonstige Termingeschäfte, Geschäften mit herausgeschobenem Erfüllungszeitpunkt und / oder Hebelwirkung",
      experienceForeignBonds:
        "Festverzinsliche Wertpapieren ausländischer Emittenten oder in Fremdwährung",
    },
    taxationSummaryStep: {
      question: "Sind Ihre steuerlichen Daten korrekt?",
      questionPartner: "Sind die steuerlichen Daten Ihres Partners korrekt?",
      questionMinor: "Sind die steuerlichen Daten des Minderjährigen korrekt?",
      questionLegalGuardian1:
        "Sind die steuerlichen Daten des ersten Erziehungsberechtigten korrekt?",
      questionLegalGuardian2:
        "Sind die steuerlichen Daten des zweiten Erziehungsberechtigten korrekt?",
      taxationCountry1: "Steuerlicher Wohnsitz",
      taxationNumber1: "Steuernummer",
      taxationCountry2: "Zusätzlicher steuerlicher Wohnsitz",
      taxationNumber2: "Zusätzliche Steuernummer",
      taxationCountry3: "Steuerlicher Wohnsitz",
      taxationNumber3: "Zusätzliche Steuernummer",
      taxationUsTaxLiability: "US-Steuerpflicht",
      taxationUsTaxNumber: "US Steuernummer",
      yes: "Ja",
      no: "Nein",
    },
    selectGenderStep: {
      question: "Sind sie...",
      questionPartner: "Ist Ihr Partner...",
      questionMinor: "Ist der Minderjährige...",
      questionLegalGuardian1: "Ist der erste Erziehungsberechtigte...",
      questionLegalGuardian2: "Ist der zweite Erziehungsberechtigte...",
      questionCompany: "Ihre Anrede...",
      male: "Männlich",
      female: "Weiblich",
      salutation: "Anrede",
    },
    hasSecondLegalGuardianStep: {
      question: "Gibt es einen zweiten Erziehungsberechtigten?",
      single: "Alleinerziehend",
      joined: "Zweiten Erziehungsberechtigten angeben",
    },
    firstNameStep: {
      question: "Ihr Vorname",
      questionPartner: "Vorname Partner",
      questionMinor: "Vorname des Minderjährigen",
      questionLegalGuardian1: "Vorname erster Erziehungsberechtigter",
      questionLegalGuardian2: "Vorname zweiter Erziehungsberechtigter",
      questionCompany: "Name der Firma",
      placeholder: "Vorname",
      companyPlaceholder: "Firmenname",
    },
    lastNameStep: {
      question: "Ihr Nachname",
      questionPartner: "Nachname Partner",
      questionMinor: "Nachname des Minderjährigen",
      questionLegalGuardian1: "Nachname erster Erziehungsberechtigter",
      questionLegalGuardian2: "Nachname zweiter Erziehungsberechtigter",
      questionCompany: "Rechtsform (GmbH / UG, ...)",
      placeholder: "Nachname",
      companyPlaceholder: "Rechtsform",
    },
    countryOfBirthStep: {
      question: "Ihr Geburtsland",
      questionPartner: "Geburtsland Partner",
      questionMinor: "Geburtsland des Minderjährigen",
      questionLegalGuardian1: "Geburtsland erster Erziehungsberechtigter",
      questionLegalGuardian2: "Geburtsland zweiter Erziehungsberechtigter",
      placeholder: "Bitte Land wählen",
    },
    placeOfBirthStep: {
      question: "Ihr Geburtsort",
      questionPartner: "Geburtsort Partner",
      questionMinor: "Geburtsort des Minderjährigen",
      questionLegalGuardian1: "Geburtsort erster Erziehungsberechtigter",
      questionLegalGuardian2: "Geburtsort zweiter Erziehungsberechtigter",
      placeholder: "Geburtsort",
    },
    nameAtBirthStep: {
      question: "Was ist Ihr Geburtsname?",
      questionPartner: "Was ist der Geburtsname Ihres Partners?",
      questionMinor: "Was ist der Geburtsname des Minderjährigen?",
      questionLegalGuardian1: "Geburtsname des ersten Erziehungsberechtigten",
      questionLegalGuardian2: "Geburtsname des zweiten Erziehungsberechtigten",
      placeholder: "Geburtsname",
    },
    dateOfBirthStep: {
      question: "Ihr Geburtsdatum",
      questionPartner: "Geburtsdatum Ihres Partners",
      questionMinor: "Geburtsdatum des Minderjährigen",
      questionLegalGuardian1: "Geburtsdatum des ersten Erziehungsberechtigten",
      questionLegalGuardian2: "Geburtsdatum des zweiten Erziehungsberechtigten",
      placeholder: "Geburtsdatum",
      label: "Geburtsdatum",
    },
    addressStep: {
      question: "Ihre Adresse: Straße",
      questionPartner: "Adresse Ihres Partners: Straße",
      questionMinor: "Adresse des Minderjährigen: Straße",
      questionLegalGuardian1: "Adresse erster Erziehungsberechtigter: Straße",
      questionLegalGuardian2: "Adresse zweiter Erziehungsberechtigter: Straße",
      questionCompany: "Firmenadresse: Straße",
      placeholder: "Straße",
      placeholderHouseNumber: "Hausnummer",
    },
    houseNumberStep: {
      placeholder: "Hausnummer",
    },
    zipStep: {
      question: "Ihre Adresse: Postleitzahl",
      questionPartner: "Adresse Ihres Partners: Postleitzahl",
      questionMinor: "Adresse des Minderjährigen: Postleitzahl",
      questionLegalGuardian1:
        "Adresse erster Erziehungsberechtigter: Postleitzahl",
      questionLegalGuardian2:
        "Adresse zweiter Erziehungsberechtigter: Postleitzahl",
      questionCompany: "Firmensitz: Postleitzahl",
      placeholder: "Postleitzahl",
    },
    cityStep: {
      question: "Ihre Adresse: Wohnort",
      questionPartner: "Adresse Ihres Partners: Wohnort",
      questionMinor: "Adresse des Minderjährigen: Wohnort",
      questionLegalGuardian1: "Adresse erster Erziehungsberechtigter: Wohnort",
      questionLegalGuardian2: "Adresse zweiter Erziehungsberechtigter: Wohnort",
      questionCompany: "Firmensitz: Ort",
      placeholder: "Wohnort",
    },
    addressCountryStep: {
      question: "Ihre Adresse: Land",
      questionPartner: "Adresse Ihres Partners: Land",
      questionMinor: "Adresse des Minderjährigen: Land",
      questionLegalGuardian1: "Adresse erster Erziehungsberechtigter: Land",
      questionLegalGuardian2: "Adresse zweiter Erziehungsberechtigter: Land",
      questionCompany: "Firmensitz: Land",
      placeholder: "Land",
    },
    occupationalGroupStep: {
      question: "In welcher Berufsgruppe sind Sie tätig",
      questionPartner: "In welcher Berufsgruppe ist Ihr Partner tätig?",
      questionMinor: "In welcher Berufsgruppe ist der Minderjährige tätig?",
      questionLegalGuardian1:
        "In welcher Berufsgruppe ist der erste Erziehungsberechtigte tätig?",
      questionLegalGuardian2:
        "In welcher Berufsgruppe ist der zweite Erziehungsberechtigte tätig?",
      placeholder: "Berufsgruppe",
    },
    occupationStep: {
      question: "Welchen Beruf üben Sie aus",
      questionPartner: "Welchen Beruf übt Ihr Partner aus?",
      questionMinor: "Welchen Beruf übt der Minderjährige aus?",
      questionLegalGuardian1:
        "Welchen Beruf übt der erste Erziehungsberechtigte aus?",
      questionLegalGuardian2:
        "Welchen Beruf übt der zweite Erziehungsberechtigte aus?",
      placeholder: "Beruf",
    },
    sectorStep: {
      question: "In welcher Branche sind Sie tätig",
      questionPartner: "In welcher Branche ist Ihr Partner tätig?",
      questionMinor: "In welcher Branche ist der Minderjährige tätig?",
      questionLegalGuardian1:
        "In welcher Branche ist der erste Erziehungsberechtigte tätig?",
      questionLegalGuardian2:
        "In welcher Branche ist der zweite Erziehungsberechtigte tätig?",
      placeholder: "Branche",
    },
    countryOfWorkStep: {
      question: "In welchem Land arbeiten Sie?",
      questionPartner: "In welchem Land arbeitet Ihr Partner?",
      questionMinor: "In welchem Land arbeitet der Minderjährige?",
      questionLegalGuardian1:
        "In welchem Land arbeitet der erste Erziehungsberechtigte?",
      questionLegalGuardian2:
        "In welchem Land arbeitet der zweite Erziehungsberechtigte?",
      placeholder: "Land wählen",
    },
    accessToInsiderInfoStep: {
      question: "Haben Sie Zugang zu Insider-Informationen?",
      questionPartner: "Hat Ihr Partner Zugang zu Insider-Informationen?",
      questionMinor: "Hat der Minderjährige Zugang zu Insider-Informationen?",
      questionLegalGuardian1:
        "Hat der erste Erziehungsberechtigte Zugang zu Insider-Informationen?",
      questionLegalGuardian2:
        "Hat der zweite Erziehungsberechtigte Zugang zu Insider-Informationen?",
      yes: "Ja",
      no: "Nein",
    },
    annualIncomeStep: {
      question: "Jährliches Einkommen (Optional)",
      questionPartner: "Jährliches Einkommen Partner (Optional)",
      questionMinor: "Jährliches Einkommen des Minderjährigen (Optional)",
      questionLegalGuardian1:
        "Jährliches Einkommen erster Erziehungsberechtigter (Optional)",
      questionLegalGuardian2:
        "Jährliches Einkommen zweiter Erziehungsberechtigter (Optional)",
      placeholder: "Jährliches Einkommen",
    },
    liquidAssetsStep: {
      question: "Liquides Vermögen (Optional)",
      questionPartner: "Liquides Vermögen Partner (Optional)",
      questionMinor: "Liquides Vermögen des Minderjährigen (Optional)",
      questionLegalGuardian1:
        "Liquides Vermögen erster Erziehungsberechtigter (Optional)",
      questionLegalGuardian2:
        "Liquides Vermögen zweiter Erziehungsberechtigter (Optional)",
      placeholder: "Liquides Vermögen",
    },
    countryOfNationalityStep: {
      questionPrimary: "Ihre Staatsangehörigkeit",
      questionSecondary: "Weitere Staatsangehörigkeit",
      questionPartnerPrimary: "Staatsangehörigkeit Partner",
      questionPartnerSecondary: "Weitere Staatsangehörigkeit Partner",
      questionMinorPrimary: "Staatsangehörigkeit des Minderjährigen",
      questionMinorSecondary: "Weitere Staatsangehörigkeit des Minderjährigen",
      questionLegalGuardian1Primary:
        "Staatsangehörigkeit erster Erziehungsberechtigter",
      questionLegalGuardian1Secondary:
        "Weitere Staatsangehörigkeit erster Erziehungsberechtigter",
      questionLegalGuardian2Primary:
        "Staatsangehörigkeit zweiter Erziehungsberechtigter",
      questionLegalGuardian2Secondary:
        "Weitere Staatsangehörigkeit zweiter Erziehungsberechtigter",
      placeholder: "Land wählen",
    },
    anotherNationalityStep: {
      question: "Sind Sie Inhaber einer weiteren Staatsangehörigkeit?",
      questionPartner:
        "Ist Ihr Partner Inhaber einer weiteren Staatsangehörigkeit?",
      questionMinor:
        "Ist der Minderjährige Inhaber einer weiteren Staatsangehörigkeit?",
      questionLegalGuardian1:
        "Ist der erste Erziehungsberechtigte Inhaber einer weiteren Staatsangehörigkeit?",
      questionLegalGuardian2:
        "Ist der zweite Erziehungsberechtigte Inhaber einer weiteren Staatsangehörigkeit?",
      yes: "Ja",
      no: "Nein",
    },
    npNationalIdentifierStep: {
      questionPrimary: "Ihre nationale Kennung",
      questionSecondary: "Ihre nationale Kennung (zweite Staatsangehörigkeit)",
      questionPartnerPrimary: "Nationale Kennung Partner",
      questionPartnerSecondary:
        "Nationale Kennung Partner (zweite Staatsangehörigkeit)",
      questionMinorPrimary: "Nationale Kennung Minderjähriger",
      questionMinorSecondary:
        "Nationale Kennung Minderjähriger (zweite Staatsangehörigkeit)",
      questionLegalGuardian1Primary:
        "Nationale Kennung erster Erziehungsberechtigter",
      questionLegalGuardian1Secondary:
        "Nationale Kennung erster Erziehungsberechtigter (zweite Staatsangehörigkeit)",
      questionLegalGuardian2Primary:
        "Nationale Kennung zweiter Erziehungsberechtigter",
      questionLegalGuardian2Secondary:
        "Nationale Kennung zweiter Erziehungsberechtigter (zweite Staatsangehörigkeit)",
      placeholder: "Nationale Kennung",
    },
    countryOfTaxationStep: {
      question: "Ihr steuerlicher Wohnsitz",
      questionPartner: "Steuerlicher Wohnsitz Partner",
      questionMinor: "Steuerlicher Wohnsitz Minderjähriger",
      questionLegalGuardian1:
        "Steuerlicher Wohnsitz erster Erziehungsberechtigter",
      questionLegalGuardian2:
        "Steuerlicher Wohnsitz zweiter Erziehungsberechtigter",
      placeholder: "Land wählen",
    },
    taxNumberStep: {
      question: "Ihre Steuernummer",
      questionPartner: "Steuernummer Partner",
      questionMinor: "Steuernummer des Minderjährigen",
      questionLegalGuardian1: "Steuernummer erster Erziehungsberechtigter",
      questionLegalGuardian2: "Steuernummer zweiter Erziehungsberechtigter",
      placeholder: "Steuernummer",
    },
    usTaxLiabilityStep: {
      question: "Unterliegen Sie der US Steuerpflicht?",
      questionPartner: "Unterliegt Ihr Partner der US Steuerpflicht?",
      questionMinor: "Unterliegt der Minderjährige der US Steuerpflicht?",
      questionLegalGuardian1:
        "Unterliegt der erste Erziehungsberechtigte der US Steuerpflicht?",
      questionLegalGuardian2:
        "Unterliegt der zweite Erziehungsberechtigte der US Steuerpflicht?",
      yes: "Ja",
      no: "Nein",
    },
    npTaxationOneMoreStep: {
      question: "Sind Sie in einem weiteren Land steuerpflichtig?",
      questionPartner:
        "Ist Ihr Partner in einem weiteren Land steuerpflichtig?",
      questionMinor:
        "Ist der Minderjährige in einem weiteren Land steuerpflichtig?",
      questionLegalGuardian1:
        "Ist der erste Erziehungsberechtigte in einem weiteren Land steuerpflichtig?",
      questionLegalGuardian2:
        "Ist der zweite Erziehungsberechtigte in einem weiteren Land steuerpflichtig?",
      yes: "Ja",
      no: "Nein",
    },
    investmentExperienceStep: {
      pleaseSelectOption: "Bitte wählen...",
      lessThanYearOption: "Weniger als ein Jahr",
      moreThanYearOption: "Mehr als ein Jahr",
      moreThanTwoYearsOption: "Mehr als zwei Jahre",
    },
    experienceCertificatesAndOptionsWithLeverageStep: {
      question:
        "Ihre Erfahrung mit Optionsscheinen und Zertifikaten mit Hebelwirkung",
    },
    experienceCertificatesAndOptionsWithoutLeverageStep: {
      question: "Ihre Erfahrung mit Zertifikaten ohne Hebelwirkung",
    },
    experienceDomesticBondsStep: {
      question:
        "Ihre Erfahrung mit festverzinslichen Wertpapieren inländischer Emittenten",
    },
    experienceDomesticStocksStep: {
      question: "Ihre Erfahrung mit Aktien inländischer Gesellschaften",
    },
    experienceForeignCurrencyStep: {
      question: "Ihre Erfahrung mit Devisengeschäften (nicht auf Termin)",
    },
    experienceForeignStocksStep: {
      question: "Ihre Erfahrung mit Aktien ausländischer Gesellschaften",
    },
    experienceFundsStep: {
      question:
        "Ihre Erfahrung mit Investmentfonds (Anlagegesellschaft außerhalb der EU)",
    },
    experienceOtherStep: {
      question:
        "Ihre Erfahrung mit sonstigen Termingeschäften, Geschäften mit herausgeschobenem Erfüllungszeitpunkt und / oder Hebelwirkung",
    },
    experienceForeignBondsStep: {
      question:
        "Ihre Erfahrung mit festverzinslichen Wertpapieren ausländischer Emittenten oder in Fremdwährung",
    },
    comdirectConditionModelStep: {
      question: "Welches Konditionsmodell bevorzugen Sie?",
      subtitle: "Hinweis: Sie können Ihr Konditionsmodell jederzeit anpassen.",
      conditionModel3: 'Modell "Flatfee"',
      conditionModel3Description:
        "Das Modell für große Depots <1>ab 8.000 € Volumen</1> <2> pro Order</2>",
      conditionModel3DescriptionDetails:
        "Dieses Konditionsmodell beinhaltet eine pauschale Transaktionsgebühr der Bank (Flatfee) von 19,95 € für Börsengeschäfte - unabhängig von der Ordergröße.",
      conditionModel5: 'Modell "Standard"',
      conditionModel5Description:
        "Das Standardmodell; für Depots mit <1>bis zu 8.000 € Volumen</1> <2>pro Order</2>",
      conditionModel5DescriptionDetails:
        "Dieses Konditionsmodell beinhaltet eine prozentuale Transaktionsgebühr von 0,25% des Ordervolumens, jedoch mind. 10,00 € und max. 90,00 €",
    },
    dabConditionModelStep: {
      question: "Welches Konditionsmodell bevorzugen Sie?",
      subtitle: "Hinweis: Sie können Ihr Konditionsmodell jederzeit anpassen.",
      conditionModel1228: 'Modell "Flatfee"',
      conditionModel1228Description:
        "Das Modell für große Depots <1>ab 6.000 € Volumen</1> <2> pro Order</2>",
      conditionModel1228DescriptionDetails:
        "Dieses Konditionsmodell beinhaltet eine pauschale Transaktionsgebühr von 15,00 € (plus evtl. Courtage) für Börsengeschäfte und Festpreisgeschäfte - unabhängig von der Ordergröße.",
      conditionModel1139: 'Modell "Standard"',
      conditionModel1139Description:
        "Das Standardmodell; für Depots mit <1>bis zu 6.000 € Volumen</1> <2>pro Order</2>",
      conditionModel1139DescriptionDetails:
        "Dieses Konditionsmodell beinhaltet eine prozentuale Transaktionsgebühr von 0,25% des Ordervolumens, jedoch mind. 10,00 € und max. 75,00 €",
    },
    dwsDepotTypeStep: {
      question:
        "Für welche DWS Produkte möchten Sie von {{appName}} Cashback profitieren?",
      fundDepot: "Mein DWS Fondsdepot",
      retirementPlan: "Meine DWS Altersvorsorge (Riester / Rürup / Basisrente)",
    },
    payoutIbanStep: {
      question: "Wohin soll Ihr Cashback überwiesen werden?",
      placeholder: "IBAN",
    },
    payoutAccountHolderLastNameStep: {
      question: "Nachname des Kontoinhabers (Cashback-Auszahlungskonto)",
      placeholder: "Nachname",
    },
    payoutAccountHolderFirstNameStep: {
      question: "Vorname des Kontoinhabers (Cashback-Auszahlungskonto)",
      placeholder: "Vorname",
    },
    promotionCodeStep: {
      question: "Haben Sie einen Gutschein oder Empfehlungscode?",
      placeholder: "Gutschein / Empfehlungscode",
      validationSuccess: "Rabatt",
    },
    phoneNumberStep: {
      question:
        "Unter welcher Telefonnummer können wir Sie bei Rückfragen erreichen?",
      placeholder: "Telefonnummer",
    },
    usTaxNumberStep: {
      question: "Wie lautet Ihre US-TIN/-SSN?",
      questionPartner: "Wie lautet die US-TIN/-SSN Ihres Partners?",
      questionMinor: "Wie lautet die US-TIN/-SSN des Minderjährigen?",
      questionLegalGuardian1:
        "Wie lautet die US-TIN/-SSN des ersten Erziehungsberechtigten?",
      questionLegalGuardian2:
        "Wie lautet die US-TIN/-SSN des zweiten Erziehungsberechtigten?",
      placeholder: "US-TIN/-SSN",
    },
    dabMobileForTanStep: {
      question: "An welche Mobilfunk-Nummer soll die DAB Ihre TAN senden?",
      placeholder: "Mobilfunk-Nummer",
    },
    fondsdepotSelectDepotTypeStep: {
      question: "Möchten Sie ein Standard-Depot oder ein VL Depot eröffnen?",
      normal: "Standard-Depot",
      vl: "VL-Depot",
    },
    accountIdentifierStep: {
      question: "Nummer Ihres bestehenden Depots",
      questions: {
        COBADEHDXXX: "Ihre comdirect Kundennummer",
        DABBDEMMXXX: "Ihre DAB Konto-Stammnummer",
      },
      placeholders: {
        AUGBDE77XXX: "10 Ziffern (0-9)",
        COBADEHDXXX: "10 Ziffern (0-9)",
        DABBDEMMXXX: "7 Ziffern (0-9)",
        DEUTDEFFXXX: "1 Buchstabe, gefolgt von 7 Ziffern",
        COBADEMXXXX: "10 oder 11 Ziffern (0-9)",
        FFBKDEFFTHK: "10 Ziffern (0-9)",
        FODBDE77XXX: "10 Ziffern (0-9)",
        METZDEFFXXX: "10 Ziffern (0-9)",
      },
      accountIdentifierIsUsedMessage:
        "Diese Depot bzw. Kundennummer wurde bereits in einer anderen Buchung verwendet.",
    },
    comdirectCustomerHelpStep: {
      helpText: "Wo finde ich meine Kundennummer?",
      question: "Wo finde ich meine comdirect Kundennummer?",
      description:
        'Sie finden Ihre Kundennummer im "Persönlichen Bereich" unter dem Menüpunkt "Verwaltung" -> "Meine Daten".',
    },
    startDateStep: {
      question: "Datum des Betreuerwechsels",
      label: "Datum Betreuerwechsel",
    },
    selectAccountHolderStep: {
      question: "Kontoinhaber wählen",
      subheading:
        "Jeder Kontoinhaber kann kostenlos beliebig viele eigene oder Gemeinschaftsdepots verwalten. {{appName}} erhält maximal 15 € / Monat pro Kontoinhaber.",
      onvistaSubheading:
        "Jeder Kontoinhaber kann kostenlos beliebig viele eigene oder Gemeinschaftsdepots verwalten.",
      orAddNew: "oder",
      newAccountHolder: "Neuen Kontoinhaber erstellen",
      newAccountHolderNote:
        "{{appName}} rechnet pro Kontoinhaber ab. Wenn Sie hier klicken, erstellen Sie einen neuen Kontoinhaber, welcher separat abgerechnet wird. Verwenden Sie diese Funktion z.B. für Partner oder Ihre Kinder.",
      onvistaNewAccountHolderNote:
        "Die Abrechnung und Auszahlung erfolgt pro Kontoinhaber. Wenn Sie hier klicken, erstellen Sie einen neuen Kontoinhaber, welcher separat abgerechnet und ausgezahlt wird. Verwenden Sie diese Funktion z.B. für Partner oder Ihre Kinder.",
    },
    // BREAKPOINT FOR GENERATORS DO NOT REMOVE
    helpStep: {
      close: "Schließen",
    },
    nextButton: {
      next: "Weiter",
      skip: "Überspringen",
    },
    orEnter: "oder EINGABE drücken",
    header: {
      phone: {
        title: "Fragen?",
      },
    },
    userCreatedNotification:
      "Ihr Benutzer-Account wurde bereits erstellt. Daher ist eine Änderung nicht mehr möglich.",
  },
  banks: {
    COBADEHDXXX: "comdirect",
    DABBDEMMXXX: "DAB BNP Paribas",
    AUGBDE77XXX: "Augsburger Aktienbank",
    DEUTDEFFXXX: "DWS",
    DEUTLU2DXXX: "MorgenFund",
    COBADEMXXXX: "FNZ",
    FFBKDEFFTHK: "FIL Fondsbank (FFB)",
    FODBDE77XXX: "Fondsdepot Bank",
    METZDEFFXXX: "Metzler (MFX)",
  },
  countryAutocomplete: {
    mostUsed: "Häufig verwendet",
    others: "Weitere",
  },
  bankFacts: {
    rating: {
      description: "Unsere Bewertung",
    },
    allBanksLink: "zum Vergleich aller Banken",
    comdirect: {
      depotFee: "0 € Depotführung",
      numberOfFunds: "über 23.000 handelbare Fonds",
      fundSavingsPlan: "0,95 € Kosten für Fondssparplan",
      allInOne: "Fonds, Aktien und ETF handeln",
    },
  },
  cashbackCalculator: {
    cashback: {
      "50": "Cashback-50",
      "100": "Cashback-100",
    },
    detailed: {
      cashbackAreaChart: {
        rentabloFee: "{{appName}} erhält max. {{fee}} monatlich",
        rentabloFeeXs: "Max. {{fee}} für {{appName}}",
        rentabloFeeCB50: "Für {{appName}}",
        cashbackLabel: "Ihr Fonds-Cashback",
        depotVolume: "Depotvolumen",
        portfolioCommission: "Bestandsprovision",
        fee: "Für {{appName}}",
        yourCashback: "Ihr Cashback",
        perMonth: "monatlich",
      },
      inputSlider: {
        label: "Ihr Vermögen",
      },
    },
  },
  products: {
    free: {
      subheader: "Basis Funktionen mit {{appName}}-Konto",
      features: [
        "1 Bankverbindung",
        "3 Jahre Historische Daten",
        "Support nur über das Nutzerforum",
      ],
    },
    plus: {
      subheader: "für Investoren im Vermögensaufbau",
      features: [
        "alle <strong>Basis-Funktionen inklusive</strong>",
        "<strong>5</strong> Bankverbindungen",
        "<strong>6 Jahre</strong> Historische Daten",
        "E-Mail Support innerhalb von 5 Tagen",
        "Umsatzlisten hochladen",
        "Crypto",
        "Dividenden",
      ],
    },
    pro: {
      subheader:
        "für Investoren, die ihr Vermögen selbst professionell verwalten",
      features: [
        "alle <strong>PLUS Funktionen inklusive</strong>",
        "<strong>unbegrenzt</strong> viele Bankverbindungen",
        "<strong>10 Jahre</strong> Historische Daten",
        "<strong>Telefon-Support</strong>,",
        "<strong>unbegrenzt</strong> Umsatzlisten hochladen",
        "Data Enrichment",
        "Reports and Export-optionen",
        "Simulatoren",
      ],
    },
  },
  fundamentals: {
    topHoldings: "Top 10 Holdings",
    chartMenu: {
      hide: "Ausblenden",
    },
    comparisonChart: {
      quote: "Kurs",
      to: "vs.",
      noData: "Sorry - bitte melden Sie fehlende Daten an ",
      remove: "Vergleich entfernen",
    },
    metrics: {
      fScore: {
        normal: "RScore",
        short: "RScore",
        desc: "<strong class='bold'>Der RScore</strong> bringt den inneren Wert einer Aktie in einer Kennzahl zum Ausdruck. Fundamentale Kennzahlen des Unternehmens werden zueinander gewichtet und in Bezug zum aktuellen Marktwert gesetzt. Der optimale FScore beträgt 100 Punkte, der niedrigste Wert beträgt -57 Punkte.",
      },
      eps: {
        normal: "Gewinn pro Aktie (EPS)",
        short: "EPS",
        desc: "<strong class='bold'>Der Gewinn je Aktie (englisch earnings per share, kurz EPS)</strong> ist eine Kennzahl, die angibt, welcher Teil des gesamten Unternehmensgewinns auf eine Aktie entfällt. Er lässt auf die Ertragskraft eines Unternehmens schließen und ermöglicht Vergleiche im Zeitablauf und zwischen einzelnen Unternehmen.",
      },
      totalLiabilities: {
        normal: "Gesamtverbindlichkeiten",
        short: "Verbindlichkeiten",
        desc: "<strong class='bold'>Die Gesamtverbindlichkeiten (englisch total liabilities)</strong> sind die Summe aus Schulden und finanziellen Verpflichtungen eines Unternehmens. Die Gesamtverbindlichkeiten werden in der Unternehmensbilanz veröffentlicht und sind ein Teil der allgemeinen Buchhaltungs-Gleichung: Vermögenswerte = Verbindlichkeiten + Eigenkapital.",
      },
      operatingCashflow: {
        normal: "Operativer cash flow (OCF)",
        short: "OCF",
        desc: "Die in einem bestimmten Zeitraum durch die Geschäftstätigkeit erwirtschafteten liquiden Mittel. In den operativen Cash Flow gehen der Jahresüberschuss, die Veränderung der Abschreibungen, der Rückstellungen und des Umlaufvermögens ein.",
      },
      capEx: {
        normal: "Investitionsausgaben (CapEx)",
        short: "CapEx",
        desc: "<strong class='bold'>Investitionsausgaben (englisch capital expenditure, CapEx)</strong> werden die bei einer Investition getätigten Ausgaben für längerfristige Anlagegüter genannt. Dies sind beispielsweise Ausgaben für neue Betriebs- und Geschäftsausstattung, Fahrzeugpark, Immobilien oder Maschinen. Im Gegensatz zu den Investitionsausgaben stehen die Aufwendungen für den operativen Geschäftsbetrieb, die Betriebskosten.",
      },
      freeCashflow: {
        normal: "Freier cash flow (FCF)",
        short: "FCF",
        desc: "<strong class='bold'>Der freie cash flow (englisch free cash flow)</strong> beschreibt die innerhalb einer Periode erarbeitete Mittel, die weder für das operative Geschäft, noch für Investitionen benötigt werden. Der Free Cash Flow beziffert die Summe der Mittel, die dem Unternehmen nach allen Ausgaben innerhalb einer Periode frei zur Verfügung stehen.",
      },
      totalEquity: {
        normal: "Gesamtkapital",
        short: "Gesamtkapital",
        desc: "<strong class='bold'>Das Gesamtkapital (englisch total capital)</strong> ist die Summe aus Eigenkapital, Fremdkapital und Sonderposten zzgl. der passiven Rechnungsabgrenzungsposten. Es bildet somit die Passivseite der Bilanz. Nach der Bilanzgleichung entspricht das Gesamtkapital betragsmäßig dem Gesamtvermögen.",
      },
      netIncome: {
        normal: "Jahresüberschuss",
        short: "Überschuss",
        desc: "Um den Gewinn zu ermitteln, werden die Ausgaben von den Einnahmen abgezogen. Im Jahresabschluss wird der Gewinn als <strong class='bold'>Jahresüberschuss</strong> bezeichnet. <strong class='bold'>Der Jahresüberschuss</strong> ergibt sich aus der positiven Differenz zwischen den Erträgen und Aufwendungen des jeweiligen Geschäftsjahres",
      },
      netRevenue: {
        normal: "Nettoumsatz",
        short: "Umsatz",
        desc: "<strong class='bold'>Beim Nettoumsatz (englisch net revenue)</strong> handelt es sich um sämtliche Einnahmen eines Unternehmens, abgezogen werden nur die Umsatzsteuer, mögliche Rabatte und andere Erlösschmälerungen auf den normalen Preis für eine Ware oder Dienstleistung.",
      },
      outstandingShares: {
        normal: "Ausstehende Aktien",
        short: "Ausstehende Aktien",
        desc: "<strong class='bold'>Ausstehende Aktien (englisch outstanding shares)</strong> gibt die Gesamtzahl aller durch Anleger und institutionellen Investoren gehaltenen Aktien an. Hierzu zählen auch Aktien, die von Mitarbeitern oder Insidern gehalten werden. I.d.R. ändert sich die Zahl der ausstehenden Aktien im Laufe der Zeit, z.B. durch Kapitalmaßnahmen.",
      },
      returnOnAssets: {
        normal: "Kapitalrendite (ROA)",
        short: "ROA",
        desc: "<strong class='bold'>Kapitalrendite (englisch return on assets, ROA)</strong> ist der Gewinn eines Unternehmens geteilt durch die Vermögenswerte in der Bilanz. Der ROA gibt Anhaltspunkte über die Effizienz und Profitabilität, mit der ein Unternehmen mit dem ihm zur Verfügung stehenden Kapital wirtschaftet.",
      },
      returnOnEquity: {
        normal: "Eigenkapitalrendite (ROE)",
        short: "ROE",
        desc: "<strong class='bold'>Die Eigenkapitalrendite (englisch return on equity, ROE)</strong> gibt das Verhältnis von Eigenkapital und Rendite eines Unternehmens in einem Geschäftsjahr an. Die sogenannte Eigenkapitalrendite beschreibt im Endeffekt die Verzinsung des Eigenkapitals des Eigentümers.",
      },
      priceToBook: {
        normal: "Kurs-Buchwert-Verhältnis",
        short: "KBV",
        desc: "<strong class='bold'>Das Kurs-Buchwert-Verhältnis (englisch price-to-book, P/B)</strong> beruht auf der Überlegung, dass sich der Wert eines Unternehmens mit dem Wert dessen Eigenkapitals abbilden lässt. Errechnet wird das KBV, indem die Marktkapitalisierung des Unternehmens durch dessen Eigenkapital geteilt wird",
      },
      priceToCashflow: {
        normal: "Kurs-Cashflow-Verhältnis",
        short: "KCV",
        desc: "<strong class='bold'>Das Kurs-Cashflow-Verhältnis (englisch price to cashflow, P/CF)</strong> Es ist eine liquiditätsorientierte Aktienkennzahl, die das Verhältnis von Aktienkurs zu Cash-Flow je Aktie angibt.",
      },
      priceToFreeCashflow: {
        normal: "Kurs-Free-Cashflow-Verhältnis",
        short: "KFCV",
        desc: "<strong class='bold'>Das Kurs-Free-Cashflow-Verhältnis (englisch price to free cashflow, P/FCF)</strong> Es ist eine liquiditätsorientierte Aktienkennzahl, die das Verhältnis von Aktienkurs zu Free-Cash-Flow je Aktie angibt.",
      },
      priceToSales: {
        normal: "Kurs-Umsatz-Verhältnis",
        short: "KUV",
        desc: "<strong class='bold'>Das Kurs-Umsatz-Verhältnis (englisch price to sales, P/S)</strong> stellt das Verhältnis des Umsatzes eines Unternehmens im Verhältnis zur Marktkapitalisierung dar. Das KUV ist eine Kennzahl zur Beurteilung der Preiswürdigkeit eines Unternehmens im Vergleich zu anderen Unternehmen aus derselben Branche.",
      },
      dividendsPerYear: {
        normal: "Dividenden-Entwicklung",
        short: "Dividenden",
        desc: "Die Dividenden Auszahlungs-Historie. Erfolgen mehrere Zahlungen pro Jahr, so werden die Werte auf volle Jahre aufsummiert.",
      },
      historicQuotesPercent: {
        normal: "Kursentwicklung bis heute",
        short: "Kursentwicklung",
        desc: "Dies zeigt die Kursentwicklung von N Jahren bis heute.",
        xAxisLabel: "{{value}}J",
      },
      priceToEarnings: {
        normal: "Kurs Gewinn Verhältnis (KGV)",
        short: "KGV",
        desc: "<strong class='bold'>Das Kurs-Gewinn-Verhältnis (KGV)</strong> für einen festgelegten Zeitraum setzt den Börsenkurs einer Aktie ins Verhältnis zu den erzielten Gewinnen. Wir berechnen das KGV dabei ausschließlich auf Grundlage tatsächlich erzielter Gewinne; erwartete Gewinne fließen nicht in die Berechnung ein.",
      },
    },
    metricsAutocomplete: {
      placeholder: "Vergleichen mit",
    },
    addMenu: {
      title: "Chart hinzufügen",
      noItems: "Keine weiteren Charts verfügbar",
    },
    dividends: {
      kpi: {
        latestDividend: "Letzte Dividende ({{year}})",
        averageAndSum: "Ø jährlich · Summe ({{count}} J.)",
      },
    },
    detailInformation: {
      title: "Detail-Informationen",
      marketCap: "Marktkapitalisierung",
      indexes: "Indizes",
      sector: "Branche",
      lastUpdate: "Letztes Bilanz-Update",
      country: "Land",
    },
    year_one: "{{count}} Jahr",
    year_other: "{{count}} Jahre",
    onlyForProBlock: {
      updateToPro: "Jetzt PRO buchen",
      title: "Nur für {{appName}} PRO Mitglieder",
    },
    upgradeBlock: {
      title: "Bis zu 10 Jahre für {{appName}} PRO Mitglieder",
      button: "Jetzt PRO buchen",
    },
    ranksAndRisks: {
      fwwFundStars: "FFW FundStars®",
      fwwFundStarsInfo:
        "Die FWW FundStars® basieren auf der Risikoadjustierten Performance (RAP). Diese zweidimensionale Kennzahl errechnet sich aus der erzielten Wertentwicklung (Performance) und dem dabei eingegangenen Risiko (Volatilität). Für die FWW FundStars® werden die Fonds in 5 Ranking-Stufen à 20 Prozent klassifiziert, aus denen die Auszeichnung mit 5 bis 1 Sternen hervorgeht. Dabei erhalten die besten 20 Prozent der Fonds fünf Sterne.",
      srri: "SRRI",
      srriInfo:
        "Der Synthetic Risk and Reward Indicator (SRRI) bezeichnet den synthetischen Risiko- und Ertragsindikator. Der SRRI ist eine Kennzahl für die Höhe der mit der Veranlagung in einem Fonds verbundenen Wertschwankungen. Der SRRI wird mit einer EU-weit einheitlichen Methodik ermittelt und kann die Werte 1 bis 7 annehmen, wobei höhere Werte für höhere Wertschwankungen stehen. In der Regel sind mit höheren Wertschwankungen auch höhere Renditechancen verbunden. Ein SRRI von 1 bedeutet aber nicht, dass es sich um eine risikofreie Anlage handelt.",
      title: "Ratings und Risiken",
    },
  },
  investment: {
    title: "Wertpapier",
    isinMissing: {
      title: "Fehlende ISIN",
      subtitle:
        "Für dieses Wertpapier liegt derzeit keine gültige ISIN vor. Bitte ergänzen Sie die ISIN, damit das Wertpapier im KICS-Reporting korrekt übermittelt werden kann.",
    },
    header: {
      chart: {
        subheader: "Aktueller Kurs",
      },
      actions: {
        addBookingButton: "Buchung hinzufügen",
        moreButton: "Mehr",
        editInvestmentButton: "Investment bearbeiten",
        deleteInvestmentButton: "Investment löschen",
      },
      deleteModal: {
        question: "Dieses Investment löschen?",
      },
    },
    details: {
      gainLossStatistics: {
        title: "Meine Wertentwicklung",
        gainAndLoss: "GuV (Entwicklung + Realisiert)",
        returnOnInvestment: "Kursgewinne",
        realizedGains: "Realisierte Gewinne",
        irr: "Rendite (IRR) p. a. über {{years}} Jahre",
        twror: "Performance",
        purchasePrice: "Erwerbspreis",
        investedAmount: "Investierter Betrag",
        marketValue: "Marktwert",
        tradingGains: "Handelsgewinne",
        dividends: "Dividenden",
        commission: "Kommission",
        tax: "Steuern",
        fromMarketReturns: "aus Kursgewinnen",
        fromMarketAndCurrencyReturns: "aus Kurs- und Währungsgewinnen",
        fromDividendsAndKupons: "aus Dividenden/Kupons",
      },
    },
    performance: "Wertentwicklung",
    tabs: {
      fundamentals: "Fundamentaldaten",
      news: "Nachrichten",
      dividends: "Dividenden",
      protocol: "Protokoll",
    },
    protocolTable: {
      bookingType: "Typ",
      overallValue: "Gesamtwert",
      period: "Zeitraum",
      amount: "Kurs",
      expenses: "Kosten",
      totalSum: "Summe",
      noBookings: "Keine Buchungen im Zeitraum",
      comment: "Kommentar",
      cancelled: "Storniert",
      gainersAndLosersLabel: "GuV",
      actions: {
        title: "Aktion",
        edit: "Bearbeiten",
        delete: "Löschen",
      },
      deleteDialog: {
        title: "Buchung löschen",
        questionMessage: "Möchten Sie diese Buchung wirklich löschen?",
        actions: {
          close: "Schließen",
          delete: "Löschen",
        },
      },
    },
    dividends: {
      noDividends: "Keine Dividenden. Möchten Sie einen Eintrag hinzufügen?",
      noDividendsAddLink: "Hinzufügen",
      addDividends: "Manueller Eintrag",
      splitAdjust: "Splitbereinigt",
      mobile: {
        count_one: "{{count}} Dividende",
        count_other: "{{count}} Dividenden",
        missing: "Nicht erfasst",
      },
      missingDividends: {
        header_one: "{{value}} fehlende Dividende.",
        header_other: "{{value}} fehlende Dividenden.",
        addBatchButton: "Jetzt hinzufügen",
      },
      dividendsTableHeaders: {
        date: "Datum",
        dividend: "Dividende",
        lots: "Stück",
        total: "Gesamt",
        actions: "Optionen",
      },
      tableActions: {
        addDividends: "Hinzufügen",
        editDividends: "Bearbeiten",
      },
    },
    newsBlock: {
      noNews: "Keine Nachrichten",
    },
    recommendation: {
      title: "Produktvorschläge",
      description:
        "Wir haben Produkte gefunden, die besser zu Ihrem Portfolio und Ihren Präferenzen passen. Mit der Checkbox kann das Produkt zum Chart hinzugefügt werden.",
      showAll: "Alle Vorschläge ansehen",
    },
  },
  singleAccountPage: {
    breadcrumbs: {
      home: "Home",
      accounts: "Konten",
    },
    header: {
      account: "Konto",
      update: "Aktualisieren",
      addTransaction: "Transaktion hinzufügen",
      edit: "Bearbeiten",
      manageBankConnection: "Bankverbindung verwalten",
      hide: "Permanent Ausblenden",
      show: "Zeigen",
      delete: "Konto löschen",
      deleteModal: {
        question: "Dieses Konto löschen?",
      },
    },
    protocolTable: {
      title: "Transaktionen",
      headers: {
        valueDate: "Valuta",
        bookingDate: "Buchtag",
        bookingInformation: "Buchungsinformation",
        value: "Wert",
      },
      mobile: {
        count_one: "{{count}} Transaktion",
        count_other: "{{count}} Transaktionen",
        search: "Suche",
        loadingMore: "Weitere Transaktionen werden geladen…",
        allLoaded: "Alle Transaktionen geladen",
      },
      details: {
        counterpart: "Gegenstelle",
        purpose: "Verwendungszweck",
        type: "Typ",
        investment: "Investment",
      },
      search: {
        placeholder: "Suche",
      },
      noPurpose: "Nicht verfügbar",
      noItems: "Keine Transaktionen für den Zeitraum",
      export: "Export CSV",
      transfer: "Kontentransfer",
      adjustingEntry: "Ausgleichsbuchung",
      adjustingEntryText:
        "Sollte der Kontostand durch einen Kauf unter Null fallen, so wird dieser automatisch ausgeglichen.",
      interval: {
        everyMonth: "Jeden Monat",
        biMonthly: "Alle 2 Monate",
        quarterly: "Quartalsweise",
        biAnnual: "Halbjährlich",
        annual: "Jährlich",
      },
    },
  },
  addManuallyPage: {
    addManuallyBreadcrumb: "Von Hand hinzufügen",
    header: {
      title: "Cash-Transaktion",
      subtitle: "Neue Cash-Transaktion erstellen",
    },
    form: {
      additionalInformation: {
        summary: "Weitere Informationen",
        interestTitle: "Zinsen / Gebühren:",
        interestBody:
          "Zinsen oder Gebühren wie z.B. Depotführungsgebühren. Sollzinsen und Gebühren haben ein negatives, Habenzinsen ein positives Vorzeichen.",
        otherGainsTitle: "Sonstige Gewinne:",
        otherGainsBody:
          "Gewinne aus (nicht verbuchten) Wertpapier-Transaktionen. Dies könnte z.B. eine Rückerstattung oder ein anderweitiger Gewinn sein.",
        taxRefundTitle: "Steuern/Rückerst.:",
        taxRefundBody:
          "Gezahlte Steuern oder erhaltene Steuerrückerstattungen. Gezahlte Steuern haben ein negatives, erhaltene Rückerstattungen ein positives Vorzeichen.",
      },
      type: "Art der Transaktion:",
      types: {
        withdrawal: "Abhebung",
        deposit: "Einzahlung",
        interest: "Zinsen / Gebühren",
        tax_refund: "Steuern / Rückerstattung",
        other_gains: "Sonstige Gewinne",
      },
      netAmount: "Nettobetrag:",
      taxAmount: "Steuern:",
      totalAmount: "Bruttobetrag:",
      date: "Eingezahlt am:",
      datepickerCancelButton: "Abbrechen",
      purpose: "Kommentar:",
      hints: {
        other_gains:
          "Sonstige Gewinne können starken Einfluss auf die Performance haben. Bitte markieren Sie diese Transaktion nur als Sonstige Gewinne wenn diese auch tatsächlich ein Handelsgewinn, eine Steuerrückerstattung o.Ä. war.",
      },
      submit: "Speichern",
      messages: {
        success: "Erfolgreich gespeichert",
      },
    },
  },
  createAndEditAccount: {
    editBreadcumb: "Bearbeiten",
    header: {
      title: "Bearbeiten: {{value}}",
    },
    actions: {
      save: "Speichern",
      delete: "Löschen",
      deleteAllInvestments: "Alle Investments löschen",
      deleteAllCashTransactions:
        "Sie können auch alle Bargeldtransaktionen löschen",
    },
    deleteDialog: {
      titleInvestments: "Alle Investments löschen",
      titleAllCashTransactions: "Alle Cash-Transaktionen löschen",
      questionInvestments: "Möchten Sie wirklich alle Investments löschen?",
      questionCashTransaction:
        "Möchten Sie wirklich alle Cash-Transaktionen löschen?",
      close: "Abbrechen",
      delete: "Löschen",
    },
    details: {
      title: "Kontodetails",
      description: "Grundlegende Angaben zu diesem Konto.",
    },
    additionalContraAccounts: {
      cardTitle: "Zusätzliche Verrechnungskonten",
      description:
        "Verknüpfe weitere Konten, über die Käufe und Verkäufe dieses Depots verrechnet werden.",
      manageButton: "Verwalten",
      setAsPrimary: "Als Hauptkonto festlegen",
      removeButton: "Verknüpfung entfernen",
      title: "Zusätzliche Verrechnungskonten wählen",
      subtitle: "Mehrfachauswahl möglich",
      primaryLabel: "Hauptverrechnungskonto",
      additionalLabel: "Zusätzliche Konten",
      otherBank: "Sonstige",
      noOptions: "Keine Konten verfügbar",
    },
    linkedDepots: {
      title: "Verrechnungskonto für",
      description:
        "Über dieses Konto werden Käufe und Verkäufe der folgenden Depots verrechnet.",
    },
    dangerZone: {
      depotTitle: "Depot und Investments löschen",
      accountTitle: "Konto und Transaktionen löschen",
      deleteAccount: {
        depot: {
          title: "Depot löschen",
          description:
            "Löscht dieses Depot vollständig – inklusive aller Investments, Transaktionen und verknüpften Verrechnungskonten. Dieser Schritt kann nicht rückgängig gemacht werden.",
          button: "Depot löschen",
          confirmTitle: "Dieses Depot löschen?",
        },
        account: {
          title: "Konto löschen",
          description:
            "Löscht dieses Konto vollständig – inklusive aller Transaktionen. Dieser Schritt kann nicht rückgängig gemacht werden.",
          button: "Konto löschen",
          confirmTitle: "Dieses Konto löschen?",
        },
        referenceAccountsLabel:
          "Welche Verrechnungskonten sollen ebenfalls gelöscht werden?",
        referenceBoundMessage:
          "Noch mit anderen Depots verknüpft – kann nicht gelöscht werden",
        deleteContraAccount: "Verrechnungskonto ebenfalls löschen",
        boundMessage:
          "Dieses Konto wird als Verrechnungskonto eines Depots verwendet und kann nicht gelöscht werden.",
      },
    },
  },
  watchlistEntry: {
    details: {
      gainLossStatistics: {
        title: "Wertentwicklung",
        gainAndLoss: "Kursentwicklung",
        entryQuote: "Einstandskurs",
        currentQuote: "Aktueller Kurs",
        historicReturns: "Historische Performance",
      },
    },
  },
  depotTransfer: {
    title: "Depotübertrag",
    header: {
      backButton: "Zurück",
      title: "Depotübertrag",
    },
    selectTransferTypeStep: {
      question:
        "Wollen Sie das gesamte Depot oder einzelne Positionen übertragen?",
      full: "Gesamtes Depot",
      partial: "Ausgewählte Positionen",
    },
    depotAutocompleteStep: {
      question: "Zu welchem Depot möchten Sie übertragen?",
      placeholder: "Depot wählen",
    },
    dateOfTransferStep: {
      question: "Wann fand der Depotübertrag statt?",
      label: "Datum",
    },
    investmentsTable: {
      investments: "Positionen",
      totalNumberOfLots: "Anzahl",
      transferNumberOfLots: "Stück Übertrag",
    },
    validation: {
      destinationAccountIdIsEmpty: "Zieldepot muss gewählt werden",
      investmentsToTransferIsEmpty:
        "Bitte wählen Sie mindestens eine Position aus",
      investmentsToTransferIsIncorrect:
        "Ungültige Stückzahl für einige Positionen",
      numberOfLotsCanNotBeLessThanZero: "darf nicht negativ sein",
      numberOfLotsCanNotBeMoreThanOriginal:
        "darf nicht größer als verfügbare Stückzahl sein",
      dateOfTransferCanNotBeInFuture:
        "Übertrags-Datum darf nicht in der Zukunft liegen",
      dateOfTransferCanNotBeEmpty: "Übertrags-Datum darf nicht leer sein",
    },
    successStep: {
      message: "Positionen wurden erfolgreich übertragen",
      finishButton: "Zurück zum Depot",
    },
    fullLotsStep: {
      question:
        "Überträgt Ihre Bank die gesamte Position oder nur volle Stücke?",
      onlyFullLots: "Nur volle Stücke",
      fullLotsAndPartials: "Die gesamte Position",
    },
    selectInvestmentsStep: {
      question: "Welche Positionen möchten Sie übertragen?",
      noInvestments: "Keine Positionen im gewählten Depot",
    },
  },
  bankConnections: {
    success: {
      message: "Import erfolgreich abgeschlossen",
      toDepots: "Zur Depotübersicht",
    },
  },
  selectContraAccount: {
    accountTypeFromBank: {
      CHECKING: "Girokonto",
      SAVINGS: "Sparkonto",
      CREDIT_CARD: "Kreditkarte",
      DEPOT: "Depot",
      LOAN: "Kredit",
      MEMBERSHIP: "Mitgliedskonto",
      HOME_PURCHASE_SAVINGS: "Bausparkonto",
      REFERENCE_ACCOUNT: "Referenzkonto",
      FOREIGN_CURRENCY_ACCOUNT: "Fremdwährungskonto",
    },
    title: "Verrechnungskonto wählen",
    nextButton: "Weiter",
    depotIndex: "{{index}} von {{total}}",
    noAccount: "Ohne Verrechnungskonto",
    noAccountWarning:
      "Ohne Verrechnungskonto nur eingeschränkte Funktionalität! Keine Übernahme von Dividenden und exakten Daten aus Transkationen",
    showAllAccounts: "Alle Bankkonten anzeigen",
    showAccountsForSameBank: "Nur Konten bei Bank anzeigen",
  },
  synchronizationLog: {
    title: "Letzte Aktualisierungen",
    noUpdateRequired: "Positionen sind aktuell",
    new: "NEU",
    rollback: "Änderungen verwerfen",
    rolledBack: "VERWORFEN",
    checkRequired: "PRÜFEN",
  },
  depotsSelector: {
    allDepots: "Alle Depots",
    amountDepots: "{{ selected }} von {{ total }} Depots",
    noDepots: "Keine Depots",
    allAccounts: "Alle Konten",
    amountAccounts: "{{ selected }} von {{ total }} Konten",
    noAccounts: "Keine Konten",
    allPortfolios: "Alle Portfolios",
    amountPortfolios: "{{ selected }} von {{ total }} Portfolios",
    noPortfolios: "Keine Portfolios",
  },
  regionSelector: {
    label: "Region wählen",
  },
  industrySelector: {
    label: "Branche wählen",
  },
  tagSelector: {
    label: "Tag eingeben",
    addNewOption: 'Tag "{{name}}" erstellen',
  },
  classifications: {
    title: "Klassifizierung",
    breadcrumbs: {
      home: "Home",
      classifications: "Depot-Klassifizierung",
    },
    tabs: {
      investments: "Investments",
      investmentType: "Assetklassen",
      region: "Regionen",
      industry: "Branchen",
      risk: "Volatilität",
      currency: "Währungen",
      yield: "Renditen",
      tag: "Eigene Gruppierungen",
    },
    empty: {
      title: "Keine Daten für diese Ansicht",
    },
    assignTagToInvestment: "Tag der Investition zuweisen",
    assignIndustryToInvestment: "Branche der Investition zuweisen",
    assignRegionToInvestment: "Region der Investition zuweisen",
    risk: {
      title: "Investments nach Risiko",
      tooltip:
        'Hoch: Das Risiko von Wertpapieren wird als "hoch" eingestuft, wenn die Volatilität  über 25 Prozent beträgt.<br/><br/>Moderat: Das Risiko von Wertpapieren wird als "moderat" eingestuft, wenn die Volatilität zwischen 15 und 25 Prozent beträgt.<br/><br/>Gering: Das Risiko von Wertpapieren wird als "gering" eingestuft, wenn die Volatilität unter 15 Prozent beträgt.',
      unclassified: "Nicht klassifiziert",
      numberToWord: {
        "0": "Gering",
        "1": "Moderat",
        "2": "Hoch",
      },
    },
    yield: {
      title: "Investments nach Rendite",
      tooltip:
        'Hoch: Der Ertrag von Wertpapieren wird als "hoch" eingestuft, wenn die Rendite pro Jahr über 12 Prozent beträgt.<br/><br/>Moderat: Der Ertrag von Wertpapieren wird als "moderat" eingestuft, wenn die Rendite pro Jahr zwischen 6 und 12 Prozent beträgt.<br/><br/>Gering: Der Ertrag von Wertpapieren wird als "gering" eingestuft, wenn die Rendite pro Jahr unter 6 Prozent beträgt.',
      unclassified: "Nicht klassifiziert",
      numberToWord: {
        "0": "Gering",
        "1": "Moderat",
        "2": "Hoch",
      },
    },
    tag: {
      assignTitle: "Kategorien zuweisen",
      title: "Ihre selbst gewählte Gruppierung",
      unclassified: "Nicht klassifiziert",
    },
    investmentType: {
      title: "Investments nach Typ",
      types: {
        "11_stock": "Aktien",
        "21_fund": "Fonds",
        "31_bond": "Anleihen",
        "41_cash": "Cash",
        "51_certos": "Zertifikate / OS",
        "52_future": "Futures",
        "61_pmetals": "Edelmetalle",
        "71_massets": "Sachwerte",
        "81_fcurr": "Währungen",
        "82_crypto": "Krypto",
        "22_etf": "ETF",
        "91_managed": "Robo / Crowd",
      },
    },
    currency: {
      title: "Investments nach Währung",
    },
    region: {
      assignTitle: "Region zuweisen",
      title: "Investments nach Region",
    },
    industry: {
      assignTitle: "Branche zuweisen",
      title: "Investments nach Branche",
    },
  },
  investmentTypeClassification: {
    types: {
      "11_stock": "Aktien",
      "21_fund": "Fonds",
      "31_bond": "Anleihen",
      "41_cash": "Cash",
      "51_certos": "Zertifikate / OS",
      "52_future": "Futures",
      "61_pmetals": "Edelmetalle",
      "71_massets": "Sachwerte",
      "81_fcurr": "Währungen",
      "82_crypto": "Krypto",
      "22_etf": "ETF",
      "91_managed": "Robo / Crowd",
    },
  },
  dividendPlannerPage: {
    title: "Dividendenerträge",
    addButton: "Hinzufügen",
    portfolio: "Portfoliowert",
    statistics: {
      portfolioValue: "Portfoliowert",
      received: "Erhaltene Dividenden",
      yield: "Dividenden-Rendite",
      predicted: "Vorhersage",
      predictedYield: "Vorhersage-Rendite",
      cagr: "CAGR",
      currentYear: "Aktuelles Jahr",
      year: "Jahr {{year}}",
      years_one: "{{count}} Jahr",
      years_other: "{{count}} Jahre",
    },
    chart: {
      title: "Dividenden aktuelles Jahr",
      dividendYield: "Dividendenrendite",
      lastYear: "vergangenes Jahr",
      total: "Gesamt",
      tooltipReceived: "erh. Div",
      tooltipPredicted: "mög. Div",
    },
    myDividends: "Meine Dividenden",
    exportPdfBtn: "Export as PDF",
    predictDropdown: {
      predictYears: "Jahre vorhersagen",
      hideForecast: "Vorhersage ausblenden",
      list: {
        nextYear: "Nächstes Jahr simulieren",
        twoYears: "2 Jahre simulieren",
        fiveYears: "5 Jahre simulieren",
        tenYears: "10 Jahre simulieren",
      },
    },
    tabs: {
      overview: "Übersicht",
      calendar: "Dividendenkalender",
    },
    chips: {
      table: "Tabellenansicht",
      calendar: "Kalenderansicht",
    },
    forecast: "Vorhersage",
    showAll: "Alle anzeigen",
    showLess: "Weniger anzeigen",
    showMore: "mehr anzeigen",
    calendar: {
      noData: "Keine Dividenden",
    },
    dividendContains_one: "{{count}} Dividende erhalten",
    dividendContains_other: "{{count}} Dividenden erhalten",
    searchPlaceholder: "Suche",
    quote: "Kurs",
    table: {
      name: "Name",
      dueIn: "Fällig im",
      dividendAmount: "Dividende /\nBetrag",
      yieldPrice: "Pers. Rendite /\nKaufpreis",
      currentYP: "Aktuelle Rendite /\nAktueller Kurs",
      dividend: "Dividende",
      amount: "Betrag",
      personalYield: "Pers. Rendite",
      purchasePrice: "Kaufpreis",
      currentYield: "Aktuelle Rendite",
      currentPrice: "Aktueller Kurs",
      sharesShort: "St.",
      groupByMonth: "Nach Monat gruppieren",
      expected: "Vorraussichtlich",
      notRecorded: "Dividende nicht erfasst",
      noFound: "Nichts gefunden",
      mobile: {
        count_one: "{{count}} Position",
        count_other: "{{count}} Positionen",
        payments_one: "{{count}} Zahlung",
        payments_other: "{{count}} Zahlungen",
        paymentsTitle: "Zahlungen",
        yieldValue: "Rendite {{value}}",
        sort: {
          dividend: "Dividende",
          currentYield: "Aktuelle Rendite",
          personalYield: "Pers. Rendite",
        },
      },
      dividendPerShare: "Dividende je Aktie",
      shares: "Anzahl",
      tax: "Steuer & Gebühren",
      paymentDate: "Zahltag",
      banner: {
        title: "Keine Steuerdaten eingetragen",
        text: "Wir können Ihre Nettobeträge berechnen und hier anzeigen, wenn Sie Ihre Steuerdaten angeben",
        supplementBtn: "Steuerdaten ergänzen",
        notNowBtn: "Jetzt nicht",
      },
      expand: {
        dividends: "Dividende",
        amount: "Betrag",
        currentYield: "Aktuelle Rendite",
        personalReturns: "Persönliche Rendite",
        gross: "(Brutto)",
        net: "(Netto)",
        grossTooltip: "Bruttobetrag (vor Steuern)",
        netTooltip: "Nettobetrag (nach Steuern)",
      },
    },
  },
  csvImport: {
    title: "CSV importieren",
    formatSelector: {
      label: "CSV-Format wählen",
    },
    csvUpload: {
      text: "CSV hierhin ziehen oder auswählen",
      error:
        "Fehler beim Upload. Bitte überprüfe, ob die hochgeladene Datei dem Format entspricht, oder versuche es mit einer anderen Datei.",
      genericHint:
        "Bitte die CSV-Datei mit den Transaktionsdaten importieren. Ein generisches CSV-Template kann <linkText>hier heruntergeladen</linkText> werden. Darüber hinaus werden folgende Formate unterstützt:",
      currencyWarning:
        "Wichtig: Der CSV Import unterstützt keine Umrechnung von Fremdwährungen. Bitte sicherstellen, dass alle Buchungen und Transaktionen in Euro angegeben sind.",
      incompatible: {
        "01_depot":
          "Der Import von Cash-Transaktionen in ein Depot ist nicht möglich. Bitte ein Konto auswählen, um die Cash-Transaktionen aus dem CSV-File zu importieren.",
        "02_cash":
          "Der Import von Wertpapier-Buchungen in ein Konto ist nicht möglich. Bitte ein Depot auswählen, um die Wertpapier-Buchungen aus dem CSV-File zu importieren.",
      },
    },
    banksTable: {
      depot: "Depot-Buchungen",
      account: "Konto-Transaktionen",
      portfolioPerformanceDepot: "Portfolio Performance (Depot)",
      portfolioPerformanceAccount: "Portfolio Performance (Konto)",
      emptyText: "Es wurden keine Buchungs- oder Transaktionsbanken gefunden.",
      loading: "Lade Buchungs- oder Transaktionsbanken...",
    },
    edit: "Bearbeiten",
    delete: "Löschen",
    parsingResults: {
      date: "Datum",
      name: "Name",
      number_of_lots: "Anzahl",
      number_of_lots_bond: "Betrag",
      security_price: "Einstandkurs",
      commission: "Gebühren",
      isin: "ISIN",
      tax_amount: "Steuern",
      transaction_type: "Transaktionstyp",
      asset_type: "Investmentart",
      currency: "Währung",
      exchange_rate: "Wechselkurs",
      tax_and_commission_in_eur: "Steuern und Gebühren in EUR",
      error: "Eintrag für {{name}} fehlt",
      saveSuccess: "Transaktionen wurden erfolgreich importiert",
      savePending: "Import wird verarbeitet, bitte warten...",
      saveError: "Beim Speichern von Transaktionen ist ein Fehler aufgetreten",
      correctionHint:
        "Bitte korrigieren Sie erst alle fehlerhaften Transaktionen, bevor Sie sie importieren.",
      allCorrected:
        "Alle fehlerhaften Transaktionen wurden erfolgreich korrigiert.",
    },
    cashParsingResults: {
      bank_booking_date: "Datum",
      counterpart_name: "Name",
      counterpart_iban: "IBAN",
      purpose: "Buchungsinformationen",
      amount: "Betrag",
      error: "Eintrag für {{name}} fehlt",
    },
  },
  transactionUpload: {
    title: "Transaktionen importieren",
    transactionTypes: {
      buy: "Kauf",
      sell: "Verkauf",
      dividend: "Dividende",
      book_in: "Einbuchung",
      book_out: "Ausbuchung",
    },
    dropOrSelectFile: "PDFs hierhin ziehen oder auswählen",
    dropOrSelectFileHint: "Nicht mehr als 10 Dateien mit jeweils bis zu 2 MB",
    newInvestment: "Neu",
    newTransaction: "Neu",
    updateTransaction: "Update",
    tax: "Steuern",
    fee: "Gebühren",
    persistData: "Positionen importieren",
    depot: "Depot",
    ignoreErrors: "Fehler ignorieren",
    success: {
      importSuccess: "Import erfolgreich",
      importDetails: "Importierte Positionen",
      toDepot: "Zurück zum Depot",
      toInvestments: "Zurück zum Investments",
    },
    somethingWrong:
      "Es ist ein Fehler aufgetreten und wir konnten die Datei nicht richtig analysieren. Bitte überprüfen Sie Ihre Dateidaten.",
    placeholder: "Depot wählen",
  },
  authContext: {
    loginTitle: "Login",
    emailConfirmationTitle: "Bitte bestätigen Sie Ihre Email Adresse",
  },
  emailConfirmation: {
    line1:
      "Wir haben Ihnen eine Email zur Bestätigung Ihres Accounts gesendet. Bitte schließen Sie die Registrierung durch klick auf den in der Email enthaltenen Bestätigungslink ab.",
    line2:
      "Sollten Sie keine Email erhalten haben, so überprüfen Sie bitte ggf. auch Ihren Spam-Ordner.",
    success:
      "Wir haben Ihnen eine Email zur Bestätigung Ihres Accounts gesendet.",
    logout: "Anmeldung abbrechen",
    button: "Email erneut senden",
    confirmationExpiredError:
      "Registrierung konnte nicht bestätigt werden. Ggf. ist der verwendete Bestätigungslink bereits ungültig.",
  },
  netfondsConsent: {
    title: "Cashback: One-Click Import",
    heading: "Neu: One-Click Datenimport",
    teaser:
      "Wir freuen uns, nun exklusiv für unsere Cashback-Kunden einen schnellen und reibungslosen Depot-Import bieten zu können.",
    description:
      "Importieren Sie Ihre Cashback-Depots mit nur einem Klick in den {{appName}} Finanzmanager und verbessern Sie Ihre Rendite mit unseren innovativen Finanztools.",
    activateDataImport: "Datenimport aktivieren",
    doNotActivateDataImport: "Datenimport nicht aktivieren",
    deactivated: "One-Click Import ist deaktiviert",
    howToActivate:
      "Sie können den One-Click Import jederzeit in Ihrem <1>Cashback-Dashboard</1> aktivieren.",
    done: "Zurück zum Dashboard",
    changedYourMind: "Import doch aktivieren?",
    selectAccountHolders: "Kontoinhaber wählen",
    selectAccountHoldersDescription:
      "One-Click import wird für die gewählten Kontoinhaber aktiviert.",
    importingData: "Depots werden importiert...",
    importingDataDescription:
      "Wir importieren Ihre Wertpapier und Transaktionsdaten. Sollten Sie über sehr viele (historische) Transaktionen verfügen, so kann der Import mehrere Minuten in Anspruch nehmen.",
    somethingWrong: {
      title: "Import fehlgeschlagen",
      contactSupport:
        "Bitte kontaktieren Sie unseren Support unter {{supportEmail}}, sollte dieses Problem mehrfach auftreten.",
    },
    deleteAccounts: {
      heading: "Bereits importierte Depots löschen?",
      teaser:
        "Es wurden bereits Depots und Konten über die Cashback-Schnittstelle importiert. Möchten Sie diese nun löschen?",
      delete: "Depots löschen",
      keep: "Daten beibehalten",
    },
    breadcrumbs: {
      title: "One-Click Import",
    },
  },
  addDividendWizard: {
    title: "Dividenden",
    breadcrumbs: {
      create: "Dividende hinzufügen",
    },
    addManualDividendStep: {
      title: "Tragen Sie die Angaben zur Dividende ein",
      date: "Datum",
      currency: "Währung",
      securityPrice: "Betrag",
      exchangeRate: "Wechselkurs",
      taxAmount: "Steuern",
      commission: "Gebühren",
      taxAndCommissionInEur: "Steuern und Gebühren in EUR?",
      amount: "Summe",
      amountAC: "Summe (EUR)",
      errors: {
        title: "Fehler bei Daten-Validierung",
      },
    },
    confirmManualDividendStep: {
      title: "Zusammenfassung Ihrer Angaben zur Dividende",
      amount: "Betrag:",
      date: "Datum:",
      tax: "Steuern:",
      commission: "Gebühren:",
      exchangeRate: "Wechselkurs:",
      total: "Summe:",
      totalAC: "Summe (€):",
      saveButtonLabel: "Speichern",
    },
  },
  batchDividendsWizard: {
    title: "Dividenden",
    listDividendsStep: {
      title: "Wählen Sie die aussstehenden Dividenden aus",
      subtitle:
        "Die ausgewählten Dividenden werden automatisch in Ihr Depot importiert",
      splitAdjust: "Splitbereinigt",
    },
    dividendsTable: {
      headers: {
        date: "Datum",
        amount: "Betrag",
        lots: "Stück",
      },
    },
    taxRequestStep: {
      taxQuestion: "Möchten Sie einen Steuersatz anwenden?",
      acceptTax: "Ja",
      declineTax: "Nein",
    },
    taxInputStep: {
      title: "Geben Sie Ihren Steuersatz ein",
      customTaxLabel: "Steuersatz",
    },
    summaryStep: {
      title: "Zusammenfassung Ihrer Dividenden- und Steuerdaten",
      saveButtonLabel: "Speichern",
      dividendsTable: {
        headers: {
          date: "Datum",
          amount: "Erhalten",
          tax: "Steuern",
          total: "Summe",
        },
      },
    },
  },
  editDividendWizard: {
    title: "Dividende Bearbeiten",
  },
  transactionWizard: {
    new: {
      title: "Investment hinzufügen",
    },
    manual: {
      title: "Investment von Hand erstellen",
    },
    add: {
      title: "Buchung hinzufügen",
    },
    edit: {
      title: "Buchung bearbeiten",
    },
    searchSymbolsStep: {
      title: "Wertpapiere suchen",
      noQuoteModal: {
        title: "Keine automatische Kursversorgung",
        text: "Für das ausgewählte Wertpapier können wir leider keine automatische Kursaktualisierung zur Verfügung stellen. Bitte erstellen Sie den Eintrag für das Investment manuell und aktualisieren Sie die Kurse bei Bedarf selbst.",
        confirm: "Manuelles Investment erstellen",
      },
    },
    selectCurrencyStep: {
      title: "Investment-Währung wählen",
      currency: "Währung",
      tryPlusMessage: "Fremdwährungen sind ein PLUS Feature.",
    },
    investmentTypeStep: {
      title: "Art des Investments",
    },
    bookingTypeStep: {
      title: "Was möchten Sie erfassen?",
      mostUsed: "Häufig verwendet",
      specials: "Weitere Transaktionsarten",
      buy: "Kauf",
      sell: "Verkauf",
      book_in: "Einbuchung (Book-in)",
      book_out: "Ausbuchung (Book-out)",
      switch: "Tausch / Fusion",
      retained_dividend: "Gratisaktien / Thes. Dividende",
      carve_out: "Carve-out",
      split: "Split",
      disabledInformation:
        "Diese Buchung ist nur für bestehende Investments verfügbar. Bitte verwenden Sie die Investment-Optionen um diese Buchung auszuwählen.",
    },
    priceAndDateStep: {
      title: "Orderdaten",
      date: "Datum",
      numberOfLots: "Stücke",
      numberOfLotsPercent: "Betrag",
      numberOfLotsGram: "Gramm",
      numberOfLotsOunces: "Unzen",
      currency: "Währung",
      securityPrice: "(Historischer) Einstandskurs",
      bookOutPrice: "Ausgebucht für",
      entryQuote: "Kurs",
      exchangeRate: "Wechselkurs",
      commission: "Gebühren",
      taxAmount: "Steuern",
      taxAndCommissionInEur: "Steuern und Gebühren in EUR?",
      totalAmount: "Summe",
      totalAmountAC: "Summe (EUR)",
      depotValuationAfterBooking: "Depotwert nach dieser Buchung",
      gram: "g",
      ounces: "oz",
      lots: "St.",
    },
    ratioAndDateStep: {
      title: "Split",
      date: "Datum",
      ratio: "Verhältnis",
      isReverse: "Reverse Split?",
    },
    nameAndDepotStep: {
      title: "Name und Depot wählen",
      name: "Name",
      selectDepot: "Depot wählen",
      newDepot: "Neues Depot",
      comment: "Mein Trading-Tagebuch:",
      investmentExists: "Sie halten bereits {{lots}} Stück in diesem Depot",
    },
    newDepotStep: {
      title: "Neues Depot erstellen",
      name: "Depotname",
      currency: "Währung",
    },
    inputFieldWithRevert: {
      revert: "Zurücksetzen",
      revertDescription: "Auf ursprünglichen Wert von {{value}} zurücksetzen",
    },
    summaryStep: {
      title: "Zusammenfassung",
      date: "Datum",
      entryQuote: "Kurs",
      securityPrice: "(Historischer) Einstandskurs",
      exchangeRate: "Wechselkurs",
      expenses: "Nebenkosten",
      totalAmount: "Gesamt",
      totalAmountAC: "Gesamt (€)",
      persist: "Speichern",
      currency: "Währung",
    },
    splitPreviewStep: {
      title: "Split wird angewandt auf:",
      titleReverse: "Reverse-Split wird angewandt auf:",
      persist: "Speichern",
    },
    persistedStep: {
      title: "Daten gespeichert",
      showInvestments: "Weiter zu Investments",
    },
    somethingWrong: {
      title: "Interner Fehler",
      contactSupport:
        "Bitte kontaktieren Sie unseren Support unter {{supportEmail}}, sollte dieses Problem mehrfach auftreten.",
      done: "Zurück zu Investments",
    },
  },
  symbolSearch: {
    loading: "Lade...",
    title: "Wertpapier-Suche",
    searchLabel: "Name, ISIN, WKN",
    searchPlaceholder: "Name, ISIN, WKN",
    noData: "Leider keine Ergebnisse",
    examples: "Beispiele",
    example1: "Daimler oder DE0007100000",
    example2: "Bitcoin oder BTC",
    example3: "Gold oder Silber",
    example4: "Dollar oder USD",
    manualInvestmentLabel: "Wert nicht verfügbar?",
    manualInvestment: "Manuelles Investment erstellen",
  },
  sidebar: {
    header: {
      title: "Finanzmanager ",
      testPremium: "Premium Testen",
    },
    footer: {
      phoneInfo: "Mo. bis Fr. 9-19 Uhr erreichbar",
      imprint: "Impressum",
      privacy: "Datenschutz",
      terms: "AGB",
      disclaimer: "Haftungsausschluss",
      wealthApi: "wealthAPI GmbH",
    },
  },
  appSidebar: {
    searchField: "Suche: Name, ISIN, WKN",
    menu: {
      accounts: "Konten",
      admin: "Administration",
      capitalMeasure: "Capital Measure",
      cashbackBookings: "Cashback Bookings",
      securitiesAdmin: "Securities Admin.",
      bankAdmin: "Bank Admin. & Reports",
      other: "Other Admin.",
      isinChanges: "ISIN Changes",
      securityType: "Security Type Changes",
      assetReport: "Asset Report",
      apiRefresh: "Historic Quotes Refresh",
      cryptoRefresh: "Crypto Currencies",
      backToLegacy: "Zurück zu v1",
      bankEvents: "Connection Events",
      bankLogs: "Bank Logs",
      bankMessages: "Bank Messages",
      bankHealth: "Bank Health Reports",
      cashback: "Cashback",
      analyse: "Analyse",
      goals: "Ziele",
      names: "Preferred Names",
      mergers: "Mergers",
      spinOffs: "Spin-Offs",
      purchaseRight: "Purchase Rights",
      cashflowAnalyzer: "Cashflow-Analyzer",
      contractAnalyzer: "Contract-Analyzer",
      providerName: "Provider name",
      etfs: "ETF/ETC Classifications",
      logos: "Company Logo",
      classification: "Klassifizierung",
      contracts: "Contracts",
      depots: "Depots",
      depotsAndAccounts: "Portfolios & Konten",
      dividendPlanner: "Erträge",
      dividends: "Dividends",
      helpdesk: "Helpdesk",
      home: "Home",
      interfaces: "Interfaces",
      investments: "Investments",
      logout: "Logout",
      newCashback: "Neue Buchung",
      oneClickImport: "One-Click Import",
      overview: "Übersicht",
      performance: "Depotanalyse",
      portfolio: "Portfolio",
      profile: "Profil",
      risk: "Return and risk",
      settings: "Einstellungen",
      splits: "Splits",
      watchlists: "Watchlists",
      depotCheck: {
        main: "Depotoptimierung",
        questionnaire: "Fragebogen",
      },
    },
  },
  premium: {
    tryPlusMessage:
      "Holen Sie mehr für sich raus und testen Sie {{appName}} <1>PLUS</1> noch heute kostenlos!",
    tryProMessage:
      "Holen Sie mehr für sich raus und testen Sie {{appName}} <1>PRO</1> noch heute kostenlos",
    tryPlus: "Jetzt kostenlos PLUS testen",
    tryPro: "Jetzt kostenlos PRO testen",
  },
  loggedAs: "Eingeloggt als {{username}}",
  intervalSelector: {
    compact: {
      oneWeek: "1W",
      oneMonth: "1M",
      sixMonths: "6M",
      oneYear: "1J",
      sinceBeginning: "Seit Beginn",
    },
    oneWeek: "1 Woche",
    oneMonth: "1 Monat",
    oneYear: "1 Jahr",
    sinceBeginning: "Seit Beginn",
  },
  dateRangePickerDialog: {
    submitButton: "Übernehmen",
    cancelButton: "Zurücksetzen",
  },
  aggregatedChart: {
    legend: {
      overview: "Gesamtübersicht",
      securities: "Wertpapiere",
      accountsAndCards: "Konten & Karten",
    },
  },
  customTooltip: {
    securitiesLabel: "Wertpapiere",
    cardsAndAccountsLabel: "Konten & Karten",
  },
  userDetails: {
    lastLogin: "Letzter Login:",
    hello: "Hallo",
  },
  sideBarMenu: {
    title: "Whitebox Analyze",
    allAssets: "Gesamtvermögen",
    securities: "Wertpapiere",
    cardsAndAccounts: "Konten & Karten",
    settings: "Einstellungen",
    help: "Hilfe & Support",
    logout: "Abmelden",
    myWhiteboxSecurities: "Meine Whitebox-Anlagen",
    mySecurities: "Meine Depots",
  },
  securitiesChart: {
    legend: {
      overview: "Gesamtübersicht",
      holdings: "Einzeltitel",
      etfs: "ETF",
      funds: "Fonds",
      bonds: "Anleihen",
      derivative: "Derivate",
      crypto: "Krypto",
    },
    typeSwitcher: {
      performance: "Performance",
      valuation: "Wert",
      disabledTooltip:
        "Ein Vergleich der Werte kann nur im Modus ‘Performance’ vorgenommen werden",
    },
  },
  promotionTeaser: {
    title: "Verbessern Sie Ihre Renditechancen!",
    desc: "Dieses Depot könnte sich als Whitebox-Anlage um einiges besser entwickeln und bis zu 5% mehr Rendite/Jahr erwirtschaften.",
    disclaimer:
      "This is a disclaimer and/or risk information, if we need to show one here, when we advertise a higher roi with a Whitebox Investment.",
    buttonMore: "Mehr erfahren",
    buttonNo: "Nein, danke",
    percent: "+5%",
    percentSubtitle: "bis zu 5% mehr im Jahr",
  },
  investmentsPage: {
    isinMissing: "ISIN fehlt. Bitte ergänzen!",
    isinInvalid:
      "Die eingegebene ISIN ist ungültig. Bitte überprüfen Sie die ISIN.",
    overview: "Übersicht",
    header: {
      title: "Investments",
      actions: {
        addTitle: "Hinzufügen",
        newDepot: "Neues Depot",
        newPortfolio: "Neues Portfolio",
        newTransaction: "Neue Transaktion",
        main: "Neues Investment",
        create: "Manuell",
        uploadPdf: "PDF Importieren",
        uploadCsv: "CSV Importieren",
      },
    },
  },
  portfolioShare: {
    share: "Teilen",
    banner: {
      portfolio: 'Du siehst gerade das Dashboard "{{portfolio}}".',
      createYourOwn: "Erstelle jetzt dein eigenes Dashboard",
      toMyDashboard: "Zu meinem Dashboard",
      register: "Anmelden",
    },
    privatePortfolio: {
      noAccess: "Du hast keinen Zugriff auf dieses Portfolio.",
      close: "Account erstellen",
    },
    modal: {
      title: "Ansicht festlegen",
      secondTitle: "Dashboard teilen",
      table: {
        selectAll: "Alle Auswählen",
        name: "Name",
        bank: "Bank",
      },
      selectButton: "Portfolio zeigen",
      shareButton: "Dashboard teilen",
      acceptButton: "Übernehmen",
      goToPortfolio: "Vorschau ansehen",
      publishButton: "Dashboard veröffentlichen",
      closeButton: "Schließen",
      cashPositionsShared:
        "Die Cash-Position deiner Verrechnungskonten werden ebenfalls geteilt, wenn dein Dashboard öffentlich ist.",
      private: "Privat",
      privateTooltip:
        "Mit dieser Auswahl bleiben deine Portfolios nur für dich einsehbar. Wenn du deine Portfolios bereits öffentlich geteilt hast, kannst du die Sichtbarkeit hier wieder sperren. Die öffentliche Ansicht ist dann wieder deaktiviert.",
      public: "Öffentlich",
      publicTooltip:
        "Mit dieser Auswahl kannst du dein Portfolio mit anderen teilen. Du kannst absolute oder prozentuale Werte anzeigen lassen. Wenn du prozentuale Werte anzeigst, wissen andere nicht, wieviel Kapital du investiert hast.",
      onlyPercentage: "Nur prozentuale Werte anzeigen",
      dashboardName: "Öffentlicher Dashboard Name",
      dashboardName_placeholder: "z.B. 70/30 Portfolio",
      linkWasCopied: "Der Link zu deinem Dashboard wurde kopiert.",
      linkToDashboard: "Link zum Dashboard",
      copyLink: "Link kopieren",
    },
  },
  investmentEditPage: {
    header: "Bearbeiten",
    breadcrumbs: {
      edit: "Bearbeiten",
    },
    noInvestment: "Investment nicht gefunden",
    tabs: {
      basic: "Stammdaten",
      quoteData: "Kurse",
      advanced: "Erweitert",
    },
    basicTab: {
      name: "Name",
      depot: "Depot",
      industry: "Branche",
      region: "Region",
      customGroup: "Eigene Gruppe",
      saveButton: "Speichern",
      saved: "Daten gespeichert",
    },
    quoteDataTab: {
      selectedText: "Gewählt:",
      nothingSelectedText: "Bitte Wert auswählen",
      saveButton: "Speichern",
    },
    advancedTab: {
      investmentType: "Typ",
      investmentCurrency: "Währung",
      isin: "ISIN",
      wkn: "WKN",
      saveButton: "Speichern",
    },
  },
  itCardsMiniCard: {
    lastTransaction: "Letzte Buchung",
    noTransactions: "Keine Buchungen",
  },
  dashboardPage: {
    allYourAssets: "Ihre Vermögensaufteilung",
    portfolio: "Portfolio",
    investmentsLink: "Gehe zu Investitionen",
    modeBanner: {
      text: "Neu: Ab sofort ist der Rentablo Finanzmanager auch im Dark Mode verfügbar. <linkText>Jetzt Dark Mode ausprobieren</linkText>",
    },
    oneClick: {
      title: "One-click Import",
      text: "Importieren Sie Ihre Cashback-Depots mit nur einen Click.",
      buttonText: "Jetzt nutzen",
    },
    depot: {
      title_one: "{{count}} Depot",
      title_other: "{{count}} Depots",
      noAccountsTitle: "Keine Depots",
      noAccountsSubtitle:
        "Sie haben bisher noch keine Depots hinzugefügt, möchten Sie das jetzt tun?",
      noAccountsButtonText: "Depots hinzufügen",
    },
    currentAssetsBlock: {
      chart: "Chart",
      gainersLosers: "Gewinner & Verlierer",
      gainersLosersShort: "G&V",
      statistic: {
        returnOnInvestment: "Kursgewinn",
        cash: "Cash",
        dividends: "Dividenden",
        realizedGain: "Realisierte Gewinne",
      },
    },
    investments: {
      title_one: "{{count}} Investment",
      title_other: "{{count}} Investments",
      noAccountsTitle: "Keine Investments",
      noAccountsSubtitle:
        "Sie haben bisher noch keine Investments hinzugefügt, möchten Sie das jetzt tun?",
      noAccountsButtonText: "Investments hinzufügen",
    },
    account: {
      title_one: "{{count}} Konten",
      title_other: "{{count}} Konten",
      noAccountsTitle: "Keine Konten",
      noAccountsSubtitle:
        "Sie haben bisher noch keine Konten hinzugefügt, möchten Sie das jetzt tun?",
      noAccountsButtonText: "Konten hinzufügen",
    },
    whitebox: {
      title_one: "{{count}} Whitebox-Anlage",
      title_other: "{{count}} Whitebox-Anlagen",
      noAccountsTitle: "Keine Whitebox-Anlagen",
      noAccountsSubtitle:
        "Sie haben bisher noch keine Whitebox-Anlagen hinzugefügt, möchten Sie das jetzt tun?",
      noAccountsButtonText: "Whitebox-Anlagen hinzufügen",
    },
    cashbackCard: {
      withSubscriptions: {
        title: "Cashback Buchung",
        text: "Für Ihre Buchung benötigen wir noch folgende Dinge:",
        text_processed: "Ihre Buchung ist in Bearbeitung:",
        text_active: "Sie können Ihre Cashback-Depots jetzt importieren",
      },
      noSubscriptions: {
        title: "Bonus erhalten",
        subtitle: "Werbe einen Freund",
        text: "Bringe einen Freund zu {{appName}} und erhalte 15€ als Belohnung.",
      },
      statusMessage: {
        processed: "Aktiv",
        incomplete: "Entwurf; bitte vervollständigen",
        in_progress: "Bitte Unterlagen Einreichen",
        internal_processing: "Unterlagen erhalten - In Bearbeitung",
        processing_at_bank: "An Bank weitergeleitet",
        processing_at_bank_reduced: "Eröffnungsprozess an Bank weitergeleitet",
        contract_terminated: "Gekündigt",
      },
    },
    netfondsImportCard: {
      consentRequired: {
        title: "Ihre Einwilligung wird benötigt",
        body: "Für den Import ihrer Cashback-Depots benötigen wir ihre Einwilligung",
      },
      importAvailable: {
        title: "One-Click Import verfügbar",
        body: "Importieren Sie Ihre Cashback-Depots mit nur einem Klick",
      },
      detailsButton: "Details",
    },
    header: {
      title: "Dashboard",
      welcomePhrases: {
        morning: "Guten Morgen",
        afternoon: "Guten Tag",
        evening: "Guten Abend",
      },
    },
    dashboard: {
      addPortfolio: "Portfolio hinzufügen",
      header: {
        subheader: "Aktuelles Vermögen",
        add: "Portfolio hinzufügen",
      },
      noDataFirstLine: "Aktuell liegen noch keine Daten vor.",
      noDataSecondLine:
        "<linkText>Bitte importiere</linkText> deine Portfolios und Konten.",
      mainDataSection: {
        cash: "Cash",
        holdings: "Holdings",
        assets: "Vermögen",
        returnOnInvestment: "Kursgewinn",
        rateOfReturn: "Interner Zinsfuß",
        dividends: "Dividenden",
        realizedGain: "Realisierte Gewinne",
      },
      includeDividends: "Inklusive Dividenden",
      cashTable: {
        header: "Cash",
      },
      investmentsTable: {
        header: "Holdings",
        columns: {
          name: "Name",
          totalValue: "Gesamtwert",
          change: "Änderung",
          allocation: "Allokation",
        },
        types: {
          "11_stock_one": "Aktie",
          "11_stock_other": "Aktien",
          "21_fund": "Fonds",
          "31_bond_one": "Anleihe",
          "31_bond_other": "Anleihen",
          "41_cash": "Cash",
          "51_certos_one": "Zertifikat / OS",
          "51_certos_other": "Zertifikaten / OS",
          "52_future_one": "Future",
          "52_future_other": "Futures",
          "61_pmetals_one": "Edelmetall",
          "61_pmetals_other": "Edelmetalle",
          "71_massets_one": "Sachwert",
          "71_massets_other": "Sachwerte",
          "81_fcurr_one": "Fremdwährung",
          "81_fcurr_other": "Fremdwährungen",
          "82_crypto_one": "Kryptowährung",
          "82_crypto_other": "Kryptowährungen",
          "22_etf": "ETF",
          "91_managed": "Robo / Crowd",
        },
      },
      performance: {
        tabs: {
          value: {
            title: "Wert",
            portfolio: "Portfolio",
            investedCapitol: "Investiertes Kapital",
          },
          performance: {
            title: "Performance",
            portfolio: "Portfolio",
            dividends: "Portfolio inkl. Dividenden",
          },
          dividend: {
            title: "Dividende",
            total: "Gesamt",
            predicted: "Erwartet",
            investedCapitol: "Investiertes Kapital",
          },
        },
        rangeName: {
          today: "Heute",
          YTD: "YTD",
          oneYear: "1 Jahr",
        },
        viewInvestedCapital: "Investiertes Kapital anzeigen",
        compare: "Vergleich",
        compareWith: "Vergleichen mit",
        compareTooltip:
          "Vergleichen Sie die Leistung mit einem Wertpapier oder Index.",
        includeDividends: "Inklusive Dividenden",
        selectCompare: {
          placeholder: "Name, ISIN oder WKN eingeben",
        },
      },
      gainersAndLosers: {
        gainers: "Gewinner",
        losers: "Verlierer",
        more: "Mehr erfahren",
        period: "1 Tag",
        noData:
          "Keine Gewinner & Verlierer verfügbar. Bitte die Portfolio-Auswahl ändern oder weitere Investments ergänzen.",
      },
      newsBlock: {
        title: "Neuigkeiten & Wissen",
        allArticles: "Alle Artikel ansehen",
        item: {
          type: "Finanzblog",
        },
      },
      cashbackBanner: {
        title: "Cashback: Jetzt Geld zurückholen!",
        text: "Sie bezahlen aktuell <strongText>{{amount}} Bestandsprovision</strongText>, mit {{name}} Cashback holen Sie es sich ganz einfach zurück.",
        button: "Cashback beantragen",
        cancel: "Jetzt nicht",
      },
    },
    cashbackSuggestionCard: {
      subtitle: "Noch mehr profitieren!",
      title: "{{amount}} Fonds-Provision p.a.",
      discount: "Inklusive 100% Agio Rabatt",
      button: "Jetzt Geld zurückholen",
    },
  },
  watchlistsPage: {
    header: {
      title: "Watchlists",
    },
    watchlists: {
      title: "Watchlist",
      create: "Neue Watchlist erstellen",
      newWatchlist: "Watchlist hinzufügen",
    },
    createAndEditForm: {
      label: "Name der Watchlist",
      placeholder: "Name der Watchlist",
    },
  },
  watchlistsCreatePage: {
    breadcrumbs: {
      home: "Home",
      watchlists: "Watchlists",
      create: "Wertpapier hinzufügen",
    },
    header: {
      title: "Watchlist erstellen",
    },
  },
  watchlistsEditPage: {
    breadcrumbs: {
      home: "Home",
      watchlists: "Watchlists",
      edit: "Bearbeiten",
    },
    header: {
      title: "Bearbeiten",
    },
  },
  watchlistSinglePage: {
    header: {
      totalItems_one: "{{count}} Wertpapier",
      totalItems_other: "{{count}} Wertpapiere",
      actions: {
        editWatchlist: "Watchlist bearbeiten",
        deleteWatchlist: "Watchlist löschen",
        addNewItem: "Wertpapier hinzufügen",
      },
      deleteDialog: {
        title: "Watchlist löschen",
      },
    },
    table: {
      noItems: "Keine Wertpapiere vorhanden",
      mobile: {
        sinceWatching: "Seit Beobachtung",
        metrics: {
          today: "Heute",
          oneYear: "1 J.",
          threeYears: "3 J.",
          fiveYears: "5 J.",
        },
        sort: {
          watchPrice: "Seit Beobachtung",
          today: "Heute",
          oneYear: "1 Jahr",
          threeYears: "3 Jahre",
          fiveYears: "5 Jahre",
        },
      },
      headers: {
        name: "Name",
        watchPrice: "Beobachtungskurs",
        currentPrice: "Aktueller Kurs",
        changeToday: "Veränd.",
        oneYear: "1 Jahr %",
        threeYear: "3 Jahr %",
        fiveYear: "5 Jahr %",
      },
    },
    chart: {
      noData: "Bitte fügen Sie weitere Watchlist-Einträge hinzu",
      maxNotice: "Es können maximal 15 Wertpapiere im Graph angezeigt werden",
      moreEntries: "+{{count}} weitere",
    },
    empty: {
      noEntriesTitle: "Noch nichts hinzugefügt",
      noEntriesSubtitle:
        "Füge Elemente hinzu, um immer auf den neusten Stand zu bleiben",
      addFirstSecurity: "Erstes Wertpapier hinzufügen",
      noWatchlistsTitle: "Noch keine Watchlist erstellt",
      noWatchlistsSubtitle:
        "Erstellen Sie Ihre erste Watchlist, um Wertpapiere zu beobachten",
    },
    detailModal: {
      currentValue: "Aktueller Wert",
      performanceToday: "Performance heute",
      edit: "Bearbeiten",
      delete: "Löschen",
      noFundamentalsData:
        "Keine Fundamentaldaten für dieses Wertpapier verfügbar",
      noPriceData: "Keine Kursdaten",
      editTitle: "Wertpapier bearbeiten",
      deleteDialog: {
        title: "Wertpapier entfernen",
        description:
          "Möchten Sie dieses Wertpapier wirklich aus Ihrer Watchlist entfernen?",
        confirm: "Entfernen",
      },
    },
  },
  securitiesAddPage: {
    title: "Wertpapier auswählen",
    description:
      "Suchen Sie einfach nach dem Investment, das Sie hinzufügen möchten.",
    breadcrumbs: {
      securities: "Watchlists",
      add: "Wertpapier hinzufügen",
    },
    securitiesTextFields: {
      date: "Datum",
      price: "Kurs",
      close: "Abbrechen",
    },
    chartHint:
      "Tipp: Wählen Sie Kaufpreis und Kaufdatum einfach über den Graph aus",
    chartNoData: "Aktuell sind keine Daten verfügbar",
    saveButton: "Hinzufügen",
    editButton: "Änderungen übernehmen",
  },
  securitiesEditPage: {
    breadcrumbs: {
      home: "Home",
      securities: "Watchlists",
      edit: "Bearbeiten",
    },
  },
  securitiesSinglePage: {
    breadcrumbs: {
      home: "Home",
      watchlists: "Watchlists",
    },
    mobileHeaderMenuActions: {
      editSecurity: "Wertpapier bearbeiten",
      deleteSecurity: "Wertpapier löschen",
    },
    deleteDialog: {
      title: "Wertpapier löschen",
    },
    tabs: {
      fundamentals: "Fundamentaldaten",
      news: "Nachrichten",
    },
  },
  singleSecurityPage: {
    breadcrumbs: {
      home: "Home",
      quotes: "Wertpapier",
    },
    tabs: {
      fundamentals: "Fundamentaldaten",
      news: "Nachrichten",
    },
  },
  depots: {
    title: "Portfolios & Konten",
    depotsTitle_one: "{{count}} Depot",
    depotsTitle_other: "{{count}} Depots",
    noAccountsTitle: "Keine Konten",
    noAccountsSubtitle:
      "Sie haben bisher noch keine Konten hinzugefügt, möchten Sie das jetzt tun?",
    noAccountsButtonText: "Konten hinzufügen",
    addManuallyButton: "Investment hinzufügen",
    deleteModal: {
      question: "Dieses Depot löschen?",
    },
  },
  depotPage: {
    breadcrumbs: {
      home: "Home",
      depots: "Depots",
    },
    header: {
      title: {
        mobile: "Depot",
      },
    },
    headerMenu: {
      moreActions: "Weitere Aktionen",
      upload: "PDF Hochladen",
      uploadCsv: "CSV Hochladen",
      update: "Aktualisieren",
      addButton: "Investment hinzufügen",
      edit: "Bearbeiten",
      showUpdateHistory: "Update-Verlauf anzeigen",
      manageBankConnection: "Bankverbindung verwalten",
      transfer: "Depotübertrag",
      editReferenceAccount: "Referenzkonto bearbeiten",
      hide: "Ausblenden",
      show: "Anzeigen",
      delete: "Depot löschen",
      reconnect: "Neu verbinden",
    },
    deleteModal: {
      question: "Dieses Depot löschen?",
      deleteContraAccount: "Verrechnungskonto löschen",
    },
    chart: {
      performanceYTD: "{{changeYTD}} Wertentwicklung",
      performanceToday: "Heute: {{changeToday}}",
      noData: "Aktuell liegen noch keine Daten vor",
    },
    tabs: {
      transactions: "Protokoll",
      investments: "Investments",
    },
    showHistoricSwitch: "Historische anzeigen",
    since: "Seit",
    subcategories: {
      depots: "Depots & Verrechnungskonten",
      cash: "Konten & Kreditkarte",
      assets: "Edelmetalle & Sachwerte",
      insurance: "Versicherungen",
      crypto: "Krypto",
    },
    addOptions: {
      depots: "Depot",
      cash: "Konten & Kreditkarten",
      assets: "Edelmetalle & Sachwerte",
      insurance: "Versicherungen",
    },
  },
  depotsSelect: {
    title: "Ansicht festlegen",
    saveButton: "Auswahl bestätigen",
    table: {
      headers: {
        name: "Name",
        bank: "Bank",
      },
    },
  },
  loginPage: {
    header: {
      title: "Bei {{appName}} einloggen",
      subtitle: "Geben Sie Ihre Zugangsdaten ein.",
    },
    form: {
      emailField: "Ihre Email Adresse",
      emailFieldPlaceholder: "name@email.de",
      passwordField: "Passwort",
      passwordFieldPlaceholder: "Passwort eingeben",
      submitButton: "Jetzt Einloggen",
      twoFACodeLabel: "2FA Code eingeben",
      twoFASubmitButton: "2FA bestätigen und einloggen",
      rememberMe: "Angemeldet bleiben",
      requestErrors: {
        loginFailed:
          "Login fehlgeschlagen. <passwordRestoreLink>Haben Sie Ihr Passwort vergessen?</passwordRestoreLink>",
        somethingWrongWithoutStatus:
          "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmals. Kontaktieren Sie unseren Support unter <supportEmailLink>{{email}}</supportEmailLink>, sollte dieses Problem mehrfach auftreten.",
      },
    },
    signupMessage: {
      link: "Registrieren",
      question: "Noch keinen Account?",
    },
    resetPassword: {
      question: "Passwort vergessen?",
      link: "Hier klicken",
    },
    twoFACodeError:
      "Ungültiger oder abgelaufener 2FA Code. Bitte versuchen Sie es erneut und <linkText>loggen Sie sich neu ein</linkText>.",
  },
  signupPage: {
    header: {
      title: "Voller Überblick über Ihre Finanzen",
      subtitle: "{{appName}} ist kostenlos und unverbindlich",
    },
    form: {
      firstName: "Vorname",
      lastName: "Nachname",
      email: "Ihre Email Adresse",
      password: "Passwort",
      acceptedAgb:
        "Ich stimme den {{appName}} <agb>AGBs</agb> und <privacy>Datenschutzbestimmungen</privacy> zu",
      news: "Ich möchte über Produktupdates und Sparangebote informiert werden",
      submitButton: "Bei {{appName}} registrieren",
      rememberMe: "Angemeldet bleiben",
      gender: {
        title: "Anrede",
        male: "Herr",
        female: "Frau",
      },
      errors: {
        agb: "AGB & Datenschutz: Muss angegeben werden",
      },
      requestErrors: {
        somethingWrongWithoutStatus:
          "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es nochmals. Kontaktieren Sie unseren Support unter <supportEmailLink>{{email}}</supportEmailLink>, sollte dieses Problem mehrfach auftreten.",
      },
    },
    loginMessage: {
      linkText: "Jetzt Einloggen",
      question: "Bereits registriert?",
    },
  },
  resetPasswordPage: {
    header: {
      title: "Passwort vergessen",
      subtitle:
        "Bitte geben Sie Ihre Email-Adresse ein; nachfolgend erhalten Sie einen Link zum Zurücksetzen des Passworts per Email.",
    },
    form: {
      email: "Email:",
      submitButton: "Email senden",
      successfulMessage:
        "Wir haben Ihnen eine Email zum Zurücksetzen Ihres Passworts gesendet ({{email}}).",
    },
  },
  assignPasswordPage: {
    header: {
      title: "Neues Passwort vergeben",
    },
    form: {
      password: "Passwort",
      submit: "Passwort ändern",
    },

    success: "Dein Passwort wurde erfolgreich geändert",
    error: "Etwas ist schief gelaufen. Bitte versuche es erneut",
  },
  depotsAccountsPage: {
    noResults: "Keine passenden Ergebnisse gefunden",
    showHiddenItems: "Versteckte Elemente anzeigen",
    mobile: {
      search: "Suche",
      category: "Kategorie",
      allCategories: "Alle Kategorien",
      categoriesSelected: "{{count}} Kategorien",
      showHidden: "Versteckte anzeigen ({{count}})",
    },
    chips: {
      all: "Alle",
      "01_depot": "Depots & Verrechnungskonten",
      "02_cash": "Konten & Kreditkarte",
      "04_insurance": "Versicherungen",
      "05_material_assets": "Edelmetalle & Sachwerte",
    },
    accountChips: {
      userGenerated: "Nutzergeneriert",
      userGeneratedTooltip:
        "Bitte Änderungen/Details anhand des Depotauszugs selbst prüfen und ggf. aktualisieren.",
      manual: "Manuell",
      manualTooltip:
        "Manuelle Aktualisierung erforderlich. Die letzte Prüfung der Bankverbindung hat am {{lastSyncDate}} stattgefunden. Die letzte Aktivität im Portfolio wurde am {{lastChange}} erkannt. Bitte aktualisieren Sie die Bankverbindung, indem Sie hier oder in der Portfolio-Ansicht auf „Aktualisieren“ klicken.",
      automatic: "Automatisch",
      automaticTooltip:
        "Automatische Aktualisierung. Die letzte Prüfung der Bankverbindung hat am {{lastSyncDate}} stattgefunden. Die letzte Aktivität im Portfolio wurde am {{lastChange}} erkannt. Ihre Bankverbindung wird automatisch aktualisiert, d.h. es gibt aktuell keinen Handlungsbedarf.",
      lastActivity: "Letzte Aktivität {{date}}",
    },
  },
  accounts: {
    title: "Konten",
    primaryReferenceBadge: "Primärkonto",
    breadcrumbs: {
      home: "Home",
      add: "Hinzufügen",
    },
    addMobileTitle: "Konten hinzufügen",
    addButton: "Hinzufügen",
    addManuallyButton: "Manuell verwaltet",
    noAccountsTitle: "Keine Konten",
    noAccountsSubtitle: "Keine Konten. Möchten Sie nun Konten hinzufügen?",
    noAccountsButtonText: "Jetzt hinzufügen",
    fillForm: "Manuell gepflegtes Konto erstellen",
    chooseType: "Typ",
    fillFormDepots: "Manuell gepflegtes Portfolio erstellen",
    add: {
      title: "Importieren oder manuell einpflegen?",
      subtitle:
        "Du hast verschiedene Möglichkeiten, deine Daten zu importieren",
      titleBank: "Depots/Konten importieren",
      subtitleBank: "Bitte wähle deine Bank aus",
      titleManual: "Manuell gepflegtes Portfolio erstellen",
      importBank: "Automatisierter Import",
      importManual: "Manueller Import",
      importBankDescription:
        "Depots und Konten direkt mit deiner Bank verbinden",
      importManualDescription:
        "Portfolio anlegen und Buchungen selbst eintragen",
      iWantTo: "So möchte ich importieren:",
      bank: "Bankimport",
      importManualDepot: "Manuelles Portfolio erstellen",
    },
    addManually: {
      chooseType: "Kontentyp",
      type: "Typ",
      name: "Name",
      namePlaceholder: "E.g. Mein Depot",
      bank: "Bank",
      bankPlaceholder: "Bank Name, BIC oder IBAN",
      currency: "Währungen",
      create: "Erstellen",
      back: "Zurück",
    },
    sort: {
      name: "Name",
      bankName: "Bank Name",
      performance: "Kurs/Änderung",
      totalValue: "Gesamtwert",
    },
    showHiddenItems: "Versteckte Elemente anzeigen",
  },
  transactionDetails: {
    productName: "Produktbezeichnung",
    numberOfLots: "Anteile",
    entryQuote: "Kurs",
    assetType: "Asset-Klasse",
    isin: "ISIN",
  },
  transactionsTable: {
    depotValue: "Depotbestand",
    period: "Zeitraum",
    valueDate: "Valuta",
    bookingDate: "Buchtag",
    bookingInformation: "Buchungsinformation",
    value: "Wert",
    noPurpose: "Nicht verfügbar",
    noTransactions: "Keine Transaktionen für den Zeitraum",
    status: {
      edit: {
        title: "Manuelle Daten",
        text: "Kein Handlungsbedarf. Die Daten wurden vom Nutzer manuell eingegeben.",
      },
      link: {
        title: "Bankimport-Daten",
        text: "Kein Handlungsbedarf. Die Bank oder der Broker hat den genauen Betrag und die genaue Stückzahl zu dieser Transaktion übermittelt. Das ist der beste Fall und liefert präzise Daten.",
      },
      returned: {
        title: "Geschätzte Daten",
        text: "Bitte Daten überprüfen. Die Bank oder der Broker hat den genauen Betrag angegeben, aber NICHT die Stückzahl. Die Stückzahl wurde daher auf der Grundlage historischer Kursdaten geschätzt. Dies funktioniert im Allgemeinen gut, wenn es nicht zu viele Transaktionen gibt.",
      },
      warning: {
        title: "Virtuelle Ausgleich-Buchung (Stückzahl unter Null)",
        text: "Handlungsbedarf: Bitte Daten korrigieren. Es musste eine virtuelle Buchung  erstellt werden, um zu verhindern, dass die Stückanzahl zu irgendeinem Zeitpunkt unter Null fällt. Ein solcher Fall kann eintreten, wenn Daten fehlen oder eine Schätzung falsch ist.",
      },
      warningDelta: {
        title: "Virtuelle Buchung (Abweichung bei Stückzahl)",
        text: "Handlungsbedarf: Bitte Daten korrigieren. Es gab eine Abweichung (auch Tracking-Error genannt) zwischen der aus der Auftragshistorie berechneten Stückzahl und der von der Bank gemeldeten Stückzahl. Solche Tracking-Error können aufgrund von Dateninkonsistenzen oder aufgrund von Kapitalmaßnahmen wie Carve-Outs, Depotübertragungen oder Splits auftreten.",
      },
      csv: {
        title: "CSV Import Daten",
        text: "Kein Handlungsbedarf. Der genaue Betrag und die genaue Stückzahl zu dieser Transaktion wurden per CSV Import übermittelt. Das ist der beste Fall und liefert präzise Daten.",
      },
    },
  },
  investmentsTable: {
    noAccountNumber: "Nicht verfügbar",
    noLastSyncDate: "Nicht verfügbar",
    summary: {
      today: "Heute",
      priceGains: "Kursgewinne",
      purchaseValue: "Kaufwert",
      marketValue: "Marktwert",
      totalReturn: "Gesamtrendite",
      showDetails: "Details anzeigen",
      hideDetails: "Details ausblenden",
    },
  },
  bookingsTable: {
    overallValue: "Depotwert",
    period: "Zeitraum",
    valueDate: "Zeitraum",
    investment: "Investition",
    price: "Preis",
    value: "Wert",
    noBookings: "Keine Buchungen für den Zeitraum",
    exchangeRate: "Tauschrate: ",
  },
  assetClassName: {
    "11_stock": "Aktie",
    "71_massets": "Sachwert",
    "91_managed": "Robo / Crowdfunding",
    "21_fund": "Fonds",
    "22_etf": "ETF",
    "51_certos": "Zertifikate/OS",
  },
  accountView: {
    noBank: "Keine Bank",
  },
  accountBox: {
    noBank: "Keine Bank",
  },
  bitpandaV1Banner:
    "Die v1 API von Bitpanda wird nicht mehr unterstützt. Bitte migrieren Sie zu v2. Bitte wählen Sie hierzu Bitpanda (v2) aus der Banksuche aus.",
  mainChartLayout: {
    timeBrushClose: "Schließen",
    timeBrushOpen: "Verlauf",
  },
  viewLayout: {
    close: "Schließen",
  },
  performanceOverview: {
    gainAndLoss: "GUV (ENTW. + Realisiert)",
    realizedGains: "Realisiert",
    returnOnInvestment: "Kursgewinne",
    performance: "Performance",
  },
  dividendsChart: {
    title: "Dividenden-Entwicklung",
    subtitle: "Die Dividenden-Auszahlungshistorie",
    tooltip:
      "Die Dividenden Auszahlungs-Historie. Erfolgen mehrere Zahlungen pro Jahr, so werden die Werte auf volle Jahre aufsummiert.",
  },
  historicalQuotesChart: {
    year_one: "{{count}} Jahr",
    year_other: "{{count}} Jahre",
    title: "Kursentwicklung",
    subtitle: "Entwicklung der letzten N Jahre bis heute",
    tooltip: "Dies zeigt die Kursentwicklung von N Jahren bis heute.",
  },
  investmentChartTooltip: {
    buy: "Kauf",
    sell: "Verkauf",
    dividend: "Dividende",
    book_in: "Einbuchung",
    book_out: "Ausbuchung",
    retained_dividend: "Thesaur. Dividende",
    purchase_right: "Verkauf Bezugsrechte",
    carve_out: "Carve out",
    split: "Split",
    expected_dividend: "Erwartete Dividende",
    reverse_split: "Reverse Split",
    switch: "Switch",
    fees: "Gebühren",
    cap_gains_tax: "KESt",
    cap_gains_tax_refund: "KESt-Rückerstattung",
    pre_tax_allowance: "Vorabpauschale",
  },
  assetTypeBreakdown: {
    allHoldings: {
      title: "Einzeltitel",
      noData: "Keine Einzeltitel",
    },
    funds: {
      title: "Fonds",
      noData: "Keine Fonds",
    },
    etfs: {
      title: "ETF",
      noData: "Keine ETF",
    },
    derivative: {
      title: "Derivate",
      noData: "Keine Derivate",
    },
    bonds: {
      title: "Anleihen",
      noData: "Keine Anleihen",
    },
    crypto: {
      title: "Krypto",
      noData: "Kein Krypto",
    },
    currencies: { title: "Währungen", noData: "Keine Währungen" },
    preciousMetals: { title: "Edelmetalle", noData: "Keine Edelmetalle" },
    filter: {
      clear: "{{classes}}: alle Anlageklassen anzeigen",
      label: "Anlageklasse",
      all: "Alle Anlageklassen",
      selected: "{{count}} Anlageklassen",
      empty: "Keine Investments in den gewählten Anlageklassen.",
      share: "{{percent}} % des Portfolios",
    },
  },
  breadcrumbs: {
    home: "Home",
    investments: "Investments",
    cashback: "Cashback",
    depotsAccounts: "Portfolios & Konten",
    accounts: "Konten",
    addDividends: "Add dividends",
    recommend: "Empfehlung",
    cashflow: "Cashflow Analyzer",
    contract: "Contract Analyzer",
    goals: "Ziele",
  },
  tradeRepublic: {
    connectFrom: {
      phone: {
        label: "Telefon",
        helperText: "Internationales Format, ex.: +4915753345623",
      },
      pin: {
        label: "PIN",
        helperText: "vier Stellen, z. B.: 1234",
      },
      submit: "Schicken",
    },
    codeFrom: {
      code: {
        label: "Code aus der App",
        helperText: "vier Stellen, z. B.: 1234",
      },
      submit: "Daten abrufen",
    },
    error: {
      title: "Error",
      message: "Bitte wenden Sie sich an den {{appName}}-Support.",
    },
    success: {
      title: "Success",
      message: "Daten werden im Hintergrund abgerufen. Danke für die Hilfe.",
    },
  },
  accountChart: {
    subtitle: "Aktueller Kontostand",
  },
  impersonation: {
    banner: "Sie agieren im Namen von {{user}}.",
    end: "Identitätswechsel beenden",
  },
  admin: {
    userManagement: {
      title: "Benutzerverwaltung",
      searchTab: "Benutzer suchen",
      search: {
        label: "Benutzer suchen",
        placeholder: "Suche nach ID, Name oder E-Mail",
        fullWildcard: "Volle Wildcard-Suche",
        fullWildcardHint: "(langsamer)",
        noMatch: 'Keine Benutzer entsprechen „{{term}}".',
        prompt: "Suchen, um Benutzer aufzulisten.",
      },
      table: {
        id: "ID",
        name: "Name",
        email: "E-Mail",
        status: "Status",
      },
      status: {
        active: "aktiv",
        inactive: "inaktiv",
      },
      recentlyViewed: {
        title: "Kürzlich angesehen",
        subtitle: "ID {{id}} · {{email}}",
      },
      detail: {
        title: "Benutzerdetails",
        fallbackTitle: "Benutzer",
        loadError: "Dieser Benutzer konnte nicht geladen werden.",
        impersonate: "Identität annehmen",
        lastLoginLine:
          "Letzte Anmeldung {{lastLogin}} · Mitglied seit {{memberSince}}",
      },
      account: {
        title: "Konto",
        email: "E-Mail",
        name: "Name",
        finApi: "FinAPI-Konto",
        emailDeliveryStatus: "E-Mail-Zustellstatus",
        resetStatus: "Status zurücksetzen",
        acceptedAgb: "AGB akzeptiert",
        acceptedAgbOn: "Ja · {{date}}",
        notAccepted: "Nicht akzeptiert",
        mandator: "Mandant",
        yes: "Ja",
        no: "Nein",
        readOnly: "(schreibgeschützt)",
        mandatorChanged: "Mandant geändert zu {{mandator}}.",
        saveEmail: "E-Mail speichern",
      },
      flags: {
        title: "Statuskennzeichen",
        emailConfirmed: "E-Mail bestätigt",
        enabled: "Konto aktiviert",
        locked: "Konto gesperrt",
        clientCredentialsDisabled: "Client-Anmeldedaten deaktiviert (Admin)",
        accountExpired: "Konto abgelaufen (schreibgeschützt)",
        passwordExpired: "Passwort abgelaufen (schreibgeschützt)",
        lockedSuccess: "Konto gesperrt.",
        unlockedSuccess: "Konto entsperrt.",
      },
      roles: {
        title: "Rollen",
        none: "Keine Rollen zugewiesen.",
        showAll: "Alle anzeigen ({{count}} weitere)",
        showLess: "Weniger anzeigen",
        addPlaceholder: "Rollen suchen, z. B. ROLE_IMPERSONATE",
        assignRole: "Rolle zuweisen",
        removeTitle: "Rolle entfernen",
        removeConfirm: "Die Rolle {{role}} von {{user}} entfernen?",
        removeConfirmLabel: "Entfernen",
      },
      common: {
        cancel: "Abbrechen",
      },
      roleManagementTab: "Rollenverwaltung",
      roleManagement: {
        title: "Alle Rollen",
        addTitle: "Rolle hinzufügen",
        addLabel: "Rollenbezeichnung",
        addPlaceholder: "z. B. ROLE_SUPPORT_AGENT",
        addButton: "Rolle hinzufügen",
        deleteTitle: "Rolle löschen",
        deleteConfirm:
          "Die Rolle {{role}} löschen? Das kann nicht rückgängig gemacht werden.",
        deleteConfirmLabel: "Löschen",
        noRoles: "Keine Rollen gefunden.",
        column: {
          authority: "Bezeichnung",
          actions: "",
        },
      },
    },
    grants: {
      title: "Benutzer-Tokens",
      receivingUser: {
        title: "Empfangender Benutzer",
        subtitle:
          "Der Benutzer, dessen API-Token das Recht erhält, andere zu imitieren.",
      },
      userSearch: {
        placeholder: "Nach E-Mail, Name oder ID suchen",
        loading: "Suche läuft…",
        noOptions: "Keine passenden Benutzer.",
      },
      tokenPicker: {
        title: "Empfangendes Token",
        subtitle:
          "Wähle aus, welches API-Token dieses Benutzers Impersonation-Rechte erhält.",
        loadError:
          "Die API-Tokens dieses Benutzers konnten nicht geladen werden.",
      },
      empty: {
        title: "Dieser Benutzer hat keine API-Tokens.",
        hint: "Der Entwickler muss ein Token in seinem eigenen Profil erstellen — Admins können das nicht in seinem Namen tun.",
      },
      table: {
        id: "ID",
        name: "Name",
        prefix: "Präfix",
        created: "Erstellt",
        permissions: "Berechtigungen",
        lastUsed: "Zuletzt verwendet",
        expires: "Läuft ab",
      },
      control: {
        grants: {
          title: "Bestehende Freigaben",
          subtitle: "Benutzer, die dieses Token derzeit imitieren kann.",
          loadError: "Die bestehenden Freigaben konnten nicht geladen werden.",
          target: "Zielbenutzer",
          grantedBy: "Erteilt von",
          expires: "Läuft ab",
          status: "Status",
          statusActive: "Aktiv",
          statusExpired: "Abgelaufen",
          revoke: "Widerrufen",
          cancel: "Abbrechen",
          empty: "Für dieses Token gibt es noch keine Impersonation-Freigaben.",
          revokeTitle: "Freigabe widerrufen",
          revokeText:
            "Diese Impersonation-Freigabe widerrufen? Das Token des Entwicklers verliert sofort den Zugriff auf diesen Benutzer.",
        },
        add: {
          title: "Freigaben hinzufügen",
          subtitle:
            "Erteile diesem Token das Recht, weitere Benutzer zu imitieren.",
          targetsLabel: "Ziel-Benutzer-IDs",
          targetsPlaceholder: "z. B. 113414, 643213, 43143",
          targetsHelper:
            "Kommagetrennte Benutzer-IDs der zu imitierenden Benutzer. Leerzeichen werden ignoriert.",
          targetsError: "Gib mindestens eine gültige Benutzer-ID ein.",
          modeSearch: "Benutzer suchen",
          modePaste: "Benutzer-IDs einfügen",
          searchLabel: "Zielbenutzer",
          searchHelper:
            "Wähle einen Benutzer aus, um ihn der Liste unten hinzuzufügen.",
          selectedEmpty: "Noch keine Benutzer ausgewählt.",
          remove: "Entfernen",
          expiryLabel: "Ablauf",
          expiryOption_one: "In {{count}} Tag",
          expiryOption_other: "In {{count}} Tagen",
          expiryHint: "Maximal 7 Tage.",
          mfaLabel: "MFA-Code",
          mfaHint: "6-stelliger Code aus deiner Authenticator-App.",
          mfaRequired: "Gib deinen MFA-Code ein.",
          mfaExpired:
            "Dein MFA-Code ist während der Anfrage abgelaufen — bitte gib einen neuen ein, um fortzufahren.",
          submit: "Berechtigungen erteilen",
          continue: "Fortfahren",
          progress: {
            pending: "Ausstehend",
            granted: "Erteilt",
            failed: "Fehlgeschlagen",
          },
        },
        errors: {
          forbidden:
            "Dein Konto hat keine Berechtigung, Impersonation-Freigaben zu erteilen.",
          notFound:
            "Das Token oder die Freigabe existiert nicht. Es wurde möglicherweise gelöscht — bitte die Seite neu laden.",
          mfaDisabled:
            "Du musst 2FA für dein Konto aktivieren, bevor du Impersonation erteilen kannst.",
          mandatorScope:
            "Sowohl der Token-Eigentümer als auch der imitierte Benutzer müssen in deinem Mandanten sein.",
          expiryRange: "Der Ablauf muss innerhalb der nächsten 7 Tage liegen.",
          generic: "Etwas ist schiefgelaufen.",
        },
      },
    },
    logos: {
      title: "Company or emitter logo",
      breadrcumb: "Company logo",
      add: "Add logo",
      searchButton: "Logo",
      isin: "ISIN",
      name: "Name",
      logo: "Logo",
      date: "Date",
      addTitle: "Add logo",
      logoUpload: "Logo hierhin ziehen oder auswählen",
      bannerTitle: "Änderung des aktuellen Logos",
      bannerDescription:
        "Das aktuelle Logo wird durch das neue Logo ersetzt, sobald Sie das neue Logo hochladen und speichern",
      bannerButton: "Okay",
      noLogos: "No logos found",
      deleteThisLogo: "Delete this logo?",
      succesUpload: "Das Logo wurde erfolgreich hochgeladen",
    },
    etfs: {
      title: "ETF/ETC Classification",
      add: "Add classification",
      deleteThisClassification: "Delete this classification?",
      isin: "ISIN",
      name: "Name",
      type: "Classification",
      date: "Date",
      apply: "Search",
      noEtfs: "No ETFs/ETCs found",
    },
    names: {
      title: "Preferred names",
      add: "Add preferred name",
      edit: "Edit preferred name",
      deleteThisName: "Delete this name?",
      isin: "ISIN",
      standardName: "Standard name",
      preferredName: "Preferred name",
      date: "Date",
      search: "Search",
      apply: "Save",
      noNames: "Nothing found",
    },
    assetReport: {
      title: "Asset Report",
      emitters: {
        label: "Fonds- / ETF- Emittent",
        all: "Alle",
        funds: "Fonds-Emittent",
        etfs: "ETF-Emittent",
      },
      emitter: {
        label: "Emittenten auswählen",
        placeholder: "Name eingeben",
      },
      isins: {
        label:
          "ISINs einfügen (Bitte geben Sie die einzelnen ISINs komma-separiert ohne Leerzeichen ein)",
        placeholder: "ISINs einfügen",
      },
      startDate: {
        label: "Datum von (Optional)",
      },
      endDate: {
        label: "Datum bis (Optional)",
      },
      button: "Report generieren",
      table: {
        tabTitle: "Tabelle",
        emitters: "Emittenten",
        isins: "ISINs",
        from: "Datum von",
        startVolume: "Startvolumen",
        to: "Datum bis",
        endVolume: "Endvolumen",
        delta: "Delta",
        total: "Gesamt Betrag:",
      },
    },
    isinChanges: {
      mainPage: {
        applyConfirmTitle:
          "Diese ISIN-Änderung auf alle Investments mit dieser ISIN anwenden?",
        applyConfirmText: "Diese Aktion kann nicht rückgängig gemacht werden",
        applyButton: "Anwenden",
        applySuccess: "ISIN-Änderung erfolgreich angewendet",
        applyError: "ISIN-Änderung konnte nicht angewendet werden",
      },
    },
    splits: {
      mainPage: {
        breadcrumbs: {
          splits: "Splits verwalten",
        },
        title: "Splits verwalten",
        addButton: "Split",
        noSplits: "Keine Splits gefunden",
        apply: "Anwenden",
        deleteThisSplit: "Diesen Split löschen?",
      },
      actions: {
        showActions: "Aktionen anzeigen",
        addToAll: "allen hinzufügen",
        updateAll: "alle aktualisieren",
        deleteAll: "aus allen löschen",
        addToAllConfirmTitle: "Diesen Split allen Positionen hinzufügen?",
        addToAllConfirmText:
          "Der Split von {{isin}} am {{date}} wird auf jeder Position gebucht, die vor dem Split-Datum gehalten wurde und keinen Split in der Nähe hat. Der Job läuft im Hintergrund.",
        updateAllConfirmTitle:
          "Diesen Split auf allen Positionen aktualisieren?",
        updateAllConfirmText:
          "Jede Position mit {{isin}} bekommt genau diesen Split am {{date}}: Fehlende Splits werden ergänzt, abweichende ersetzt. Der Job läuft im Hintergrund.",
        deleteAllConfirmTitle: "Diesen Split aus allen Positionen löschen?",
        deleteAllConfirmText:
          "Die aus diesem gelöschten Split erzeugten Split-Buchungen werden auf jeder Position mit {{isin}} zurückgerollt. Der Job läuft im Hintergrund.",
        started_one: "Für {{count}} Depot gestartet",
        started_other: "Für {{count}} Depots gestartet",
        error: "Der Split konnte nicht verarbeitet werden",
      },
      editPage: {
        submit: "Speichern",
        breadcrumbs: {
          edit: "Split bearbeiten",
          add: "Split hinzufügen",
        },
      },
    },
    dividends: {
      save: "Speichern",
      close: "Abbrechen",
      clone: "Dividenden kopieren",
      mainPage: {
        title: "Dividenden verwalten",
        breadcrumbs: {
          dividends: "Dividenden verwalten",
        },
        noDividends: "Keine Dividenden gefunden",
        apply: "Anwenden",
        deleteThisDividend: "Diesen Dividend löschen?",
        noIsin: "Keine ISIN angegeben. Bitte geben Sie eine ISIN an",
      },
      cloneModal: {
        title: "Dividenden kopieren",
        success: "Dividenden erfolgreich kopiert",
      },
      addPage: {
        title: "Dividende hinzufügen",
      },
      editPage: {
        title: "Dividende bearbeiten",
        fields: {
          isin: "ISIN",
          amount: "Amount",
          currency: "Currency",
          exDate: "Execution Date",
          paymentDate: "Payment date",
          splitAdjustedAmount: "Split adjusted amount",
          amountInCurrency: "Amount in currency",
          splitAdjustedAmountInCurrency: "Split adjusted amount in currency",
          markedAsDeleted: "Marked as deleted",
          wasCurated: "Was curated",
          isSpecial: "Special",
        },
      },
    },
    interfaces: {
      mainPage: {
        title: "Interfaces verwalten",
        breadcrumbs: {
          interfaces: "Interfaces verwalten",
        },
      },
      editPage: {
        submit: "Speichern",
        breadcrumbs: {
          edit: "Interface bearbeiten",
          add: "Interface hinzufügen",
        },
      },
    },
    bankMessages: {
      title: "Übersicht über Banknachrichten",
      createNew: "Nachricht erstellen",
      breadcrumbs: {
        bankMessages: "Nachrichtenübersicht",
      },
      filterBy: "Filtern nach",
      createSuccess: "Nachricht erfolgreich erstellt",
      createError: "Nachricht konnte nicht erstellt werden",
      deleteSuccess: "Nachricht erfolgreich gelöscht",
      deleteError: "Nachricht konnte nicht gelöscht werden",
      updateSuccess: "Nachricht erfolgreich aktualisiert",
      updateError: "Nachricht konnte nicht aktualisiert werden",
      copySuccess: "Nachricht erfolgreich kopiert",
      copyError: "Nachricht konnte nicht kopiert werden",
      table: {
        severity: "Nachrichtentyp",
        bic: "BIC",
        message_text: "Nachrichtentext",
        valid_until: "Fälligkeit",
        unlimited: "Unbefristet",
        expired: "Abgelaufen",
        expiresToday: "Läuft heute ab",
        expiresIn_one: "Fällig in {{amount}} Tag",
        expiresIn_other: "Fällig in {{amount}} Tagen",
        expiresInHours_one: "Fällig in {{amount}} Stunde",
        expiresInHours_other: "Fällig in {{amount}} Stunden",
        INFO: "Info",
        WARNING: "Warning",
        ERROR: "Error",
        edit: "Bearbeiten",
        copy: "Kopieren",
        delete: "Löschen",
        noData: "Keine Daten",
      },
      form: {
        limited: "Begrenzte Nachricht",
        message_text: "Nachrichtentext",
        message_text_placeholder: "Text eingeben",
        severity: "Schweregrad",
        bic: "BIC",
        start_date: "Date von",
        start_date_tooltip:
          'Bitte wähle das Startdatum für die Anzeige der Nachricht aus. Bei Auswahl des heutigen Tages als Startdatum wird die Nachricht sofort nach Klick auf den Button "Nachricht aktualisieren" angezeigt. Bei Auswahl eines zukünftigen Datums wird die Nachricht am ausgewählten Tag ab 0 Uhr angezeigt.',
        end_date: "Date bis",
        end_date_tooltip:
          "Bitte wähle das Enddatum für die Anzeige der Nachricht aus. Die Nachricht wird am ausgewählten Tag bis 0 Uhr angezeigt.",
      },
      newModal: {
        title: "Nachricht erstellen",
        submit: "Nachricht erstellen",
      },
      editModal: {
        title: "Nachricht noch mal verwenden",
        submit: "Nachricht aktualisiren",
      },
    },
    bankEvents: {
      title: "Bank Connection Events",
      userId: "User ID",
      userId_placeholder: "User ID eingeben",
      table: {
        date: "Datum",
        bankName: "Bank Name",
        faq: "FAQ",
        copyCode: "Code kopieren",
        warning: "Warning",
        error: "Error",
        info: "Info",
        faqTooltip:
          'Der Link führt Dich zu unserem wealthAPI Help Center. Du musst mit Deinen Anmeldedaten bei Zendesk eingeloggt sein, damit Du Zugriff auf unsere FAQ hast. Am besten merkst Du Dir die "message" aus dem Code. Gib die entsprechenden Stichworte in die FAQ-Suche ein, damit Du den passenden Eintrag angezeigt bekommst.',
        noData: "Keine Daten",
      },
    },
    cashbackBookings: {
      title: "Cashback Bookings",
      mandatorLabel: "Filter by mandator (default: all mandators)",
      absByMonth: "Cashback subscriptions absolute by month",
      mailReturnByMonth: "Subscription mail return rate in percent by month",
      averageMailReturn: "Average mail return rate is {{value}}",
      churnByMonth: "Subscription churn rate in percent by month",
      avgChurnRate: "Average churn rate is {{value}}",
      currentAssetsByBank: "Current assets by bank",
      totalManagedByMonth: "Total managed assets by month",
    },
    apiRefresh: {
      title: "Historic Quotes Refresh",
      hqIsin: {
        isinLabel: "ISIN",
      },
      hqTicker: {
        tickerLabel: "Ticker symbol",
        quoteLabel: "Quote provider",
      },
      button: "Refresh",
      successMessage: "Refreshed succesfully",
      errorMessage: "Refresh failed",
    },
    bankLogs: {
      title: "Bank Sync Logs",
      subtitle:
        "Anhand einer User ID kannst Du Dir für einen bestimmten Zeitraum die Importdaten zu einer ausgewählten Bank anzeigen lassen. Die Log Files werden Dir als Code zur Verfügung gestellt, wenn Du auf einen Eintrag in der Tabelle klickst.",
      form: {
        start_date: "Datum von",
        start_date_tooltip:
          "Bitte wähle das Startdatum für den gewünschten Zeitraum aus",
        end_date: "Datum bis",
        end_date_tooltip:
          "Bitte wähle das Enddatum für den gewünschten Zeitraum aus",
        userId: "User ID",
        bank: "Bank",
      },
      table: {
        date: "Zeit",
        logId: "Log ID",
        userId: "User ID",
        noData: "Keine Daten",
      },
    },
    bankHealth: {
      title: "Bank Health Reports",
      tabs: {
        table: "Tabelle",
        chart: "Chartansicht",
        errors: "Tracking error",
      },
      form: {
        start_date: "Datum von",
        start_date_tooltip:
          "Bitte wähle das Startdatum für den gewünschten Zeitraum aus",
        end_date: "Datum bis",
        end_date_tooltip:
          "Bitte wähle das Enddatum für den gewünschten Zeitraum aus",
        bank: "Bank",
        interval: "Intervall",
        interval_tooltip:
          "Bitte wähle das gewünschte Zeit-Intervall für die Analyse aus. Du kannst zwischen 15 Minuten-, 1 Stunden-, Tages- und Wochen-Intervall wählen. Bitte berücksichtige, dass die Verfügbarkeit bestimmter Intervalle vom voreingestellten Zeitraum (von... bis) abhängig ist.",
        day: "Tag",
        week: "Woche",
        quarter: "15 Minuten",
        hour: "Stunde",
      },
      table: {
        date: "Datum",
        interval: "Zeit",
        includeUserErrors: "Benutzerbasierte Fehler",
        successRate: "Erfolgsquote",
        failureRate: "Fehlerquote",
        totalImports: "Gesamtimporte",
        noData: "Keine Daten",
      },
      errors: {
        isin: "ISIN",
        count: "Anzahl Tracking errors",
        noIsin: "Keine ISIN",
        details: {
          button: "Details",
          title: "Tracking errors für {{isin}}",
          total: "{{total}} Tracking errors insgesamt",
          id: "ID",
          userId: "User-ID",
          depotId: "Depot-ID",
          investmentName: "Investment",
          delta: "Delta",
          createdAt: "Erstellt am",
        },
      },
    },
    cryptoRefresh: {
      title: "Crypto Currencies",
      form: {
        coinGeckoId: "CoinGecko ID",
      },
      addButton: "Add",
      successMessage: "Crypto currency added successfully",
      errorMessage: "Failed to add crypto currency",
      refreshButton: "Refresh",
      refreshSuccessMessage: "Crypto currency refreshed successfully",
      refreshErrorMessage: "Failed to refresh crypto currency",
    },
    finApi: {
      validity: {
        expired: "Abgelaufen",
        expiresToday: "Läuft heute ab",
        expiresIn_one: "Läuft in {{count}} Tag ab",
        expiresIn_other: "Läuft in {{count}} Tagen ab",
        unlimited: "Unbefristet",
      },
      clientConfiguration: {
        loadError:
          "Die finAPI-Client-Konfiguration konnte nicht geladen werden.",
        form: {
          title: "Bearbeitbare Einstellungen",
          userNotificationCallbackUrl:
            "Callback-URL für Benutzerbenachrichtigungen",
          finTSProductRegistrationNumber: "FinTS-Produktregistrierungsnummer",
          finTSProductRegistrationNumberHint:
            "Eine gespeicherte Nummer wird als XXXXX angezeigt. Unverändert lassen, um sie zu behalten.",
          refreshTokensValidityPeriod: "Gültigkeit der Refresh-Tokens",
          userAccessTokensValidityPeriod:
            "Gültigkeit der Benutzer-Access-Tokens",
          clientAccessTokensValidityPeriod:
            "Gültigkeit der Client-Access-Tokens",
          validityPeriodHint:
            "In Sekunden. 0 bedeutet, dass die Tokens nie ablaufen.",
          validityPeriodError:
            "Bitte eine ganze Zahl von Sekunden (0 oder mehr) eingeben.",
          betaBanksEnabled: "Beta-Banken aktiviert",
          saveSuccess: "finAPI-Client-Konfiguration gespeichert",
          saveError:
            "Die finAPI-Client-Konfiguration konnte nicht gespeichert werden",
        },
        overview: {
          hint: "Diese Einstellungen verwaltet finAPI; ändern kann sie nur der finAPI-Support.",
          sections: {
            access: "Lizenz & Zugriff",
            banks: "Banken & Aktualisierung",
            users: "Benutzer",
            categorization: "Kategorisierung",
          },
          fields: {
            isMandatorAdmin: "Mandanten-Admin",
            mandatorLicense: "Lizenz",
            aisEnabled: "Kontoinformationsdienst (AIS)",
            paymentsEnabled: "Zahlungsauslösung (PIS)",
            isStandalonePaymentsEnabled: "Standalone-Zahlungen",
            aisViaWebForm: "AIS über Web Form",
            pisViaWebForm: "PIS über Web Form",
            pisStandaloneViaWebForm: "Standalone-PIS über Web Form",
            preferredConsentType: "Bevorzugter Consent-Typ",
            enabledProducts: "Aktivierte Produkte",
            corsAllowedOrigins: "Erlaubte CORS-Origins",
            testBanksEnabled: "Testbanken",
            businessBanksEnabled: "Geschäftsbanken",
            isWebScrapingEnabled: "Web-Scraping",
            availableBankGroups: "Bankgruppen",
            accountTypeRestrictions: "Einschränkung der Kontotypen",
            nonEuroAccountHandling: "Nicht-Euro-Konten",
            transactionImportLimitation:
              "Importlimit für Umsätze (Tage, 0 = keins)",
            isAutomaticBatchUpdateEnabled: "Automatisches Batch-Update",
            isDevelopmentModeEnabled: "Entwicklungsmodus",
            isUserAutoVerificationEnabled: "Automatische Benutzerverifizierung",
            maxUserLoginAttempts: "Max. Login-Versuche (0 = unbegrenzt)",
            userRetentionPeriod:
              "Aufbewahrung von Benutzern (Tage, 0 = unbegrenzt)",
            userSynchronizationCallbackUrl:
              "Callback-URL für Benutzersynchronisation",
            pfmServicesEnabled: "PFM-Services",
            isAutoCategorizationEnabled: "Automatische Kategorisierung",
            allKeywordsMustMatchForCategorization:
              "Alle Schlüsselwörter müssen passen",
            categoryRestrictionsEnabled: "Kategorie-Einschränkungen",
            categoryRestrictions: "Beschränkt auf Kategorien",
          },
        },
      },
      tppCertificates: {
        description:
          "QWAC-Zertifikate weisen uns beim TLS-Handshake gegenüber den Banken aus; mit QSealC-Zertifikaten signieren wir unsere Anfragen an die Banken.",
        addButton: "Zertifikat hinzufügen",
        noData: "Keine TPP-Zertifikate hinterlegt.",
        columns: {
          id: "ID",
          type: "Typ",
          label: "Bezeichnung",
          validFrom: "Gültig ab",
          validUntil: "Gültig bis",
        },
        create: {
          title: "TPP-Zertifikat hinzufügen",
          type: "Typ",
          label: "Bezeichnung",
          publicKey: "Zertifikat (Public Key)",
          privateKey: "Private Key",
          privateKeyHint:
            "PKCS #8 im PEM-Format, beginnend mit -----BEGIN PRIVATE KEY----- oder -----BEGIN ENCRYPTED PRIVATE KEY-----",
          passphrase: "Passphrase",
          validFromDate: "Gültig ab",
          validUntilDate: "Gültig bis",
          submit: "Zertifikat hinzufügen",
          error: "Das Zertifikat konnte nicht hinzugefügt werden.",
        },
        createSuccess: "Zertifikat hinzugefügt",
        deleteTitle: "TPP-Zertifikat löschen",
        deleteConfirm:
          "Das {{type}}-Zertifikat „{{label}}“ löschen? Das kann nicht rückgängig gemacht werden.",
        deleteSuccess: "Zertifikat gelöscht",
      },
      tppCredentials: {
        description:
          "Zugangsdaten, die uns die Banken bei der Registrierung als TPP ausgestellt haben, je TPP-Authentifizierungsgruppe.",
        addButton: "Zugangsdaten hinzufügen",
        noData: "Keine TPP-Zugangsdaten hinterlegt.",
        columns: {
          id: "ID",
          authenticationGroup: "Authentifizierungsgruppe",
          label: "Bezeichnung",
          validFrom: "Gültig ab",
          validUntil: "Gültig bis",
        },
        create: {
          title: "TPP-Zugangsdaten hinzufügen",
          authenticationGroup: "Authentifizierungsgruppe",
          authenticationGroupPlaceholder: "Nach Namen suchen",
          noAuthenticationGroups: "Keine Authentifizierungsgruppen gefunden",
          label: "Bezeichnung",
          tppClientId: "Client-ID",
          tppClientSecret: "Client-Secret",
          tppApiKey: "API-Key",
          tppName: "TPP-Name",
          tppNameHint: "Nur für wenige Banken nötig, z. B. Revolut.",
          validFromDate: "Gültig ab",
          validUntilDate: "Gültig bis",
          submit: "Zugangsdaten hinzufügen",
          error: "Die Zugangsdaten konnten nicht hinzugefügt werden.",
        },
        createSuccess: "Zugangsdaten hinzugefügt",
        deleteTitle: "TPP-Zugangsdaten löschen",
        deleteConfirm:
          "Die Zugangsdaten „{{label}}“ löschen? Das kann nicht rückgängig gemacht werden.",
        deleteSuccess: "Zugangsdaten gelöscht",
      },
      inactiveUsers: {
        description:
          "finAPI-Nutzer, die zu keinem aktiven Nutzer mehr bei uns gehören, z. B. weil der Nutzer gelöscht wurde. Die Zahlen stammen aus dem letzten Neuaufbau der Statistik.",
        reloadButton: "Neu laden",
        rebuildButton: "Statistik neu aufbauen",
        rebuildStarted:
          "Die Statistik wird neu aufgebaut. Dabei werden alle Nutzer von finAPI gelesen, das dauert einige Minuten; nach dem Neuladen füllen sich die Zahlen.",
        rebuildError: "Die Statistik konnte nicht neu aufgebaut werden.",
        deleteButton: "Inaktive Nutzer löschen",
        loadError: "Die Statistik konnte nicht geladen werden.",
        noData: "Noch keine Statistik vorhanden.",
        noDataHint: "Sie erscheint hier nach einem Neuaufbau.",
        summary: {
          inactive: "Inaktive Nutzer",
          active: "Aktive Nutzer",
        },
        columns: {
          mandator: "Mandant",
          inactive: "Inaktive Nutzer",
          active: "Aktive Nutzer",
        },
        delete: {
          title: "Inaktive finAPI-Nutzer löschen",
          text_one:
            "Damit wird {{formattedCount}} inaktiver Nutzer bei finAPI gelöscht, über alle Mandanten hinweg. Das kann nicht rückgängig gemacht werden.",
          text_other:
            "Damit werden {{formattedCount}} inaktive Nutzer bei finAPI gelöscht, über alle Mandanten hinweg. Das kann nicht rückgängig gemacht werden.",
          confirmationLabel: "Zur Bestätigung {{word}} eingeben",
          submit: "Inaktive Nutzer löschen",
          error: "Die inaktiven Nutzer konnten nicht gelöscht werden.",
          started_one:
            "{{formattedCount}} inaktiver Nutzer wird im Hintergrund gelöscht.",
          started_other:
            "{{formattedCount}} inaktive Nutzer werden im Hintergrund gelöscht.",
        },
        trialRun: {
          button: "Probelauf",
          result_one:
            "Probelauf: {{formattedCount}} inaktiver Nutzer würde gelöscht. {{formattedActive}} aktive Nutzer sind nicht betroffen.",
          result_other:
            "Probelauf: {{formattedCount}} inaktive Nutzer würden gelöscht. {{formattedActive}} aktive Nutzer sind nicht betroffen.",
          error: "Der Probelauf ist fehlgeschlagen.",
        },
      },
    },
    mandators: {
      searchPlaceholder: "Nach Public ID, ID oder Client-ID suchen",
      addButton: "Mandant hinzufügen",
      totalCount_one: "{{count}} Mandant",
      totalCount_other: "{{count}} Mandanten",
      matchCount: "{{count}} von {{total}} Mandanten",
      noData: "Keine Mandanten gefunden.",
      noSearchResults: "Kein Mandant passt zu „{{search}}“.",
      loadError: "Die Mandanten konnten nicht geladen werden.",
      columns: {
        publicId: "Public ID",
        id: "ID",
        clientId: "Client-ID",
      },
      edit: {
        createTitle: "Mandant hinzufügen",
        title: "Mandant bearbeiten",
        publicId: "Public ID",
        clientId: "Client-ID",
        clientSecret: "Client-Secret",
        keepHint: "Leer lassen, um die aktuelle Client-ID zu behalten.",
        clientSecretHint: "Leer lassen, um das aktuelle Secret zu behalten.",
        error: "Der Mandant konnte nicht gespeichert werden.",
        saveSuccess: "Mandant {{publicId}} gespeichert",
      },
      configuration: {
        fallbackTitle: "Mandant",
        hint: "Jede Karte speichert für sich und sendet nur die geänderten Werte. Secrets werden nie angezeigt; zum Ersetzen einen neuen Wert eingeben.",
        loadError: "Die Konfiguration konnte nicht geladen werden.",
        saveSuccess: "{{section}} gespeichert",
        saveError: "Die Konfiguration konnte nicht gespeichert werden.",
        secretStored: "Hinterlegt. Zum Ersetzen einen neuen Wert eingeben.",
        secretNotSet: "Nicht gesetzt.",
        wholeNumber: "Bitte eine ganze Zahl eingeben.",
        sections: {
          access: "Registrierung und Anmeldung",
          licenses: "Lizenzen und Funktionen",
          bankConnections: "Bankanbindungen",
          finApi: "finAPI",
          zendesk: "Zendesk",
        },
        fields: {
          supportsNewUserRegistration: "Neue Nutzer können sich registrieren",
          oauthClientCredentialsEnabled: "OAuth verlangt Client-Zugangsdaten",
          refreshTokenExpirationInSeconds: "Gültigkeit des Refresh-Tokens",
          supportsSubscriptions: "Abonnements",
          stockFundamentalsLicense: "Aktien-Fundamentaldaten",
          fundFundamentalsLicense: "Fonds-Fundamentaldaten",
          cryptoLicense: "Krypto",
          publicPortfoliosLicense: "Öffentliche Portfolios",
          dividendPlannerLicense: "Dividendenplaner",
          brokerizeLicense: "Brokerize",
          userStatusManagementLicense: "Verwaltung des Nutzerstatus",
          complianceLicense: "Compliance",
          investmentReportEnabled: "Investment-Report",
          anonymousCommentsEnabled: "Anonyme Kommentare",
          commentChallengeTokenEnabled: "Challenge-Token für Kommentare",
          isTppWebFormRequired: "TPP-Webformular erforderlich",
          isEarlyWebFormRedirectSupported:
            "Frühe Weiterleitung aus dem Webformular",
          batchSyncCallbackUrl: "Callback-URL für den Batch-Sync",
          finApiClientId: "Client-ID",
          finApiClientSecret: "Client-Secret",
          finApiAdminClientId: "Admin-Client-ID",
          finApiAdminClientSecret: "Admin-Client-Secret",
          finApiDataDecryptionKey: "Schlüssel zur Datenentschlüsselung",
          zendeskSupportLicense: "Zendesk-Support",
          zendeskClientId: "OAuth-Client-ID",
          zendeskClientSecret: "OAuth-Client-Secret",
          zendeskRequesterEmail: "E-Mail des Anfragenden",
          zendeskRequesterName: "Name des Anfragenden",
          zendeskTicketTags: "Ticket-Tags",
        },
        hints: {
          refreshTokenExpirationInSeconds: "In Sekunden.",
          batchSyncCallbackUrl: "Eine öffentliche HTTPS-URL.",
          zendeskClientId:
            "Zendesk legt die Tickets im Namen des Benutzers an, dem dieser OAuth-Client gehört.",
          zendeskRequesterEmail:
            "Kann geändert, aber nicht entfernt werden. Leer lassen, um die aktuelle E-Mail-Adresse zu behalten.",
          zendeskRequesterName:
            "Kann geändert, aber nicht entfernt werden. Leer lassen, um den aktuellen Namen zu behalten.",
          zendeskTicketTags:
            "Durch Kommas getrennt, ohne Leerzeichen innerhalb eines Tags. Leer lassen, um die Tags zu entfernen.",
        },
      },
    },
    currencies: {
      searchPlaceholder: "Nach Code oder Name suchen",
      addButton: "Währung hinzufügen",
      noData: "Keine Währung gefunden.",
      loadError: "Die Währungen konnten nicht geladen werden.",
      columns: {
        code: "Code",
        name: "Name",
        toEUR: "In EUR",
        deletedAt: "Gelöscht am",
      },
      edit: {
        createTitle: "Währung hinzufügen",
        title: "Währung bearbeiten",
        code: "Code",
        codeHint: "3 bis 10 Buchstaben oder Ziffern, z. B. CHF.",
        codeError: "Bitte 3 bis 10 Buchstaben oder Ziffern verwenden.",
        codeExists:
          "Diese Währung gibt es bereits. Bitte bearbeiten Sie sie in der Liste.",
        name: "Name",
        error: "Die Währung konnte nicht gespeichert werden.",
        saveSuccess: "Währung {{code}} gespeichert",
      },
      delete: {
        title: "Währung löschen",
        text: "{{code}} ({{name}}) löschen? Die Währung wird nur als gelöscht markiert: Sie bleibt mit ihrem Löschdatum in der Liste, und Konten und Investments verwenden sie weiter.",
        success: "Währung {{code}} als gelöscht markiert",
      },
    },
    invoicing: {
      mandator: "Mandant",
      mandatorPlaceholder: "Nach Public ID oder ID suchen",
      noMandators: "Kein Mandant gefunden",
      month: "Monat",
      includeBankConnections:
        "Nutzer mit Bankanbindung zählen (dauert bis zu einer Minute)",
      chooseMandator:
        "Einen Mandanten wählen, um seine Abrechnungsdaten zu sehen.",
      loadError: "Die Abrechnungsdaten konnten nicht geladen werden.",
      noData: "Keine Daten.",
      columns: {
        figure: "Kennzahl",
        value: "Wert",
      },
      fields: {
        customerId: "Kundennummer",
        invoiceId: "Rechnungsnummer",
        period: "Monat",
        activeUsers: "Aktive Nutzer",
        finApiUsers: "finAPI-Nutzer",
        brokerizeUsers: "brokerize-Nutzer",
        usersWithBankConnections: "Nutzer mit Bankanbindung",
        lastLogin0to6: "Letzter Login vor 0 bis 6 Monaten",
        lastLogin6to12: "Letzter Login vor 6 bis 12 Monaten",
        lastLogin12to18: "Letzter Login vor 12 bis 18 Monaten",
        lastLoginMoreThan18: "Letzter Login vor mehr als 18 Monaten",
      },
      wazag: {
        description: "Jetzt gezählt, über alle Mandanten hinweg.",
        loadError: "Die WAZAG-Zahlen konnten nicht geladen werden.",
        users: "Aktive Nutzer mit finAPI-Nutzer",
        cashAccounts: "Deren finAPI-Giro- und Kreditkartenkonten",
      },
    },
    kpis: {
      allMandators: "Alle Mandanten",
      loadError: "Die KPIs konnten nicht geladen werden.",
      userGrowth: {
        description:
          "Jetzt gezählt. Registrierte Nutzer sind alle nicht als gelöscht markierten Nutzer, abgewanderte Nutzer alle als gelöscht markierten. Ein registrierter Nutzer ist aktiv, wenn er sich in der gewählten Zeit angemeldet hat. Diagramme und Tabelle zählen jeden Nutzer im Monat seiner Registrierung.",
        activeWithin: "Aktiv innerhalb von",
        months_one: "{{count}} Monat",
        months_other: "{{count}} Monaten",
        registeredUsers: "Registrierte Nutzer",
        activeUsers: "Aktive Nutzer",
        churnedUsers: "Abgewanderte Nutzer",
        perMonth: "Nutzer nach Registrierungsmonat",
        cumulated: "Nutzer nach Registrierungsmonat, kumuliert",
        signUpMonth: "Registrierungsmonat",
        view: "Ansicht",
        chart: "Diagramm",
        table: "Tabelle",
      },
    },
  },
  cashbackWizard: {
    yes: "Ja",
    no: "Nein",
    start: {
      title: "Cashback ist kostenfrei und einfach zu beantragen",
      subtitle:
        "Sie benötigen ca. 5 Minuten. Falls Sie bereits Kunde einer {{appName}} Partnerbank sind (z.B. comdirect), halten Sie bitte Ihre Depot- bzw. Kundennummer bereit.",
      steps: {
        first: {
          title: "Schritt 1",
          description: "Daten eingeben",
        },
        second: {
          title: "Schritt 2",
          description: "Ausdrucken",
        },
        third: {
          title: "Schritt 3",
          description: "An uns senden",
        },
      },
      cards: {
        title: "Das sagen Kunden",
        subtitle: "Überzeugen Sie sich selbst",
        vincentWillkomm: {
          name: "Vincent Willkomm",
          profession: "Finanzblogger, Hamburg",
          text: "“Um die Kosten von aktiven Investmentfonds in Richtung ETF-Niveau zu drücken, nutze ich das Cashback. Das garantiert die höchste Rückerstattung von Provisionen.”",
        },
        ingeborgK: {
          name: "Ingeborg K.",
          profession: "Pensionärin, Nürnberg",
          text: "“Ich nutze {{appName}} Cashback bereits seit Januar 2018 und freue mich seitdem über pünktliche Auszahlungen von mehr als 1.200 Euro im Quartal.”",
        },
        konetzke: {
          name: "Toralf Konetzke",
          profession: "Unternehmer und Profisportler, Cottbus",
          text: "“Mit dem Cashback habt Ihr bei mir einen Elfmeter verwandelt. Kosten runter und Rendite hoch - perfekt! Danke und weiter so!”",
        },
        siebers: {
          name: "Torsten Siebers",
          profession: "Unternehmensberater, Hamburg",
          text: "“Als Nutzer bin ich immer wieder begeistert, mit welchem Enthusiasmus sich das Team von {{appName}} dem Verbraucherschutz widmet und mit Fonds-Cashback auch umsetzt.”",
        },
      },
    },
    sidebar: {
      main: "Cashback",
      personalInformation: "Persönliche Informationen",
      depotSelection: "Depotauswahl",
      depotFacility: {
        newUser: "Depoteröffnung",
        existingUser: "Vermittlerwechsel",
        commonTitle: "Depoteröffnung / -übertrag",
      },
      experience: "Investmenterfahrung",
      payout: "Tarif & Referenzkonto",
      summary: "Abschluss",
      cashback: "Cashback beantragen",
      you: "Ihre Angaben",
      partner: "Ihr Partner",
      minor: "Minderjährige/r",
      legalGuardian1: "1. Erziehungsberechtigte/r",
      legalGuardian2: "2. Erziehungsberechtigte/r",
    },
    workflow: {
      accountType: {
        title: "Sind Sie Privat- oder Geschäftskunde?",
        subtitle: "Bitte legen Sie fest, welche Art Kunde Sie sind",
        PRIVATE: "Privatkunde",
        COMPANY: "Juristische Person",
        COMPANY_subtitle: "UG, GmbH, AG, Stiftung, Verein",
      },
      newOrExistingDepot: {
        title: "Haben Sie bereits ein Depot eröffnet?",
        subtitle:
          "Fügen Sie bestehende Depots hinzu oder eröffnen Sie ein neues Depot",
        newDepot: "Nein, ich möchte ein neues Depot eröffnen",
        existingDepot: "Ja, Ich führe bereits ein Depot",
      },
    },
    selectBank: {
      title: {
        default: "Bei welcher Bank möchten Sie Ihr Cashback-Depot eröffnen?",
        onvista:
          "Bei welcher Partnerbank möchten Sie Ihr onvista-Cashback Depot eröffnen?",
        existingUser:
          "Bei welcher {{appName}} Partnerbank führen Sie Ihr Depot?",
        existingUser_onvista: "Bei welcher Partnerbank führen Sie Ihr Depot?",
      },
      subtitle: "Wir arbeiten mit folgenden Partnern zusammen",
      bestService: "Bester Kundenservice",
      bestPrice: "Preis / Leistungs-Sieger",
      tooltip: {
        rating: "Unsere Bewertung",
        AUGBDE77XXX:
          "Als ehemaliger AAB-Kunde gewährt die FNZ einen maximalen Rabatt auf den Ausgabeaufschlag in Höhe von 95 %. Um 100 % Rabatt zu erhalten, empfehlt Ihnen die FNZ Ihre Wertpapiere Ihres ehemaligen AAB-Depots zu einem “reinen” FNZ Depot zu übertragen.",
        COBADEHDXXX: {
          depotFee: "0€ Depotführung",
          numberOfFunds: "über 24.000 handelbare Fonds",
          fundSavingsPlan: "0,95€ Kosten für Fondssparplan",
          allInOne: "Fonds, Aktien und ETF handeln",
          rating: 5,
        },
        DABBDEMMXXX: {
          depotFee: "0€ Depotführung",
          numberOfFunds: "über 13.000 handelbare Fonds",
          fundSavingsPlan: "2€ Kosten für Fondssparplan",
          allInOne: "Fonds, Aktien und ETF handeln",
          rating: 3,
        },
        COBADEMXXXX: {
          depotFee:
            "Depotführung: Junior Depot: 0€,\n Standard-Online Depot: 53€ p.a.",
          numberOfFunds: "über 6.900 handelbare Fonds",
          fundSavingsPlan: "0€ Kosten für Fondssparplan",
          allInOne: "Fonds und ETF handeln",
          rating: 3,
        },
        FODBDE77XXX: {
          depotFee:
            "Depotführung: \nMinderjährigen-Depot: 0 €; \nFondsdepot Online: 39 €",
          numberOfFunds: "über 7.000 handelbare Fonds",
          fundSavingsPlan: "0€ Kosten für Fondssparplan",
          allInOne: "Nur Fonds",
          rating: 4,
        },
        FFBKDEFFTHK: {
          depotFee:
            "Depotführung: JuniorDepot: 0 € , Fondsdepot: mind. 25 €, \nmax. 50 € p.a., \nFondsdepotPlus: 45 € p.a.",
          numberOfFunds: "über 7.000 handelbare Fonds",
          fundSavingsPlan: "0€ Kosten für Fondssparplan",
          allInOne: "Nur Fonds",
          rating: 2,
        },
      },
      morgenFundNote: {
        title: "Eröffnung Cashback-Depot bei MorgenFund",
        text: "Sehr geehrte Kunden/innen, um ein Investment-Depot bei der MorgenFund zu eröffnen, schreiben Sie uns bitte eine E-Mail an: <supportEmailLink>{{supportEmail}}</supportEmailLink>. Wir senden Ihnen die erforderlichen Informationen sowie Eröffnungsunterlagen per E-Mail zu.",
      },
    },
    accountHolder: {
      selectExistingHolder: {
        title: "Wählen Sie den Kontoinhaber",
        subtitle: {
          default:
            "Jeder Kontoinhaber kann kostenlos beliebig viele eigene oder Gemeinschaftsdepots verwalten. {{appName}} erhält maximal 15€ / Monat pro Kontoinhaber",
          onvista:
            "Jeder Kontoinhaber kann kostenlos beliebig viele eigene oder Gemeinschaftsdepots verwalten.",
        },
        label: "Gepeicherte",
        newAccount: "Neuen Kontoinhaber erstellen",
        info: "{{appName}} rechnet pro Kontoinhaber ab. Wenn Sie einen neuen erstellen, wird dieser seperat abgerechnet. Nutzen Sie diese Funktion z.B. für Partner oder Ihre Kinder.",
        info_onvista:
          "Die Abrechnung und Auszahlung erfolgt pro Kontoinhaber. Wenn Sie hier klicken, erstellen Sie einen neuen Kontoinhaber, welcher separat abgerechnet und ausgezahlt wird. Verwenden Sie diese Funktion z.B. für Partner oder Ihre Kinder.",
      },
      accountHolderType: {
        title: {
          default: "Welche Art von Depot möchten Sie eröffnen?",
          existingUser: "Um welche Art von Depot handelt es sich?",
        },
        subtitle: {
          default: "Wir haben das passende Depot für Ihre Anforderungen",
        },
        single: {
          title: "Einzeldepot",
          subtitle: "Ihr persönliches Dept mit Ihnen als einziger Depotinhaber",
        },
        joined: {
          title: "Gemeinschaftsdepot",
          subtitle:
            "Ein Depot für Sie und z.B. Ihren Ehepartner oder gleichberechtigen Inhaber",
        },
        minor: {
          title: "Minderjährigendepot",
          subtitle:
            "Das Depot für das Kind mit dem Erziehungsberechtigten als Bevollmächtigen",
        },
        select: "Jetzt eröffnen",
        select_existingUser: "Auswählen",
      },
    },
    auth: {
      signup: {
        title: "Jetzt registrieren und sofort bei der Fondsanlage sparen",
        subtitle: "{{appName}} ist kostenlos und unverbindlich",
        email: "Ihre Email Adresse",
        email_placeholder: "Bspw. markus@mustermann.de",
        password: "Passwort festlegen",
        password_placeholder: "Bitte legen Sie ein Passwort fest...",
        acceptedAgb:
          "Ich stimme den {{appName}} <link1>AGBs</link1> und <link2>Datenschutzbestimmungen</link2> zu",
        receiveNewsletter:
          "Ich möchte über Produktupdates und Sparangebote informiert werden",
        next: "Bei {{appName}} registrieren",
        emailTaken:
          "Die eingegebene Email ist bereits vergeben. Falls Sie die Email zuvor verwendet haben, ",
        emailTakenLink: "loggen Sie sich bitte ein",
        rememberMe: "Angemeldet bleiben",
      },
    },
    naturalPerson: {
      personalData: {
        title: {
          default: "Bitte geben Sie Ihre persönlichen Daten ein",
          partner: "Bitte geben Sie die persönlichen Daten Ihres Partners ein",
          legalGuardian1:
            "Bitte geben Sie die persönlichen Daten des ersten Erziehungsberechtigten ein",
          legalGuardian2:
            "Bitte geben Sie die persönlichen Daten des zweiten Erziehungsberechtigten ein",
          minor:
            "Bitte geben Sie die persönlichen Daten des Minderjährigen ein",
        },
        subtitle: {
          default:
            "Die Informationen werden für die Depoteröffnung von Ihrer Bank benötigt",
          existingUser: "Die Informationen werden von Ihrer Bank benötigt",
        },
        gender: "Anrede",
        academicTitle: "Akademischer Titel",
        firstName: "Vorname",
        lastName: "Nachname",
        countryOfBirth: "Geburtsland",
        placeOfBirth: "Geburtsort",
        dateOfBirth: "Geburtsdatum",
        nameAtBirth: "Geburtsname",
        areAccountHoldersMarried: "Sind Sie mit Ihrem Partner verheiratet?",
        reduced: {
          title: {
            default: "Bitte geben Sie Ihre persönlichen Daten ein",
            partner:
              "Bitte geben Sie die persönlichen Daten Ihres Partners ein",
            legalGuardian1:
              "Bitte geben Sie die persönlichen Daten des ersten Erziehungsberechtigten ein",
            legalGuardian2:
              "Bitte geben Sie die persönlichen Daten des zweiten Erziehungsberechtigten ein",
            minor:
              "Bitte geben Sie die persönlichen Daten des Minderjährigen ein",
          },
          subtitle:
            "Die Informationen werden für die Depoteröffnung von Ihrer Bank benötigt",
          gender: "Anrede",
          academicTitle: "Akademischer Titel",
          firstName: "Vorname",
          lastName: "Nachname",
          phoneNumber: "Telefonnummer für Rückfragen",
          phoneNumber_placeholder: "+49",
        },
      },
      addressData: {
        title: {
          default: "Bitte geben Sie Ihre Adresse ein",
          partner: "Bitte geben Sie die Adresse Ihres Partners ein",
          legalGuardian1:
            "Bitte geben Sie die Adresse des ersten Erziehungsberechtigten ein",
          legalGuardian2:
            "Bitte geben Sie die Adresse des zweiten Erziehungsberechtigten ein",
          minor: "Bitte geben Sie die Adresse des Minderjährigen ein",
        },
        subtitle: {
          default:
            "Die Informationen werden für die Depoteröffnung von Ihrer Bank benötigt",
          existingUser: "Die Informationen werden von Ihrer Bank benötigt",
        },
        street: "Straße",
        houseNumber: "Hausnummer",
        houseNumber_placeholder: "Nr.",
        zip: "Postleitzahl",
        city: "Wohnort",
        city_placeholder: "Ihr Wohnort",
        addressCountry: "Land",
        phoneNumber: "Telefonnummer für Rückfragen",
        phoneNumber_placeholder: "+49",
      },
      hasSecondLegalGuardian: {
        title: "Gibt es einen zweiten Erziehungsberechtigten?",
        subtitle:
          "Sollte es einen zweiten Erziehungsberechtigen geben, geben Sie bitte diesen ebenfalls an.",
      },
      companyData: {
        title: "Bitte geben Sie Ihre Firmendaten ein",
        subtitle: {
          default:
            "Die Informationen werden für die Depoteröffnung von Ihrer Bank benötigt",
          existingUser: "Die Informationen werden von Ihrer Bank benötigt",
        },
        firstName: "Firmenname",
        firstName_placeholder: "Ihr Firmenname",
        lastName: "Rechtsform",
        lastName_placeholder: "Ihre Rechtsform",
      },
      companyAddressData: {
        title: "Bitte geben Sie Ihre Firmenadresse ein",
        subtitle: {
          default:
            "Die Informationen werden für die Depoteröffnung von Ihrer Bank benötigt",
          existingUser: "Die Informationen werden von Ihrer Bank benötigt",
        },
        street: "Straße",
        houseNumber: "Hausnummer",
        houseNumber_placeholder: "Nr.",
        zip: "Postleitzahl",
        city: "Firmenort",
        city_placeholder: "Ihr Firmenort",
        addressCountry: "Land",
        phoneNumber: "Telefonnummer für Rückfragen",
        phoneNumber_placeholder: "+49",
      },
    },
    turnover: {
      title: "Wie hoch sind Ihre erwarteten Kontoumsätze?",
      regularIncomePerMonth: "Regelmäßig erwartete Geldingänge pro Monat*",
      regularCashTransfersPerMonth:
        "Regelmäßig erwartete Bargeldeinzahlungen und Bargeldauszahlungen pro Monat*",
      transfersAbroad:
        "Ich tätige regelmäßig Überweisungen ins Ausland oder erhalte regelmäßig Zahlungen aus dem Ausland.*",
      country1: "Land 1",
      country2: "Land 2",
      country3: "Land 3",
      country4: "Land 4",
      country5: "Land 5",
      country6: "Land 6",
      countryPlaceholder: "Land eingeben",
    },
    bankOnboardingRedirect: {
      title: "Sehr gute Wahl! Jetzt Depot eröffnen.",
      text: "Für die Eröffnung Ihres Depots leiten wir Sie auf die Seite unseres Partners der {{bankName}} weiter. Direkt nach Eingabe Ihrer Daten erhalten Sie Zugang zu Ihrem neuen Depot.",
      btn: "Jetzt Depot bei der {{bankName}} eröffnen",
      fnzBanner:
        "<boldText>Hinweis:</boldText> Aus abwicklungstechnischen Gründen von Seiten der FNZ ist die Angabe einer ISIN bei Investmentdepots immer zwingend erforderlich. Deswegen tragen wir diese automatisch im Antragsformular für Sie ein. Die Angabe einer ISIN löst keinen Kauf aus, solange keine Angaben zum Betrag gemacht werden.",
    },
    mifid: {
      mifidData: {
        title: {
          default: "Bitte geben Sie Ihre MiFID Daten ein",
          partner: "Bitte geben Sie die MiFID Daten Ihres Partners ein",
          legalGuardian1:
            "Bitte geben Sie die MiFID Daten des ersten Erziehungsberechtigten ein",
          legalGuardian2:
            "Bitte geben Sie die MiFID Daten des zweiten Erziehungsberechtigten ein",
          minor: "Bitte geben Sie die MiFID Daten des Minderjährigen ein",
        },
        banner: {
          title: 'MiFID steht für "Markets in Financial Instruments Directive"',
          text: "Die EU-Richtlinie regelt europaweit den Wertpapierhandel und setzt hohe Standards für den Anlegerschutz. Um die regulatorischen Anforderungen zu erfüllen, sind wir verpflichtet, bestimmte Angaben von Ihnen zu erfragen.",
        },
        mifidOccupationGroup: "Berufsgruppe",
        mifidOccupation: "Beruf",
        mifidSector: "Branche",
        mifidCountryOfWork: "Land wählen",
        mifidAccessToInsiderInfo: "Haben Sie Zugang zu Insiderinforationen?",
      },
      mifidAdditionalData: {
        DAB: {
          title: "Weitere Pflichtangaben zur Depoteröffnung bei der DAB",
        },
        FNZ: {
          title: "Weitere Pflichtangaben zur Depoteröffnung bei der FNZ",
        },
        comdirect: {
          title:
            "Bitte geben Sie Ihre erwarteten Kontoumsätze ein (Daten für MiFID)",
        },
        banner: {
          title: "Warum diese Angaben?",
          text: "Für die Depoteröffnung verlangt Ihre Bank weitere Angaben wie zum Beispiel detaillierte Angaben zur Mittelherkunft.  Diese Informationen werden im Rahmen des Geldwäschegesetzes (GwG) erhoben und dienen der Geldwäscheprävention. Um die regulatorischen Anforderungen zu erfüllen, sind wir verpflichtet, diese Angaben von Ihnen zu erfragen.",
        },
        mifidAnnualIncome: "Jährliches Einkommen",
        pep: "Sind Sie eine politisch exponierte Person?",
        mifidLiquidAssets: "Liquides Vermögen",
        mifidOriginOfIncome: "Herkunft des Einkommens",
        mifidOriginOfAssets: "Herkunft des Vermögens",
        mifidPlannedAssets: "Geplantes Vermögen",
        regularIncomePerMonth: "Regelmäßig erwartete Geldeingänge pro Monat",
        regularIncomePerMonth_placeholder: "Keine regelmäßigen Geldeingänge",
        optionsForRegularIncomePerMonth: {
          0: "Keine regelmäßigen Geldeingänge",
          1: "1 - 1000 Euro",
          1001: "1001 - 2000 Euro",
          2001: "2001 - 3000 Euro",
          3001: "3001 - 4000 Euro",
          4001: "4001 - 5000 Euro",
          5001: "5001 - 6000 Euro",
          6001: "6001 - 8000 Euro",
          8001: "8001 - 13000 Euro",
          13001: "13001 - 25000 Euro",
          25001: "25001 - 80000 Euro",
          80001: "mehr als 80000 Euro",
        },
        regularCashTransfersPerMonth:
          "Regelmäßig erwartete Bargeldeinzahlung und Bargeldauszahlung pro Monat",
        regularCashTransfersPerMonth_placeholder: "Keine",
        optionsForRegularCashTransfersPerMonth: {
          0: "Keine",
          1: "1 - 100 Euro",
          101: "101 - 500 Euro",
          501: "501 - 800 Euro",
          801: "801 - 1200 Euro",
          1201: "1201 - 1600 Euro",
          1601: "1601 - 2100 Euro",
          2101: "2101 - 3000 Euro",
          3001: "3001 - 4000 Euro",
          4001: "4001 - 8000 Euro",
          8001: "mehr als 8000 Euro",
        },
        hasRegularInternationalTransfers:
          "Ich überweise regelmäßig ins Ausland oder erhalte regelmäßig Überweisungen aus dem Ausland",
        internationalTransfersCountry1: "Land auswählen",
        internationalTransfersCountry2: "Land auswählen",
      },
    },
    nationality: {
      title: {
        default: "Bitte geben Sie Ihre Staatsangehörigkeit an",
        partner: "Bitte geben Sie die Staatsangehörigkeit Ihres Partners an",
        minor: "Bitte geben Sie die Staatsangehörigkeit des Minderjährigen an",
        legalGuardian1:
          "Bitte geben Sie die Staatsangehörigkeit des ersten Erziehungsberechtigten an",
        legalGuardian2:
          "Bitte geben Sie die Staatsangehörigkeit des zweiten Erziehungsberechtigten an",
      },
      nationalityCountry: "Staatsangehörigkeit",
      nationalIdentifier: "Nationale Kennung",
      nationalityAnother:
        "Sind Sie Inhaber einer weiteren Staatsangehörigkeit?",
      nationalitySecondaryCountry: "Weitere Staatsangehörigkeit",
      nationalitySecondaryIdentifier:
        "Nationale Kennung (zweite Staatsangehörigkeit)",
    },
    taxation: {
      title: {
        default: "Bitte geben Sie Ihre steuerrelevanten Daten ein",
        partner:
          "Bitte geben Sie die steuerrelevanten Daten Ihres Partners ein",
        minor:
          "Bitte geben Sie die steuerrelevanten Daten des Minderjährigen ein",
        legalGuardian1:
          "Bitte geben Sie die steuerrelevanten Daten des ersten Erziehungsberechtigten ein",
        legalGuardian2:
          "Bitte geben Sie die steuerrelevanten Daten des zweiten Erziehungsberechtigten ein",
      },
      taxationData: {
        taxationCountry1: "Land wählen",
        taxationCountry2: "Land wählen",
        taxationNumber1: "Steuernummer",
        taxationOneMore: "Sind Sie in einem weiteren Land steuerpflichtig?",
        taxationNumber2: "Steuernummer",
        taxationUsTaxLiability: "Unterliegen Sie der US Steuerpflicht?",
        taxationUsTaxNumber: "US-TIN /-SSN",
      },
    },
    finalTaxUsNote: {
      title:
        "Bitte wenden Sie sich zum weiteren Vorgehen an unseren Kundensupport",
      subtitle:
        "Die comdirect Bank bietet keine standardisierte Depoteröffnung für US-Steuerpflichtige an. Wir unterstützen Sie gern und zeigen Ihnen, wie Sie ein Depot eröffnen können. Bitte wenden Sie sich zum weiteren Vorgehen an unseren Kundensupport.",
      card: {
        caption: "Ich bin für Sie zuständig",
        title: "Patrick Rujan",
        subtitle: "Kundensupport {{appName}}",
        subtitle_onvista: "Kundensupport onvista Cashback",
        email: "{{supportEmail}}",
        chat: "chat",
      },
    },
    experience: {
      title: "Wie erfahren sind Sie mit Investments?",
      subtitle:
        "Bitte geben Sie an, wie viel Investment-Erfahrung Sie mit den aufgeführten Wertpapieren besitzen. Die Angaben sind optional.",
      lessThanYear: "Weniger als ein Jahr",
      moreThanYear: "Mehr als ein Jahr",
      moreThanTwoYears: "Mehr als zwei Jahre",
      experienceData: {
        experienceCertificatesAndOptionsWithLeverage:
          "Ihre Erfahrung mit Investmentfonds (Anlagegesellschaft außerhalb der EU)",
        experienceCertificatesAndOptionsWithoutLeverage:
          "Ihre Erfahrung mit Aktien ausländischer Gesellschaften",
        experienceDomesticBonds:
          "Ihre Erfahrung mit festverzinslichen Wertpapieren inländischer Emittenten",
        experienceDomesticStocks:
          "Ihre Erfahrung mit Aktien inländischer Gesellschaften",
        experienceForeignCurrency:
          "Ihre Erfahrung mit Devisengeschäften (nicht auf Termin)",
        experienceForeignStocks:
          "Ihre Erfahrung mit Aktien ausländischer Gesellschaften",
        experienceFunds:
          "Ihre Erfahrung mit Investmentfonds (Anlagegesellschaft außerhalb der EU)",
        experienceForeignBonds:
          "Ihre Erfahrung mit festverzinslichen Wertpapieren ausländischer Emittenten oder in Fremdwährung",
        experienceOther:
          "Ihre Erfahrung mit sonstigen Termingeschäften, Geschäften mit herausgeschobenem Erfüllungszeitpunkt und / oder Hebelwirkung",
      },
    },
    bankSpecificDetails: {
      conditionModel: {
        title: "Bitte wählen Sie Ihr Gebührenmodell aus",
        subtitle:
          "Das Gebührenmodell gilt für Transaktionen <span>über die Börse.</span> <br/> Bei Transaktionen <span>über die Börse</span> empfehlen wir Ihnen:",
        table: {
          description:
            "Für Transaktionen <span>über die Fondsgesellschaft</span> (bei der comdirect Festpreisgeschäft genannt) gelten Orderprovisionen:",
          orderVolumeFrom: "Ordervolumen von",
          orderVolumeTo: "Ordervolumen bis",
          orderCommision: "Orderprovision",
          over: "über",
          bottomText:
            "Weitere Informationen (bspw. ETF Konditionen) entnehmen Sie bitte unserer Konditionstabelle und dem Preis- / Leistungsverzeichnis der comdirect: <link1>https://www.comdirect.de/faq/preisverzeichnis</link1>.",
        },
        comdirect: {
          standard: {
            subtitle: "Für Depots bis zu 8.000€ Volumen pro Order",
            title: "Standard",
            feeLabel: "Transaktionsgebühr",
            fee: "0,25%",
            feeLimits: "Min. 10€, aber Max. 90€",
          },
          flatfee: {
            subtitle: "Für Depots ab 8.000€ Volumen pro Order",
            title: "Flatfee",
            feeLabel: "Transaktionsgebühr",
            fee: "19,95€",
            feeLimits: "Pauschal unabhängig von der Ordergröße",
          },
        },
        DAB: {
          standard: {
            subtitle: "Für Depots bis zu 6.000 € Volumen pro Order",
            title: "Standard",
            feeLabel: "Prozentuale Transaktionsgebühr",
            fee: "0,25%",
            feeLimits: "Min. 10€, Max. 75€",
          },
          flatfee: {
            subtitle: "Für große Depots ab 6.000 € Volumen pro Order",
            title: "Flatfee",
            feeLabel: "Pauschale Transaktionsgebühr",
            fee: "15,00€ (plus evtl. Courtage)",
            feeLimits: "unabhängig von der Ordergröße",
          },
        },
      },
      fondsdepotDepotType: {
        title: "Möchten Sie ein Standard Depot oder ein VL Depot eröffnen?",
        normal: {
          subtitle: "Fondsdepotbank Produkt",
          title: "Standard",
          description: "Multifondsfähiges Depot",
        },
        vl: {
          subtitle: "Fondsdepotbank Produkt 2",
          title: "VL Depot",
          description: "Depot für Vermögenswirksame Leistungen",
        },
      },
      dabMobileForTan: {
        title: "An welche Mobilfunk-Nummer soll die DAB Ihre TAN senden?",
        dabMobileForTan: "Mobilfunk-Nummer",
      },
      accountIdentifier: {
        comdirectInfo: "Wo finde ich meine Kundennummer?",
        comdirectModalTitle: "Wo finde ich meine comdirect Kundennummer?",
        comdirectModalSubtitle:
          'Sie finden Ihre Kundennummer im "Persönlichen Bereich" unter dem Menüpunkt "Verwaltung" -> "Meine Daten".',
        dabHint:
          "Hinweis: Ihre DAB Stammnummer besteht aus den ersten 7 Ziffern Ihrer Kontonummer",
        COBADEHDXXX: {
          title: "Bitte geben Sie Ihre comdirect Kundennummer ein",
          accountIdentifier: "Comdirect Kundennummer",
          accountIdentifier_placeholder: "10 Ziffern (0-9)",
          error: "Muss aus 10 Zahlen bestehen (0-9)",
        },
        COBADEMXXXX: {
          title: "Nummer Ihres bestehenden Depots",
          accountIdentifier: "Depotnummer",
          accountIdentifier_placeholder: "10-11 Ziffern (0-9)",
          error: "Muss aus 10 oder 11 Zahlen bestehen (0-9)",
        },
        DABBDEMMXXX: {
          title: "Ihre DAB Konto-Stammnummer",
          accountIdentifier: "Konto-Stammnummer",
          accountIdentifier_placeholder: "7 Ziffern (0-9)",
          error: "Muss aus 7 Zahlen bestehen (0-9)",
        },
        AUGBDE77XXX: {
          title: "Nummer Ihres bestehenden Depots",
          accountIdentifier: "Depotnummer",
          accountIdentifier_placeholder: "10 Ziffern (0-9)",
          error: "Muss aus 10 Zahlen bestehen (0-9)",
        },
        DEUTLU2DXXX: {
          title: "Nummer Ihres bestehenden Depots",
          accountIdentifier: "Depotnummer",
          accountIdentifier_placeholder: "Buchstabe (A-Z) und 7 Ziffern (0-9)",
          error: "Ein Buchstabe, gefolgt von 7 Zahlen",
        },
        DEUTDEFFXXX: {
          title: "Nummer Ihres bestehenden Depots",
          accountIdentifier: "Depotnummer",
          accountIdentifier_placeholder: "Buchstabe (A-Z) und 7 Ziffern (0-9)",
          error: "Ein Buchstabe, gefolgt von 7 Zahlen",
        },
        FFBKDEFFTHK: {
          title: "Nummer Ihres bestehenden Depots",
          accountIdentifier: "Depotnummer",
          accountIdentifier_placeholder: "10 Ziffern (0-9)",
          error: "Muss aus 10 Zahlen bestehen (0-9)",
        },
        FODBDE77XXX: {
          title: "Nummer Ihres bestehenden Depots",
          accountIdentifier: "Depotnummer",
          accountIdentifier_placeholder: "9-10 Ziffern (0-9)",
          error: "Muss aus 9 oder 10 Zahlen bestehen (0-9)",
        },
        METZDEFFXXX: {
          title: "Nummer Ihres bestehenden Depots",
          accountIdentifier: "Depotnummer",
          accountIdentifier_placeholder: "10 Ziffern (0-9)",
          error: "Muss aus 10 Zahlen bestehen (0-9)",
        },
        isUsed:
          "Diese Depot bzw. Kundennummer wurde bereits in einer anderen Buchung verwendet.",
      },
    },
    payout: {
      ibanNotFound:
        "Leider haben wir keine Bank zu Ihrer IBAN gefunden. Aktuell unterstützen wir nur Konten von deutschen, österreichischen und Schweizer Banken.",
      contraAccount: {
        title: "Bitte geben Sie Ihr Referenzkonto für Bargeldtransaktionen an",
        banner: {
          title: "Warum diese Angaben?",
          text: "Ein Referenzkonto ist ein Girokonto bei Ihrer Bank, das zur Abwicklung  des Zahlungsverkehrs dient. Wenn Sie Wertpapiere kaufen, überweisen Sie Geld von Ihrem Referenzkonto auf das Verrechnungskonto Ihres Depots. Ihr Referenzkonto muss SEPA-fähig sein und in Euro geführt werden.",
        },
        iban: "IBAN",
        formSectionLabel: "Kontoinhaber des Referenzkontos",
        contraAccountHolderFirstName: "Vorname",
        contraAccountHolderFirstName_placeholder: "Vorname des Kontoinhabers",
        contraAccountHolderLastName: "Nachname",
        contraAccountHolderLastName_placeholder: "Nachname des Kontoinhabers",
      },
      payoutData: {
        title: "Bitte geben Sie Ihr Konto für Cashback-Auszahlungen an",
        iban: "IBAN",
        formSectionLabel: "Kontoinhaber des Cashback-Auszahlungskonto",
        payoutAccountHolderFirstName: "Vorname",
        payoutAccountHolderFirstName_placeholder: "Vorname des Kontoinhabers",
        payoutAccountHolderLastName: "Nachname",
        payoutAccountHolderLastName_placeholder: "Nachname des Kontoinhabers",
        company: {
          payoutAccountHolderFirstName: "Firmenname",
          payoutAccountHolderFirstName_placeholder: "Ihr Firmenname",
          payoutAccountHolderLastName: "Rechtsform",
          payoutAccountHolderLastName_placeholder: "Ihre Rechtsform",
        },
      },
    },
    summary: {
      printAndDownload: {
        title: "Antrag per PDF abschließen",
        subtitle:
          "Ihr Cashback Antrag wurde erstellt und liegt zum Download bereit",
        editData: "Daten bearbeiten",
        download: "Antrag downloaden & drucken",
        downloadAgain: "Antrag erneut downloaden",
        afterDownload: {
          title: "Fast geschafft!",
          subtitle: "Folgende Schritte sind zu erledigen",
          actions: {
            printOut: "Bitte ausgedruckte Dokumente unterschreiben",
            identifyViaRentablo:
              "Legen Sie eine Kopie Ihres Personalausweises / Reisepass bei",
            identifyViaRentablo_subtitle:
              "Wir legitimieren Sie im Zuge der Depoteröffnung. Unsere Mitarbeiter kontaktieren Sie nach Erhalt der Dokumente.",
            sendBack: "Dokumente zu uns zurücksenden",
            sendBank_subtitle: "Ein Rücksende-Formular liegt bei",
            birthCertificate: "Legen Sie eine Geburtsurkunde bei",
            birthCertificate_subtitle:
              "Bitte fügen Sie eine Kopie der Geburtsurkunde des Minderjährigen bei. Diese wird von der Bank im Rahmen der Kontoeröffnung benötigt.",
            postIdent: "Identifizieren über PostIdent",
            postIdent_subtitle:
              "Bitte identifizieren Sie sich mit dem beiliegenden PostIdent Formular bei der Post",
            allDone: "Alles Erledigt!",
          },
          newDepot: "Weiteres Depot hinzufügen",
          backToOverview: "Zurück zur Übersicht",
        },
        cashbackBonus: {
          title: "Sie haben einen Gutschein-Code?",
          subtitle:
            "Wenn Sie einen Gutschein haben, wird der Cashback-Bonus mit dem Provisionseinbehalt verrechnet und erhöht so Ihr Cashback",
          submit: "Code speichern",
          code: "Gutschein-Code",
          code_placehoder: "Gutschein-Code eingeben",
          success: "Der Gutschein-Code wurde erfolgreich angewendet",
          alreadyApplied: "Erfolgreich angewendet",
        },
      },
      companySummary: {
        afterDownload: {
          title: "Super, so geht es weiter!",
          subtitle: "Folgender Ablaufplan",
          banner:
            "Sollten Sie innerhalb des nächsten Arbeitstages keine Rückmeldung von uns erhalten haben, so senden Sie uns gerne eine Email an <strongText>{{supportEmail}}</strongText> oder rufen Sie uns einfach unter der <strongText>030 - 71533009 an.</strongText>",
          bannerForMandators:
            "Sollten Sie innerhalb des nächsten Arbeitstages keine Rückmeldung von uns erhalten haben, so senden Sie uns gerne eine Email an <strongText>{{supportEmail}}</strongText>.",
          actions: {
            dataReceived: "Wir haben Ihre Anfrage zur Depoteröffnung erhalten",
            weWillContactYou: "Wir werden uns in Kürze bei Ihnen melden",
            weWillContactYou_subtitle:
              "Leider ergeben sich bei der Eröffnung von Firmendepots häufige Änderungen in den Abläufen der jeweiligen Bank. Einer unserer Mitarbeiter wird Sie daher in Kürze mit Details zur Depoteröffnung kontaktieren.",
          },
        },
      },
    },
    companyNote: {
      title: "Bedingungen für Firmendepots",
      terms:
        "Firmendepots unterscheiden sich in Größe und Betreuungsaufwand erheblich von Privatkunden-Depots. Aus diesem Grund beträgt Ihr Cashback <strongText>pauschal 80%</strongText> der an {{appName}} ausgekehrten Bestandsprovisionen, ab dem ersten Euro.",
      oneClick:
        "Darüber hinaus steht Ihnen kostenfrei der {{appName}} One-Click Import zur einfachen Verwaltung Ihres Firmendepots zur Verfügung.",
    },
    errorMessageText: {
      title:
        "Leider ist ein Fehler bei der Verarbeitung Ihrer Daten aufgetreten.",
      subtitle:
        "Bitte wenden Sie sich zum weiteren Vorgehen an unseren Kundensupport.",
    },
    rateSupport: {
      professionalism: "Professionalität",
      customerSatisfaction: "Kundenzufriedenheit",
      customerLoyalty: "Kundentreue",
      reviews:
        "ProvenExpert.com • Ermittelt aus {{value}} veröffentlichten  Bewertungen",
    },
  },
  impressumPage: {
    title: "Impressum",
    card: {
      title: "Betreiber des Internetangebots:",
      address: "<0>Rentablo GmbH</0>\nFanny-Zobel-Str. 9\n12435 Berlin",
      contacts:
        "Telefon: <0>(0) 30 - 71 53 30 09</0>\nEmail: <1>info@rentablo.de</1>\nWeb: <2>https://www.rentablo.de</2>",
      inn: "Handelsregister: Berlin Charlottenburg HRB 256105 B\nUStID: DE364629593",
      bottom:
        "Geschäftsführung und inhaltlich Verantwortlicher gemäß § 55 Abs. 2 RStV:\n\n<0>Dipl. Btrw. André Rabenstein (CEO), Dr. Wolfram Stacklies (CTO)</0>\nAnschrift wie oben",
    },
    mailAddressTitle: "Postanschrift",
    companyName: "Rentablo",
    companyCustomerService: "Kundenservice",
    mailAddress: "Fanny-Zobel-Straße 9 \n12435 Berlin",
    sendToCustomerService:
      "Bitte senden Sie Ihre Rentablo Cashback-Unterlagen\n an unseren Kundenservice",
    section1:
      "<2>Die technische Abwicklung des Rentablo Finanzmanagers erfolgt über die wealthAPI GmbH:</2><0>Zulassung als Kontoinformationsdienstleister (KID)</0> wealthAPI GmbH ist ein von der Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin) regulierter Zahlungsdienst. Die offizielle Erlaubnis zur Erbringung von Kontoinformationsdiensten gemäß §1 Abs. 1 Satz 2 Nr. 8 ZAG hat die wealthAPI am 23.08.2019 von der BaFin erhalten und kann unter <1>https://portal.mvp.bafin.de/database/ZahlInstInfo/zahlinst.do?id=152048</1> eingesehen werden.",
    section1_withoutCashback:
      "<2>Die technische Abwicklung des Rentablo Finanzmanagers erfolgt über die wealthAPI GmbH:</2><0>Zulassung als Kontoinformationsdienstleister (KID)</0> wealthAPI GmbH ist ein von der Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin) regulierter Zahlungsdienst. Die offizielle Erlaubnis zur Erbringung von Kontoinformationsdiensten gemäß §1 Abs. 1 Satz 2 Nr. 8 ZAG hat die wealthAPI am 23.08.2019 von der BaFin erhalten und kann unter <1>https://portal.mvp.bafin.de/database/ZahlInstInfo/zahlinst.do?id=152048</1> eingesehen werden.",
    section2:
      "<0>Erlaubnis</0> Innerhalb der Bundesrepublik Deutschland und Österreich ist eine Gewerbeerlaubnis für die Tätigkeit gem. § 34c,d,f Abs. 1 GewO vorhanden.",
    section3:
      "<0>Status</0>Immobilienmakler mit Erlaubnis nach § 34 c Abs. 1 GewO\nVersicherungsmakler mit Erlaubnis nach § 34 d Abs. 1 GewO (Registrierungsnummer § 34d: D-VXM7-AKOHU-03)\nFinanzanlagenvermittler gemäß § 34f Abs.1 GewO (Registrierungsnummer § 34f: D-F-107-AWW1-16)",
    section4:
      "<0>Umfang der Erlaubnis</0>Anteile oder Aktien an inländischen offenen Investmentvermögen, offenen EU-Investmentvermögen oder ausländischen offenen Investmentvermögen, die nach dem Kapitalanlagegesetzbuch vertrieben werden dürfen (§ 34 f Abs. 1 Nr. 1 GewO)\n\nAnteilen oder Aktien an inländischen geschlossenen Investmentvermögen, geschlossenen EU-Investmentvermögen oder ausländischen geschlossenen Investmentvermögen, die nach dem Kapitalanlagegesetzbuch vertrieben werden dürfen (§ 34 f Abs. 1 Nr. 2 GewO)\n\nVermögensanlagen im Sinne des § 1 Absatz 2 des Vermögensanlagengesetzes (§ 34 f Abs. 1 Nr. 3 GewO)",
    section5:
      "<0>Die Erlaubnis wurde erteilt von der zuständigen Erlaubnis- und Aufsichtsbehörde</0><1>Bezirksamt Treptow-Köpenick von Berlin - Ordnungsamt\nZentrale Anlauf- und Beratungsstelle | Ord ZAB 1</1>Salvador-Allende-Str. 80 A/B\n12559 Berlin\n\nTel. +49 30 90297 4629",
    section6: {
      "1": "<0>Gemeinsame Registerstelle</0><1>Industrie - und Handelskammer Berlin</1>Fasanenstr. 85\n10623 Berlin\n\nTel:. 030-31510-0\nFax 030-31510-166\n<2>www.berlin.ihk.de</2>",
      "2": "Gemeinsame Registerstelle im Sinne des § 11 Absatz 1 Nr. 4 VersVermV\n\nDeutscher Industrie- und Handelskammertag (DIHK) e. V.\nBreite Straße 29\n10178 Berlin\n\nTel: 0180/6 00 58 50 (20 Cent/Min aus dem dt. Festnetz, höchstens 60 Cent/Min aus Mobilfunknetzen)\nRegisterabruf: <0>www.vermittlerregister.info</0>",
    },
    section7:
      "<0>Beteiligungen</0>Es besteht keine unmittelbare oder mittelbare Beteiligung über zehn Prozent am Stimmrecht oder Kapital eines Versicherers durch Maklerunternehmen/Versicherungsmakler.\n\nEs besteht keine unmittelbare oder mittelbare Beteiligung über zehn Prozent an Stimmrecht oder Kapital des Maklerunternehmens/Versicherungsmakler durch Versicherer.",
    section8:
      "<0>Informationen zur Streitschlichtung</0>Online-Streitbeilegung gemäß Art. 14 Abs. 1 ODR-VO: \nDie Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie unter <1>ec.europa.eu/consumers/odr</1> finden. \n\nVerbraucher haben die Möglichkeit, diese Plattform für die Beilegung ihrer Streitigkeiten zu nutzen. Wir sind im Einzelfall bereit, an einem außergerichtlichen Schlichtungsverfahren teilzunehmen.",
    section9:
      "<0>Schlichtungsstellen</0>Versicherungsombudsmann e.V.\n<1>Postfach 08 06 32, 10006 Berlin\n</1><2>www.versicherungsombudsmann.de</2>\n\nOmbudsmann Private Kranken- und Pflegeversicherung\n<3>Postfach 06 02 22, 10052 Berlin\n</3><4>www.pkv-ombudsmann.de</4>\n\nOmbudsstelle für Investmentfonds der Unternehmen des BVI\n<5>Unter den Linden 42, 10052 Berlin\n</5><6>www.ombudsstelle-investmentfonds.de</6>",
    section10:
      "<0>Verfahren zur Beschwerdebearbeitung</0>Beschwerden sollen in schriftlicher Form an <1>info@rentablo.de</1> gesendet werden. In dringenden Fällen können Beschwerden auch über die Rentablo Service-Hotline eingereicht werden.\n\nEine Bearbeitung Ihrer Beschwerde erfolgt grundsätzlich durch den Rentablo Kundenservice. Je nach Art und Umfang des Mangels erfolgt ggf. eine betriebsinterne Weiterleitung. Wir versuchen Ihr Anliegen innerhalb von fünf Werktagen zu bearbeiten. Bei Vorgängen, die Partnerbanken betreffen haben wir auf die Bearbeitszeiten der Bank leider keinen Einfluss.",
    section11:
      "<0>Berufsrechtliche Regelungen</0>§ 34 d Gewerbeordnung\n§§ 59-68 VVG\nVersVermV\nDie berufsrechtlichen Regelungen können über die vom Bundesministerium der Justiz und von der juris GmbH betriebenen Homepage <1>www.gesetze-im-internet.de</1> eingesehen und abgerufen werden.\n\nMitglied der Industrie- und Handelskammer\n\n<2>Industrie- und Handelskammer zu Berlin</2>Fasanenstraße 85\n10623 Berlin",
    section12:
      "<0>Sonstige</0>Bei allen anderen Streitigkeiten, die im Zusammenhang mit unserer Tätigkeit gegenüber einem Verbraucher stehen, können Sie sich an folgende staatlich anerkannte Verbraucherschlichtungsstelle wenden:\n\n<1>Allgemeine Verbraucherschlichtungsstelle (beim Zentrum für Schlichtung e.V.)</1>Straßburger Straße 8\n77694 Kehl\nInternet: <2>www.verbraucher-schlichter.de</2>",
    disclaimer: "Haftungshinweis",
    disclaimerText:
      "Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.",
    liability:
      "Haftung für eigene Inhalte, eingeschränkte Haftung für fremde Inhalte",
    liabilityText:
      "Alle Inhalte unseres Internetauftritts wurden mit Sorgfalt und nach bestem Gewissen erstellt. Eine Gewähr für die Aktualität, Vollständigkeit und Richtigkeit sämtlicher Seiten wird nicht übernommen. Wir sind als Dienstanbieter für eigene Inhalte auf den Rentablo-Seiten verantwortlich, jedoch nicht verpflichtet, die übermittelten oder gespeicherten fremden Informationen zu überwachen. Dazu zählen auch Inhalte, die von Rentablo-Mitgliedern veröffentlicht werden. Gleichwohl überprüfen wir alle Inhalte, zu denen uns eine konkrete Rechtsverletzung zur Kenntnis gebracht wird. Wir haften aber frühestens ab dem Zeitpunkt der Kenntniserlangung und einer angemessenen Prüffrist.",
    limited: "Eingeschränkte Haftung für externe Links",
    limitedText:
      'Rentablo-Seiten enthalten Verknüpfungen zu Webseiten Dritter ("externe Links"). Auf deren Inhalt hat Rentablo keinen Einfluss. Wir übernehmen aus diesem Grund keine Gewähr. Für die Inhalte und Richtigkeit der Informationen ist der jeweilige Informationsanbieter der verlinkten Webseite verantwortlich. Dazu zählen auch Links, die von Rentablo-Mitgliedern veröffentlicht werden. Gleichwohl überprüfen wir alle Links, zu denen uns eine konkrete Rechtsverletzung zur Kenntnis gebracht wird. Wir haften aber frühestens ab dem Zeitpunkt der Kenntniserlangung und einer angemessenen Prüffrist.',
    copyright: "Urheberrecht",
    copyrightText:
      "Die auf dieser Webseite veröffentlichten Inhalte unterliegen dem deutschen Urheberrecht. Jede Art der Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung von Rentablo. Bitte wenden Sie sich für die Genehmigung an <0>presse@rentablo.de</0>",
    privacy: "Datenschutz",
    privacyText:
      "Durch den Besuch unseres Internetauftritts können Informationen über den Zugriff (z.B. Datum, Uhrzeit, aufgerufene Seite) und personenbezogene Daten (z.B. IP-Adresse) gespeichert und verarbeitet werden. Für weitere Informationen zur Verarbeitung von Daten bei dem Besuch unserer Websites verweisen wir auf unsere <0>Datenschutzerklärung</0> \n\nZur Verarbeitung von Informationen und personenbezogenen Daten im Rahmen des Anmelde- und Registrierungsprozesses verweisen wir ebenfalls auf unsere <1>Datenschutzerklärung</1>\n\n",
    bottomText:
      "Sollten die Inhalte oder die Aufmachung unserer Website gegen die Rechte Dritter oder gegen gesetzliche Bestimmungen verstoßen, dann schicken Sie uns bitte eine Nachricht über unser Kontaktformular ohne Kostennote. \n\nWir garantieren Ihnen, dass wir zu Recht beanstandete Passagen umgehend entfernen werden, ohne dass von Ihrer Seite die Einschaltung eines Rechtsanwalts erforderlich ist. Sollten Sie trotz dieses Hinweises ohne vorherige Kontaktaufnahme eine Abmahnung eröffnen, werden wir diese vollumfänglich zurückweisen und gegebenenfalls Gegenklage wegen Verletzung vorgenannter Bestimmungen einreichen.",
  },
  impressumPageForMandators: {
    title: "Impressum",
    card: {
      title: "Betreiber des Internetangebots:",
      address:
        "<0>Depotcheck.ai is eine Marke der wealthAPI GmbH</0>\nFanny-Zobel-Str. 9\n12435 Berlin",
      contacts:
        "Telefon: <0>(0) 30 - 57 71 49 38</0> (nur Anrufbeantworter)\nEmail: <1>info@wealthapi.eu</1>\nWeb: <2>https://www.wealthapi.eu</2>",
      inn: "Handelsregister: Berlin Charlottenburg HRB 256105 B\nUStID: DE364629593",
      bottom:
        "Geschäftsführung und inhaltlich Verantwortlicher gemäß § 55 Abs. 2 RStV:\n\n<0>Dipl. Btrw. André Rabenstein (CEO), Dr. Wolfram Stacklies (CTO)</0>\nAnschrift wie oben",
    },
    mailAddressTitle: "Postanschrift",
    companyName: "WealthAPI",
    companyCustomerService: "Kundenservice",
    mailAddress: "Fanny-Zobel-Straße 9 \n12435 Berlin",
    section1:
      "<2>Die technische Abwicklung des Rentablo Finanzmanagers erfolgt über die wealthAPI GmbH:</2><<0>Zulassung als Kontoinformationsdienstleister (KID)</0> wealthAPI GmbH ist ein von der Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin) regulierter Zahlungsdienst. Die offizielle Erlaubnis zur Erbringung von Kontoinformationsdiensten gemäß §1 Abs. 1 Satz 2 Nr. 8 ZAG hat die wealthAPI am 23.08.2019 von der BaFin erhalten und kann unter <1>https://portal.mvp.bafin.de/database/ZahlInstInfo/zahlinst.do?id=152048</1> eingesehen werden.",
    section1_withoutCashback:
      "<<0>Zulassung als Kontoinformationsdienstleister (KID)</0> wealthAPI GmbH ist ein von der Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin) regulierter Zahlungsdienst. Die offizielle Erlaubnis zur Erbringung von Kontoinformationsdiensten gemäß §1 Abs. 1 Satz 2 Nr. 8 ZAG hat die wealthAPI am 23.08.2019 von der BaFin erhalten und kann unter <1>https://portal.mvp.bafin.de/database/ZahlInstInfo/zahlinst.do?id=152048</1> eingesehen werden.",
    section2:
      "<0>Erlaubnis</0> Innerhalb der Bundesrepublik Deutschland und Österreich ist eine Gewerbeerlaubnis für die Tätigkeit gem. § 34c,d,f Abs. 1 GewO vorhanden.",
    section3:
      "<0>Status</0>Immobilienmakler mit Erlaubnis nach § 34 c Abs. 1 GewO\nVersicherungsmakler mit Erlaubnis nach § 34 d Abs. 1 GewO (Registrierungsnummer § 34d: D-VXM7-AKOHU-03)\nFinanzanlagenvermittler gemäß § 34f Abs.1 GewO (Registrierungsnummer § 34f: D-F-107-AWW1-16)",
    section4:
      "<0>Umfang der Erlaubnis</0>Anteile oder Aktien an inländischen offenen Investmentvermögen, offenen EU-Investmentvermögen oder ausländischen offenen Investmentvermögen, die nach dem Kapitalanlagegesetzbuch vertrieben werden dürfen (§ 34 f Abs. 1 Nr. 1 GewO)\n\nAnteilen oder Aktien an inländischen geschlossenen Investmentvermögen, geschlossenen EU-Investmentvermögen oder ausländischen geschlossenen Investmentvermögen, die nach dem Kapitalanlagegesetzbuch vertrieben werden dürfen (§ 34 f Abs. 1 Nr. 2 GewO)\n\nVermögensanlagen im Sinne des § 1 Absatz 2 des Vermögensanlagengesetzes (§ 34 f Abs. 1 Nr. 3 GewO)",
    section5:
      "<0>Die Erlaubnis wurde erteilt von der zuständigen Erlaubnis- und Aufsichtsbehörde</0><1>Bezirksamt Treptow-Köpenick von Berlin - Ordnungsamt\nZentrale Anlauf- und Beratungsstelle | Ord ZAB 1</1>Salvador-Allende-Str. 80 A/B\n12559 Berlin\n\nTel. +49 30 90297 4629",
    section6: {
      "1": "<0>Gemeinsame Registerstelle</0><1>Industrie - und Handelskammer Berlin</1>Fasanenstr. 85\n10623 Berlin\n\nTel:. 030-31510-0\nFax 030-31510-166\n<2>www.berlin.ihk.de</2>",
      "2": "Gemeinsame Registerstelle im Sinne des § 11 Absatz 1 Nr. 4 VersVermV\n\nDeutscher Industrie- und Handelskammertag (DIHK) e. V.\nBreite Straße 29\n10178 Berlin\n\nTel: 0180/6 00 58 50 (20 Cent/Min aus dem dt. Festnetz, höchstens 60 Cent/Min aus Mobilfunknetzen)\nRegisterabruf: <0>www.vermittlerregister.info</0>",
    },
    section7:
      "<0>Beteiligungen</0>Es besteht keine unmittelbare oder mittelbare Beteiligung über zehn Prozent am Stimmrecht oder Kapital eines Versicherers durch Maklerunternehmen/Versicherungsmakler.\n\nEs besteht keine unmittelbare oder mittelbare Beteiligung über zehn Prozent an Stimmrecht oder Kapital des Maklerunternehmens/Versicherungsmakler durch Versicherer.",
    section8:
      "<0>Informationen zur Streitschlichtung</0>Online-Streitbeilegung gemäß Art. 14 Abs. 1 ODR-VO: \nDie Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie unter <1>ec.europa.eu/consumers/odr</1> finden. \n\nVerbraucher haben die Möglichkeit, diese Plattform für die Beilegung ihrer Streitigkeiten zu nutzen. Wir sind im Einzelfall bereit, an einem außergerichtlichen Schlichtungsverfahren teilzunehmen.",
    section9:
      "<0>Schlichtungsstellen</0>Versicherungsombudsmann e.V.\n<1>Postfach 08 06 32, 10006 Berlin\n</1><2>www.versicherungsombudsmann.de</2>\n\nOmbudsmann Private Kranken- und Pflegeversicherung\n<3>Postfach 06 02 22, 10052 Berlin\n</3><4>www.pkv-ombudsmann.de</4>\n\nOmbudsstelle für Investmentfonds der Unternehmen des BVI\n<5>Unter den Linden 42, 10052 Berlin\n</5><6>www.ombudsstelle-investmentfonds.de</6>",
    section10:
      "<0>Verfahren zur Beschwerdebearbeitung</0>Beschwerden sollen in schriftlicher Form an <1>info@wealthapi.eu</1> gesendet werden. In dringenden Fällen können Beschwerden auch über die wealthAPI Service-Hotline eingereicht werden.\n\nEine Bearbeitung Ihrer Beschwerde erfolgt grundsätzlich durch den wealthAPI Kundenservice. Je nach Art und Umfang des Mangels erfolgt ggf. eine betriebsinterne Weiterleitung. Wir versuchen Ihr Anliegen innerhalb von fünf Werktagen zu bearbeiten. Bei Vorgängen, die Partnerbanken betreffen haben wir auf die Bearbeitszeiten der Bank leider keinen Einfluss.",
    section11:
      "<0>Berufsrechtliche Regelungen</0>§ 34 d Gewerbeordnung\n§§ 59-68 VVG\nVersVermV\nDie berufsrechtlichen Regelungen können über die vom Bundesministerium der Justiz und von der juris GmbH betriebenen Homepage <1>www.gesetze-im-internet.de</1> eingesehen und abgerufen werden.\n\nMitglied der Industrie- und Handelskammer\n\n<2>Industrie- und Handelskammer zu Berlin</2>Fasanenstraße 85\n10623 Berlin",
    section12:
      "<0>Sonstige</0>Bei allen anderen Streitigkeiten, die im Zusammenhang mit unserer Tätigkeit gegenüber einem Verbraucher stehen, können Sie sich an folgende staatlich anerkannte Verbraucherschlichtungsstelle wenden:\n\n<1>Allgemeine Verbraucherschlichtungsstelle (beim Zentrum für Schlichtung e.V.)</1>Straßburger Straße 8\n77694 Kehl\nInternet: <2>www.verbraucher-schlichter.de</2>",
    disclaimer: "Haftungshinweis",
    disclaimerText:
      "Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.",
    liability:
      "Haftung für eigene Inhalte, eingeschränkte Haftung für fremde Inhalte",
    liabilityText:
      "Alle Inhalte unseres Internetauftritts wurden mit Sorgfalt und nach bestem Gewissen erstellt. Eine Gewähr für die Aktualität, Vollständigkeit und Richtigkeit sämtlicher Seiten wird nicht übernommen. Wir sind als Dienstanbieter für eigene Inhalte auf den wealthAPI-Seiten verantwortlich, jedoch nicht verpflichtet, die übermittelten oder gespeicherten fremden Informationen zu überwachen. Dazu zählen auch Inhalte, die von wealthAPI-Mitgliedern veröffentlicht werden. Gleichwohl überprüfen wir alle Inhalte, zu denen uns eine konkrete Rechtsverletzung zur Kenntnis gebracht wird. Wir haften aber frühestens ab dem Zeitpunkt der Kenntniserlangung und einer angemessenen Prüffrist.",
    limited: "Eingeschränkte Haftung für externe Links",
    limitedText:
      'wealthAPI-Seiten enthalten Verknüpfungen zu Webseiten Dritter ("externe Links"). Auf deren Inhalt hat wealthAPI keinen Einfluss. Wir übernehmen aus diesem Grund keine Gewähr. Für die Inhalte und Richtigkeit der Informationen ist der jeweilige Informationsanbieter der verlinkten Webseite verantwortlich. Dazu zählen auch Links, die von wealthAPI-Mitgliedern veröffentlicht werden. Gleichwohl überprüfen wir alle Links, zu denen uns eine konkrete Rechtsverletzung zur Kenntnis gebracht wird. Wir haften aber frühestens ab dem Zeitpunkt der Kenntniserlangung und einer angemessenen Prüffrist.',
    copyright: "Urheberrecht",
    copyrightText:
      "Die auf dieser Webseite veröffentlichten Inhalte unterliegen dem deutschen Urheberrecht. Jede Art der Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung von wealthAPI. Bitte wenden Sie sich für die Genehmigung an <0>presse@wealthapi.eu</0>",
    privacy: "Datenschutz",
    privacyText:
      "Durch den Besuch unseres Internetauftritts können Informationen über den Zugriff (z.B. Datum, Uhrzeit, aufgerufene Seite) und personenbezogene Daten (z.B. IP-Adresse) gespeichert und verarbeitet werden. Für weitere Informationen zur Verarbeitung von Daten bei dem Besuch unserer Websites verweisen wir auf unsere <0>Datenschutzerklärung</0> \n\nZur Verarbeitung von Informationen und personenbezogenen Daten im Rahmen des Anmelde- und Registrierungsprozesses verweisen wir ebenfalls auf unsere <1>Datenschutzerklärung</1>\n\n",
    bottomText:
      "Sollten die Inhalte oder die Aufmachung unserer Website gegen die Rechte Dritter oder gegen gesetzliche Bestimmungen verstoßen, dann schicken Sie uns bitte eine Nachricht über unser Kontaktformular ohne Kostennote. \n\nWir garantieren Ihnen, dass wir zu Recht beanstandete Passagen umgehend entfernen werden, ohne dass von Ihrer Seite die Einschaltung eines Rechtsanwalts erforderlich ist. Sollten Sie trotz dieses Hinweises ohne vorherige Kontaktaufnahme eine Abmahnung eröffnen, werden wir diese vollumfänglich zurückweisen und gegebenenfalls Gegenklage wegen Verletzung vorgenannter Bestimmungen einreichen.",
  },
  privacyPage: {
    title: "Datenschutzerklärung",
    subtitle: "Für Rentablo GmbH (im folgenden Rentablo).",
    card: {
      "1": "Ihre Finanzdaten sind bei uns sicher.",
      "2": "Unsere Datenschutzerklärung schließt den Verkauf Ihrer Daten an Dritte aus",
    },
    "1": {
      title: "1. Datenschutz",
      text: "(1) Datenschutzbeauftragter / Verantwortlicher für IT-Sicherheit:\n\nZur Beantwortung datenschutzrechtlicher Begehren kann sich der Kunde an den bestellten Datenschutzbeauftragten wenden:\nHerr Wolfram Stacklies, <0>(0) 30 - 71 53 30 09</0> oder <1>datenschutz@rentablo.de</1>\n\n(2) Wir legen Wert darauf, dass Sie sich beim Besuch unserer Online-Angebote sicher und wohl fühlen. Auf dieser Seite informieren wir Sie über unseren Umgang mit Ihren Daten. Rentablo behandelt Ihre Daten absolut vertraulich. Es findet keinerlei Weitergabe von Daten an Dritte zu Marketingzwecken statt.\n\n(3) Bitte beachten Sie, dass Sie von unserer Seite auch per Hyperlinks zu anderen Anbietern, Kooperationspartnern und durch Werbung auf fremde Websites gelangen können, welche wiederum einem eigenen Datenschutz unterliegen.\n\n(4) Benutzer von Rentablo haben die Möglichkeit, die Zusammensetzung ihrer verwalteten Depots (in Form einer Watchlist; ohne Angabe von Beträgen) oder Watchlists mit anderen Benutzern dieser Seite zu teilen. Hierbei kann jeder Nutzer selbst entscheiden, welche Daten er wem zur Verfügung stellen wird. Diese Berechtigung kann vom Benutzer jederzeit wieder entzogen werden.\n<2>In der Standardeinstellung sind diese Daten nicht einsehbar.</2>\n\n(5) Rentablo wird Nutzerentscheidungen stets respektieren und zu keinem Zeitpunkt Investmentdaten ohne ausdrückliche Zustimmung des Benutzers veröffentlichen.",
    },
    "2": {
      title: "2. Erhebung und Nutzung von Daten",
      text: "<0>a) Von uns erhobene Informationen</0> Wir erfassen Informationen, um allen unseren Nutzern bessere Dienste zur Verfügung zu stellen.\n\nUnter personenbezogenen Daten sind gemäß Bundesdatenschutzgesetz Informationen zu verstehen, welche dazu genutzt werden können, Rückschlüsse auf Ihre Person und Ihre persönlichen oder sachlichen Verhältnisse zu ziehen.\n\nWenn Sie die Webseiten von Rentablo besuchen, werden temporär Daten wie Ihre IP-Adresse oder das Datum des Zugriffs gespeichert.\n\nDarüber hinausgehende personenbezogene Daten wie Ihr Name, Ihre Anschrift oder Ihre E-Mail-Adresse werden nur erfasst, sofern Sie diese freiwillig angeben, wie zum Beispiel im Rahmen der Registrierung.\n\n<1>b) Nutzung der Daten</1> Ihre Daten werden von uns grundsätzlich nur insoweit genutzt, wie es zur Durchführung unseres Internetangebotes und des Nutzungsverhältnisses erforderlich ist oder sonst gesetzlich erlaubt ist.\n\nRentablo nutzt die im Rahmen seiner Dienste erhobenen Daten zur Bereitstellung, zur Wartung, zum Schutz und zur Verbesserung seiner Dienste und zur Entwicklung neuer Dienste sowie zum Schutz seiner Nutzer. Rentablo verwendet diese Daten außerdem, um Ihnen maßgeschneiderte Inhalte anzubieten. Hierzu aggregiert Rentablo Daten und erstellt anonymisierte Auswertungen, um z.B. Peer-Group-Vergleiche zu ermöglichen.\n\nRentablo wird Ihre personenbezogenen Daten für Marketing-Maßnahmen wie z.B. zur Versendung von E-Mails mit allgemeinen Informationen oder werbendem Charakter (z.B. Newsletter) nur dann verarbeiten und nutzen, wenn Sie dazu vorher ausdrücklich separat Ihr Einverständnis erklärt haben. Sie haben die Möglichkeit, solche Informationen jederzeit abzubestellen.\n\nWir werden Ihre Einwilligung zur Datenerhebung und Speicherung protokollieren. Bei Bedarf teilen wir Ihnen mit, wann und wie Sie Ihre Einwilligung gegeben haben. Sollten Sie Ihre Zustimmung nicht geben, bitten wir um Verständnis, dass Sie unser Angebot nicht nutzen können.\n\nDarüber hinaus wird Rentablo nur dann Daten erheben, verarbeiten oder nutzen, soweit dies bei Vorliegen tatsächlicher Anhaltspunkte im Einzelfall erforderlich ist, um betrügerisches oder sonstiges rechtswidriges oder vertragswidriges Verhalten auf den Webseiten von Rentablo aufzudecken. Zu diesem Zweck darf Rentablo auch Nutzungsdaten, unter anderem mit Hilfe von Cookies, erheben, verarbeiten und nutzen.\n\n<2>c) Weitergabe von Daten</2> Rentablo übermittelt Ihren Namen und Ihre Kontaktdaten wie Ihre E-Mail-Adresse an andere bei Rentablo registrierte Benutzer oder Rentablo-Kooperationspartner nur, wenn Sie dies im Rahmen einer Einladung, einer Angebotsanfrage oder eines Auftrages selbst veranlasst haben.\n\nAls registrierter Nutzer ist der von Ihnen gewählte Nutzername grundsätzlich allen Besuchern auf allen Rentablo Webseiten zugänglich.\n\nRentablo verwendet spezialisierte Drittanbieter zur Bereitstellung seiner Dienste. Hierunter fallen z.B. E-Mailing und Bankschnittstellen. Rentablo gibt Nutzerdaten an diese Dienstleister mit dem ausschließlichen Zweck der Diensterbringung weiter. Eine Weitergabe zu Marketingzwecken ist ausgeschlossen.\n\nIhre personenbezogenen Daten wird Rentablo darüber hinaus nur im Rahmen der gesetzlichen Vorschriften an Dritte übermitteln, insbesondere an Strafverfolgungs- und Aufsichtsbehörden zur Abwehr von Gefahren für die staatliche und öffentliche Sicherheit sowie zur Verfolgung von Straftaten oder wenn dies zur Wahrung berechtigter Interessen eines Dritten erforderlich ist.",
    },
    "3": {
      title: "3. Externe Dienstleister",
      text: "Rentablo bedient sich zu ihrer Aufgabenerfüllung externer Dienstleister. Insbesondere da wesentliche Vorgänge der Datenverarbeitung, der IT-Infrastruktur sowie spezieller kundenspezifischer Anwendungen hiervon betroffen sind, werden mit den Dienstleistern vertragliche Regelungen schriftlich festgehalten.\n\nRentablo verpflichtet alle externen Dienstleistungserbringer zur Wahrung des Datengeheimnisses und der Vertraulichkeit. Der Dienstleister hat eine Hilfsfunktion, er leistet dem Auftraggeber in einer oder mehreren Phasen der Datenerhebung, -verarbeitung oder -nutzung weisungsgebundene Unterstützung. Er übernimmt keine Aufgabe in ihrer Vollständigkeit, sondern lediglich ihre technische Ausführung.\n\nRentablo setzt derzeit im Zusammenhang mit der Datenverarbeitung folgende Dienstleistungsunternehmen ein:\n\n<0>Google Ireland Limited</0>Gordon House, Barrow Street, Dublin 4, Ireland (Hosting im Google Datacenter Frankfurt. Gebäude und Infrastruktur unterliegen einer 24/7-Überwachung, Sicherheitsbereiche werden zusätzlich videoüberwacht. Eine Mehrfaktor-Authentifizierung gewährleistet eine höchst zuverlässige Zutrittskontrolle.)\n\n<1>Mailchimp</1>The Rocket Science Group, LLC, 675 Ponce de Leon Ave NE, Suite 5000, Atlanta, GA 30308 USA (Mailing Portal Rentablo Newsletter)\n\n<2>wildbit LLC</2>225 Chestnut St., Philadelphia, PA, 19106 (Mailing Anbieter für Transaktionale Email-Kommunikation)\n\n<3>finAPI GmbH</3>Adams-Lehmann-Straße 44, 80797 München, Deutschland (Bankschnittstellen und Zwischenspeicherung von Kontoinformationsdaten)\n\n<4>Netfonds AG</4><5>Heidenkampsweg 73, 20097 Hamburg, Deutschland (Betreuung von über Rentablo-Cashback verwaltete Depots; in diesem Zusammenhang Speicherung von Kunden- und Transaktionsdaten auf Servern der Netfonds AG)</5>",
    },
    "4": {
      title: "4. Cookies",
      text: 'Rentablo speichert Informationen in Form sog. Cookies auf Ihrem System. Diese dienen zur Identifikation Ihrer aktuellen oder vergangenen Nutzer-Session.\n\nDarüber hinaus nutzen wir Webanalyse-Tools Dritter (z.B. Google Analytics, Hotjar und vergleichbare Webanalyse-Dienste), für die bedarfsgerechte Gestaltung von Web-Angeboten. Hierzu setzen die Webanalyse-Dienste auch Cookies ein.\n\nDie Auswertung und Aufbereitung dieser Daten erfolgt sowohl in Staaten der EU- als auch in Staaten, die nicht der EU angehören (z.B. Google Analytics in den USA).\n\nDie Webanalyse-Dienste werden die übertragenen Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Website-Aktivitäten für uns zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen. Auch werden die Webanalyse-Dienste diese Informationen gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben oder soweit Dritte diese Daten im Auftrag der Webanalysedienste verarbeiten. Die Webanalyse-Dienste werden in keinem Fall Ihre IP-Adresse mit anderen Daten der Webanalyse-Dienste in Verbindung bringen. Wir erhalten ausschließlich Auswertungen ohne Personenbezug. IP-Adressen werden ausschließlich anonymisiert gespeichert.\n\nWeitere Informationen zur Google Inc. und Google Analytics finden Sie unter: (<0>https://www.google.com</0>). Die Datenschutzerklärung von Google finden Sie unter: <1>https://www.google.com/intl/de/policies/privacy/</1>. Um Informationen zu erhalten, wie Sie das Tracking durch Google Analytics unterbinden können, klicken Sie bitte den folgenden Link: <2>https://tools.google.com/dlpage/gaoptout?hl=de</2>.\n\nIntegration und Verwendung von Facebook- und Twitter-Plugins\nWir verwenden in bestimmten Bereichen auf unseren Websites Technologien des sozialen Netzwerkes facebook.com (unter anderem Plugins, Facebook Pixel). Facebook.com ist ein Angebot der Facebook Inc., 1601 S. California Ave, Palo Alto, CA 94304, USA. Sollten Sie eine unserer Websites, die ein Plugin von Facebook integriert hat, aufrufen, wird eine Verbindung zu den Facebook-Servern hergestellt. Erst durch die dadurch initiierte Mitteilung an Ihren Browser wird das Plugin auf unserer jeweiligen Website dargestellt.\n\nWir weisen Sie hiermit ausdrücklich darauf hin, dass durch die Erkennung Ihres Browsers automatisch die Information an die Facebook-Server übermittelt wird, welche unserer Internetseiten von Ihnen besucht wurden.\n\nSofern Sie dabei auch noch als Mitglied bei Facebook eingeloggt sind, ordnet Facebook diese Informationen Ihrem persönlichen Facebook-Benutzerkonto zu. Gleiches gilt auch für die Nutzung der Plugin-Funktionen, z.B. durch Anklicken des "Gefällt mir"-Buttons. Dabei werden ebenfalls diese Informationen Ihrem Facebook-Benutzerkonto zugeordnet. Sie können dies verhindern, wenn Sie sich vor Nutzung unserer Websites bei Facebook ausloggen.\n\nBeim Facebook-Pixel handelt es sich um JavaScript-Code, welcher Daten an Facebook übermittelt (u.a. HTTP Header-Informationen wie IP-Adresse, Informationen zum Webbrowser, Seitenspeicherort, Dokument, URL der Website und Nutzeragent des Webbrowsers sowie Tag und Uhrzeit der Nutzung).\n\nDarüber hinaus werden pixelspezifische Daten wie zum Beispiel die Pixel-ID und Facebook-Cookie-Daten, einschließlich Ihrer Facebook-ID übermittelt (diese Daten werden verwendet, um Ereignisse mit einem bestimmten Facebook-Werbekonto zu verknüpfen und sie einem Facebook-Nutzer zuzuordnen)\n\nWenn Sie der Nutzung vom Facebook Pixel widersprechen möchten, können Sie ein Opt-Out Cookie bei Facebook setzen oder JavaScript in Ihrem Browser deaktivieren.\n\nUmfassende Informationen zur Erhebung, Speicherung und Nutzung Ihrer Daten durch Facebook, zur diesbezüglichen Ausübung Ihrer Rechte und zum Schutz Ihrer Privatsphäre finden Sie in den Facebook Datenschutzrichtlinien <3>https://de-de.facebook.com/policy.php</3> und dem Leitfaden zur Privatsphäre <4>https://de-de.facebook.com/privacy/explanation.php</4>.\n\nWir nutzen auf dieser Website Funktionen des Dienstes Twitter, einem Angebot der Twitter Inc., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA ("Twitter"). Durch das Benutzen von Twitter und der Funktion "Re-Tweet" werden die von Ihnen besuchten Webseiten mit Ihrem Twitter-Account verknüpft und anderen Nutzern bekannt gegeben. Dabei werden auch Daten an Twitter übertragen.\n\nWir weisen darauf hin, dass wir als Anbieter der Seiten keine Kenntnis vom Inhalt der übermittelten Daten sowie deren Nutzung durch Twitter erhalten. Weitere Informationen hierzu finden Sie in der Datenschutzerklärung von Twitter: twitter.com/privacy.\n\nIhre Datenschutzeinstellungen bei Twitter können Sie in den Konto-Einstellungen unter twitter.com/account/settings ändern.',
    },
    "5": {
      title: "5. Hotjar",
      text: "Diese Website nutzt Hotjar. Anbieter ist die Hotjar Ltd., Level 2, St Julians Business Centre, 3, Elia Zammit Street, St Julians STJ 1000, Malta, Europe (Website: <0>https://www.hotjar.com</0>). Wir haben einenVertrag über Auftragsverarbeitungmit Hotjar geschlossen, um die strengen europäischen Datenschutzvorschriften umzusetzen.\n\nHotjar ist ein Werkzeug zur Analyse Ihres Nutzerverhaltens auf unserer Website. Mit Hotjar können wir u. a. Ihre Maus- und Scrollbewegungen und Klicks aufzeichnen. Hotjar kann dabei auch feststellen, wie lange Sie mit dem Mauszeiger auf einer bestimmten Stelle verblieben sind. Aus diesen Informationen erstellt Hotjar sogenannte Heatmaps, mit denen sich feststellen lässt, welche Websitebereiche vom Websitebesucher bevorzugt angeschaut werden.\n\nDes Weiteren können wir feststellen, wie lange Sie auf einer Seite verblieben sind und wann Sie sie verlassen haben. Wir können auch feststellen, an welcher Stelle Sie Ihre Eingaben in ein Kontaktformular abgebrochen haben (sog. Conversion-Funnels). Darüber hinaus können mit Hotjar direkte Feedbacks von Websitebesuchern eingeholt werden. Diese Funktion dient der Verbesserung der Webangebote des Websitebetreibers.\n\nDie Nutzung von Hotjar und die Speicherung von Hotjar-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren.<1>Deaktivieren von Hotjar</1>Wenn Sie die Datenerfassung durch Hotjar deaktivieren möchten, klicken Sie auf folgenden Link und folgen Sie den dortigen Anweisungen: <2>https://www.hotjar.com/opt-out</2>.\n\nBitte beachten Sie, dass die Deaktivierung von Hotjar für jeden Browser bzw. für jedes Endgerät separat erfolgen muss. Nähere Informationen über Hotjar und zu den erfassten Daten entnehmen Sie der Datenschutzerklärung von Hotjar unter dem folgenden Link: <3>https://www.hotjar.com/privacy</3>.<4>Interessenbezogene Werbung</4>Auf unserer Website kann ggf. interessenbezogene Werbung verwendet werden. Hierzu verwendet Rentablo Nutzerprofile des Google Content Werbenetzwerks oder eigene, anonymisierte Nutzerdaten.<5>Kostenpflichtige-Dienste</5>Wir bieten Ihnen kostenpflichtige Leistungen oder die kostenpflichtige Bestellung von Produkten oder Dienstleistungen an<7>; wie z.B. Rentablo-Cashback</7>. Hierfür sind von Ihnen dann gegebenenfalls und abhängig von dem jeweiligen Dienst noch weitere Daten abzugeben (z.B. eine Lieferadresse oder Bezahldaten). Rentablo protokolliert in diesem Fall weitere Nutzungsdaten zur Erbringung des Angebots und zur Wahrung Ihrer und der Interessen berechtigter Dritter.<6>Löschung und Änderung Ihrer Daten</6>Sie können jederzeit Auskunft über Ihre bei uns gespeicherten Daten sowie eine Berichtigung, Sperrung und Löschung beantragen. Alle Möglichkeiten, mit Rentablo Kontakt aufzunehmen, finden Sie im Impressum.\n\nÄnderung dieser Datenschutzerklärung\nRentablo wird Sie an geeigneter Stelle darauf hinweisen, wenn diese Datenschutzerklärung geändert wird.",
    },
    "6": {
      title: "6. Sicherheit",
      text: "Rentablo schützt Ihre Daten vor dem unberechtigten Zugriff Dritter im Rahmen der jeweiligen technischen Möglichkeiten. Die Gültigkeit dieser Datenschutzerklärung ist begrenzt auf unsere Webseiten. Auf Links zu anderen Unternehmen erstreckt sich diese Datenschutzerklärung nicht. Wir setzen umfangreiche technische sowie organisatorische Sicherheitsmaßnahmen ein, um Ihre persönlichen Daten vor vorsätzlichen Manipulationen, Verlust oder dem Zugriff durch unautorisierte Dritte zu schützen. Diese werden im Rahmen der geltenden Datenschutzgesetze, entsprechend der technologischen Entwicklungen ständig verbessert. Dennoch möchten wir Sie darauf hinweisen, dass trotz unserer Sicherheitsmaßnahmen Informationen, welche Sie freiwillig über das Netz freigeben, von anderen genutzt werden können. So können wir bei Datenübertragungsfehlern sowie unautorisierten Zugriffen auf Ihre Daten durch Dritte keine Haftung übernehmen.",
    },
    "7": {
      title: "7. Einwilligung und Widerruf",
      text: "Mit der Registrierung bei Rentablo willigen Sie in diese Datenschutzerklärung ein. Ihre Einwilligungserklärung können Sie jederzeit mit Wirkung für die Zukunft widerrufen.",
    },
    "8": {
      title: "8. Kontakt & Auskunftsrecht",
      text: "Bei weiteren Fragen oder Anregungen zum Thema Datenschutz wenden Sie sich bitte an uns. Sie können zudem jederzeit Auskunft über die von uns über Sie gespeicherten Daten erhalten. In unserem öffentlichen Verfahrensverzeichnis haben wir die Angaben nach § 4g BDSG zusammengefasst. Bei Bedarf schreiben Sie bitte an:\n\n<0>Rentablo GmbH, Fanny-Zobel-Str. 9, 12435 Berlin oder </0><1>info@rentablo.de</1>\n\nStand: 15.09.2025",
    },
  },
  privacyPageForMandators: {
    title: "Datenschutzerklärung",
    subtitle:
      "Für Depotcheck.ai, eine Marke der wealthAPI GmbH (im folgenden Depotcheck)",
    card: {
      "1": "Ihre Finanzdaten sind bei uns sicher.",
      "2": "Unsere Datenschutzerklärung schließt den Verkauf Ihrer Daten an Dritte aus",
    },
    "1": {
      title: "1. Datenschutz",
      text: "(1) Datenschutzbeauftragter / Verantwortlicher für IT-Sicherheit:\n\nZur Beantwortung datenschutzrechtlicher Begehren kann sich der Kunde an den bestellten Datenschutzbeauftragten wenden:\nHerr Wolfram Stacklies, <1>datenschutz@wealthapi.eu</1>.\n\n(2) Wir legen Wert darauf, dass Sie sich beim Besuch unserer Online-Angebote sicher und wohl fühlen. Auf dieser Seite informieren wir Sie über unseren Umgang mit Ihren Daten. Depotcheck behandelt Ihre Daten absolut vertraulich. Es findet keinerlei Weitergabe von Daten an Dritte zu Marketingzwecken statt.\n\n(3) Bitte beachten Sie, dass Sie von unserer Seite auch per Hyperlinks zu anderen Anbietern, Kooperationspartnern und durch Werbung auf fremde Websites gelangen können, welche wiederum einem eigenen Datenschutz unterliegen.\n\n(4) Benutzer von Depotcheck haben die Möglichkeit, die Zusammensetzung ihrer verwalteten Depots (in Form einer Watchlist; ohne Angabe von Beträgen) oder Watchlists mit anderen Benutzern dieser Seite zu teilen. Hierbei kann jeder Nutzer selbst entscheiden, welche Daten er wem zur Verfügung stellen wird. Diese Berechtigung kann vom Benutzer jederzeit wieder entzogen werden.\n<2>In der Standardeinstellung sind diese Daten nicht einsehbar.</2>\n\n(5) Depotcheck wird Nutzerentscheidungen stets respektieren und zu keinem Zeitpunkt Investmentdaten ohne ausdrückliche Zustimmung des Benutzers veröffentlichen.",
    },
    "2": {
      title: "2. Erhebung und Nutzung von Daten",
      text: "<0>a) Von uns erhobene Informationen</0> Wir erfassen Informationen, um allen unseren Nutzern bessere Dienste zur Verfügung zu stellen.\n\nUnter personenbezogenen Daten sind gemäß Bundesdatenschutzgesetz Informationen zu verstehen, welche dazu genutzt werden können, Rückschlüsse auf Ihre Person und Ihre persönlichen oder sachlichen Verhältnisse zu ziehen.\n\nWenn Sie die Webseiten von Depotcheck besuchen, werden temporär Daten wie Ihre IP-Adresse oder das Datum des Zugriffs gespeichert.\n\nDarüber hinausgehende personenbezogene Daten wie Ihr Name, Ihre Anschrift oder Ihre E-Mail-Adresse werden nur erfasst, sofern Sie diese freiwillig angeben, wie zum Beispiel im Rahmen der Registrierung.\n\n<1>b) Nutzung der Daten</1> Ihre Daten werden von uns grundsätzlich nur insoweit genutzt, wie es zur Durchführung unseres Internetangebotes und des Nutzungsverhältnisses erforderlich ist oder sonst gesetzlich erlaubt ist.\n\nDepotcheck nutzt die im Rahmen seiner Dienste erhobenen Daten zur Bereitstellung, zur Wartung, zum Schutz und zur Verbesserung seiner Dienste und zur Entwicklung neuer Dienste sowie zum Schutz seiner Nutzer. Depotcheck verwendet diese Daten außerdem, um Ihnen maßgeschneiderte Inhalte anzubieten. Hierzu aggregiert Depotcheck Daten und erstellt anonymisierte Auswertungen, um z.B. Peer-Group-Vergleiche zu ermöglichen.\n\nDepotcheck wird Ihre personenbezogenen Daten für Marketing-Maßnahmen wie z.B. zur Versendung von E-Mails mit allgemeinen Informationen oder werbendem Charakter (z.B. Newsletter) nur dann verarbeiten und nutzen, wenn Sie dazu vorher ausdrücklich separat Ihr Einverständnis erklärt haben. Sie haben die Möglichkeit, solche Informationen jederzeit abzubestellen.\n\nWir werden Ihre Einwilligung zur Datenerhebung und Speicherung protokollieren. Bei Bedarf teilen wir Ihnen mit, wann und wie Sie Ihre Einwilligung gegeben haben. Sollten Sie Ihre Zustimmung nicht geben, bitten wir um Verständnis, dass Sie unser Angebot nicht nutzen können.\n\nDarüber hinaus wird Depotcheck nur dann Daten erheben, verarbeiten oder nutzen, soweit dies bei Vorliegen tatsächlicher Anhaltspunkte im Einzelfall erforderlich ist, um betrügerisches oder sonstiges rechtswidriges oder vertragswidriges Verhalten auf den Webseiten von Depotcheck aufzudecken. Zu diesem Zweck darf Depotcheck auch Nutzungsdaten, unter anderem mit Hilfe von Cookies, erheben, verarbeiten und nutzen.\n\n<2>c) Weitergabe von Daten</2> Depotcheck übermittelt Ihren Namen und Ihre Kontaktdaten wie Ihre E-Mail-Adresse an andere bei Depotcheck registrierte Benutzer oder Depotcheck-Kooperationspartner nur, wenn Sie dies im Rahmen einer Einladung, einer Angebotsanfrage oder eines Auftrages selbst veranlasst haben.\n\nAls registrierter Nutzer ist der von Ihnen gewählte Nutzername grundsätzlich allen Besuchern auf allen Depotcheck Webseiten zugänglich.\n\nDepotcheck verwendet spezialisierte Drittanbieter zur Bereitstellung seiner Dienste. Hierunter fallen z.B. E-Mailing und Bankschnittstellen. Depotcheck gibt Nutzerdaten an diese Dienstleister mit dem ausschließlichen Zweck der Diensterbringung weiter. Eine Weitergabe zu Marketingzwecken ist ausgeschlossen.\n\nIhre personenbezogenen Daten wird Depotcheck darüber hinaus nur im Rahmen der gesetzlichen Vorschriften an Dritte übermitteln, insbesondere an Strafverfolgungs- und Aufsichtsbehörden zur Abwehr von Gefahren für die staatliche und öffentliche Sicherheit sowie zur Verfolgung von Straftaten oder wenn dies zur Wahrung berechtigter Interessen eines Dritten erforderlich ist.",
    },
    "3": {
      title: "3. Externe Dienstleister",
      text: "Depotcheck bedient sich zu ihrer Aufgabenerfüllung externer Dienstleister. Insbesondere da wesentliche Vorgänge der Datenverarbeitung, der IT-Infrastruktur sowie spezieller kundenspezifischer Anwendungen hiervon betroffen sind, werden mit den Dienstleistern vertragliche Regelungen schriftlich festgehalten.\n\nDepotcheck verpflichtet alle externen Dienstleistungserbringer zur Wahrung des Datengeheimnisses und der Vertraulichkeit. Der Dienstleister hat eine Hilfsfunktion, er leistet dem Auftraggeber in einer oder mehreren Phasen der Datenerhebung, -verarbeitung oder -nutzung weisungsgebundene Unterstützung. Er übernimmt keine Aufgabe in ihrer Vollständigkeit, sondern lediglich ihre technische Ausführung.\n\nDepotcheck setzt derzeit im Zusammenhang mit der Datenverarbeitung folgende Dienstleistungsunternehmen ein:\n\n<0>Google Ireland Limited</0>Gordon House, Barrow Street, Dublin 4, Ireland (Hosting im Google Datacenter Frankfurt. Gebäude und Infrastruktur unterliegen einer 24/7-Überwachung, Sicherheitsbereiche werden zusätzlich videoüberwacht. Eine Mehrfaktor-Authentifizierung gewährleistet eine höchst zuverlässige Zutrittskontrolle.)\n\n<1>Mailchimp</1>The Rocket Science Group, LLC, 675 Ponce de Leon Ave NE, Suite 5000, Atlanta, GA 30308 USA (Mailing Portal Depotcheck Newsletter)\n\n<2>wildbit LLC</2>225 Chestnut St., Philadelphia, PA, 19106 (Mailing Anbieter für Transaktionale Email-Kommunikation)\n\n<3>finAPI GmbH</3>Adams-Lehmann-Straße 44, 80797 München, Deutschland (Bankschnittstellen und Zwischenspeicherung von Kontoinformationsdaten)\n\n<4>Netfonds AG</4><5>Heidenkampsweg 73, 20097 Hamburg, Deutschland (Betreuung von über Rentablo-Cashback verwaltete Depots; in diesem Zusammenhang Speicherung von Kunden- und Transaktionsdaten auf Servern der Netfonds AG)</5>",
    },
    "4": {
      title: "4. Cookies",
      text: 'Depotcheck speichert Informationen in Form sog. Cookies auf Ihrem System. Diese dienen zur Identifikation Ihrer aktuellen oder vergangenen Nutzer-Session.\n\nDarüber hinaus nutzen wir Webanalyse-Tools Dritter (z.B. Google Analytics, Hotjar und vergleichbare Webanalyse-Dienste), für die bedarfsgerechte Gestaltung von Web-Angeboten. Hierzu setzen die Webanalyse-Dienste auch Cookies ein.\n\nDie Auswertung und Aufbereitung dieser Daten erfolgt sowohl in Staaten der EU- als auch in Staaten, die nicht der EU angehören (z.B. Google Analytics in den USA).\n\nDie Webanalyse-Dienste werden die übertragenen Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Website-Aktivitäten für uns zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen. Auch werden die Webanalyse-Dienste diese Informationen gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben oder soweit Dritte diese Daten im Auftrag der Webanalysedienste verarbeiten. Die Webanalyse-Dienste werden in keinem Fall Ihre IP-Adresse mit anderen Daten der Webanalyse-Dienste in Verbindung bringen. Wir erhalten ausschließlich Auswertungen ohne Personenbezug. IP-Adressen werden ausschließlich anonymisiert gespeichert.\n\nWeitere Informationen zur Google Inc. und Google Analytics finden Sie unter: (<0>https://www.google.com</0>). Die Datenschutzerklärung von Google finden Sie unter: <1>https://www.google.com/intl/de/policies/privacy/</1>. Um Informationen zu erhalten, wie Sie das Tracking durch Google Analytics unterbinden können, klicken Sie bitte den folgenden Link: <2>https://tools.google.com/dlpage/gaoptout?hl=de</2>.\n\nIntegration und Verwendung von Facebook- und Twitter-Plugins\nWir verwenden in bestimmten Bereichen auf unseren Websites Plugins des sozialen Netzwerkes facebook.com. Facebook.com ist ein Angebot der Facebook Inc., 1601 S. California Ave, Palo Alto, CA 94304, USA. Sollten Sie eine unserer Websites, die ein Plugin von Facebook integriert hat, aufrufen, wird eine Verbindung zu den Facebook-Servern hergestellt. Erst durch die dadurch initiierte Mitteilung an Ihren Browser wird das Plugin auf unserer jeweiligen Website dargestellt.\n\nWir weisen Sie hiermit ausdrücklich darauf hin, dass durch die Erkennung Ihres Browsers automatisch die Information an die Facebook-Server übermittelt wird, welche unserer Internetseiten von Ihnen besucht wurden.\n\nSofern Sie dabei auch noch als Mitglied bei Facebook eingeloggt sind, ordnet Facebook diese Informationen Ihrem persönlichen Facebook-Benutzerkonto zu. Gleiches gilt auch für die Nutzung der Plugin-Funktionen, z.B. durch Anklicken des "Gefällt mir"-Buttons. Dabei werden ebenfalls diese Informationen Ihrem Facebook-Benutzerkonto zugeordnet. Sie können dies verhindern, wenn Sie sich vor Nutzung unserer Websites bei Facebook ausloggen.\n\nUmfassende Informationen zur Erhebung, Speicherung und Nutzung Ihrer Daten durch Facebook, zur diesbezüglichen Ausübung Ihrer Rechte und zum Schutz Ihrer Privatsphäre finden Sie in den Facebook Datenschutzrichtlinien <3>https://de-de.facebook.com/policy.php</3> und dem Leitfaden zur Privatsphäre <4>https://de-de.facebook.com/privacy/explanation.php</4>.\n\nWir nutzen auf dieser Website Funktionen des Dienstes Twitter, einem Angebot der Twitter Inc., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA ("Twitter"). Durch das Benutzen von Twitter und der Funktion "Re-Tweet" werden die von Ihnen besuchten Webseiten mit Ihrem Twitter-Account verknüpft und anderen Nutzern bekannt gegeben. Dabei werden auch Daten an Twitter übertragen.\n\nWir weisen darauf hin, dass wir als Anbieter der Seiten keine Kenntnis vom Inhalt der übermittelten Daten sowie deren Nutzung durch Twitter erhalten. Weitere Informationen hierzu finden Sie in der Datenschutzerklärung von Twitter: twitter.com/privacy.\n\nIhre Datenschutzeinstellungen bei Twitter können Sie in den Konto-Einstellungen unter twitter.com/account/settings ändern.',
    },
    "5": {
      title: "5. Hotjar",
      text: "Diese Website nutzt Hotjar. Anbieter ist die Hotjar Ltd., Level 2, St Julians Business Centre, 3, Elia Zammit Street, St Julians STJ 1000, Malta, Europe (Website: <0>https://www.hotjar.com</0>). Wir haben einenVertrag über Auftragsverarbeitungmit Hotjar geschlossen, um die strengen europäischen Datenschutzvorschriften umzusetzen.\n\nHotjar ist ein Werkzeug zur Analyse Ihres Nutzerverhaltens auf unserer Website. Mit Hotjar können wir u. a. Ihre Maus- und Scrollbewegungen und Klicks aufzeichnen. Hotjar kann dabei auch feststellen, wie lange Sie mit dem Mauszeiger auf einer bestimmten Stelle verblieben sind. Aus diesen Informationen erstellt Hotjar sogenannte Heatmaps, mit denen sich feststellen lässt, welche Websitebereiche vom Websitebesucher bevorzugt angeschaut werden.\n\nDes Weiteren können wir feststellen, wie lange Sie auf einer Seite verblieben sind und wann Sie sie verlassen haben. Wir können auch feststellen, an welcher Stelle Sie Ihre Eingaben in ein Kontaktformular abgebrochen haben (sog. Conversion-Funnels). Darüber hinaus können mit Hotjar direkte Feedbacks von Websitebesuchern eingeholt werden. Diese Funktion dient der Verbesserung der Webangebote des Websitebetreibers.\n\nDie Nutzung von Hotjar und die Speicherung von Hotjar-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren.<1>Deaktivieren von Hotjar</1>Wenn Sie die Datenerfassung durch Hotjar deaktivieren möchten, klicken Sie auf folgenden Link und folgen Sie den dortigen Anweisungen: <2>https://www.hotjar.com/opt-out</2>.\n\nBitte beachten Sie, dass die Deaktivierung von Hotjar für jeden Browser bzw. für jedes Endgerät separat erfolgen muss. Nähere Informationen über Hotjar und zu den erfassten Daten entnehmen Sie der Datenschutzerklärung von Hotjar unter dem folgenden Link: <3>https://www.hotjar.com/privacy</3>.<4>Interessenbezogene Werbung</4>Auf unserer Website kann ggf. interessenbezogene Werbung verwendet werden. Hierzu verwendet Depotcheck Nutzerprofile des Google Content Werbenetzwerks oder eigene, anonymisierte Nutzerdaten.<5>Kostenpflichtige-Dienste</5>Wir bieten Ihnen kostenpflichtige Leistungen oder die kostenpflichtige Bestellung von Produkten oder Dienstleistungen an<7>; wie z.B. Rentablo-Cashback</7>. Hierfür sind von Ihnen dann gegebenenfalls und abhängig von dem jeweiligen Dienst noch weitere Daten abzugeben (z.B. eine Lieferadresse oder Bezahldaten). Depotcheck protokolliert in diesem Fall weitere Nutzungsdaten zur Erbringung des Angebots und zur Wahrung Ihrer und der Interessen berechtigter Dritter.<6>Löschung und Änderung Ihrer Daten</6>Sie können jederzeit Auskunft über Ihre bei uns gespeicherten Daten sowie eine Berichtigung, Sperrung und Löschung beantragen. Alle Möglichkeiten, mit Depotcheck Kontakt aufzunehmen, finden Sie im Impressum.\n\nÄnderung dieser Datenschutzerklärung\nDepotcheck wird Sie an geeigneter Stelle darauf hinweisen, wenn diese Datenschutzerklärung geändert wird.",
    },
    "6": {
      title: "6. Sicherheit",
      text: "Depotcheck schützt Ihre Daten vor dem unberechtigten Zugriff Dritter im Rahmen der jeweiligen technischen Möglichkeiten. Die Gültigkeit dieser Datenschutzerklärung ist begrenzt auf unsere Webseiten. Auf Links zu anderen Unternehmen erstreckt sich diese Datenschutzerklärung nicht. Wir setzen umfangreiche technische sowie organisatorische Sicherheitsmaßnahmen ein, um Ihre persönlichen Daten vor vorsätzlichen Manipulationen, Verlust oder dem Zugriff durch unautorisierte Dritte zu schützen. Diese werden im Rahmen der geltenden Datenschutzgesetze, entsprechend der technologischen Entwicklungen ständig verbessert. Dennoch möchten wir Sie darauf hinweisen, dass trotz unserer Sicherheitsmaßnahmen Informationen, welche Sie freiwillig über das Netz freigeben, von anderen genutzt werden können. So können wir bei Datenübertragungsfehlern sowie unautorisierten Zugriffen auf Ihre Daten durch Dritte keine Haftung übernehmen.",
    },
    "7": {
      title: "7. Einwilligung und Widerruf",
      text: "Mit der Registrierung bei Depotcheck willigen Sie in diese Datenschutzerklärung ein. Ihre Einwilligungserklärung können Sie jederzeit mit Wirkung für die Zukunft widerrufen.",
    },
    "8": {
      title: "8. Kontakt & Auskunftsrecht",
      text: "Bei weiteren Fragen oder Anregungen zum Thema Datenschutz wenden Sie sich bitte an uns. Sie können zudem jederzeit Auskunft über die von uns über Sie gespeicherten Daten erhalten. In unserem öffentlichen Verfahrensverzeichnis haben wir die Angaben nach § 4g BDSG zusammengefasst. Bei Bedarf schreiben Sie bitte an:\n\n<0>wealthAPI GmbH, Fanny-Zobel-Str. 9, 12435 Berlin oder </0><1>info@wealthapi.eu</1>\n\nStand: 15.09.2025",
    },
  },
  redesign: {
    header: {
      actions: {
        fundDiscount: "Fondsdiscount",
        yourDiscount: "Ihre Vorteile",
        depotManagerApp: "Depotverwaltungs-App",
        aboutUs: "Über uns",
        knowledge: "Wissen",
        login: "Login",
        becomeCustomer: "Kunde werden",
        inApp: "Home",
        cashback: "Cashback beantragen",
        faqs: "FAQs",
        forum: "Forum",
        blog: "Blog",
        support: "Support",
      },
    },
    footer: {
      copyright: "Rentablo GmbH",
      column1: {
        title: "Unternehmen",
        items: [
          // {
          //   href: "https://rentablo.de/aboutUs",
          //   title: "Über uns",
          // },
          {
            href: "https://rentablo.de/jobs",
            title: "Jobs & Karriere",
          },
          {
            href: "https://www.financequality.net/partnerprogramme/rentablo-fond-cashback/",
            title: "Partnerprogramm",
          },
          {
            href: "https://rentablo.de/sicherheit",
            title: "Sicherheit",
          },
          {
            href: "https://wealthapi.eu",
            title: "Geschäftskunden",
          },
        ],
      },
      column2: {
        title: "Features",
        items: [
          {
            href: "https://rentablo.de/software-depotverwaltung",
            title: "Software Depotverwaltung",
          },
          {
            href: "https://rentablo.de/portfolio-performance",
            title: "Portfolio Performance",
          },
          {
            href: "https://rentablo.de/portfolio-optimierung",
            title: "Portfolio Optimierung",
          },
          {
            href: "https://rentablo.de/kostenloser-finanzmanager-online",
            title: "Kostenloser Portfoliomanager",
          },
          {
            href: "https://rentablo.de/elektronisches-haushaltsbuch",
            title: "Elektronisches Haushaltsbuch",
          },
        ],
      },
      column3: {
        title: "Wissen & Finanztools",
        items: [
          {
            href: "https://forum.rentablo.de/",
            title: "Forum & FAQ",
          },
          {
            href: "https://blog.rentablo.de/",
            title: "Finanzblog",
          },
          {
            href: "https://rentablo.de#cashback-calculator",
            title: "Fondsdiscount-Rechner",
          },
          {
            href: "https://rentablo.de/investment/popularFunds",
            title: "Beliebte Fonds",
          },
        ],
      },
      column4: {
        title: "Finanztools & Wissen",
        items: [
          {
            href: "https://forum.rentablo.de/",
            title: "Forum & FAQ",
          },
          {
            href: "https://blog.rentablo.de/",
            title: "Finanzblog",
          },
          {
            href: "https://rentablo.de/kostenloser-finanzmanager-online",
            title: "Kostenloser Portfoliomanager",
          },
          {
            href: "https://rentablo.de/elektronisches-haushaltsbuch",
            title: "Elektronisches Haushaltsbuch",
          },
          {
            href: "https://blog.rentablo.de/vergleichsrechner-und-finanztools/",
            title: "Vergleichsrechner",
          },
        ],
      },
      subFooterItems: [
        {
          href: "impressum",
          title: "Impressum",
        },
        {
          href: "privacy",
          title: "Datenschutz",
        },
        {
          href: "agb",
          title: "AGBs",
        },
        {
          href: "disclaimer",
          title: "Haftungsausschluss",
        },
      ],
    },
  },
  addToDepot: "Zum Depot hinzufügen",
  addToWatchlist: "Zur Watchlist hinzufügen",
  showMore: "mehr anzeigen",
  supportCard: {
    caption: "Ich bin für Sie zuständig",
    title: "Patrick Rujan",
    subtitle: "Kundensupport {{appName}}",
  },
  bankSelect: {
    pageTitle: "Depots/Konten importieren",
    title: "Bitte wählen Sie Ihre Bank aus.",
    searchLabel: "Suche: Name, IBAN, BLZ, BIC",
    selectBic: {
      title:
        "Bitte wählen Sie die BIC (Bank Identifier Code) aus. Dies ist eine 8- oder 11-stellige Bankleitzahl, mit der Geldinstitute weltweit eindeutig identifiziert werden können.",
      back: "Zurück",
    },
    notFound: "Nicht gefunden",
    notSupported: "Diese Bank wird aktuell noch nicht unterstützt",
  },
  netfondsOnboarding: {
    next: "Speichern und weiter",
    sidebar: {
      main: "Onboarding",
      preferences: "Anlageziele und Präferenzen",
      sustainability: "Nachhaltigkeit",
      details: "Auswahl und dynamische Simulation Strategie",
      signup: "Registrierung",
      experience: "Kenntnisse & Erfahrungen",
      incomeAssets: "Wirtschaftliche Verhältnisse",
      personal: "Persönliche Angaben",
      agreements: "Vereinbarungen",
      summary: "Zusammenfassung",
    },
    investmentGoal: {
      title: "Welches Anlageziel verfolgen Sie?",
      valueRetention: "Werterhalt auf Kapitalmarktzinsniveau",
      longTermInvestment: "Langfristiger Vermögensaufbau",
      shortTermProfit: "Kurzfristige Gewinnerzielungabsicht",
      additionalIncome:
        "Erzielung von Zusatzerträgen bei Inkaufnahme höherer Risiken",
    },
    investmentHorizon: {
      title: "Wie lange möchten Sie anlegen?",
      shortTerm: "0-3 Jahre",
      midTerm: "3-5 Jahre",
      longTerm: "> 5 Jahre",
    },
    preferredRiskClass: {
      title: "Bitte geben Sie Ihre Risikotoleranz an",
      riskClassB: "Ertrag - Risikoklasse B",
      riskClassB_subtitle:
        "Sie haben nur eine <b>geringe Renditeerwartung</b>. Der Werterhalt des Gesamtportfolios steht für Sie im Vordergrund. Sie möchten daher nur <b>geringe Risiken</b> aufgrund von Marktschwankungen (z. B. Kurs-, Zins- und Währungsschwankungen) und nur geringe Verlustrisiken für das Gesamtportfolio eingehen. <b>Risikotoleranz - 5%</b> nach Kosten.",
      riskClassC: "Ausgewogen - Risikoklasse C",
      riskClassC_subtitle:
        "Sie haben eine <b>moderate Renditeerwartung</b>. Neben Zinserträgen wird auch ein Ertrag aus Kurssteigerungen angestrebt. Dafür nehmen Sie <b>moderate Risiken</b> aufgrund von Marktschwankungen (z. B. Kurs-, Zins- und Währungsschwankungen) und moderate Verlustrisiken für das Gesamtportfolio in Kauf. <b>Risikotoleranz - 30%</b> nach Kosten.",
      riskClassD: "Wachstum - Risikoklasse D",
      riskClassD_subtitle:
        "Sie haben eine <b>höhere Renditeerwartung</b>, die möglichst dauerhaft über dem Kapitalmarktzinsniveau liegt. Dafür nehmen Sie <b>höhere Risiken</b> aufgrund von Marktschwankungen (z. B. Kurs-, Zins- und Währungsschwankungen) und höhere Verlustrisiken für das Gesamtportfolio in Kauf. <b>Risikotoleranz - 50%</b> nach Kosten.",
    },
    sustainabilityPreference: {
      title: "Nachhaltigkeitspräferenzen wählen",
      important: "Ja, nachhaltige Geldanlage ist mir wichtig",
      notImportant: "Nein, nachhaltige Geldanlage ist mir nicht wichtig",
      notSure: "Ich bin noch unentschlossen, aktuell noch nicht",
    },
    sustainabilityFactors: {
      title: "Welche weiteren Nachhaltigkeitsfaktoren sind Ihnen wichtig?",
      subtitle:
        "Hinweis: Sie können die folgenden Konzepte einzeln, aber auch alle gemeinsam berücksichtigen. Je restriktiver Sie vorgehen, desto weniger Geldanlageprodukte werden zur Auswahl stehen. Weitere Informationen finden Sie in der <linkText>Nachhaltigkeitsbroschüre</linkText>.",
      climateProtection:
        "Klimaschutz, Anpassung an den Klimawandel (Taxonomie)",
      climateProtection_tooltipTitle: "EU-Taxonomie",
      climateProtection_tooltipText:
        "Klassifizierungssystem für nachhaltige Wirtschaftstätigkeiten innerhalb der EU mit derzeit 6 Umweltzielen im Fokus. Voraussetzung: Ein Unternehmen muss einen Beitrag zu mindestens einem Umweltziel leisten und kein Verstoß gegen die anderen Umweltziele und Einhaltung der Mindestanforderungen in den Bereichen Governance, Menschen- und Arbeitnehmerrechte. Der Anteil ökologisch nachhaltiger Investitionen i.S.d. Taxonomieverordnung wird in Prozent mit Werten von 0 bis 100 angegeben. Je höher der Wert, desto positiver im Sinne von ökologisch nachhaltig ist er.",
      unSustainableDevelopmentGoals:
        "UN Sustainable Development Goals (Offenlegung)",
      unSustainableDevelopmentGoals_tooltipTitle:
        "UN Sustainable Development Goals (Offenlegung)",
      unSustainableDevelopmentGoals_tooltipText:
        'Bewertung, inwieweit Unternehmen Möglichkeiten zur Erreichung der 17 von der UN definierten Nachhaltigkeitsziele ("Sustainable Development Goals" - SDGs) nutzen. Die Werteskala reicht von -100% (erhebliche Behinderung) bis 100% (wesentlicher Beitrag zur Zielerreichung).',
      exclusionsTitle:
        "Bitte wählen Sie aus, welche absoluten Ausschlüsse Ihnen für die Geldanlage wichtig sind",
      gasEmission: "Treibhausgas-Emission",
      gasEmission_tooltipTitle: "Treibhausgas-Emission",
      gasEmission_tooltipText:
        "Direkte und indirekte Freisetzung von klimaschädlichen Gasen und Engagement im Bereich der fossilenBrennstoffe",
      hazardousWaste: "Gefährliche Abfälle",
      hazardousWaste_tooltipTitle: "Gefährliche Abfälle",
      hazardousWaste_tooltipText:
        "Vom Unternehmen erzeugte gefährliche Abfälle",
      waterPollution: "Verschmutzung von Wasser",
      waterPollution_tooltipTitle: "Verschmutzung von Wasser",
      waterPollution_tooltipText:
        "Ermittlung des chemischen Sauerstoffbedarfs (CSB) zur Bewertung der Belastung von Abwasser mit organischen Stoffen",
      negativeImpact: "Negativer Einfluss auf die Biodiversität",
      negativeImpact_tooltipTitle: "Negativer Einfluss auf die Biodiversität",
      negativeImpact_tooltipText:
        "Aktivitäten mit negativem Einfluss auf biodiversitätssensible Gebiete",
      socialEmployment: "Soziales und Arbeitnehmerbelange",
      socialEmployment_tooltipTitle: "Soziales und Arbeitnehmerbelange",
      socialEmployment_tooltipText:
        "Verstöße gegen die UNGC/OECD-Leitsätze und unbereinigtes geschlechtsspezifisches Lohngefälle",
      sustainabilityClass: {
        title: "Ihre Nachhaltigkeitsklasse",
        text: "Ihre Nachhaltigkeitsklasse beträgt aktuell 1 von 5.",
        link: "weitere Informationen",
      },
    },
    details: {
      title: "Konfigurieren Sie die Details Ihrer Anlage",
      strategy: "Ihre Anlagestrategie",
      chartTitle: "Erwartete Vermögensentwicklung",
      return: "Rendite",
      volatility: "Volatilität",
      "10-years": "10 Jahre",
      "20-years": "20 Jahre",
      investmentAmount: "Ihre erstmalige Anlage",
      savingsPlan: "Ihr monatlicher Sparplan",
    },
    signup: {
      title: "Registrierung",
      email: "Ihre Email Adresse",
      email_placeholder: "Bitte geben Sie Ihre Email Adresse ein...",
      password: "Passwort",
      password_placeholder: "Bitte legen Sie ein Passwort fest...",
      acceptedTerms:
        "Ich willige in die Verarbeitung meiner Daten ein. Diese werden sowohl an Musterfinanz als Vermittler der Vermögensverwaltung, an die Netfonds AG, als Abwickler sowie die jeweilige Depotbank zur Eröffnung des Depots versandt. Nähere Angaben zu der Verwendung Ihrer Daten finden Sie in der <link>Datenschutzerklärung</link>.",
      receiveNewsletter:
        "Ich möchte regelmäßig über neue Angebote <link1>informiert werden</link1>. Ihre hiermit erteilten Einwilligen sind jederzeit widerruflich (per E-Mail an <link2>max.mustermann@musterfinanz.de</link2> oder an die im Impressum angegebenen Kontaktdaten).",
    },
    systemKnowledge: {
      title: "In welchen Anlagen haben Sie Kenntnisse?",
      subtitle: "Mehrfachauswahl möglich",
      shares: "Aktien",
      funds: "Fonds",
      security3: "Wertpapier 3",
      security4: "Wertpapier 4",
      noKnowledge: "Keine Kenntnisse",
    },
    investmentExperience: {
      title: "Wie sind Ihre Erfahrungen mit diesen Anlagen?",
      subtitle: "Anzahl der Geschäfte in den letzten 5 Jahren.",
      shares: "Aktien",
      funds: "Fonds",
      security3: "Wertpapier 3",
      security4: "Wertpapier 4",
      "1-5-years": "1-5 Jahre",
      "more-than-5-years": "> 5 Jahre",
      noExperience: "Keine",
    },
    netIncomePerMonth: {
      title: "Monatliche Nettoeinkünfte",
      netIncomePerMonth: "Wie hoch sind Ihre monatlichen Nettoeinkünfte?",
    },
    expensesPerMonth: {
      title: "Monatliche Ausgaben",
      expensesPerMonth: "Wie hoch sind Ihre monatlichen Ausgaben?",
    },
    assets: {
      title:
        "Besitzen Sie Vermögen in Form von Immobilien oder Beteiligungen? Wenn ja, wie hoch ist dieses Vermögen circa?",
      "more-than-0": "> 0 €",
      "more-than-25000": "> 25.000 €",
      "more-than-50000": "> 50.000 €",
      "more-than-75000": "> 75.000 €",
      "more-than-100000": "> 100.000 €",
      other: "andere Angabe",
      realEstateAssets: "Ihr Vermögen in Immobilien/Beteiligungen",
    },
    personalData: {
      title: "Bitte geben Sie Ihre persönlichen Daten ein",
      subtitle:
        "Die Informationen werden für die Depoteröffnung von Ihrer Bank benötigt",
      salutation: "Anrede",
      salutation_placeholder: "Wählen Sie eine Anrede",
      academicTitle: "Akademischer Titel",
      academicTitle_placeholder: "Wählen Sie Ihren Titel",
      firstName: "Vorname",
      firstName_placeholder: "Ihr Vorname",
      lastName: "Nachname",
      lastName_placeholder: "Ihr Nachname",
      dateOfBirth: "Geburtsdatum",
      placeOfBirth: "Geburtsort",
      placeOfBirth_placeholder: "Bitte Geburtsort angeben",
      countryOfBirth: "Geburtsland",
      countryOfBirth_placeholder: "Bitte wählen Sie ihr Geburtsland",
      maritalStatus: "Familienstand",
      maritalStatus_placeholder: "Bitte wählen Sie Ihren Familienstand",
      phoneNumber: "Tel. Mobil",
      phoneNumber_placeholder: "Bitte Ihre Mobilfunknummer ein",
      email: "E-Mail",
      email_placeholder: "Bitte geben Sie Ihre E-Mail Adresse ein",
      education: "Ausbildung",
      education_placeholder: "Bitte wählen Sie Ihre Ausbildung",
      occupation: "Beruf",
      occupation_placeholder: "Bitte wählen Sie Ihren Beruf",
      sector: "Branche",
      sector_placeholder: "Bitte wählen Sie eine Branche",
    },
    addressData: {
      title: "Bitte geben Sie Ihre Adresse ein",
      subtitle:
        "Die Informationen werden für die Depoteröffnung von Ihrer Bank benötigt",
      street: "Straße",
      houseNumber: "Hausnummer",
      houseNumber_placeholder: "Nr.",
      zip: "Postleitzahl",
      city: "Wohnort",
      city_placeholder: "Ihr Wohnort",
      addressCountry: "Land",
      nationalityCountry: "Staatsangehörigkeit",
    },
    taxationData: {
      title: "Ihre steuerrelevanten Daten",
      taxationCountry1: "Steuerpflichtig in ",
      taxationNumber1: "Steueridentifikationsnummer",
      interText: "Haben Sie eine weitere Steueransässigkeit?",
      taxationCountry2: "Steuerpflichtig in ",
      taxationNumber2: "Steueridentifikationsnummer",
    },
    mifidData: {
      title: "Bitte geben Sie Ihre Daten für MiFID ein",
      isNotPoliticallyExposed: "Ich bin keine politisch exponierte Person",
      isNotPoliticallyExposed_tooltipTitle: "Politisch exponierte Person",
      isNotPoliticallyExposed_tooltipText:
        "(PEP) sind gemäß §6 Abs. 2 Nr. 1 Geldwäschegesetz Personen, die ein wichtiges öffentliches Amt ausüben oder ausgeübt haben (z.B. Politiker, Botschafter).\n" +
        "Nehmen Sie bei Fragen gerne persönlichen Kontakt mit uns oder Ihrer Beraterin/Ihrem Berater auf.",
      isOwnAccount: "Ich handele auf eigene Rechnung",
      isOwnAccount_tooltipTitle: "Wirtschaftlich Berechtigte(r)",
      isOwnAccount_tooltipText:
        "Sollten Sie nicht auf eigene Rechnung handeln, wenden Sie sich bitte persönlich an uns oder Ihre Beraterin/Ihren Berater - wir helfen Ihnen bei der Anlage.\n" +
        "Aus technischen Gründen ist ein Online-Strategiekauf momentan nur für wirtschaftlich berechtigte Personen möglich.",
    },
    contraAccount: {
      title: "Bankverbindung",
      banner: {
        text: "Ein Referenzkonto ist ein Girokonto bei Ihrer Bank, das zur Abwicklung  des Zahlungsverkehrs dient. Ihr Referenzkonto muss SEPA-fähig sein und in Euro geführt werden.",
      },
      iban: "IBAN",
      formSectionLabel: "Kontoinhaber des Referenzkontos",
      contraAccountHolderFirstName: "Vorname",
      contraAccountHolderFirstName_placeholder: "Vorname des Kontoinhabers",
      contraAccountHolderLastName: "Nachname",
      contraAccountHolderLastName_placeholder: "Nachname des Kontoinhabers",
    },
    agreements: {
      title: "Vereinbarungen",
      subtitle:
        "Bitte lesen Sie sich die nachfolgenden Vereinbarungen in Ruhe durch:",
      customerInfoAcknowlegmentAccepted:
        "Ich habe die <linkText>Kundeninformationen</linkText> erhalten und zur Kenntnis genommen.",
      frameworkAgreementAccepted:
        "Ich stimme der <linkText>Rahmenvereinbarung</linkText> zu",
      processingDataAccepted:
        "Ich willige in die Verarbeitung meiner Daten ein. Diese werden sowohl an wealthAPI / Wolfram  Stacklies, als Zuführer zur NFS Hamburger Vermögen GmbH, an die Netfonds AG,, als Abwickler sowie an die jeweilige Deoptbank (FIL Fondsbank GmbH) zur Eröffnung des Depots und Anlagen in die gewählten Strategien versand. Nährere Angaben zu der Verwendung Ihrer Daten finden Sie in den <linkText>Datenschutzhinweisen</linkText>.",
      servicesPerfomanceAccepted:
        "Hiermit erkläre ich mich in der Ausführung der beauftragten Dienstleistungen vor Ablauf der Widerrufsfrist von 14 Tagen nach Abgabe meiner Vertragserklärung einverstanden.",
    },
    consent: {
      title: "Einwilligung zur Kontaktaufnahme (Modul A + B)",
      subtitle:
        "Aus Gründen der besseren Lesbarkeit wird die gleichzeitige Verwendung der Sprachformen männlich, weiblich und divers verzichtet. Sämtliche Personenbezeichnungen gelten gleichermaßen für alle Geschlechter. der Kunde willigt in die Kontaktaufnahme mit folgenden Kommunikationsmitteln ein:",
      sections: {
        1: "Modul A",
        2: "Modul B",
        3: "Modul C",
      },
      contactViaPhone:
        "per Telefon oder ggf. SMS (bei Angabe einer Mobilfunknummer",
      contactViaEmail: "per E-Mail",
      contactViaFax: "per Telefax",
      contactViaMessengers:
        "per Messangerdienst (Whatsapp, Signal u.a.) und oder Internettelefonie",
      contactViaElectronicCommunication:
        "per elektronischem Postfach unter Einsatz verschiedener Authentifizierungsverfahren",
      newsletterAccepted:
        "Ich willige ein, Marktinformationen, Newsletter und Informationen zu Produkten und Dienstleistungen über Fernkommunikationsmittel  zu erhalten.",
      newsletterNotAccepted: "Ich willige nicht ein",
      banner: {
        text: "Hinweis: Die Einwilligungserklärungen sind freiwillig und können ohne Einfluss auf bestehende Vertragsverhältnisse ganz oder teilweise (auch für einzelne Kommunikationswege und Module) widerrufen werden. Für die einzelnen Module A,B,C gelten die unten stehenden Bedingungen. ",
      },
      warning:
        "Bitte beachten Sie, dass eine Kombination der einzelnen Module möglich ist. ",
    },
    summary: {
      title: "Zusammenfassung",
      personalDataTitle: "Persönliche Daten",
      depotManagement: "Depotführung",
      assetManagement: "Bevollmächtigter Vermögensverwalter",
      portfolioPurchase: "Kauf im Portfolio",
      savingsPlan: "Monatlicher Sparplan",
      managementFee: "Laufende Verwaltungsvergütung",
      riskClass: "Risikoklasse",
      documents: "Dokumente",
      apply: "Kostenpflichtig beantragen",
      riskClassB: "B",
      riskClassC: "C",
      riskClassD: "D",
      fields: {
        academicTitle: "Titel",
        education: "Ausbildung",
        salutation: "Anrede",
        occupation: "Beruf",
        fullName: "Vor- und Nachname",
        sector: "Branche",
        dateOfBirth: "Geburtsdatum",
        placeOfBirth: "Geburtsort",
        address: "Wohnhaft in",
        taxationNumber1: "Steuernummer (TIN)",
        taxationCountry1: "Steuerpflichtig in",
        nationalityCountry: "Staatsangehörigkeit",
        phoneNumber: "Mobilfunknummer",
        email: "E-Mail",
        accountHolderName: "Kontoinhaber",
        maritalStatus: "Familienstand",
        iban: "IBAN",
        isNotPoliticallyExposed: "keine politisch exponierte Person",
        isOwnAccount: "Wirtschaftlich Begünstigter",
      },
    },
  },
  finanzfluss: {
    bankConnections: {
      bankingCredentials: {
        storeSecrets: {
          info: "Deine Daten werden sicher verschlüsselt gespeichert. Nur wenn der Haken gesetzt ist, kann dein Konto automatisch aktualisiert werden.",
        },
      },
      bankIsBusy: {
        bannerText:
          "Aktuell werden sehr viele parallele Import Anfragen an {{bankName}} gestellt. Dadurch kann es zu einer temporären Unterbrechung der Verbindung durch den Broker kommen. Wir bitten um dein Verständnis, dass der Import deines {{bankName}} Depots aktuell nicht möglich ist. Versuche es gerne erneut in einigen Minuten.",
      },
    },
  },
  feedbackPage: {
    title: "Euer Feedback hilft uns, die richtigen Dinge zu priorisieren.",
    intro:
      "Dein Feedback ist für uns von unschätzbarem Wert ❤️️ und wir arbeiten kontinuierlich daran, den Copilot zu verbessern und deine Erfahrung damit so positiv wie möglich zu gestalten. <br /> <br /> Auf dieser Seite kannst du sehen, an welchen Verbesserungen wir aktuell arbeiten. Außerdem kannst du uns deine eigenen Verbesserungsvorschläge mitteilen und über die Vorschläge anderer Nutzer abstimmen. So hilfst du uns, die richtigen Dinge zu priorisieren.<br /> <br /> Fragen zur Benutzung des Copilot hat oder technische Probleme kannst du über 👉 <linkText>folgendes Formular</linkText> 👈 an uns schicken. Vielen Dank für deine Unterstützung 🙏",
    link: "folgendes Formular",
  },
  securitiesSearch: {
    title: "Asset suchen",
    placeholder: "Name, ISIN oder WKN eingeben",
    all: "Alle",
    back: "Zurück zu Suchergebnissen",
    isin: "ISIN",
    type: "Klasse",
    showMore: "Mehr anzeigen",
    loading: "Lade...",
    noResults: "Keine Ergebnisse",
  },
  kpmg: {
    sidebar: {
      lastUpdated: "Letzte Übertragung zu KICS am {{date}} um {{time}}.",
      lastUpdatedWarning:
        "Warnung: Letzte Übertragung zu KICS vor {{days}} Tagen ({{date}} um {{time}}).",
      onboardingGuideLink: "KICS Onboarding-Anleitung",
    },
    dashboard: {
      portfolio: "Portfolio",
      kicksReportingTitle: "Depots KICS-Reporting",
    },
    kicsOnboarding: {
      stepCounter: "Schritt {{step}} / {{total}}",
      buttons: {
        back: "Zurück",
        next: "Weiter",
        done: "Fertig",
      },
      step1: {
        title:
          'In KICS navigieren – auf dem Startbildschirm "Search and add" auswählen',
        description:
          'Suchen Sie auf dem KICS-Startbildschirm die Schaltfläche "Search and add" und klicken Sie auf das Symbol. Sie werden anschließend zur Maske "Search and add" weitergeleitet.',
      },
      step2: {
        title: 'Broker "wealthAPI" über die Suche finden',
        description:
          'Geben Sie "wealthapi" ein (Groß-/Kleinschreibung egal) und klicken Sie auf das Such-Symbol. Lassen Sie alle anderen Einstellungen unverändert.',
      },
      step3: {
        title: 'Broker "wealthAPI" und "Action"-Menü öffnen',
        description:
          'Nach dem Klick auf das "Search"-Symbol sehen Sie einen Datensatz vom Typ "Company" mit dem Namen "WEALTHAPI". Wählen Sie anschließend die passende Aktion im "Action"-Menü aus.',
      },
      step4: {
        title: 'Aktion: Broker "wealthAPI" zu Ihrem KICS-Konto hinzufügen',
        description:
          'Wählen Sie für den Eintrag "WEALTHAPI" die Aktion "Add brokerage firm account".',
      },
      step5: {
        title:
          "Ihre Brokerage-Account-ID aus dem wealthAPI Compliance-Tool abrufen",
        description:
          'Melden Sie sich in der wealthAPI Compliance-Lösung unter {{complianceUrl}} an. Nach dem Login finden Sie Ihre persönliche Compliance-ID wie gezeigt in der Menüleiste. Klicken Sie auf das "Copy"-Symbol, um Ihre persönliche ID zu kopieren. Im gezeigten Beispiel ist dies "96275".',
      },
      step6: {
        title:
          'Einrichtung des Brokers "wealthAPI" durch Eingabe Ihrer Account-ID abschließen',
        description:
          '(1) Tragen Sie Ihre persönliche Compliance-ID als "Brokerage firm account number" ein (im gezeigten Beispiel "96275"; Ihre persönliche ID weicht ab).\n(2) Geben Sie eine eigene Beschreibung ein, z. B. "wealthAPI Compliance Tool".\n(3) Wählen Sie "Individual", wenn es sich um Ihr persönliches Konto handelt, oder "Shared" bei einem Gemeinschaftskonto ("Individual" ist in der Regel die richtige Wahl).\n(4) Wählen Sie "Purchase" als Acquisition method.\n(5) Wählen Sie Ihr persönliches Portfolio-Profil – falls Sie nur eines haben, ist es bereits vorausgewählt.\n(6) Wählen Sie das heutige Datum als "Acquisition date".',
      },
      step7: {
        title: 'Einrichtung des "wealthAPI"-Brokerage-Accounts abschließen',
        description:
          'Sie sehen einen Bestätigungsdialog. Wählen Sie "Accept" und klicken Sie anschließend auf "Submit", um den Broker "wealthAPI" anzulegen.',
      },
      step8: {
        title: "Bestätigungsbildschirm",
        description:
          'Herzlichen Glückwunsch, Sie sind fertig! "WEALTHAPI" ist nun als Brokerage-Konto in KICS hinterlegt.',
      },
      step9: {
        title: "Wichtige Hinweise zum KICS-Import:",
        description:
          "<ul><li>Damit die Depotdaten, die an KICS übertragen werden, aktuell sind, müssen Sie regelmäßig überprüfen, ob der automatische Abruf der Depotdaten vom Finanzinstitut noch aktiv ist. Diese Information ist im eMail Status-Report und im Menüpunkt Portfolios und Konten ersichtlich.</li><li>Die Datenübertragung an KICS erfolgt einmal täglich. Bitte überprüfen Sie regelmäßig, ob die Daten in KICS vollständig sind.</li><li>In folgenden Fällen erfolgt <u>kein automatischer Übertrag an KICS</u>, sodass weiterhin eine manuelle Pflege direkt in KICS erforderlich ist:<ul><li>Krypto-Assets</li><li>Relevante Underlyings von Derivaten (z.B. Optionen) iSd. KPMG-internen Richtlinien</li><li>Investments, die zwischen zwei Datenübertragungen erworben und wieder veräußert wurden (z.B. bei Daytrading)</li><li>Geldmarktfonds, in die Neobroker Ihre Einlagen/Guthaben von Tagesgeldkonten teils automatisch investieren.</li></ul></li></ul>",
      },
    },
  },
  accountReview: {
    title: "Zusätzliche Konten überprüfen",
    subtitle:
      "Bitte wählen Sie aus, welche zusätzlichen Konten (optional) importiert werden sollen.",
    description:
      "Bitte überprüfen Sie, ob noch ein Referenzkonto oder sonstiges Konto zusätzlich importiert werden soll. Wählen Sie dieses Konto bitte aus, indem Sie den Schalter für das entsprechende Konto nach rechts schieben.",
    requiredSection: "Portfolios & Referenzkonten (nicht änderbar)",
    confirm: "Übernehmen",
    deleteError:
      "Einige Konten konnten nicht entfernt werden. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
  },
  termsOfUsePage: {
    title: "Allgemeine Geschäftsbedingungen (AGB)",
    introText1:
      'Hier finden Sie die Allgemeinen Geschäftsbedingungen (im Folgenden „AGB") der',
    introCompanyNote: "(nachfolgend {{mandatorShortName}})",
    introText2:
      "die für die Nutzung der Dienste von {{mandatorShortName}} gelten.",
    introText3:
      "Für einen registrierungspflichtigen Dienst bei {{mandatorShortName}} müssen Sie Ihr Einverständnis zu den für die Nutzung dieses Dienstes jeweils anwendbaren Nutzungsbedingungen geben.",
    generalTitle: "Allgemeine Nutzungsbedingungen",
    section1: {
      title: "Geltungsbereich",
      p1: "(1) Die AGB gelten für alle auf den Seiten von {{mandatorShortName}} dem Nutzer angebotenen Leistungen, insbesondere auch für die kostenpflichtigen Inhalte & Services.",
      p2: "(2) Abweichungen von diesen AGB oder speziellen Nutzungsbedingungen zu einzelnen Diensten gelten nur dann als vereinbart, wenn sie von {{mandatorShortName}} ausdrücklich schriftlich bestätigt wurden. Insbesondere die bloße Unterlassung eines Widerspruchs seitens {{mandatorShortName}} gegen andere AGB führt nicht dazu, dass diese damit als vereinbart gelten.",
      p3: "(3) {{mandatorShortName}} ist berechtigt, die vorliegenden AGB jederzeit zu ändern.",
      p4: "(4) {{mandatorShortName}} ist im Rahmen der Änderung der AGB insbesondere berechtigt, im Falle der Unwirksamkeit einer Bedingung diese mit Wirkung für bestehende Verträge zu ergänzen oder zu ersetzen, bei Änderung einer gesetzlichen Vorschrift oder höchstrichterlichen Rechtsprechung, wenn durch diese Änderung eine oder mehrere Bedingungen des Vertragsverhältnisses betroffen werden, die betroffenen Bedingungen so anzupassen, wie es dem Zweck der geänderten Rechtslage entspricht, sofern der Nutzer durch die neue bzw. geänderte Bedingungen nicht schlechter steht als nach der ursprünglichen Bedingung.",
      p5: "(5) {{mandatorShortName}} ist nicht verantwortlich für die von Dritten bereitgehaltenen Internet-Dienste, auf die {{mandatorShortName}} von seinen Seiten verlinkt oder die {{mandatorShortName}} vermittelt. Für diese Angebote gelten jeweils die Nutzungsbedingungen der jeweiligen Anbieter. {{mandatorShortName}} übernimmt hierfür keinerlei Haftung oder Gewährleistung.",
    },
    section2: {
      title: "Datenschutz",
      text: "{{mandatorShortName}} ist die Sicherheit und der Schutz Ihrer Daten sehr wichtig. Deshalb haben wir eine eigene Datenschutzerklärung erstellt, welche Bestandteil unserer AGB ist und die Sie <0>hier abrufen können</0>.",
    },
    section3: {
      title: "Bestpreis-Garantie",
      p1: "(1) Upgrade und Downgrade von Accounts/Cashback-Modellwechsel. Um unseren Nutzern einen maximalen Ertrag zu bieten, prüfen wir regelmäßig, welches Cashback-Modell Ihnen den höchsten Nutzen bringt und stellen Ihren Account gegebenenfalls automatisch auf die für Sie günstigste Lösung um. Ein solcher Modellwechsel stellt keine Kündigung dar, Ihr Account als solcher bleibt bestehen und wir passen lediglich die Vergütungs- und Rechtekonditionen Ihres Accounts an.",
      p2: "(2) Sollten Sie jemals ein besseres öffentliches Angebot eines anderen Anbieters entdecken, passen wir Ihre Konditionen an!",
    },
    section4: {
      title: "Zugangs- und Teilnahmeberechtigung",
      p1: "(1) Grundsätzlich sind alle natürlichen Personen zugangs- und teilnahmeberechtigt, eine gewerbliche Nutzung bedarf der schriftlichen Zustimmung von {{mandatorShortName}}.",
      p2: "(2) {{mandatorShortName}} schließt Verträge über kostenpflichtige Inhalte nur mit Personen über 18 Jahre oder nach ausdrücklicher Zustimmung des gesetzlichen Vertreters.",
      p3: "(3) Im Übrigen sind die Internetseiten nicht an Personen in Ländern gerichtet, die das Vorhalten bzw. den Aufruf der darin eingestellten Inhalte untersagen. Jeder Nutzer ist selbst verantwortlich, sich über etwaige Beschränkungen vor Aufruf dieser Web-Seiten zu informieren und diese einzuhalten.",
    },
    sectionCashbackReferral: {
      title: "Werbeprämien - Kunde wirbt Kunde",
      p1: "(1) Vom Prämienbezug ausgeschlossen sind Empfehlungen:",
      p1Item1:
        "bei denen der Empfehlende selbst kein Rentablo Cashback-Kunde ist",
      p1Item2:
        "die bereits bestehende Verträge ergänzen (z.B. Aufnahme von Kindern oder Ehepartnern)",
      p1Item3: "für Produkte, die vom Empfehlungsprogramm ausgenommen sind",
      p1Item4: "die gegenseitig erfolgen",
      p2: "(2) Das Werben von Kunden, z.B. in Gutschein-Portalen, Foren, Blogbeiträgen, Social Media-Kanälen oder sonstigen Plattformen ist nicht gestattet. Das Anwerben von Kunden gilt ausschließlich im direkten Kontakt mit dem geworbenen Kunden.",
      p3: "(3) Empfehlungen, die nicht den Teilnahmebedingungen entsprechen, werden nicht gewertet. Eine Kombinationen von verschiedenen Gutscheinen/Prämien ist nicht möglich.",
      p4: "(4) Der Cashback-Bonus wird mit den Rentablo Provisionseinbehalt verrechnet und erhöht so Ihr Cashback. Der Bonus ist auch mit anderen {{mandatorShortName}}-Dienstleistungen wie z.B. unserer Honorarberatung verrechenbar.",
    },
    section5: {
      title: "Verfügbarkeit",
      text: "Die Leistungen von {{mandatorShortName}} werden unter dem Vorbehalt der Verfügbarkeit dem Nutzer angeboten. {{mandatorShortName}} bemüht sich abzusichern, dass dem Nutzer die Leistungen von {{mandatorShortName}} ohne Störungen zur Verfügung stehen. Durch Wartungsarbeiten und/oder Weiterentwicklung und/oder andere Störungen (z.B. von Datenlieferanten oder anderen Dienstleistern) können die Nutzungsmöglichkeiten eingeschränkt und/oder zeitweise unterbrochen werden. Dadurch kann es unter Umständen auch zu Datenverlusten kommen. Daraus entstehen keine Entschädigungsansprüche der betroffenen Nutzer. {{mandatorShortName}} ist ferner berechtigt, die angebotenen Dienste und Leistungen jederzeit nach eigenem Ermessen ohne Ankündigung zu ändern oder einzustellen.",
    },
    sectionCashbackPayout: {
      title:
        "Pflicht zur Aktualisierung des Auszahlungskontos; Rücklastschriften und Verfall des Cashback-Guthabens",
      p1: "(1) Aktualitätspflicht: Der Nutzer ist verpflichtet, sein hinterlegtes Auszahlungskonto stets aktuell zu halten und Änderungen der Bankverbindung unverzüglich in seinem Nutzerkonto zu aktualisieren. {{mandatorShortName}} übernimmt keine Haftung für Verzögerungen oder den Verlust von Cashback-Auszahlungen, die auf veraltete oder fehlerhafte Kontodaten des Nutzers zurückzuführen sind.",
      p2: "(2) Bearbeitungspauschale und Mindestauszahlungsbetrag bei Rücküberweisungen: Wird eine Cashback-Auszahlung aufgrund einer nicht aktuellen Bankverbindung an {{mandatorShortName}} zurückgebucht, gilt Folgendes:",
      p2ItemA:
        "a) {{mandatorShortName}} wird den Nutzer erst dann kontaktieren und eine erneute Auszahlung vornehmen, wenn das kumulierte ausstehende Cashback-Guthaben einen Betrag von mindestens 25,00 € erreicht.",
      p2ItemB:
        "b) Für den entstandenen Bearbeitungsaufwand wird eine Bearbeitungspauschale von 10,00 € vom ausstehenden Cashback-Betrag einbehalten. Fremdkosten der Bank für Rückbuchungsvorgänge werden ebenfalls von der Auszahlung abgezogen.",
      p3: "(3) Verfall des Cashback-Guthabens: Der Anspruch auf Auszahlung des Cashback-Guthabens erlischt dauerhaft, wenn einer der folgenden Tatbestände erfüllt ist:",
      p3ItemA:
        "a) Der Nutzer aktualisiert seine Bankverbindung nicht bis zum 31.12. des Jahres, in dem der Auszahlungsanspruch durch die Cashback-Abrechnung entstanden ist (Auszahlung nicht möglich), oder",
      p3ItemB:
        "b) {{mandatorShortName}} hat drei Kontaktversuche unternommen, um den Nutzer zur Aktualisierung seiner Bankverbindung aufzufordern, und der Nutzer hat hierauf nicht reagiert (Nutzer reagiert nicht).",
    },
    section6: {
      title: "Vertragsverhältnis, Vertragsgegenstand, Leistungsbeschreibung",
      p1: "(1) Das Vertragsverhältnis über die Nutzung kostenpflichtiger Inhalte von {{mandatorShortName}} kommt durch die Anmeldung bei dem gewünschten und gewählten Zahlungssystemanbieter, der Zustimmung zu den allgemeinen Nutzungsbedingungen und der jeweiligen Annahme durch {{mandatorShortName}} zustande. Die Annahme durch {{mandatorShortName}} erfolgt spätestens mit Eröffnung des Zugriffs auf den kostenpflichtigen Inhalt.",
      p2: "(2) Über die Nutzung von Diensten Dritter, die {{mandatorShortName}} auf ihren Seiten bewirbt, bzw. zu denen {{mandatorShortName}} über ihre Seiten den Zugang vermittelt, kommen Vertragsverhältnisse ausschließlich zwischen dem Nutzer und dem anbietenden Dritten zustande. {{mandatorShortName}} übernimmt hierfür keinerlei Haftung oder Gewährleistung.",
      p3: "(3) Gegenstand des Vertrages ist die – je nach gewähltem Account – unentgeltliche oder entgeltliche Nutzung von {{mandatorShortName}}. {{mandatorShortName}} ist ein Online-Finanzmanager, der die Finanzdaten der Nutzer im Rahmen eines Kontoinformationsdienstes darstellt.",
      p4: "(4) Zudem bietet {{mandatorShortName}} den Nutzern kostenfreie Informationstools sowie Beratungs- und Vermittlungsdienstleistungen auf Provisions- und Honorarbasis für alle Arten von Finanzdienstleistungen gemäß Gewerbeordnung §34c (Immobilien), § 34d (Versicherungen) und § 34f 1-3 (Finanzanlagen).",
      p5: "(5) Wir stellen sämtliche Dienste ausschließlich zur Information zur Verfügung. Ziel ist es, den Nutzer zu selbständigen Entscheidungen zu befähigen. {{mandatorShortName}} stellt für private Nutzer kostenfreie Tools zur Auswertung seiner Finanzanlagen und Erfolge, seiner persönlichen Situation, der Erfassung seiner Ziele & Wünsche und seines Bedarfes zur Verfügung. Insbesondere leisten wir keine automatische Rechts-/Steuer- oder Vermögensberatung. Eine qualifizierte Beratung in finanziellen Angelegenheiten kann nur in einem persönlichen Gespräch und nur unter Berücksichtigung und Abwägung der individuellen Verhältnisse und Bedürfnisse eines Nutzers erfolgen. Bei Bedarf kann der Nutzer kostenpflichtige Expertise zu festen Tarifen buchen und sich Unterstützung bei der Auswertung und bei seinen Entscheidungen sichern. Der Nutzer kann gewünschte Termine verbindlich online buchen und bis 24 Stunden vor dem Termin kostenfrei stornieren. Mit der Anmeldung erklären Sie, dass Sie hiervon Kenntnis genommen haben.",
      p6: '(6) Ziel ist es, dem Nutzer Zugang zu provisionsfreien oder kostengünstigen und leistungsstarken Finanzprodukten zu vermitteln. {{mandatorShortName}} stellt on- oder offline, ausschließlich für private Nutzer, entgeltlich und unverbindlich Auskünfte über Tarife und Konditionen von kooperierenden Versicherungs- / Finanzdienstleistungsunternehmen, sowie Energie- und Telekomunikationsunternehmen (im Folgenden "Anbieter" genannt) zur Verfügung.',
      p7: "{{mandatorShortName}} vermittelt auf der Grundlage eines vom Nutzer online oder offline abgegebenen Angebots Anträge an den jeweiligen Anbieter. Über die Vermittlung hinausgehende Verpflichtungen werden nicht übernommen. Insbesondere erbringt {{mandatorShortName}} selbst keine Versicherungs- oder Finanzdienstleistungen, liefert keine Energie und erbringt keine Telekommunikationsdienstleistungen.",
      p8: "{{mandatorShortName}} wird als Plattform für die Vermittlung von Verträgen und Versicherungen in der oder den vom Nutzer gewählten Sparte(n) tätig. Auf der Grundlage der in den Vergleichen oder Angebotsanforderungen gemachten Angaben bietet {{mandatorShortName}} die Beschaffung des passenden Vertrages oder Versicherungsschutzes an. Grundsätzlich geschieht dies auf Basis einer objektiven und ausgewogenen Marktbetrachtung. {{mandatorShortName}} analysiert dazu regelmäßig den Markt und programmiert die entsprechende Vergleichssoftware bzw. greift auf die Softwareprodukte von Drittanbietern zurück. In den Vergleichen können nicht alle Anbieter oder Versicherungsgesellschaften und nicht alle am Markt vorhandenen Versicherungstarife wie zum Beispiel spezielle Makler- und Deckungskonzepte oder Agenturtarife aufgeführt werden. Bei speziellen Versicherungen hat der Nutzer die Möglichkeit, schriftliche Angebote und Beratung durch einen qualifizierten Produktexperten anzufordern. Der Nutzer erhält verschiedene Vorschläge von Anbietern, die unter Zugrundelegung der von ihm eingegebenen Daten berechnet werden.",
      p9: "Sofern sich der Nutzer für einen bestimmten Vorschlag von {{mandatorShortName}} entschieden hat, kann er entweder online durch seine Unterschrift bzw. das Anklicken des dafür vorgesehenen Buttons oder offline ein Angebot auf Grundlage des ursprünglichen Vorschlags von {{mandatorShortName}} anfordern, bzw. ein solches Angebot abgeben.",
      p10: "Ein Vermittlungsverhältnis mit {{mandatorShortName}} kommt mit Übermittlung der Vorschläge an den Anbieter durch {{mandatorShortName}} auf Grundlage der tatsächlich übermittelten Daten des Nutzers zustande.",
      p11: "Ein Versicherungs- oder Finanzdienstleistungsvertrag kommt nur zwischen dem Nutzer und dem von ihm ausgewählten Anbieter zustande. {{mandatorShortName}} hat auf das Zustandekommen, bzw. Nichtzustandekommen eines solchen Vertragsverhältnisses keinerlei Einfluss. Ob ein Vertrag mit dem Anbieter zustande kommt, ist abhängig von den entsprechenden Bedingungen des jeweiligen Anbieters.",
      p12: "Die konkreten Angebote der Anbieter können sich im Einzelfall hinsichtlich individueller Umstände von den einzelnen Tarifen oder Voraussetzungen, welche {{mandatorShortName}} berechnet und zur Verfügung stellt, unterscheiden. Für Inhalt und Richtigkeit der Angebote sind ausschließlich die Anbieter verantwortlich.",
      p13: "(7) {{mandatorShortName}} schließt aus für Kunden aktiv Wertpapiere zu kaufen oder zu verkaufen. Kunden müssen Käufe und Verkäufe selbsttätig über Ihre Depotbank ausführen.",
    },
    section7: {
      title: "Eröffnung eines Nutzer-Accounts",
      p1: "(1) Für bestimmte Leistungen auf den Seiten von {{mandatorShortName}} muss sich der Nutzer registrieren oder kann einen Nutzer-Account eröffnen.",
      p2: "(2) Ein Anspruch auf Abschluss eines Nutzungsvertrages besteht nicht. Wir können Ihre Registrierungsanfrage jederzeit ohne Angabe von Gründen ablehnen. In diesem Fall löschen wir selbstverständlich alle von Ihnen bereits angegebenen Informationen und Daten.",
      p3: "(3) {{mandatorShortName}} behält sich vor, Teile seines Angebotes nur im Rahmen eines kostenpflichtigen Premium Accounts anzubieten. Des Weiteren behält {{mandatorShortName}} sich vor, Testphasen für den Premium Account anzubieten, in denen dieser für die jeweils angegebene Zeit kostenlos getestet werden kann. Die genaue Leistungsbeschreibung der Accounts ist über unsere Startseite abrufbar. Wir behalten uns das Recht vor, nach eigenem Ermessen Teile der Nutzungsmöglichkeiten des kostenpflichtigen Accounts zum Bestandteil des kostenlosen Accounts zu machen.",
    },
    section8: {
      title: "Umfang der Nutzung des Content",
      p1: "(1) Der Nutzer ist nur berechtigt, den von {{mandatorShortName}} zur Verfügung gestellten Content zu privaten /eigenen Zwecken zu nutzen. Er ist insbesondere nicht berechtigt, Content oder Teile davon an Dritte weiterzugeben oder Dritten Zugriff auf entgeltlichen Content zu verschaffen. Hiervon abweichende Regelungen, insbesondere eine gewerbliche Nutzung ist nur mit schriftlicher Genehmigung durch {{mandatorShortName}} gültig.",
      p2: "(2) Sämtliche von {{mandatorShortName}} angebotenen Inhalte unterliegen gewerblichen Schutzrechten und dürfen nur in der von {{mandatorShortName}} genehmigten Form, Art und Weise genutzt werden. Das Urheberrecht verbleibt beim jeweiligen Schutzrechtsinhaber. Eine Vervielfältigung, Veröffentlichung oder Verwendung der angebotenen Leistungen in elektronischer Form oder anderen gedruckten Veröffentlichungen ist ohne ausdrückliche schriftliche Genehmigung durch {{mandatorShortName}} nicht gestattet.",
      p3: "(3) Insbesondere ist eine automatisierte Abfrage der von {{mandatorShortName}} bereitgestellten Inhalte ohne ausdrückliche schriftliche Genehmigung in jeglicher Form nicht zulässig.",
      p4: "(4) Verstößt der Nutzer gegen die ihm eingeräumten Nutzungsrechte oder besteht der Verdacht des Missbrauches der zur Verfügung gestellten Inhalte, so ist {{mandatorShortName}} berechtigt, den Zugang des Nutzers ohne vorherige Ankündigung zu unterbinden und rechtliche Schritte gegen ihn einzuleiten.",
    },
    section9: {
      title: "Zahlungsvorgänge",
      p1: "(1) Die Entgelte für kostenpflichtige Inhalte werden vor Erbringung der Leistung mit einem vom Nutzer zu wählenden Zahlungssystemanbieter abgerechnet. Es gelten hierbei ausschließlich die Nutzungsbedingungen des jeweils vom Nutzer ausgewählten Zahlungssystemanbieters, auf die an gegebener Stelle hingewiesen und entsprechende Hilfestellungen gegeben werden. Die Entgeltforderungen sind entsprechend den jeweiligen Nutzungsbedingungen mit dem jeweils gewählten Zahlungssystemanbieter zu begleichen.",
      p2: "(2) Wenn der Nutzer seinen Zahlungsverpflichtungen nicht nachkommt bzw. Zahlungsaktionen nicht durchgeführt oder solche rückbelastet werden, ist {{mandatorShortName}}, vorbehaltlich weitergehender Ansprüche, berechtigt, den Zugang des Nutzers zu sperren. Erfolgt die Sperrung wegen offen stehender Forderungen und gleicht der Nutzer diese aus, wird der Zugang wieder entsperrt.",
      p3: "(3) {{mandatorShortName}} behält sich das Recht vor, Dritte mit der Durchführung des Inkassos zu beauftragen.",
      p4: "(4) Verstößt der Nutzer gegen die ihm gewährten Nutzungsrechte nach §{{usageRightsSection}} oder seine Pflichten nach §{{obligationsSection}}, so ist {{mandatorShortName}} berechtigt, den Vertrag fristlos zu kündigen, wovon die Zahlungsverpflichtung des Kunden unberührt bleibt, d.h. bereits bezahlte Nutzungsentgelte werden nicht erstattet. Ferner behält {{mandatorShortName}} sich vor, weitergehende Rechtsansprüche wie Schadenersatz wahrzunehmen.",
    },
    section10: {
      title: "Pflichten des Nutzers",
      p1: "(1) Bei der Buchung kostenpflichtiger Angebote versichert der Nutzer, dass die von ihm im Rahmen einer Buchung auf den Seiten von {{mandatorShortName}} gemachten Angaben zu seiner Person, insbesondere sein Vor-, Nachname und seine Postanschrift sowie das Geburtsdatum und die E-Mail-Adresse wahrheitsgemäß und richtig sind, und dass er, sofern sich die dort gemachten Angaben verändern, die Änderung der Daten unverzüglich {{mandatorShortName}} anzeigt. Unwahre Angaben berechtigen {{mandatorShortName}} zur sofortigen und unwiderruflichen und ggf. rückwirkenden Einstellung des Angebotes.",
      p2: "(2) Der Nutzer verpflichtet sich, im Rahmen der Nutzung der Dienste von {{mandatorShortName}} nicht gegen geltende Rechtsvorschriften und etwaige vertragliche Bestimmungen zu verstoßen. Er verpflichtet sich insbesondere dazu, dass etwaige von ihm verbreiteten Inhalte keine Rechte Dritter (z. B. Urheberrechte, Patent- und Markenrechte) verletzen, dass die geltenden Strafgesetze und Jugendschutzbestimmungen beachtet werden und dass keine rassistischen, den Holocaust leugnenden, grob anstößigen, pornografischen oder sexuellen, jugendgefährdenden, extremistischen, Gewalt verherrlichenden oder verharmlosenden, den Krieg verherrlichenden, für eine terroristische oder extremistische politische Vereinigung werbenden, zu einer Straftat auffordernden, ehrverletzende Äußerung enthaltenden, beleidigenden oder für Minderjährige ungeeigneten oder sonstige strafbaren Inhalte verbreitet werden. Der Nutzer verpflichtet sich weiter, zum Schutz der Daten den anerkannten Grundsätzen der Datensicherheit Rechnung zu tragen und die Verpflichtungen der Datenschutzbestimmungen zu beachten, ggf. an {{mandatorShortName}} ausgehende E-Mails und Abfragen mit größtmöglicher Sorgfalt auf Viren zu überprüfen, gesetzliche, behördliche und technische Vorschriften einzuhalten, seinen eventuellen Nutzernamen und das Kenn- sowie das Passwort geheim zu halten, nicht weiterzugeben, keine Kenntnisnahme zu dulden oder zu ermöglichen und die erforderlichen Maßnahmen zur Gewährleistung der Vertraulichkeit zu ergreifen und bei einem Missbrauch oder Verlust dieser Angaben oder einem entsprechenden Verdacht diese {{mandatorShortName}} unverzüglich anzuzeigen. Hinweise auf eine missbräuchliche Nutzung der Inhalte von {{mandatorShortName}} oder des Zahlungssystems sind {{mandatorShortName}} ebenfalls unverzüglich anzuzeigen.",
      p3: "(3) Der Nutzer stellt {{mandatorShortName}} von etwaigen Ansprüchen Dritter, die diese gegen {{mandatorShortName}} aufgrund von Verletzung ihrer Rechte durch diesen Nutzer geltend machen, frei. Dazu gehören auch die Kosten einer angemessenen Rechtsverfolgung und -verteidigung. {{mandatorShortName}} behält sich das Recht vor, bei begründetem Verdacht missbräuchlicher Nutzung der Leistungen von {{mandatorShortName}} oder der Zahlungssysteme diesem Nutzer den Zugang zu ihren Inhalten und den eventuell bestehenden Nutzer-Account zu sperren, sowie die Ermittlungsbehörden einzuschalten.",
      p4: "(4) Gegen Ansprüche von {{mandatorShortName}} kann der Nutzer nur mit unbestrittenen oder rechtskräftigen Ansprüchen aufrechnen. Zurückbehaltungsrechte stehen dem Nutzer nur wegen Ansprüchen aus dem einzelnen, konkreten Vertragsverhältnis zu, dessen Bestandteil diese AGB sind.",
      p5: "(5) Der Nutzer verpflichtet sich, die zum Login bei {{mandatorShortName}} notwendigen Daten (in der Regel Email-Adresse und Passwort) geheim zu halten und keinem Dritten zugänglich zu machen. Bei Missbrauchsverdacht ist {{mandatorShortName}} umgehend zu unterrichten.",
      p6: "(6) Verstößt der Nutzer gegen eine der genannten Pflichten, so ist {{mandatorShortName}} berechtigt, den Zugang des Kunden zu geschützten Bereichen ohne vorherige Ankündigung zu sperren.",
    },
    section11: {
      title: "Haftung",
      p1: "(1) Eine Haftung von {{mandatorShortName}} sowie ihrer Vertreter oder Erfüllungsgehilfen auf Schadensersatz, insbesondere wegen Verzugs, Nichterfüllung, Schlechterfüllung oder unerlaubter Handlung besteht nur bei Verletzung wesentlicher Vertragspflichten, auf deren Erfüllung in besonderem Maße vertraut werden durfte. Der Haftungsausschluss gilt nicht für Vorsatz und grobe Fahrlässigkeit. Im Übrigen ist eine Haftung von {{mandatorShortName}} ausgeschlossen, es sei denn, es bestehen zwingende gesetzliche Regelungen.",
      p2: "(2) {{mandatorShortName}} haftet nur für vorhersehbare Schäden. Die Haftung für mittelbare Schäden, insbesondere Mangelfolgeschäden, unvorhersehbare Schäden oder untypische Schäden sowie entgangenen Gewinn ist ausgeschlossen. Gleiches gilt für die Folgen von Arbeitskämpfen, zufälligen Schäden und höherer Gewalt.",
      p3: "(3) {{mandatorShortName}} stellt eigene Informationen und Daten sowie Informationen anderer Anbieter mittels Hyperlinks (Internetverknüpfung) im Internet und auf mobilen Endgeräten zur Verfügung.",
      p4: "Diese Informationen und Daten dienen allein Informationszwecken, ohne dass sich der Nutzer auf die Aktualität, Richtigkeit oder Vollständigkeit der Informationen berufen oder verlassen kann. {{mandatorShortName}} übernimmt insofern keine Gewährleistung oder Haftung, insbesondere nicht für direkte oder indirekte Schäden, die durch die Nutzung der Informationen oder Daten, die auf den {{mandatorShortName}} Websites zu finden sind, entstehen. {{mandatorShortName}} übernimmt insbesondere keine Verantwortung für Inhalte oder die Funktionsfähigkeit, Fehlerfreiheit oder Rechtmäßigkeit von Webseiten Dritter, auf die durch Verlinkung von den {{mandatorShortName}} Websites verwiesen wird.",
      p5: "(4) {{mandatorShortName}} ist bei der Behandlung der vom Nutzer mitgeteilten Daten und der Durchführung der Vergleichsberechnungen um ständige Aktualität, Vollständigkeit und Richtigkeit bemüht. {{mandatorShortName}} ist jedoch nicht dazu verpflichtet, sämtliche am Markt befindlichen Versicherungs- und Finanzdienstleistungsunternehmen in die Berechnungen mit einzubeziehen. Speziell im Versicherungsbereich erfolgt die Beschränkung auf verfügbare provisionsfreie Tarife.",
      p6: "Jegliche Informationen über Versicherungs- und Finanzdienstleistungen oder sonstige Informationen auf den zu {{mandatorShortName}} gehörenden Webseiten und Blogs stellen keine Beratung für den Nutzer dar, sondern dienen der Erleichterung einer selbständigen Anlageentscheidung des Nutzers, auf die {{mandatorShortName}} keinen Einfluss hat. Keine der Informationen ist als Zusage einer Garantie oder Zusicherung zu verstehen. Die Leistungen von {{mandatorShortName}} umfassen insbesondere keine Rechts- oder Steuerberatung. Bindend ist der Wortlaut des jeweiligen Vertrages oder Versicherungsscheines. Der Nutzer ist dazu verpflichtet, den genauen Inhalt des jeweiligen Vertrages/Versicherungsscheins zu prüfen und mögliche Abweichungen umgehend zu melden.",
      p7: "(5) Für den Fall der Übermittlung von vorsätzlich falschen oder unwahren persönlichen Daten durch den Nutzer haftet {{mandatorShortName}} nicht. Gleichzeitig behält sich {{mandatorShortName}} vor, ihn von der Inanspruchnahme der angebotenen, bzw. zu Verfügung gestellten Leistungen auszuschließen und Ersatz für dadurch eingetretene Schäden zu verlangen.",
      p8: "(6) {{mandatorShortName}} bietet Diskussionsforen und Chats an. Die von den Nutzern in diesen Foren ausgetauschten Inhalte und Informationen unterliegen keiner Kontrolle durch {{mandatorShortName}}. Aus diesem Grund übernimmt {{mandatorShortName}} keine Haftung für die in die Foren eingestellten Inhalte und Informationen. Die Verantwortung für die Inhalte, die der Nutzer auf den Seiten von {{mandatorShortName}} veröffentlicht, liegt ausschließlich bei dem Nutzer.",
      p9: "(7) {{mandatorShortName}} schließt jegliche Haftung wegen technischer oder sonstiger Störungen aus.",
      p10: "(9) Die vorstehenden Haftungsbeschränkungen gelten für sämtliche vertragliche und nichtvertragliche Ansprüche.",
    },
    section12: {
      title: "Finanzanalysen",
      p1: "(1) {{mandatorShortName}} wird nicht als Ersteller von Finanzanalysen tätig. Etwaige Weitergaben von Finanzanalysen Dritter erfolgen ohne wesentliche Änderung der Finanzanalysen und ohne deren inhaltliche Überprüfung.",
      p2: "(2) Sofern das Produkt als Finanzanalyse qualifiziert, wird ausdrücklich klargestellt, dass {{mandatorShortName}} nur als Weitergeber einer im Wesentlichen unveränderten Finanzanalyse tätig wird. Für den gegebenenfalls als Finanzanalyse qualifizierenden Inhalt des Produktes ist der Produkthersteller die inhaltlich verantwortliche Person.",
    },
    section13: {
      title: "Disclaimer",
    },
    section14: {
      title: "Mängelhaftung",
      p1: "(1) Werden kostenpflichtige Inhalte wegen unvollständiger oder mangelhafter Leistungen von {{mandatorShortName}} durch den Nutzer beanstandet, so muss der Nutzer entsprechend der Nutzungsbedingungen des vom Nutzer gewählten Zahlungssystemanbieters die Beanstandungen entweder {{mandatorShortName}} oder dem Zahlungsanbieter unverzüglich nach Kenntnisnahme anzeigen.",
      p2: "(2) Haftet {{mandatorShortName}} wegen berechtigter und rechtzeitiger Beanstandungen, so hat {{mandatorShortName}} im Fall unvollständiger Leistung nachzuliefern und im Fall mangelhafter Leistung nach Ihrer Wahl nachzubessern oder Ersatz zu liefern. Der Nutzer kann Herabsetzung der Entgelte verlangen, wenn Nachbesserungsversuche oder Ersatzlieferung von {{mandatorShortName}} verweigert werden, unmöglich sind oder in sonstiger Weise fehlschlagen. Es besteht kein Rücktrittsrecht zu Gunsten des Nutzers.",
    },
    section15: {
      title: "Urheberrecht",
      p1: "(1) Sämtliche auf den Seiten von {{mandatorShortName}} veröffentlichte Inhalte, Informationen, Bilder, Videos und Datenbanken und Computerprogramme (z.B. Widgets) sind urheberrechtlich geschützt.",
      p2: "(2) Die Nutzung ist nur für den privaten persönlichen Gebrauch gestattet. Jede darüber hinausgehende Nutzung, insbesondere die private und gewerbliche Vervielfältigung, Änderung, Verbreitung oder Speicherung von Informationen oder Daten, insbesondere von Texten, Textteilen, von Bild- und Filmmaterial, bedarf der vorherigen ausdrücklichen Zustimmung von {{mandatorShortName}}. Dies gilt auch für die Aufnahme in elektronische Datenbanken und Vervielfältigung auf CD-ROM, DVD etc.",
      p3: "Nicht gestattet ist eine private und/oder gewerbliche Vervielfältigung, Änderung, Verbreitung oder sonstiger Missbrauch von Computerprogrammen. Der Nutzer erwirbt durch das Herunterladen oder die Zusendung des Quellcodes eines Computerprogrammes keine Eigentumsrechte. Es werden keinerlei Urheberrechte oder sonstige Leistungsschutzrechte übertragen. Wird der Dienst und/ oder die Leistungen eingestellt, ist der Nutzer verpflichtet, den zur Verfügung gestellten Quellcode unverzüglich zu löschen.",
      p4: "Im Übrigen gelten die rechtlichen Grenzen, die sich aus dem Urheberrecht und den sonstigen anwendbaren gesetzlichen Vorschriften ergeben.",
    },
    section16: {
      title: "Vom Nutzer eingesandte Inhalte",
      p1: "(1) Der Nutzer, der (z. B. im Rahmen von Gewinnspielen, Leser-Aktionen, Internetwettbewerben oder eines SMS-Tickers) eigene Inhalte (z. B. Videos, Fotos, Fotoserien, Texte etc.) an {{mandatorShortName}} einsendet, erklärt sich durch die Einsendung damit einverstanden, dass die eingesandten Inhalte honorarfrei im Internet und im Printbereich vervielfältigt, verbreitet und öffentlich wiedergegeben werden. Der Nutzer erklärt weiterhin, sämtliche Urheber- sowie sonstige Rechte an den eingesandten Inhalten zu besitzen und dass auf eingesandten grafischen Inhalten (z. B. Videos, Fotos, Fotoserien) abgebildete Personen, die nicht nur Beiwerk zu einer Örtlichkeit oder Teil von abgebildeten Versammlungen, Aufzügen oder ähnlichen Vorgängen sind, mit der Veröffentlichung einverstanden sind. Bei Personen unter 18 Jahren gilt das Einverständnis des Erziehungsberechtigten. Auf dem Postweg eingesandte Beiträge können nicht an den Teilnehmer zurückgeschickt werden.",
      p2: "(2) Die Nutzer verpflichten sich, keine Inhalte mit rechtswidrigen, grob anstößigen, pornografischen oder sexuellen, jugendgefährdenden, extremistischen, Gewalt verherrlichenden oder verharmlosenden, den Krieg verherrlichenden, für eine terroristische oder extremistische politische Vereinigung werbenden, zu einer Straftat auffordernden, ehrverletzende Äußerung enthaltenden, oder sonstigen strafbaren Inhalten an {{mandatorShortName}} .de zu senden. Ebenso verpflichtet sich der Nutzer keine Inhalte zu versenden, die Werbung oder gewerbliche Inhalte enthalten.",
      p3: "(3) {{mandatorShortName}} behält sich das Recht vor, eingesandte Inhalte nicht zu veröffentlichen.",
      p4: "(4) Der Nutzer stellt {{mandatorShortName}} von allen Ansprüchen Dritter vollumfänglich frei, die dadurch entstehen, dass der Nutzer gegen seine Pflichten nach diesen Bedingungen verstößt oder – entgegen dieser Erklärung – der Nutzer nicht alle Rechte an den eingesandten Inhalten besitzt oder abgebildete Personen nicht mit der Veröffentlichung einverstanden sind.",
      p5: "(5) Die eingesendeten Inhalte sind persönliche Äußerungen der Nutzer und stellen nicht die Meinung von {{mandatorShortName}} dar. Der Nutzer hat keinen Rechtsanspruch auf Veröffentlichung der eingesandten Inhalte.",
    },
    section17: {
      title: "Widerrufsrecht",
      p1: "(1) Der Nutzer ist berechtigt, seine auf den Vertragsabschluss gerichtete Willenserklärung binnen zwei Wochen zu widerrufen. Die Frist beginnt frühestens mit Erhalt dieser Belehrung oder nach Erhalt Ihrer Vertragsunterlagen oder des Versicherungsscheins. Zur Fristwahrung genügt die rechtzeitige Absendung der Widerrufserklärung. Sie ist ohne Angabe von Gründen schriftlich abzufassen und zu richten an:",
      p2: "(2) Im Falle eines wirksamen Widerrufs sind die beiderseits empfangenen Leistungen zurückzugewähren und gegebenenfalls gezogene Nutzungen herauszugeben. Kann der Nutzer die empfangenen Leistungen ganz oder teilweise nicht oder nur in verschlechtertem Zustand zurückgewähren, muss insoweit Wertersatz geleistet werden.",
      p3: "(3) Besondere Hinweise: Das Widerrufsrecht erlischt vorzeitig, wenn der Vertrag von beiden Seiten auf ausdrücklichen Wunsch des Kunden vollständig erfüllt worden ist, bevor der Kunde sein Widerrufsrecht ausgeübt hat. Dies ist z.B. der Fall, wenn die gekauften Services vom Kunden verwendet werden. Hierfür ist eine einmalige Nutzung/Login ausreichend.",
      p4: '(4) Besonderer Hinweis zu Premium-Dienstleistungen: Bei Premium-Dienstleistungen handelt es sich um die Bereitstellung von "Digitalen Inhalten", welche in einem passwortgeschützten Kundenbereich zur Verfügung gestellt werden. Diese digitalen Inhalte sind auf Grund ihrer Beschaffenheit nicht für eine Rücksendung geeignet. Ein Widerrufsrecht besteht gemäß § 312 d Abs. 4 Nr. 1 BGB nicht. Mit der ersten Nutzung der persönlichen Zugangsdaten erlischt das Widerrufsrecht vorzeitig, da der Vertrag von beiden Seiten auf ausdrücklichen Wunsch des Kunden vollständig erfüllt worden ist, bevor der Kunde sein Widerrufsrecht ausgeübt hat.',
      p5: "(5) Besonderer Hinweis zur Vermittlung von Dienstleistungen, Produkten und Versicherungen: Widerrufsfolgen im Falle eines wirksamen Widerrufs endet der Vertrag/Versicherungsschutz, und der Anbieter/Versicherer erstattet Ihnen den auf die Zeit nach Zugang des Widerrufs entfallenden Teil der Prämien, wenn Sie zugestimmt haben, dass der Vertrag/ Versicherungs-schutz vor dem Ende der Widerrufsfrist beginnt. Der Widerruf eines Vertrages hat keine Auswirkungen auf das Vertragsvermittlungsverhältnis mit {{mandatorShortName}}, sofern dieses bereits erfüllt wurde.",
    },
    sectionCashbackBilling: {
      title: "Vergütung und Abrechnung",
      p1Rentablo:
        "(1) Die Nutzung des {{mandatorShortName}}-Accounts oder die Nutzung des Rentablo-Premium-Accounts innerhalb einer Testphase ist kostenlos. Die Vergütung der Nutzung des Rentablo-Premium Accounts und der Rentablo Cashback-Modelle erfolgt nach den von Ihnen gewählten Abrechnungskonditionen (Monats- oder Jahresabonnement) und bemisst sich nach der zum Zeitpunkt des Vertragsschlusses aktuellen Preisliste und den dort beschriebenen Rabatten, die Sie auf unserer Startseite abrufen können.",
      p1: "(1) Die Nutzung des {{mandatorShortName}}-Accounts ist kostenlos. Die Vergütung der Rentablo Cashback-Modelle erfolgt nach den von Ihnen gewählten Abrechnungskonditionen (Monats- oder Jahresabonnement) und bemisst sich nach der zum Zeitpunkt des Vertragsschlusses aktuellen Preisliste und den dort beschriebenen Rabatten, die Sie auf unserer Startseite abrufen können.",
      p2: "(2) Die Vergütung für das Rentablo Fonds-Cashback erfolgt quartalsweise nachgelagert. Die Cashbackkosten werden mit dem Cashback verrechnet und die Differenz wird auf das vom Kunden benannte Konto überwiesen. Sonstige Vergütungen z.B. für Premiummodelle sind zu Beginn der jeweiligen Abrechnungsperiode am Tag der jeweiligen Buchung eines Zeitraums (Monat oder Jahr) für den jeweils ausgewählten Abrechnungszeitraum im Voraus fällig. Verlängert sich der Vertrag durch ein Abonnement, wird jede weitere Zahlung zu Beginn der neuen Abrechnungsperiode fällig.",
      p3: "(3) Alle genannten Vergütungen und Preise verstehen sich inklusive der jeweils gültigen gesetzlichen Umsatzsteuer.",
      p4: "(4) Sie dürfen nur mit rechtskräftig festgestellten oder unbestrittenen Forderungen aufrechnen oder ein Zurückbehaltungsrecht geltend machen. Forderungen aus diesem Vertrag dürfen Sie nur mit schriftlicher Zustimmung von uns an Dritte abtreten.",
      p5: "(5) Leisten Sie eine Zahlung trotz Fälligkeit nicht, so befinden Sie sich in Verzug (bereits sofort ab der ersten Nichtzahlung trotz Fälligkeit). Beachten Sie hier insbesondere unser Kündigungsrecht.",
      p6: "(6) Beim Fonds-Cashback ist zu beachten, dass lediglich die Bestandsprovisionen als Cashback ausgeschüttet werden können, welche {{mandatorShortName}} als Vermittler von den Banken bzw. der Vertriebsgesellschaft auch tatsächlich erhält.",
    },
    section18: {
      title: "Laufzeit des Vertrages",
      cashbackP1Title: "(1) Rentablo Cashback",
      cashbackP1Text:
        "Der Vertrag über die unentgeltliche Nutzung von {{mandatorShortName}} mit dem kostenlosen Account wird auf unbestimmte Zeit geschlossen.",
      p2Title:
        "({{num}}) {{mandatorShortName}}-Portfoliomanager-Account (kostenlos)",
      p2Text:
        "Der Vertrag über die unentgeltliche Nutzung von {{mandatorShortName}} mit dem kostenlosen Account wird auf unbestimmte Zeit geschlossen.",
      p3Title: "(3) {{mandatorShortName}}-Portfoliomanager-Account",
      p3Text:
        'Der Vertrag über die Nutzung von {{mandatorShortName}} Portfoliomanager-Account wird auf unbestimmte Zeit geschlossen. Eine Kündigung ist jeweils mit 30 Tagen Kündigungsfrist zum Ende des Quartals möglich. Verträge laufen bis zum Ende des vereinbarten Zeitraums und verlängern sich automatisch jeweils um die gleiche Dauer, wenn Ihr Account nicht vorher von Ihnen oder uns gekündigt wird ("Abonnement").Das jeweilige Vergütungsmodell können Sie bei Abschluss des Vertrages wählen und wir werden Sie deutlich darauf hinweisen.',
      p4Title: "(4) Testphase {{mandatorShortName}} Portfoliomanager-Account",
      p4Text:
        "Nutzten Sie den Premium Account mit einer Testphase, so läuft der Vertrag zunächst für die Dauer der Testphase. Danach wechselt der Vertrag automatisch in das kostenpflichtige Modell um",
    },
    section19: {
      title: "Kündigung",
      p1: "(1) Die Kündigung aus wichtigem Grund bleibt jeder Partei vorbehalten. Ein wichtiger Grund liegt insbesondere vor, wenn der Nutzer trotz Mahnung fortgesetzt gegen wesentliche Bestimmungen dieser AGB verstößt und/oder der Nutzer ein gegen Dritte gerichtetes Fehlverhalten begeht, indem er das Angebot von {{mandatorShortName}} zu rechtswidrigen oder für Dritte belästigend wirkenden Zwecken einsetzt. Außerdem besteht ein wichtiger Grund, wenn Sie mit Ihren Zahlungsverpflichtungen in nicht unerheblicher Höhe in Verzug kommen. Als nicht unerheblich gilt ein Betrag in Höhe einer monatlichen Vergütung für den jeweiligen Account. Sie bleiben in diesem Fall verpflichtet, die Vergütungen zu zahlen. Die Geltendmachung weiterer Ansprüche wegen Zahlungsverzugs behalten wir uns vor.",
      p2: "(2) Sämtliche Kündigungen nach diesen AGB haben durch eine schriftliche Mitteilung an die in Punkt {{addressSection}} genannten Adressen zu erfolgen.",
      p3: "(3) Mit Wirksamwerden der Kündigung wird der Zugang zu den Leistungen von {{mandatorShortName}} gesperrt.",
      p4: "(4) Beide Parteien können den kostenlosen Account jederzeit kündigen. Sie können den Premium-Account jederzeit – bei Verträgen mit Mindestlaufzeit zum Ablauf der vereinbarten Laufzeit und bei Testphasen zum Ende der Testphase – kündigen. Wir können den Vertrag mit einer Frist von zwei Wochen – bei Verträgen mit Mindestlaufzeit zum Ablauf der vereinbarten Laufzeit und bei Testphasen zum Ende der Testphase – kündigen.",
      p5: '(5) Den {{mandatorShortName}}-Account können Sie dadurch kündigen, dass Sie im Profil auf "Account löschen" klicken oder an <0>{{supportEmail}}</0> eine kurze Email schreiben. Wir können den Nutzungsvertrag per E-Mail kündigen. Außerdem können wir den Nutzungsvertrag über den kostenlosen Account durch die Einstellung der Möglichkeit eines Accounts insgesamt kündigen.',
      p6: "(6) Der Service ist sehr kostengünstig, da er sich ausschließlich an Selbstentscheider richtet. Zum Schutz der Gemeinschaft kann {{mandatorShortName}} Kunden, welche den Support-Service missbräuchlich oder über das übliche Maß hinaus in Anspruch nehmen, kündigen oder die Zusammenarbeit ablehnen. {{mandatorShortName}} wird diese Kunden auf Ihr Fehlverhalten hinweisen.",
    },
    section20: {
      title: "Schlussbestimmungen",
      p1: "(1) Gerichtsstand ist, sofern der Nutzer Vollkaufmann ist, für alle aus dem Vertragsverhältnis mittelbar oder unmittelbar sich ergebenden Streitigkeiten vermögensrechtlicher Art Berlin. Ein etwaiger ausschließlicher Gerichtsstand bleibt hiervon unberührt. Erfüllungsort ist Berlin. Es gilt deutsches Recht, unter Ausschluss des UN-Kaufrechts.",
      p2: "(2) Im Zusammenhang mit der Teilnahme an Gewinnspielen ist der Rechtsweg ausgeschlossen.",
      p3: "(3) Sollten einzelne Bestimmungen dieser AGB einschließlich dieser Regelungen ganz oder teilweise unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen oder Teile solcher Bestimmungen unberührt. Anstelle der unwirksamen oder fehlenden Bestimmungen treten die jeweiligen gesetzlichen Regelungen.",
      p4: "(4) Diese Allgemeinen Geschäftsbedingungen sind abschließend für die Regelung der rechtlichen Beziehungen zwischen dem Nutzer und {{mandatorShortName}} sowie dessen Erfüllungsgehilfen.",
    },
    published:
      "Die AGBs werden auf der Internetweite <0>{{rootUrl}}</0> veröffentlicht und somit sind auch zukünftige Änderungen der AGB allen Nutzern zugänglich. Der Nutzer hat für seine Information selbst Sorge zu tragen.",
    date: "Stand: 28.08.2026",
  },
  tppWebFormTermsOfUsePage: {
    title: "Allgemeine Geschäftsbedingungen (AGB)",
    agreement: {
      title:
        "Nutzungsvereinbarung und Hinweise für Endnutzer von wealthAPI Kontoinformations- und Zahlungsauslösediensten",
      date: "Stand: 06.12.2021",
      section1: {
        title: "1 Inhalt und Zustandekommen des Vertrages",
        sub1: {
          title: "1.1 Vertragsparteien und Gegenstand",
          text: 'Die {{b2bName}}, {{street}} {{streetNumber}}, {{zip}} {{city}} (AG Berlin Charlottenburg HRB 256105 B), E-Mail: {{b2bEmail}} ("wealthAPI") ist ein von der Bundesanstalt für Finanzdienstleistungsaufsicht ("BaFin"), Graurheindorfer Str. 108, D-53117 Bonn, Fax: + 49 228 4108-1550, E-Mail: poststelle@bafin.de, beaufsichtigtes Zahlungsinstitut.',
          text2:
            'Der von wealthAPI als Online-Dienst zur Verfügung gestellte Kontoinformationsdienst ("KID") erlaubt es Endnutzern, ihre Kontostände und Kontobewegungen (nachfolgend "Kontoinformationen") von Zahlungskonten und sonstigen Konten von Kredit- und Finanzdienstleistungsinstituten, Kreditkartenunternehmen und anderen Finanzdatenanbietern (nachfolgend "Kontoanbieter") auszulesen, soweit diese Konten jeweils in den Leistungsumfang zwischen dem Endnutzer und dem Dienste-Anbieter (wie im Folgenden definiert) einbezogen sind.',
          text3:
            "Die ausgelesenen Kontoinformationen werden bei wealthAPI gespeichert und über ein API (Application Programming Interface) dem Endnutzer über den Dienst des Dienst-Anbieters zugänglich gemacht.",
        },
        sub2: {
          title: "1.2 Verhältnis zum Dienst-Anbieter",
          text: "wealthAPI und der Dienst-Anbieter sind rechtlich und wirtschaftlich selbstständige Unternehmen und erbringen für den Endnutzer unterschiedliche Leistungen (zum Zusammenspiel von wealthAPI und Dienst siehe Ziffer 2.1.1).",
        },
        sub3: {
          title: "1.3 Weg zum Vertragsschluss",
          text: "Voraussetzung für die Erbringung von Kontoinformationsdiensten durch wealthAPI ist der Abschluss dieser Nutzungsvereinbarung. Hierzu wird der Endnutzer aus dem Dienst auf eine Webseite order ein System von wealthAPI weitergeleitet. Auf dieser Webseite/diesen System können vom Endnutzer folgende Aktivitäten durchgeführt werden:",
          p1: '1.3.1 Der Endnutzer kann die Datenschutzhinweise und die vorvertraglichen Informationen für Kontoinformationsdienste und die Nutzungsbedingungen zur Kenntnis nehmen. Mit dem Anklicken des "Weiter" Buttons stimmt der Endnutzer den Nutzungsbedingungen zu. Mit der Zustimmung kommt der Vertrag zwischen Endnutzer und wealthAPI zustande ("Vertragsschluss"). Die Nutzungsbedingungen stehen dem Endnutzer als Link zum Download und zum Ausdruck zur Verfügung.',
          p2: '1.3.2 Anschließend kann der Endnutzer seine Zugangsdaten für den Zugang zum Kontoanbieter (Benutzerkennung o.ä. und PIN/Passwort) eingeben. Teilweise hat der Endnutzer zusätzlich die Option, die Speicherung der PIN durch wealthAPI zu erlauben oder abzulehnen. Per Klick auf den entsprechenden Button (z.B. "Bankdaten abrufen") werden die Zugangsdaten an wealthAPI übermittelt und die Verbindung zum Kontoanbieter durch wealthAPI hergestellt.',
          p3: "1.3.3 Im Falle eines wealthAPI KID kann der Kontoanbieter eine starke Kundenauthentifizierung verlangen. In diesem Fall kann der Endnutzer seine personalisierten Sicherheitsmerkmale, bspw. eine TAN, in der Eingabemaske angeben und über wealthAPI an den Kontoanbieter übermitteln, sofern dies erforderlich und technisch möglich ist.",
          p4: "1.3.4 wealthAPI nutzt für die Erbringung von Kontoinformationsdiensten Dienste der finAPI GmbH (Adams-Lehmann-Straße 44, D-80797 München) im Rahmen einer enstprechenden Vereinbarung zur Aufgragsdatenvereinbarung. Kontoinformationen des Benutzers werden auf Seiten der finAPI GmbH gespeichert, soweit dies zur Erbringung des KID notwendig ist.",
          extra:
            "Die Einbindung weiterer Kontoanbieter und/oder Konten nach Vertragsschluss ist, soweit diese von Dienste-Anbieter unterstützt werden, grundsätzlich möglich und erfolgt ebenfalls durch Weiterleitung des Endnutzers auf eine Webseite/ ein System von wealthAPI.",
        },
        sub4: {
          title: "1.4 Keine abweichenden Regelungen/Änderungen",
          text: "Für die Erbringung der Kontoinformation- oder Zahlungsauslösedienste durch wealthAPI gelten im Verhältnis zwischen wealthAPI und dem Endnutzer ausschließlich diese Nutzungsbedingungen. Änderungen dieser Nutzungsbedingungen werden vor ihrem Inkrafttreten rechtzeitig schriftlich, in elektronischer Form oder in Textform mitgeteilt; sie gelten als genehmigt, wenn der wealthAPI nicht binnen eines Monats nach Bekanntgabe der Änderungen ein Widerspruch des Endnutzers zugeht. Die Mitteilung kann über wealthAPI durch Anzeige innerhalb der Eingabemaske oder über den Dienst-Anbieter erfolgen. Ein Widerspruch berechtigt den Endnutzer zur fristlosen Kündigung dieser Nutzungsvereinbarung. wealthAPI wird den Endnutzer auf die Frist und die Möglichkeit zum Widerspruch hinweisen.",
        },
      },
      section2: {
        title: "2 Leistungsbeschreibung",
        sub1: {
          title: "2.1 Leistungsbeschreibung",
          sub1: {
            title: "2.1.1 Zusammenspiel von Dienst und wealthAPI",
            text: "Der Endnutzer kann wealthAPI KID aus dem Dienst des Dienst-Anbieters heraus nutzen. Dabei wird die Eingabe und Verwaltung der persönlichen Zugangsdaten des Endnutzers beim jeweiligen Kontoanbieter sowie die Ausführung der KID direkt von wealthAPI für den Endnutzer durchgeführt. Nach Ausführung der KID Funktionen stellt wealthAPI die entsprechenden Daten dem Endnutzer zur Anzeige und Verarbeitung in dem Dienst des Dienst-Anbieters zur Verfügung. Der Dienst-Anbieter erhält dabei zu keinem Zeitpunkt sensible Zahlungsdaten, die ihm einen Zugriff auf Kontoinformationen bei Kontoanbietern des Endnutzers ermöglichen. Die sensiblen Zahlungsdaten werden direkt an wealthAPI-Systeme übergeben, von wealthAPI verarbeitet und im Falle des KID von wealthAPI bzw. der finAPI GmbH im Auftrag von wealthAPI gespeichert. Die vom Endnutzer eingegebenen, sensiblen Zahlungsdaten werden durch die wealthAPI vor unbefugtem Zugriff geschützt.",
          },
          sub2: {
            title: "2.1.2 wealthAPI KID Funktionen",
            text: "Allgemein umfassen die KID von wealthAPI für den Endnutzer folgende Funktionen mit der Maßgabe, dass sich die für den Endnutzer im Einzelfall zur Verfügung stehenden Funktionen auch nach dem zwischen dem Endnutzer und dem Dienst-Anbieter vereinbarten Leistungsumfang richten, so dass gegebenenfalls einzelne der im Folgenden aufgeführten Funktionen für den Endnutzer nicht nutzbar sind:",
            p1: "2.1.2.1 Allgemein",
            p1Text:
              "Entgegennahme der persönlichen Zugangsdaten des Endnutzers beim jeweiligen Kontoanbieter auf einer gesonderten und gesicherten Webseite/Systems von wealthAPI. Entgegennahme einer TAN oder eines sonstigen weiteren Sicherheitsmerkmals auf einer gesonderten Webseite/Systems von wealthAPI und Übermittlung an den Kontoanbieter des Endnutzers.",
            p2: "2.1.2.2 Darüber hinaus umfasst der KID folgende Funktionen",
            p2Item1:
              "Einzelner oder wiederholter Abruf von Kontoinformationen.",
            p2Item2:
              "Speicherung und Aggregation der abgerufenen Kontoinformationen für den späteren Abruf durch einen vom Endnutzer bevollmächtigten Dienst.",
            p2Item3:
              "Abruf der Kontoinformationen durch den vom Endnutzer genutzten Dienst.",
            p2Item4:
              "Optionale verschlüsselte Speicherung der Zugangsdaten zu einem Kontoanbieter.",
            p2Item5:
              "Änderung und Löschung der zuvor gespeicherten Zugangsdaten.",
            p3: "2.1.2.4 Weitere aufbauende optionale Dienstleistungen",
            p3Text:
              "Die Kategorisierung von Kontoinformationen. Einzelne Funktionen der wealthAPI KID hängen von Produkten und Leistungen Dritter ab, auf die wealthAPI keinen Einfluss hat. Dies kann dazu führen, dass einzelne Funktionen der wealthAPI KID vorübergehend oder dauerhaft nicht verfügbar sein können.",
          },
        },
        sub2: {
          title: "2.2 Garantien nur in Schriftform mit Unterschrift",
          text: 'Garantien und Zusicherungen von Eigenschaften durch wealthAPI sind im Zweifel nur dann als solche auszulegen, wenn sie in Schriftform (mit Unterschrift) erfolgen und als "Garantie" bezeichnet sind.',
        },
        sub3: {
          title: "2.3 Bereitstellung und Nutzung",
          text: "Dem Endnutzer stehen die Funktionalitäten von wealthAPI im Umfang des zwischen dem Endnutzer und dem Dienst-Anbieter vereinbarten Nutzungsumfangs zur Verfügung und die Nutzung gemäß dieser Nutzungsvereinbarung zu.",
        },
      },
      section3: {
        title: "3 Pflichten und Obliegenheiten des Endnutzers",
        sub1: {
          title: "3.1 Einhalten vorgegebener Nutzungsszenarien",
          text1:
            "Endnutzern ist es nicht gestattet, die wealthAPI Funktionen in einer Weise zu nutzen, die in diesen Nutzungsbedingungen nicht ausdrücklich gestattet ist.",
          text2:
            "Endnutzer dürfen auf die wealthAPI KID nicht zugreifen oder diese nutzen, um",
          item1:
            "die Funktionalität des wealthAPI KID zu stören, zu belasten oder zu unterbrechen;",
          item2:
            "den Betrieb oder die Funktionalität des wealthAPI KID zu umgehen, zu behindern oder zu manipulieren;",
          item3: "technische Beschränkungen zu umgehen oder zu unterlaufen;",
          item4:
            "den wealthAPI KID auf einer anderen Webseite oder in einer anderen Anwendung einzubetten oder anderweitig zu verlinken;",
          item5:
            "die Sicherheit der wealthAPI Software oder eines Netzwerks oder eines Servers, das bzw. den wealthAPI nutzt, zu verletzen oder Sicherheitsschwachstellen derselben zu auszunutzen;",
          item6:
            "den wealthAPI KID für im Zusammenhang mit Aktivitäten, die eine Straftat darstellen oder gegen nationale und ausländische gesetzliche Bestimmungen verstoßen, zu nutzen.",
        },
        sub2: {
          title: "3.2 Sperrung bei Missbrauch",
          text: "wealthAPI ist berechtigt, den Zugang des Endnutzers zu sperren, wenn Anhaltspunkte für eine missbräuchliche Nutzung oder eine Gefährdung der Datensicherheit vorliegen.",
        },
      },
      section4: {
        title: "4 Haftungsbeschränkung",
        text: "wealthAPI haftet im Rahmen der gesetzlichen Bestimmungen für Schäden, soweit diese",
        item1:
          "1. vorsätzlich oder grob fahrlässig von wealthAPI verursacht wurden oder",
        item2:
          "2. leicht fahrlässig von wealthAPI verursacht wurden und auf wesentliche Pflichtverletzungen zurückzuführen sind, die die Erreichung des Zwecks dieses Vertrages gefährden oder auf die Verletzung von Pflichten, deren Erfüllung die ordnungsgemäße Durchführung dieses Vertrages erst ermöglicht und auf deren Einhaltung der Endnutzer vertrauen darf (Kardinalspflichtverletzung). In diesem Fall haftet wealthAPI nur begrenzt auf den für einen Vertrag dieser Art typischerweise vorhersehbaren Schaden.",
        text2:
          "Die Haftungsbeschränkungen gelten auch bei Ansprüchen gegen Mitarbeiter und Beauftragte von wealthAPI.",
      },
      section5: {
        title: "5 Kosten",
        text: "Die Nutzung des wealthAPI KID ist für den Endnutzer kostenlos.",
      },
      section6: {
        title: "6 Laufzeit und Vertragsbeendigung",
        sub1: {
          title: "6.1 Laufzeit und Vertragsbeendigung",
          text1:
            "Der Vertrag beginnt mit Vertragsschluss und ist auf unbestimmte Zeit geschlossen. Der Vertrag kann von beiden Parteien mit einer Frist von zwei Wochen gekündigt werden. Das Recht zur außerordentlichen Kündigung bleibt unberührt. Kündigungen bedürfen der Textform (z.B. E-Mail).",
          text2:
            "Der Vertrag endet, ohne dass es einer Erklärung des Endnutzers oder von wealthAPI bedarf, wenn",
          item1:
            "das Vertragsverhältnis zwischen wealthAPI und dem Dienst-Anbieter endet.",
          item2:
            "das den Endnutzer betreffende Vertragsverhältnis zwischen dem Endnutzer und den Dienst-Anbieter endet.",
        },
        sub2: {
          title: "6.2 Folgen der Vertragsbeendigung",
          text: "Mit Vertragsende wird wealthAPI die personenbezogenen Daten des Endnutzers löschen, sofern wealthAPI nicht gesetzlich zur Aufbewahrung berechtigt oder verpflichtet ist.",
        },
      },
      section7: {
        title: "7 Sonstiges",
        sub1: {
          title: "7.1 Anwendbares Recht",
          text: "Auf diesen Vertrag und sämtliche damit im Zusammenhang stehende Streitigkeiten findet ausschließlich deutsches Recht Anwendung.",
        },
        sub2: {
          title: "7.2 Gerichtsstand",
          text: "Ist der Kunde Kaufmann, eine juristische Person des öffentlichen Rechts oder ein öffentlich-rechtliches Sondervermögen, so ist ausschließlicher Gerichtsstand Berlin. wealthAPI bleibt in diesem Fall berechtigt, am Sitz des Kunden zu klagen.",
        },
        sub3: {
          title: "7.3 Ausschließliche Geltung",
          text: "Diese Nutzungsvereinbarung gilt ausschließlich. Entgegenstehende oder abweichende Allgemeine Geschäftsbedingungen des Endnutzers werden von wealthAPI nicht anerkannt und entfalten keine rechtliche Wirkung, es sei denn, wealthAPI stimmt diesen zuvor ausdrücklich schriftlich zu.",
        },
      },
    },
    precontractual: {
      title:
        "Vorvertragliche Informationen für Kontoinformationsdienste und Zahlungsauslösedienste (§ 675d BGB i.V.m: Art. 248 EGBGB)",
      section1: {
        title: "1 Informationen zum Zahlungsdienstleister",
        sub1: {
          title: "1.1 Name und Anschrift Zahlungsdienstleisters",
        },
        sub2: {
          title: "1.2 Zuständige Aufsichtsbehörde/Register",
          bafin: "Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin)",
          bafinBonn: "Dienstsitz Bonn:",
          bafinBonnAddress: "Graurheindorfer Str. 108",
          bafinBonnZip: "53117 Bonn",
          bafinFrankfurt: "Dienstsitz Frankfurt:",
          bafinFrankfurtAddress: "Marie-Curie-Str. 24-28",
          bafinFrankfurtZip: "60439 Frankfurt",
          registerId: "Zahlungsinstitute-Register: BaFin ID 152048",
          and: "und",
          bundesbank: "Deutsche Bundesbank",
          bundesbankDept: "Hauptverwaltung Brandenburg",
          bundesbankAddress: "Leibnizstr. 10",
          bundesbankZip: "10965 Berlin",
        },
      },
      section2: {
        title: "2 Informationen zur Nutzung der Zahlungsdienste",
        sub1: {
          title: "2.1 Kontoinformationsdienste",
          text: "Der von der wealthAPI als Online-Dienst zur Verfügung gestellte Kontoinformationsdienst ist ein Online-Dienst zur Mitteilung konsolidierter Informationen über Zahlungskonten und sonstigen Konten von Kredit- und Finanzdienstleistungsinstituten, Kreditkartenunternehmen und anderen Finanzdatenanbietern. Der Vertragsschluss zwischen dem Endnutzer und wealthAPI kommt für einen Kontoinformationsdienst zustande, wenn der Endnutzer die personalisierten Sicherheitsmerkmale (Benutzerkennung o.ä., ggfs. Kontonummer oder IBAN und PIN/Passwort) auf der Webseite der wealthAPI und durch das Bestätigen des entsprechenden Dialogfelds seine ausdrückliche Zustimmung zum Kontoinformationsdienst erteilt.",
        },
        sub2: {
          title: "2.2 Entgelte/Wechselkurs/Referenzwechselkurs",
          text: "Die Nutzung der Zahlungsdienste von wealthAPI ist für sie unentgeltlich. Auf Entgelte, Zinsen und Wechselkurse aus Ihrem Vertragsverhältnis mit dem Kontoinhaber hat die wealthAPI keinen Einfluss.",
        },
        sub3: {
          title: "2.3 Kommunikation",
          text: "Die vorvertraglichen Informationspflichten werden dem Endnutzer vor Abschluss der jeweiligen Verträge durch wealthAPI zur Verfügung gestellt. Die Kommunikation zwischen dem Endnutzer und wealthAPI erfolgt in deutscher Sprache. Dies gilt auch für die Vertragssprache.",
        },
        sub4: {
          title: "2.4 Schutz- und Abhilfemaßnahmen",
          text: "Im Falle eines vermuteten oder tatsächlichen Betrugs oder bei Sicherheitsrisiken wird wealthAPI oder der Dienst-Anbieter den Endnutzer hierüber informieren.",
        },
        sub5: {
          title: "2.5 Informationen zur Haftung",
          p1: "2.5.1 Beruhen nicht autorisierte Zahlungsvorgänge auf der Nutzung eines verloren gegangenen, gestohlenen oder sonst abhandengekommenen Zahlungsinstruments oder auf der sonstigen missbräuchlichen Verwendung eines Zahlungsinstruments, so kann der Kontoanbieter vom Endnutzer den Ersatz des hierdurch entstandenen Schadens bis zu einem Betrag von 50 Euro verlangen.",
          p2: "2.5.2 Der Endnutzer haftet nicht nach Absatz 2.5.1, wenn",
          p2Item1:
            "1. es ihm nicht möglich gewesen ist, den Verlust, den Diebstahl, das Abhandenkommen oder eine sonstige missbräuchliche Verwendung des Zahlungsinstruments vor dem nicht autorisierten Zahlungsvorgang zu bemerken oder",
          p2Item2:
            "2. der Verlust des Zahlungsinstruments durch einen Angestellten, einen Agenten, eine Zweigniederlassung des Kontoanbieters des Endnutzers oder eine sonstige Stelle, an die Tätigkeiten Kontoanbieters des Endnutzers ausgelagert wurden, verursacht worden ist.",
          p3: "2.5.3 Abweichend von den 2.5.1 und 2.5.2 ist der Endnutzer seinem Kontoinhaber zum Ersatz des gesamten Schadens verpflichtet, der infolge eines nicht autorisierten Zahlungsvorgangs entstanden ist, wenn der Endnutzer",
          p3Item1: "1. in betrügerischer Absicht gehandelt hat oder",
          p3Item2:
            "2. den Schaden herbeigeführt hat durch vorsätzliche oder grob fahrlässige Verletzung",
          p3Item2a:
            "a) einer oder mehrerer Pflichten gemäß § 675l Absatz 1 oder",
          p3Item2b:
            "b) einer oder mehrerer vereinbarter Bedingungen für die Ausgabe und Nutzung des Zahlungsinstruments.",
          p4: "2.5.4 Abweichend von den 2.5.1 und 2.5.3 ist der Endnutzer seinem Kontoinhaber nicht zum Schadensersatz verpflichtet, wenn",
          p4Item1:
            "1. der Kontoanbieter des Endnutzers eine starke Kundenauthentifizierung im Sinne des § 1 Absatz 24 des Zahlungsdiensteaufsichtsgesetzes nicht verlangt oder",
          p4Item2:
            "2. der Zahlungsempfänger oder sein Zahlungsdienstleister eine starke Kundenauthentifizierung im Sinne des § 1 Absatz 24 des Zahlungsdiensteaufsichtsgesetzes nicht akzeptiert.",
          p4Text:
            "Satz 1 gilt nicht, wenn der Endnutzer in betrügerischer Absicht gehandelt hat. Im Fall von Satz 1 Nummer 2 ist derjenige, der eine starke Kundenauthentifizierung nicht akzeptiert, verpflichtet, dem Kontoanbieter des Endnutzers den daraus entstehenden Schaden zu ersetzen.",
          p5: "2.5.5 Abweichend von den 2.5.1 und 2.5.3 ist der Endnutzer nicht zum Ersatz von Schäden verpflichtet, die aus der Nutzung eines nach der Anzeige gemäß § 675l Absatz 1 Satz 2 verwendeten Zahlungsinstruments entstanden sind. Der Zahler ist auch nicht zum Ersatz von Schäden im Sinne des Absatzes 1 verpflichtet, wenn der Kontoanbieter seiner Pflicht gemäß § 675m Abs. 1 Nr. 3 nicht nachgekommen ist. Die Sätze 1 und 2 sind nicht anzuwenden, wenn der Endnutzer in betrügerischer Absicht gehandelt hat.",
        },
        sub6: {
          title:
            "2.6 Informationen über die Frist innerhalb der, der Endnutzer dem Kontoanbieter nicht autorisierte oder fehlerhaft ausgelöste oder ausgeführte Zahlungsvorgänge anzeigen muss",
          text: "Der Endnutzer ist verpflichtet, seinen Kontoanbieter unverzüglich nach Feststellung eines nicht autorisierten oder fehlerhaft ausgeführten Zahlungsvorgangs zu unterrichten. Ansprüche und Einwendungen des Endnutzers gegen seinen Kontoanbieter sind ausgeschlossen, wenn nicht der Endnutzer seinen Kontoanbieter nicht spätestens 13 Monate nach dem Tag der nicht autorisierten oder fehlerhaften unterrichtet hat.",
        },
        sub7: {
          title: "2.7 Haftung für nicht autorisierte Zahlungsvorgänge",
          text: "Im Fall eines nicht autorisierten Zahlungsvorgangs hat der Kontoanbieter des Endnutzers gegen diesen keinen Anspruch auf Erstattung seiner Aufwendungen. Der Kontoanbieter des Endnutzers ist verpflichtet, dem Endnutzer den Zahlungsbetrag unverzüglich zu erstatten und, sofern der Betrag einem Zahlungskonto belastet worden ist, dieses Zahlungskonto wieder auf den Stand zu bringen, auf dem es sich ohne die Belastung durch den nicht autorisierten Zahlungsvorgang befunden hätte. Diese Verpflichtung ist unverzüglich, spätestens jedoch bis zum Ende des Geschäftstags zu erfüllen, der auf den Tag folgt, an welchem dem Kontoanbieter angezeigt wurde, dass der Zahlungsvorgang nicht autorisiert ist, oder er auf andere Weise davon Kenntnis erhalten hat. Ansprüche und Einwendungen des Endnutzers gegen den Kontoanbieter sind ausgeschlossen, wenn dieser seinen Kontoanbieter nicht spätestens 13 Monate nach dem Tag der Belastung mit einem nicht autorisierten oder fehlerhaft ausgeführten Zahlungsvorgang hiervon unterrichtet hat.",
        },
        sub8: {
          title:
            "2.8 Haftung bei nicht erfolgter, fehlerhafter oder verspäteter Ausführung eines Zahlungsauftrags",
          p1: "2.8.1 Wird ein Zahlungsvorgang vom Endnutzer ausgelöst, kann dieser von seinem Kontoanbieter im Fall einer nicht erfolgten oder fehlerhaften Ausführung des Zahlungsauftrags die unverzügliche und ungekürzte Erstattung des Zahlungsbetrags verlangen. Wurde der Betrag einem Zahlungskonto des Endnutzers belastet, ist dieses Zahlungskonto wieder auf den Stand zu bringen, auf dem es sich ohne den fehlerhaft ausgeführten Zahlungsvorgang befunden hätte. Soweit vom Zahlungsbetrag entgegen § 675q Abs. 1 Entgelte abgezogen wurden, hat der Kontoanbieter des Endnutzers den abgezogenen Betrag dem Zahlungsempfänger unverzüglich zu übermitteln. Weist der Kontoanbieter des Endnutzers nach, dass der Zahlungsbetrag ungekürzt beim Zahlungsdienstleister des Zahlungsempfängers eingegangen ist, entfällt die Haftung nach diesem Absatz.",
          p2: "2.8.2 Wird ein Zahlungsvorgang vom Endnutzer ausgelöst, kann dieser im Fall einer verspäteten Ausführung des Zahlungsauftrags verlangen, dass sein Kontoanbieter gegen den Zahlungsdienstleister des Zahlungsempfängers den Anspruch nach Satz 2 geltend macht. Der Kontoanbieter des Endnutzers kann vom Zahlungsdienstleister des Zahlungsempfängers verlangen, die Gutschrift des Zahlungsbetrags auf dem Zahlungskonto des Zahlungsempfängers so vorzunehmen, als sei der Zahlungsvorgang ordnungsgemäß ausgeführt worden. Weist der Kontoanbieter des Endnutzers nach, dass der Zahlungsbetrag rechtzeitig beim Zahlungsdienstleister des Zahlungsempfängers eingegangen ist, entfällt die Haftung nach diesem Absatz.",
          p3: "2.8.3 Ansprüche des Endnutzes gegen seinen Kontoanbieter nach Absatz 2.8.1 Satz 1 und 2 bestehen nicht, soweit der Zahlungsauftrag in Übereinstimmung mit der vom Zahlungsdienstnutzer angegebenen fehlerhaften Kundenkennung ausgeführt wurde. In diesem Fall kann der Endnutzer von seinem Kontoanbieter jedoch verlangen, dass dieser sich im Rahmen seiner Möglichkeiten darum bemüht, den Zahlungsbetrag wiederzuerlangen.",
          p4: "2.8.4 Ein Endnutzer kann von seinem Kontoanbieter über die Ansprüche nach 2.8.1 hinaus die Erstattung der Entgelte und Zinsen verlangen, die der Kontoanbieter ihm im Zusammenhang mit der nicht erfolgten oder fehlerhaften Ausführung des Zahlungsvorgangs in Rechnung gestellt oder mit denen er dessen Zahlungskonto belastet hat.",
          p5: "2.8.5 Wenn bei Beteiligung mehrerer Zahlungsdienstleister an dem Zahlungsvorgang von diesen Zahlungsdienstleistern mindestens einer innerhalb und mindestens einer außerhalb des Europäischen Wirtschaftsraums belegen ist, ist Absatz 2.8.1 bis 2.8.2 auf die innerhalb des Europäischen Wirtschaftsraums getätigten Bestandteile des Zahlungsvorgangs nicht anzuwenden.",
          p6: "2.8.6 Beschwerde- und Rechtsbehelfsverfahren/Streitbeilegungsverfahren",
          p6Text:
            "Bei Beschwerden können sich Endnutzer gemäß § 60 ZAG an die Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin) wenden. Die Beschwerden sind schriftlich oder zur Niederschrift bei der BaFin einzulegen und sollen den Sachverhalt sowie den Beschwerdegrund angeben. Die Beschwerde ist zu richten an:",
          p6BafinAddress: "Bundesanstalt für Finanzdienstleistungsaufsicht",
          p6BafinStreet: "Graurheindorfer Straße 108, 53117 Bonn",
          p6Schlichtung:
            "wealthAPI ist grundsätzlich bereit, an Streitbeilegungsverfahren bei der Schlichtungsstelle der Deutschen Bundesbank teilzunehmen. Die Schlichtungsstelle bei der Deutschen Bundesbank ist eine behördliche Verbraucherschlichtungsstelle. Ihr sachlicher Zuständigkeitsbereich ist gesetzlich festgelegt.",
          p6SchlichtungTitle: "Schlichtungsstelle bei der Deutschen Bundesbank",
          p6SchlichtungPO: "Postfach 11 12 32",
          p6SchlichtungZip: "60047 Frankfurt",
          p6SchlichtungPhone: "Telefon: 069 / 2388 1907",
          p6SchlichtungEmail: "E-Mail: schlichtung@bundesbank.de",
          p6SchlichtungWeb: "Internet:",
          p6SchlichtungUrl:
            "http://www.bundesbank.de/Navigation/DE/Service/Schlichtungsstelle/schlichtungsstelle.html",
        },
      },
    },
    privacy: {
      title:
        "Datenschutzerklärung der wealthAPI GmbH für die Nutzung von wealthAPI-Diensten",
      version: "Version 1.0 - 27.12.2019",
      section1: {
        title: "1. Angaben zum Verantwortlichen und Datenschutzbeauftragten",
        responsible:
          "Verantwortliche Stelle im Sinne des Datenschutzrechts ist:",
        companyName: 'wealthAPI GmbH (nachfolgend "wealthAPI")',
        directors: "Geschäftsführer: André Rabenstein, Dr. Wolfram Stacklies",
        oldZip: "12107 Berlin",
        registration:
          "eingetragen beim Amtsgericht Charlottenburg unter HRB 166061 B",
        dpoTitle: "Kontakt zum Datenschutzbeauftragten",
        dpoText:
          "Bei Fragen zum Datenschutz schreiben Sie uns gerne eine E-Mail oder wenden Sie sich direkt an unseren Datenschutzbeauftragten:",
      },
      section2: {
        title: "2. Allgemeines zur Datenverarbeitung",
        text: 'wealthAPI verarbeitet personenbezogene Daten im Einklang mit geltendem Recht, insbesondere der Verordnung (EU) 2016/679 des europäischen Parlaments und des Rates vom 27.04.2016 ("Datenschutz-Grundverordnung", DSGVO) und des Bundesdatenschutzgesetzes (BDSG). wealthAPI verwendet alle Kunden-, Endnutzer- bzw. Interessentendaten (nachfolgend "Kundendaten") grundsätzlich nur',
        item1: "zur Durchführung vorvertraglicher Maßnahmen,",
        item2:
          'zur Erfüllung ihrer vertraglichen Pflichten gegenüber dem betroffenen Kunden, Endnutzer bzw. Interessenten (nachfolgend "Kunden") wie in der Nutzungsvereinbarung für Endnutzer beschrieben, sowie',
        item3:
          "zur Erfüllung sonstiger rechtlicher, insbesondere aufsichtsrechtlicher Pflichten (Art. 6 Abs. 1 lit. b), c) DSGVO).",
        item4:
          "Darüber hinaus kann auch eine Verarbeitung zur Wahrung berechtigter Interessen von wealthAPI stattfinden, beispielsweise die Erstellung anonymisierter Auswertungen zur Verbesserung oder Erweiterung der Services für Kunden, zu Zwecken des Forderungsmanagements, der Rechtsverteidigung oder der Direktwerbung für eigene Dienstleistungen (z.B. Newsletter), soweit nicht überwiegende Interessen, Grundrechte oder Grundfreiheiten des Kunden entgegenstehen (Art. 6 Abs. 1 lit. f) DSGVO); insoweit steht dem Kunden ein Widerspruchsrecht zu.",
        item5:
          "Grundsätzlich gibt Rentablo keine Kundendaten an Dritte weiter. Zu den oben genannten Zwecken gibt wealthAPI ausnahmsweise Kundendaten an vertraglich zu Datenschutz und Datensicherheit verpflichtete Dritte (z.B. wealthAPI Mitarbeiter, externe Dienstleister wie z.B. von wealthAPI beauftragte Kontoinformationsdienste, IT-Dienstleister, Betreiber von Endnutzer-Anwendungen auf Basis von wealthAPI Diensten), sowie an Konto- und Depotführende Institute weiter. Die Weitergabe von Kundendaten ist jeweils auf das erforderliche Maß zur Zweckerfüllung beschränkt.",
        item6:
          "Eine Verarbeitung von Kundendaten und/oder deren Weitergabe an Dritte zu anderen als den oben genannten Zwecken erfolgt nur auf Grundlage ordnungsgemäßer Einwilligung des Kunden (Art. 6 Abs. 1 lit. a) DSGVO).",
        item7:
          "wealthAPI speichert und verarbeitet personenbezogene Kundendaten, solange es für die Erfüllung ihrer vertraglichen und gesetzlichen Pflichten erforderlich ist. Dabei ist zu beachten, dass die Geschäftsbeziehung zu den Kunden auf Dauer angelegt ist. Sobald der Kunde wealthAPI personenbezogene Daten mitgeteilt und wealthAPI auf dieser Grundlage ein Vertragsverhältnis (z.B. Vertrag über die Erbringung von wealthAPI KontoInformationsDiensten) mit ihm begründet und solche Dienstleistungen erbracht hat, bestehen handels-, steuerrechtliche und aufsichtsrechtliche Archivierungs-, Dokumentations- und Auskunftspflichten, an die wealthAPI gebunden ist und die auch Kundendaten umfassen. Solche Fristen betragen zwei bis zehn Jahre.",
        item8:
          "Sind die Daten für die Erfüllung vertraglicher oder gesetzlicher Pflichten nicht mehr erforderlich, werden diese regelmäßig gelöscht, es sei denn, ihre (befristete) Weiterverarbeitung ist für die Erhaltung von Beweismitteln im Rahmen der Verjährungsfristen (bis zu 30 Jahre) erforderlich, soweit seitens wealthAPI für diese Speicherung über die gesetzlichen Aufbewahrungsfristen hinaus ein überwiegendes berechtigtes Interesse gemäß Art. 6 Abs. 1 lit. f) DSGVO besteht.",
      },
      section3: {
        title: "3. Rechte des Betroffenen",
        generalTitle: "Allgemeine Datenschutzrechte",
        generalText:
          "Kunden haben das Recht auf Auskunft nach Art. 15 DSGVO, das Recht auf Berichtigung nach Art. 16 DSGVO, das Recht auf Löschung nach Art. 17 DSGVO, das Recht auf Einschränkung der Verarbeitung nach Art. 18 DSGVO, das Recht auf Widerspruch nach Art. 21 DSGVO sowie das Recht auf Datenübertragbarkeit aus Art. 20 DSGVO.",
        revocationTitle: "Widerrufsrechte",
        revocationText:
          "Einige Datenverarbeitungsvorgänge sind nur mit ausdrücklicher Einwilligung des Kunden möglich. Kunden können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.",
        exerciseTitle:
          "Ausübung der Datenschutzrechte, Mitwirkungspflichten und Einschränkungen",
        exerciseText1:
          "Für die Ausübung bestimmter Widerspruchs- und Widerrufsrechte besteht vereinzelt die Möglichkeit der Betätigung von Links oder Buttons; hierauf werden Kunden im jeweiligen Zusammenhang gesondert aufmerksam gemacht. Daneben können Kunden sich zur Geltendmachung ihrer Datenschutzrechte jederzeit postalisch oder per E-Mail an den Datenschutzbeauftragten wenden (Kontaktdaten oben).",
        exerciseNote: "Hinweis:",
        exerciseText2:
          "Eingaben von Kunden können gegebenenfalls nur bearbeiten werden, wenn Kunden wealthAPI ihren vollständigen Vor- und Nachnamen, ihre aktuelle und ggf. auch alte Anschrift, ihr Geburtsdatum und ihre E-Mail-Adresse angeben. Diese Angaben dienen ausschließlich zum Abgleich und stellen somit für Kunden einen Schutz dar, damit nicht unberechtigte Dritte persönlichen Daten von Kunden erhalten oder deren Datenschutzrechte ausüben können. Wünschenswert und hilfreich, aber nicht notwendig, wären darüber hinaus auch etwaige Angebots-, Vorgangs- und/oder Vertragsnummern, die wealthAPI Kunden mitgeteilt hat, damit wealthAPI schneller die betreffenden Daten identifizieren kann.",
        exerciseText3:
          "Bei Ausübung des Auskunftsrechts und des Löschungsrechts gelten die Einschränkungen nach §§ 34 und 35 BDSG. Im Übrigen können sich Einschränkungen daraus ergeben, dass einer vollständigen oder teilweisen Erfüllung der Datenschutzrechte im Einzelfall andere gesetzliche Bestimmungen oder ein berechtigtes Interesse von wealthAPI entgegenstehen.",
        complaintTitle: "Beschwerderecht",
        complaintText:
          "Kunden haben ein Beschwerderecht bei der für wealthAPI zuständigen Aufsichtsbehörde. Eine Verpflichtung des Kunden zur Bereitstellung personenbezogener Daten besteht bis zum Abschluss des Vertragsverhältnisses (z.B. Vertrag über die Erbringung von wealthAPI KontoInformationsdiensten) grundsätzlich nicht. Allerdings ist ohne diese Daten der Abschluss des Vertragsverhältnisses und dessen Erfüllung durch die Erbringung der vertraglich vereinbarten Leistungen gegenüber dem Kunden für wealthAPI nicht möglich.",
      },
    },
  },
  disclaimerPage: {
    header: {
      title: "Haftungsausschluss",
      subtitle: "Disclaimer",
    },
    content: {
      section1:
        "Copyright © {{year}} {{companyName}} (im folgenden {{mandatorShortName}}).",
      section1Break: "Alle Rechte vorbehalten.",
      section2:
        "Nachdruck, Weiterverbreitung und elektronische Archivierung der Inhalte nur mit schriftlicher Erlaubnis des Herausgebers. Der Herausgeber übernimmt trotz sorgfältiger Überprüfung der zugrundeliegenden Quellen keine Gewähr für den Inhalt des Angebotes. Jede Haftung entstandener Schäden ist ausgeschlossen.",
      section3:
        "Der Herausgeber haftet nicht für eingesandte Manuskripte und Unterlagen. Die hierin enthaltenen Angaben und Mitteilungen sind ausschließlich zur Information und zum persönlichen Gebrauch bestimmt. Keine der hierin enthaltenen Informationen begründet ein Angebot zum Verkauf oder die Werbung von Angeboten zum Kauf eines Terminkontraktes, eines Wertpapiers oder einer Option.",
      section4:
        "Die Einschätzungen zu Aktien, Zertifikaten und anderen Finanzprodukten, die auf {{mandatorShortName}} bzw. anderen Veröffentlichungen publiziert werden, stellen keine Aufforderung zum Kauf oder Verkauf der besprochenen Wertpapiere dar. Sofern der Autor/die Autoren/ die Redaktion in einem Artikel/Tweet die persönliche Meinung einbringt, ist dies nicht als Beratungsdienstleistung zu werten. Die Einschätzungen sind zudem unabhängig. Sie beruhen auf Quellen, die wir für vertrauenswürdig und zuverlässig halten. Für Emissionsangaben Dritter übernehmen wir kein Obligo. Trotz sorgfältiger Bearbeitung können wir für die Richtigkeit der Angaben und Kurse keine Gewähr übernehmen. Alle Meinungen und Informationen dienen ausschließlich der Information, begründen kein Haftungsobligo und sollen nicht als Aufforderung verstanden werden, eine Transaktion zu tätigen. Auch stellen die vorgestellten Strategien keinesfalls einen Aufruf zur Nachbildung, auch nicht stillschweigend, dar.",
      section5:
        "Wir weisen ausdrücklich darauf hin, dass der Handel mit Aktien, Optionsscheinen, Zertifikaten, Optionen und anderen Finanzprodukten mit grundsätzlichen Risiken verbunden ist und der Totalverlust des eingesetzten Kapitals nicht ausgeschlossen werden kann. Die vorgestellten Meinungen, Strategien und Informationen dürfen keinesfalls als allgemeine oder persönliche Beratung aufgefasst werden, da die Inhalte lediglich die Meinung der Redaktion widerspiegeln. Gewinne aus der Vergangenheit können zukünftige Ergebnisse nicht garantieren. Wer also aufgrund eines Artikels von {{mandatorShortName}} oder einer Empfehlung anderer {{mandatorShortName}} der Community Anlageentscheidungen trifft, handelt auf eigenes Risiko. Anleger sollten sich von einem bankunabhängigen Experten beraten lassen, inwieweit die vorgestellten Wertpapiere zu ihrem persönlichen Risikoprofil passen.",
      section6:
        "Die Besucher von {{mandatorShortName}} erklären sich durch das Lesen der hier veröffentlichten Artikel und den Kontakt mit Nutzern aus der Community mit diesem Haftungsausschuss einverstanden und stellen infolgedessen den Autor/die Autoren der Artikel oder Watchlisten von allen Haftungs- und Gewährleistungsansprüchen frei.",
      section7:
        "Alle Kursinformationen werden, je nach ausgewählter Börse, unterschiedlich zeitverzögert dargestellt (Deutsche Börse: 15 Minuten, Nasdaq: 20 Minuten, Dow Jones: 20 Minuten, NYSE: 20 Minuten). Alle Kursinformationen sind ohne Gewähr, Ansprüche gegen den Herausgeber oder Rechteinhaber (Bsp. Dow Jones, Shanghai Stock Exchange) sind ausgeschlossen.",
      section8:
        "{{mandatorShortName}} übernimmt keine Gewähr für die Inhalte der im Diskussionsforum veröffentlichten Beiträge. Der Verfasser eines Beitrages ist für den Inhalt allein verantwortlich. Es wird darauf hingewiesen, dass die Verbreitung falscher Tatsachen mit dem Ziel, Börsenpreise zu manipulieren, strafrechtlich geahndet wird. {{mandatorShortName}} überprüft die einzelnen Beiträge nicht auf deren Richtigkeit oder Wahrheitsgehalt. {{mandatorShortName}} behält sich das Recht vor, Beiträge zu löschen und Mitglieder von der Benutzung der Plattform auszuschließen.",
      section9:
        "Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc., um eine Analyse der Benutzung der Website zu ermöglichen. Die durch den Einsatz von Google Analytics erzeugten Informationen über Ihre Nutzung dieser Website (einschließlich Ihrer IP-Adresse) werden an einen Server der Google Inc. in den USA übertragen und dort gespeichert. Google wird diese Informationen lediglich dazu verwenden, die Nutzung der Website zu analysieren, indem anonymisierte Auswertungen und Grafiken zur Anzahl der Besuche, Anzahl der pro Nutzer aufgerufenen Seiten usw. erstellt werden. Diese setzen wir ausschließlich zu Zwecken der eigenen Nutzungsanalyse und vor allem der Optimierung und bedarfsgerechten Gestaltung unserer Webseiten ein. Mehr Informationen zur von Google eingesetzten Technologie finden Sie unter <0>www.google.com/analytics</0>. Durch die Nutzung dieser Website erklären Sie sich mit der Bearbeitung der über Sie erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor benannten Zweck einverstanden.",
    },
    trademarks: {
      section1:
        "Die folgenden Namen oder Bezeichnungen sind eingetragene Marken der Deutsche Börse AG: Deutsche Börse®, FWB®, Neuer Markt® (Wort-Bildmarke), SMAX®, European Energy Exchange® EEX®, Eurex®, Xetra®, DAX®, TecDAX®, MDAX®, SDAX®, CDAX®, HDAX®, VDAX®, JEX®, REX®, PEX®, Xelsius®, XTF Exchange Traded Funds®.",
      section2: "STOXX® und EURO STOXX® sind Marken der STOXX Limited.",
      section3:
        "iBoxx ist eine eingetragene Marke der International Index Company Ltd.",
      section4:
        "SWX, SWX Swiss Exchange, Swiss Market Index, SMI, Swiss Performance Index, SPI, SNMI, SWX Eurobonds and SWX New Market are registered trademarks of the SWX Swiss Exchange.",
      section5:
        "The copyright of Nikkei 225 is owned by Nihon Keizai Shimbun, Inc. NIKKEI.",
      section6:
        'DOW JONES Disclaimer: THE INDEX DATA ARE PROVIDED TO YOU "AS IS". NEITHER S&P DOW JONES INDICES, DOW JONES & COMPANY, INC. ("DOW JONES") NOR ANY OF THEIR RESPECTIVE AFFILIATES, AGENTS OR LICENSORS WARRANTS THE ACCURACY, COMPLETENESS, CURRENTNESS, NONINFRINGEMENT, MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE OF THE INDICES OR INDEX DATA. ALTHOUGH S&P DOW JONES INDICES MAKES REASONABLE EFFORTS TO COMPLY WITH ITS GUIDELINES REGARDING THE SELECTION OF COMPONENTS IN THE DOW JONES ISLAMIC MARKET INDICES, S&P DOW JONES INDICES CANNOT GUARANTEE OR WARRANT THAT THOSE INDICES OR THE DATA RELATED THERETO WILL COMPLY WITH SHARIAH LAW OR OTHER ISLAMIC PRINCIPLES AND S&P DOW JONES INDICES EXPRESSLY DISCLAIMS ANY SUCH WARRANTY. NEITHER S&P DOW JONES INDICES NOR ANY OF ITS AFFILIATES, AGENTS OR LICENSORS SHALL BE LIABLE TO YOU OR ANYONE ELSE FOR ANY LOSS OR INJURY RESULTING DIRECTLY FROM USE OF THE INDICES OR INDEX DATA CAUSED IN WHOLE OR PART BY S&P DOW JONES INDICES\' NEGLIGENCE OR CONTINGENCIES BEYOND ITS CONTROL IN PROCURING, COMPILING, INTERPRETING, REPORTING OR DELIVERING THE INDICES OR INDEX DATA. IN NO EVENT WILL S&P DOW JONES INDICES, DOW JONES OR ANY OF THEIR RESPECTIVE AFFILIATES, AGENTS OR LICENSORS BE LIABLE TO YOU OR ANYONE ELSE FOR ANY DECISION MADE OR ACTION TAKEN BY YOU IN RELIANCE ON THE INDICES. NEITHER S&P DOW JONES INDICES, DOW JONES NOR ANY OF THEIR RESPECTIVE AFFILIATES, AGENTS OR LICENSORS SHALL BE LIABLE TO YOU OR ANYONE ELSE FOR ANY DAMAGES (INCLUDING, WITHOUT LIMITATION, CONSEQUENTIAL, SPECIAL, INCIDENTAL, INDIRECT, OR SIMILAR DAMAGES) EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.',
    },
    other: {
      section1:
        'PDF-Import: Teile des PDF Import basieren auf dem Projekt "Tresor Import" (<0>https://github.com/tresorone/tresor-import</0>).',
      section2:
        "Für Daten von Ariva: Alle Kursinformationen sind nach den Bestimmungen der jeweiligen Börse mindestens 15 Minuten oder mehr verzögert (NYSE/AMEX: 20 Min.). Technologie und Daten von Ariva.",
    },
  },
  referenceAccountPage: {
    breadcrumb: "Referenzkonto bearbeiten",
    accountsCard: {
      title: "Verrechnungskonten",
      description:
        "Verknüpfe weitere Konten, über die Käufe und Verkäufe dieses Depots verrechnet werden.",
    },
    changeButton: "Ändern",
    cancelButton: "Abbrechen",
    selectPrimary: {
      title: "Primäres Konto auswählen",
      confirm: "Übernehmen",
    },
    addTrigger: "Weiteres Verrechnungskonto hinzufügen",
  },
  goals: {
    overview: {
      title: "Ziele",
      subtitle:
        "Vermögen ist der heutige Wert der zugeordneten Konten, Plan der Wert, den Ihr Plan für heute vorsieht.",
      newGoal: "Neues Ziel",
    },
    status: {
      onTrack: "Auf Kurs",
      behindPlan: "Hinter Plan",
      atRisk: "Gefährdet",
    },
    figures: {
      wealth: "Vermögen",
      plan: "Plan",
      deviation: "Abweichung",
    },
    deviation: {
      abovePlan: "{{amount}} ({{percent}}) über Plan",
      belowPlan: "{{amount}} ({{percent}}) unter Plan",
      abovePlanShort: "{{amount}} über Plan",
      belowPlanShort: "{{amount}} unter Plan",
    },
    card: {
      target: "Ziel {{amount}} bis {{date}}",
      details: "Details",
    },
    actions: {
      menu: "Aktionen für {{name}}",
      edit: "Bearbeiten",
      showOnDashboard: "Im Dashboard anzeigen",
      shownOnDashboard: "Im Dashboard angezeigt",
      shownOnDashboardNotice: "„{{name}}“ wird jetzt im Dashboard angezeigt",
      delete: "Ziel löschen",
      deleteTitle: "Ziel „{{name}}“ löschen?",
      deleteText:
        "Das Ziel und sein Plan werden gelöscht. Ihre Konten bleiben unverändert.",
      deletedNotice: "Ziel „{{name}}“ gelöscht",
    },
    detail: {
      progress: "Vermögen und Plan",
    },
    chart: {
      today: "Heute",
      mode: "Darstellung",
      line: "Linie",
      bar: "Balken",
      range: "Zeitraum",
      ranges: {
        fiveYears: "5J",
        tenYears: "10J",
        untilTarget: "Bis zum Ziel",
      },
      period: "{{from}} bis {{to}}",
      target: "Ziel {{amount}}",
    },
    banner: {
      behindTitle: "Ihr Vermögen liegt {{percent}} unter Plan.",
      behindText:
        "Mit einer höheren Sparrate oder einem späteren Zieldatum kommen Sie wieder auf Kurs.",
      atRiskTitle: "Die Zielerreichung ist gefährdet.",
      atRiskText:
        "Ihr Vermögen liegt {{percent}} unter Plan, und bis zum Zieldatum bleiben {{remaining}}.",
      atRiskTextNoTime: "Ihr Vermögen liegt {{percent}} unter Plan.",
      adjustPlan: "Plan anpassen",
    },
    plan: {
      title: "Plan",
      edit: "Plan bearbeiten",
      target: "Ziel",
      targetValue: "{{amount}} bis {{date}}",
      todaysMoney: "in heutiger Kaufkraft",
      remaining: "noch {{duration}}",
      targetDateReached: "Zieldatum erreicht",
      savings: "Sparrate",
      perMonth: "{{amount}} / Monat",
      since: "seit {{date}}, Start mit {{amount}}",
      accounts: "Konten",
      accountCount_one: "{{count}} Konto",
      accountCount_other: "{{count}} Konten",
    },
    duration: {
      years_one: "{{count}} Jahr",
      years_other: "{{count}} Jahre",
      months_one: "{{count}} Monat",
      months_other: "{{count}} Monate",
    },
    icons: {
      beach: "Ruhestand",
      "home-outline": "Wohnen",
      finance: "Vermögen",
      car: "Auto",
      "airplane-takeoff": "Reise",
      bullseye: "Allgemein",
    },
    wizard: {
      newGoal: "Neues Ziel",
      stepLabel: "Schritt {{current}} von {{total}} · {{name}}",
      cancel: "Abbrechen",
      saved: "Ziel „{{name}}“ gespeichert",
      saveError:
        "Das Ziel konnte nicht gespeichert werden. Bitte prüfen Sie Ihre Angaben und versuchen Sie es erneut.",
      accounts: {
        stepName: "Konten",
        title: "Welche Konten zählen zu diesem Ziel?",
        subtitle:
          "Der aktuelle Wert dieser Konten ist Ihr Fortschritt. Depots, Konten und Sachwerte lassen sich kombinieren, auch über mehrere Banken.",
        required: "Bitte wählen Sie mindestens ein Konto.",
        selected_one: "{{count}} Konto ausgewählt",
        selected_other: "{{count}} Konten ausgewählt",
        value: "aktueller Wert {{amount}}",
        valueAsStart:
          "aktueller Wert {{amount}} wird als Startvermögen vorgeschlagen",
      },
      plan: {
        stepName: "Plan",
        title: "Wie sieht Ihr Plan aus?",
        subtitle:
          "Aus Startvermögen, Sparrate und Laufzeit berechnen wir, welche Rendite Sie für Ihr Zielvermögen brauchen.",
        initialWealth: "Startvermögen",
        initialWealthHint_one: "Wert des gewählten Kontos",
        initialWealthHint_other: "Wert der {{count}} gewählten Konten",
        initialWealthHintAt_one: "Wert des gewählten Kontos Anfang {{date}}",
        initialWealthHintAt_other:
          "Wert der {{count}} gewählten Konten Anfang {{date}}",
        startMonth: "Startdatum",
        startMonthInvalid: "Bitte wählen Sie einen Monat bis heute.",
        target: "Zielvermögen",
        targetTooLow: "Das Zielvermögen muss über dem Startvermögen liegen.",
        targetInTodaysMoney:
          "in heutiger Kaufkraft · entspricht {{amount}} im {{date}}",
        years: "Laufzeit",
        yearsValue: "{{years}} · bis {{date}}",
        savings: "Monatliche Sparrate",
        savingsTotal: "ca. {{amount}} Einzahlungen bis zum Zieldatum",
        adjustInflation: "Zielvermögen an Inflation anpassen",
        inflationRate: "Inflationsrate",
        inflationValue: "{{rate}} % p. a.",
        result: "Ergebnis",
        requiredYield: "Benötigte Rendite",
        yieldValue: "{{percent}} p. a.",
        rating: {
          realistic: "realistisch",
          challenging: "herausfordernd",
          ambitious: "ambitioniert",
        },
        summary:
          "So viel Rendite pro Jahr braucht Ihr Plan, um {{amount}} bis {{date}} zu erreichen.",
        summaryWithoutYield:
          "Startvermögen und Sparrate reichen schon ohne Rendite für {{amount}} bis {{date}}.",
        chartTitle: "Plan bis {{date}}",
      },
      details: {
        stepName: "Name und Icon",
        title: "Fast fertig: Wie soll Ihr Ziel heißen?",
        subtitle:
          "Name und Icon erscheinen in der Übersicht und auf Ihrem Dashboard.",
        name: "Name des Ziels",
        nameRequired: "Bitte geben Sie Ihrem Ziel einen Namen.",
        nameTooLong: "Der Name darf höchstens 255 Zeichen lang sein.",
        description: "Beschreibung (optional)",
        icon: "Welches Icon passt zu Ihrem Ziel?",
        targetDate: "Zieldatum",
        dashboardHint:
          "Das Dashboard zeigt ein Ziel. Ihr erstes Ziel wird automatisch angezeigt.",
        save: "Ziel speichern",
      },
    },
    dashboard: {
      plan: "Plan {{amount}} ·",
      emptyTitle: "Kein Finanzziel",
      emptyText:
        "Große Pläne? Legen Sie ein Ziel fest und behalten Sie es im Blick.",
    },
    empty: {
      title: "Setzen Sie sich Ihr erstes Finanzziel",
      text: "Legen Sie Zielbetrag und Zieldatum fest und ordnen Sie die passenden Konten zu. Wir vergleichen den aktuellen Wert laufend mit Ihrem Plan.",
      steps: {
        define: {
          title: "Ziel festlegen",
          text: "Zielvermögen, Zieldatum und Sparrate. Konten verschiedener Banken lassen sich kombinieren.",
        },
        track: {
          title: "Fortschritt verfolgen",
          text: "Der Wert Ihrer Konten wird mit dem Soll-Wert Ihres Plans verglichen.",
        },
        adjust: {
          title: "Rechtzeitig nachsteuern",
          text: "Sie sehen, welche Rendite nötig ist, und passen Sparrate oder Zieldatum an.",
        },
      },
      create: "Ziel erstellen",
    },
  },
};
